var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// node_modules/binary-search-bounds/search-bounds.js
var require_search_bounds = __commonJS({
  "node_modules/binary-search-bounds/search-bounds.js"(exports, module) {
    "use strict";
    function ge(a, y, c, l, h) {
      var i = h + 1;
      while (l <= h) {
        var m = l + h >>> 1, x = a[m];
        var p = c !== void 0 ? c(x, y) : x - y;
        if (p >= 0) {
          i = m;
          h = m - 1;
        } else {
          l = m + 1;
        }
      }
      return i;
    }
    function gt(a, y, c, l, h) {
      var i = h + 1;
      while (l <= h) {
        var m = l + h >>> 1, x = a[m];
        var p = c !== void 0 ? c(x, y) : x - y;
        if (p > 0) {
          i = m;
          h = m - 1;
        } else {
          l = m + 1;
        }
      }
      return i;
    }
    function lt(a, y, c, l, h) {
      var i = l - 1;
      while (l <= h) {
        var m = l + h >>> 1, x = a[m];
        var p = c !== void 0 ? c(x, y) : x - y;
        if (p < 0) {
          i = m;
          l = m + 1;
        } else {
          h = m - 1;
        }
      }
      return i;
    }
    function le(a, y, c, l, h) {
      var i = l - 1;
      while (l <= h) {
        var m = l + h >>> 1, x = a[m];
        var p = c !== void 0 ? c(x, y) : x - y;
        if (p <= 0) {
          i = m;
          l = m + 1;
        } else {
          h = m - 1;
        }
      }
      return i;
    }
    function eq(a, y, c, l, h) {
      while (l <= h) {
        var m = l + h >>> 1, x = a[m];
        var p = c !== void 0 ? c(x, y) : x - y;
        if (p === 0) {
          return m;
        }
        if (p <= 0) {
          l = m + 1;
        } else {
          h = m - 1;
        }
      }
      return -1;
    }
    function norm(a, y, c, l, h, f) {
      if (typeof c === "function") {
        return f(a, y, c, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0);
      }
      return f(a, y, void 0, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0);
    }
    module.exports = {
      ge: function(a, y, c, l, h) {
        return norm(a, y, c, l, h, ge);
      },
      gt: function(a, y, c, l, h) {
        return norm(a, y, c, l, h, gt);
      },
      lt: function(a, y, c, l, h) {
        return norm(a, y, c, l, h, lt);
      },
      le: function(a, y, c, l, h) {
        return norm(a, y, c, l, h, le);
      },
      eq: function(a, y, c, l, h) {
        return norm(a, y, c, l, h, eq);
      }
    };
  }
});

// node_modules/two-product/two-product.js
var require_two_product = __commonJS({
  "node_modules/two-product/two-product.js"(exports, module) {
    "use strict";
    module.exports = twoProduct;
    var SPLITTER = +(Math.pow(2, 27) + 1);
    function twoProduct(a, b, result) {
      var x = a * b;
      var c = SPLITTER * a;
      var abig = c - a;
      var ahi = c - abig;
      var alo = a - ahi;
      var d = SPLITTER * b;
      var bbig = d - b;
      var bhi = d - bbig;
      var blo = b - bhi;
      var err1 = x - ahi * bhi;
      var err2 = err1 - alo * bhi;
      var err3 = err2 - ahi * blo;
      var y = alo * blo - err3;
      if (result) {
        result[0] = y;
        result[1] = x;
        return result;
      }
      return [y, x];
    }
  }
});

// node_modules/robust-sum/robust-sum.js
var require_robust_sum = __commonJS({
  "node_modules/robust-sum/robust-sum.js"(exports, module) {
    "use strict";
    module.exports = linearExpansionSum;
    function scalarScalar(a, b) {
      var x = a + b;
      var bv = x - a;
      var av = x - bv;
      var br = b - bv;
      var ar = a - av;
      var y = ar + br;
      if (y) {
        return [y, x];
      }
      return [x];
    }
    function linearExpansionSum(e, f) {
      var ne = e.length | 0;
      var nf = f.length | 0;
      if (ne === 1 && nf === 1) {
        return scalarScalar(e[0], f[0]);
      }
      var n = ne + nf;
      var g = new Array(n);
      var count = 0;
      var eptr = 0;
      var fptr = 0;
      var abs = Math.abs;
      var ei = e[eptr];
      var ea = abs(ei);
      var fi = f[fptr];
      var fa = abs(fi);
      var a, b;
      if (ea < fa) {
        b = ei;
        eptr += 1;
        if (eptr < ne) {
          ei = e[eptr];
          ea = abs(ei);
        }
      } else {
        b = fi;
        fptr += 1;
        if (fptr < nf) {
          fi = f[fptr];
          fa = abs(fi);
        }
      }
      if (eptr < ne && ea < fa || fptr >= nf) {
        a = ei;
        eptr += 1;
        if (eptr < ne) {
          ei = e[eptr];
          ea = abs(ei);
        }
      } else {
        a = fi;
        fptr += 1;
        if (fptr < nf) {
          fi = f[fptr];
          fa = abs(fi);
        }
      }
      var x = a + b;
      var bv = x - a;
      var y = b - bv;
      var q0 = y;
      var q1 = x;
      var _x, _bv, _av, _br, _ar;
      while (eptr < ne && fptr < nf) {
        if (ea < fa) {
          a = ei;
          eptr += 1;
          if (eptr < ne) {
            ei = e[eptr];
            ea = abs(ei);
          }
        } else {
          a = fi;
          fptr += 1;
          if (fptr < nf) {
            fi = f[fptr];
            fa = abs(fi);
          }
        }
        b = q0;
        x = a + b;
        bv = x - a;
        y = b - bv;
        if (y) {
          g[count++] = y;
        }
        _x = q1 + x;
        _bv = _x - q1;
        _av = _x - _bv;
        _br = x - _bv;
        _ar = q1 - _av;
        q0 = _ar + _br;
        q1 = _x;
      }
      while (eptr < ne) {
        a = ei;
        b = q0;
        x = a + b;
        bv = x - a;
        y = b - bv;
        if (y) {
          g[count++] = y;
        }
        _x = q1 + x;
        _bv = _x - q1;
        _av = _x - _bv;
        _br = x - _bv;
        _ar = q1 - _av;
        q0 = _ar + _br;
        q1 = _x;
        eptr += 1;
        if (eptr < ne) {
          ei = e[eptr];
        }
      }
      while (fptr < nf) {
        a = fi;
        b = q0;
        x = a + b;
        bv = x - a;
        y = b - bv;
        if (y) {
          g[count++] = y;
        }
        _x = q1 + x;
        _bv = _x - q1;
        _av = _x - _bv;
        _br = x - _bv;
        _ar = q1 - _av;
        q0 = _ar + _br;
        q1 = _x;
        fptr += 1;
        if (fptr < nf) {
          fi = f[fptr];
        }
      }
      if (q0) {
        g[count++] = q0;
      }
      if (q1) {
        g[count++] = q1;
      }
      if (!count) {
        g[count++] = 0;
      }
      g.length = count;
      return g;
    }
  }
});

// node_modules/two-sum/two-sum.js
var require_two_sum = __commonJS({
  "node_modules/two-sum/two-sum.js"(exports, module) {
    "use strict";
    module.exports = fastTwoSum;
    function fastTwoSum(a, b, result) {
      var x = a + b;
      var bv = x - a;
      var av = x - bv;
      var br = b - bv;
      var ar = a - av;
      if (result) {
        result[0] = ar + br;
        result[1] = x;
        return result;
      }
      return [ar + br, x];
    }
  }
});

// node_modules/robust-scale/robust-scale.js
var require_robust_scale = __commonJS({
  "node_modules/robust-scale/robust-scale.js"(exports, module) {
    "use strict";
    var twoProduct = require_two_product();
    var twoSum = require_two_sum();
    module.exports = scaleLinearExpansion;
    function scaleLinearExpansion(e, scale2) {
      var n = e.length;
      if (n === 1) {
        var ts = twoProduct(e[0], scale2);
        if (ts[0]) {
          return ts;
        }
        return [ts[1]];
      }
      var g = new Array(2 * n);
      var q = [0.1, 0.1];
      var t = [0.1, 0.1];
      var count = 0;
      twoProduct(e[0], scale2, q);
      if (q[0]) {
        g[count++] = q[0];
      }
      for (var i = 1; i < n; ++i) {
        twoProduct(e[i], scale2, t);
        var pq = q[1];
        twoSum(pq, t[0], q);
        if (q[0]) {
          g[count++] = q[0];
        }
        var a = t[1];
        var b = q[1];
        var x = a + b;
        var bv = x - a;
        var y = b - bv;
        q[1] = x;
        if (y) {
          g[count++] = y;
        }
      }
      if (q[1]) {
        g[count++] = q[1];
      }
      if (count === 0) {
        g[count++] = 0;
      }
      g.length = count;
      return g;
    }
  }
});

// node_modules/robust-subtract/robust-diff.js
var require_robust_diff = __commonJS({
  "node_modules/robust-subtract/robust-diff.js"(exports, module) {
    "use strict";
    module.exports = robustSubtract;
    function scalarScalar(a, b) {
      var x = a + b;
      var bv = x - a;
      var av = x - bv;
      var br = b - bv;
      var ar = a - av;
      var y = ar + br;
      if (y) {
        return [y, x];
      }
      return [x];
    }
    function robustSubtract(e, f) {
      var ne = e.length | 0;
      var nf = f.length | 0;
      if (ne === 1 && nf === 1) {
        return scalarScalar(e[0], -f[0]);
      }
      var n = ne + nf;
      var g = new Array(n);
      var count = 0;
      var eptr = 0;
      var fptr = 0;
      var abs = Math.abs;
      var ei = e[eptr];
      var ea = abs(ei);
      var fi = -f[fptr];
      var fa = abs(fi);
      var a, b;
      if (ea < fa) {
        b = ei;
        eptr += 1;
        if (eptr < ne) {
          ei = e[eptr];
          ea = abs(ei);
        }
      } else {
        b = fi;
        fptr += 1;
        if (fptr < nf) {
          fi = -f[fptr];
          fa = abs(fi);
        }
      }
      if (eptr < ne && ea < fa || fptr >= nf) {
        a = ei;
        eptr += 1;
        if (eptr < ne) {
          ei = e[eptr];
          ea = abs(ei);
        }
      } else {
        a = fi;
        fptr += 1;
        if (fptr < nf) {
          fi = -f[fptr];
          fa = abs(fi);
        }
      }
      var x = a + b;
      var bv = x - a;
      var y = b - bv;
      var q0 = y;
      var q1 = x;
      var _x, _bv, _av, _br, _ar;
      while (eptr < ne && fptr < nf) {
        if (ea < fa) {
          a = ei;
          eptr += 1;
          if (eptr < ne) {
            ei = e[eptr];
            ea = abs(ei);
          }
        } else {
          a = fi;
          fptr += 1;
          if (fptr < nf) {
            fi = -f[fptr];
            fa = abs(fi);
          }
        }
        b = q0;
        x = a + b;
        bv = x - a;
        y = b - bv;
        if (y) {
          g[count++] = y;
        }
        _x = q1 + x;
        _bv = _x - q1;
        _av = _x - _bv;
        _br = x - _bv;
        _ar = q1 - _av;
        q0 = _ar + _br;
        q1 = _x;
      }
      while (eptr < ne) {
        a = ei;
        b = q0;
        x = a + b;
        bv = x - a;
        y = b - bv;
        if (y) {
          g[count++] = y;
        }
        _x = q1 + x;
        _bv = _x - q1;
        _av = _x - _bv;
        _br = x - _bv;
        _ar = q1 - _av;
        q0 = _ar + _br;
        q1 = _x;
        eptr += 1;
        if (eptr < ne) {
          ei = e[eptr];
        }
      }
      while (fptr < nf) {
        a = fi;
        b = q0;
        x = a + b;
        bv = x - a;
        y = b - bv;
        if (y) {
          g[count++] = y;
        }
        _x = q1 + x;
        _bv = _x - q1;
        _av = _x - _bv;
        _br = x - _bv;
        _ar = q1 - _av;
        q0 = _ar + _br;
        q1 = _x;
        fptr += 1;
        if (fptr < nf) {
          fi = -f[fptr];
        }
      }
      if (q0) {
        g[count++] = q0;
      }
      if (q1) {
        g[count++] = q1;
      }
      if (!count) {
        g[count++] = 0;
      }
      g.length = count;
      return g;
    }
  }
});

// node_modules/robust-orientation/orientation.js
var require_orientation = __commonJS({
  "node_modules/robust-orientation/orientation.js"(exports, module) {
    "use strict";
    var twoProduct = require_two_product();
    var robustSum = require_robust_sum();
    var robustScale = require_robust_scale();
    var robustSubtract = require_robust_diff();
    var NUM_EXPAND = 5;
    var EPSILON = 11102230246251565e-32;
    var ERRBOUND3 = (3 + 16 * EPSILON) * EPSILON;
    var ERRBOUND4 = (7 + 56 * EPSILON) * EPSILON;
    function orientation_3(sum, prod, scale2, sub) {
      return function orientation3Exact2(m0, m1, m2) {
        var p = sum(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])));
        var n = sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0]));
        var d = sub(p, n);
        return d[d.length - 1];
      };
    }
    function orientation_4(sum, prod, scale2, sub) {
      return function orientation4Exact2(m0, m1, m2, m3) {
        var p = sum(sum(scale2(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m1[2]), sum(scale2(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), -m2[2]), scale2(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m3[2]))), sum(scale2(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), m0[2]), sum(scale2(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), -m1[2]), scale2(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m3[2]))));
        var n = sum(sum(scale2(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m0[2]), sum(scale2(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), -m2[2]), scale2(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), m3[2]))), sum(scale2(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m0[2]), sum(scale2(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), -m1[2]), scale2(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m2[2]))));
        var d = sub(p, n);
        return d[d.length - 1];
      };
    }
    function orientation_5(sum, prod, scale2, sub) {
      return function orientation5Exact(m0, m1, m2, m3, m4) {
        var p = sum(sum(sum(scale2(sum(scale2(sum(prod(m3[1], m4[0]), prod(-m4[1], m3[0])), m2[2]), sum(scale2(sum(prod(m2[1], m4[0]), prod(-m4[1], m2[0])), -m3[2]), scale2(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m4[2]))), m1[3]), sum(scale2(sum(scale2(sum(prod(m3[1], m4[0]), prod(-m4[1], m3[0])), m1[2]), sum(scale2(sum(prod(m1[1], m4[0]), prod(-m4[1], m1[0])), -m3[2]), scale2(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), m4[2]))), -m2[3]), scale2(sum(scale2(sum(prod(m2[1], m4[0]), prod(-m4[1], m2[0])), m1[2]), sum(scale2(sum(prod(m1[1], m4[0]), prod(-m4[1], m1[0])), -m2[2]), scale2(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m4[2]))), m3[3]))), sum(scale2(sum(scale2(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m1[2]), sum(scale2(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), -m2[2]), scale2(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m3[2]))), -m4[3]), sum(scale2(sum(scale2(sum(prod(m3[1], m4[0]), prod(-m4[1], m3[0])), m1[2]), sum(scale2(sum(prod(m1[1], m4[0]), prod(-m4[1], m1[0])), -m3[2]), scale2(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), m4[2]))), m0[3]), scale2(sum(scale2(sum(prod(m3[1], m4[0]), prod(-m4[1], m3[0])), m0[2]), sum(scale2(sum(prod(m0[1], m4[0]), prod(-m4[1], m0[0])), -m3[2]), scale2(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), m4[2]))), -m1[3])))), sum(sum(scale2(sum(scale2(sum(prod(m1[1], m4[0]), prod(-m4[1], m1[0])), m0[2]), sum(scale2(sum(prod(m0[1], m4[0]), prod(-m4[1], m0[0])), -m1[2]), scale2(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m4[2]))), m3[3]), sum(scale2(sum(scale2(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), m0[2]), sum(scale2(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), -m1[2]), scale2(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m3[2]))), -m4[3]), scale2(sum(scale2(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m1[2]), sum(scale2(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), -m2[2]), scale2(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m3[2]))), m0[3]))), sum(scale2(sum(scale2(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m0[2]), sum(scale2(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), -m2[2]), scale2(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), m3[2]))), -m1[3]), sum(scale2(sum(scale2(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), m0[2]), sum(scale2(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), -m1[2]), scale2(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m3[2]))), m2[3]), scale2(sum(scale2(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m0[2]), sum(scale2(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), -m1[2]), scale2(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m2[2]))), -m3[3])))));
        var n = sum(sum(sum(scale2(sum(scale2(sum(prod(m3[1], m4[0]), prod(-m4[1], m3[0])), m2[2]), sum(scale2(sum(prod(m2[1], m4[0]), prod(-m4[1], m2[0])), -m3[2]), scale2(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m4[2]))), m0[3]), scale2(sum(scale2(sum(prod(m3[1], m4[0]), prod(-m4[1], m3[0])), m0[2]), sum(scale2(sum(prod(m0[1], m4[0]), prod(-m4[1], m0[0])), -m3[2]), scale2(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), m4[2]))), -m2[3])), sum(scale2(sum(scale2(sum(prod(m2[1], m4[0]), prod(-m4[1], m2[0])), m0[2]), sum(scale2(sum(prod(m0[1], m4[0]), prod(-m4[1], m0[0])), -m2[2]), scale2(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), m4[2]))), m3[3]), scale2(sum(scale2(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m0[2]), sum(scale2(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), -m2[2]), scale2(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), m3[2]))), -m4[3]))), sum(sum(scale2(sum(scale2(sum(prod(m2[1], m4[0]), prod(-m4[1], m2[0])), m1[2]), sum(scale2(sum(prod(m1[1], m4[0]), prod(-m4[1], m1[0])), -m2[2]), scale2(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m4[2]))), m0[3]), scale2(sum(scale2(sum(prod(m2[1], m4[0]), prod(-m4[1], m2[0])), m0[2]), sum(scale2(sum(prod(m0[1], m4[0]), prod(-m4[1], m0[0])), -m2[2]), scale2(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), m4[2]))), -m1[3])), sum(scale2(sum(scale2(sum(prod(m1[1], m4[0]), prod(-m4[1], m1[0])), m0[2]), sum(scale2(sum(prod(m0[1], m4[0]), prod(-m4[1], m0[0])), -m1[2]), scale2(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m4[2]))), m2[3]), scale2(sum(scale2(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m0[2]), sum(scale2(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), -m1[2]), scale2(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m2[2]))), -m4[3]))));
        var d = sub(p, n);
        return d[d.length - 1];
      };
    }
    function orientation2(n) {
      var fn = n === 3 ? orientation_3 : n === 4 ? orientation_4 : orientation_5;
      return fn(robustSum, twoProduct, robustScale, robustSubtract);
    }
    var orientation3Exact = orientation2(3);
    var orientation4Exact = orientation2(4);
    var CACHED = [
      function orientation0() {
        return 0;
      },
      function orientation1() {
        return 0;
      },
      function orientation22(a, b) {
        return b[0] - a[0];
      },
      function orientation3(a, b, c) {
        var l = (a[1] - c[1]) * (b[0] - c[0]);
        var r = (a[0] - c[0]) * (b[1] - c[1]);
        var det = l - r;
        var s;
        if (l > 0) {
          if (r <= 0) {
            return det;
          } else {
            s = l + r;
          }
        } else if (l < 0) {
          if (r >= 0) {
            return det;
          } else {
            s = -(l + r);
          }
        } else {
          return det;
        }
        var tol = ERRBOUND3 * s;
        if (det >= tol || det <= -tol) {
          return det;
        }
        return orientation3Exact(a, b, c);
      },
      function orientation4(a, b, c, d) {
        var adx = a[0] - d[0];
        var bdx = b[0] - d[0];
        var cdx = c[0] - d[0];
        var ady = a[1] - d[1];
        var bdy = b[1] - d[1];
        var cdy = c[1] - d[1];
        var adz = a[2] - d[2];
        var bdz = b[2] - d[2];
        var cdz = c[2] - d[2];
        var bdxcdy = bdx * cdy;
        var cdxbdy = cdx * bdy;
        var cdxady = cdx * ady;
        var adxcdy = adx * cdy;
        var adxbdy = adx * bdy;
        var bdxady = bdx * ady;
        var det = adz * (bdxcdy - cdxbdy) + bdz * (cdxady - adxcdy) + cdz * (adxbdy - bdxady);
        var permanent = (Math.abs(bdxcdy) + Math.abs(cdxbdy)) * Math.abs(adz) + (Math.abs(cdxady) + Math.abs(adxcdy)) * Math.abs(bdz) + (Math.abs(adxbdy) + Math.abs(bdxady)) * Math.abs(cdz);
        var tol = ERRBOUND4 * permanent;
        if (det > tol || -det > tol) {
          return det;
        }
        return orientation4Exact(a, b, c, d);
      }
    ];
    function slowOrient(args) {
      var proc2 = CACHED[args.length];
      if (!proc2) {
        proc2 = CACHED[args.length] = orientation2(args.length);
      }
      return proc2.apply(void 0, args);
    }
    function proc(slow, o0, o1, o2, o3, o4, o5) {
      return function getOrientation(a0, a1, a2, a3, a4) {
        switch (arguments.length) {
          case 0:
          case 1:
            return 0;
          case 2:
            return o2(a0, a1);
          case 3:
            return o3(a0, a1, a2);
          case 4:
            return o4(a0, a1, a2, a3);
          case 5:
            return o5(a0, a1, a2, a3, a4);
        }
        var s = new Array(arguments.length);
        for (var i = 0; i < arguments.length; ++i) {
          s[i] = arguments[i];
        }
        return slow(s);
      };
    }
    function generateOrientationProc() {
      while (CACHED.length <= NUM_EXPAND) {
        CACHED.push(orientation2(CACHED.length));
      }
      module.exports = proc.apply(void 0, [slowOrient].concat(CACHED));
      for (var i = 0; i <= NUM_EXPAND; ++i) {
        module.exports[i] = CACHED[i];
      }
    }
    generateOrientationProc();
  }
});

// node_modules/cdt2d/lib/monotone.js
var require_monotone = __commonJS({
  "node_modules/cdt2d/lib/monotone.js"(exports, module) {
    "use strict";
    var bsearch = require_search_bounds();
    var orient = require_orientation()[3];
    var EVENT_POINT = 0;
    var EVENT_END = 1;
    var EVENT_START = 2;
    module.exports = monotoneTriangulate;
    function PartialHull(a, b, idx, lowerIds, upperIds) {
      this.a = a;
      this.b = b;
      this.idx = idx;
      this.lowerIds = lowerIds;
      this.upperIds = upperIds;
    }
    function Event(a, b, type, idx) {
      this.a = a;
      this.b = b;
      this.type = type;
      this.idx = idx;
    }
    function compareEvent(a, b) {
      var d = a.a[0] - b.a[0] || a.a[1] - b.a[1] || a.type - b.type;
      if (d) {
        return d;
      }
      if (a.type !== EVENT_POINT) {
        d = orient(a.a, a.b, b.b);
        if (d) {
          return d;
        }
      }
      return a.idx - b.idx;
    }
    function testPoint(hull, p) {
      return orient(hull.a, hull.b, p);
    }
    function addPoint(cells, hulls, points, p, idx) {
      var lo = bsearch.lt(hulls, p, testPoint);
      var hi = bsearch.gt(hulls, p, testPoint);
      for (var i = lo; i < hi; ++i) {
        var hull = hulls[i];
        var lowerIds = hull.lowerIds;
        var m = lowerIds.length;
        while (m > 1 && orient(
          points[lowerIds[m - 2]],
          points[lowerIds[m - 1]],
          p
        ) > 0) {
          cells.push(
            [
              lowerIds[m - 1],
              lowerIds[m - 2],
              idx
            ]
          );
          m -= 1;
        }
        lowerIds.length = m;
        lowerIds.push(idx);
        var upperIds = hull.upperIds;
        var m = upperIds.length;
        while (m > 1 && orient(
          points[upperIds[m - 2]],
          points[upperIds[m - 1]],
          p
        ) < 0) {
          cells.push(
            [
              upperIds[m - 2],
              upperIds[m - 1],
              idx
            ]
          );
          m -= 1;
        }
        upperIds.length = m;
        upperIds.push(idx);
      }
    }
    function findSplit(hull, edge) {
      var d;
      if (hull.a[0] < edge.a[0]) {
        d = orient(hull.a, hull.b, edge.a);
      } else {
        d = orient(edge.b, edge.a, hull.a);
      }
      if (d) {
        return d;
      }
      if (edge.b[0] < hull.b[0]) {
        d = orient(hull.a, hull.b, edge.b);
      } else {
        d = orient(edge.b, edge.a, hull.b);
      }
      return d || hull.idx - edge.idx;
    }
    function splitHulls(hulls, points, event) {
      var splitIdx = bsearch.le(hulls, event, findSplit);
      var hull = hulls[splitIdx];
      var upperIds = hull.upperIds;
      var x = upperIds[upperIds.length - 1];
      hull.upperIds = [x];
      hulls.splice(
        splitIdx + 1,
        0,
        new PartialHull(event.a, event.b, event.idx, [x], upperIds)
      );
    }
    function mergeHulls(hulls, points, event) {
      var tmp = event.a;
      event.a = event.b;
      event.b = tmp;
      var mergeIdx = bsearch.eq(hulls, event, findSplit);
      var upper = hulls[mergeIdx];
      var lower = hulls[mergeIdx - 1];
      lower.upperIds = upper.upperIds;
      hulls.splice(mergeIdx, 1);
    }
    function monotoneTriangulate(points, edges) {
      var numPoints = points.length;
      var numEdges = edges.length;
      var events = [];
      for (var i = 0; i < numPoints; ++i) {
        events.push(new Event(
          points[i],
          null,
          EVENT_POINT,
          i
        ));
      }
      for (var i = 0; i < numEdges; ++i) {
        var e = edges[i];
        var a = points[e[0]];
        var b = points[e[1]];
        if (a[0] < b[0]) {
          events.push(
            new Event(a, b, EVENT_START, i),
            new Event(b, a, EVENT_END, i)
          );
        } else if (a[0] > b[0]) {
          events.push(
            new Event(b, a, EVENT_START, i),
            new Event(a, b, EVENT_END, i)
          );
        }
      }
      events.sort(compareEvent);
      var minX = events[0].a[0] - (1 + Math.abs(events[0].a[0])) * Math.pow(2, -52);
      var hull = [new PartialHull([minX, 1], [minX, 0], -1, [], [], [], [])];
      var cells = [];
      for (var i = 0, numEvents = events.length; i < numEvents; ++i) {
        var event = events[i];
        var type = event.type;
        if (type === EVENT_POINT) {
          addPoint(cells, hull, points, event.a, event.idx);
        } else if (type === EVENT_START) {
          splitHulls(hull, points, event);
        } else {
          mergeHulls(hull, points, event);
        }
      }
      return cells;
    }
  }
});

// node_modules/cdt2d/lib/triangulation.js
var require_triangulation = __commonJS({
  "node_modules/cdt2d/lib/triangulation.js"(exports, module) {
    "use strict";
    var bsearch = require_search_bounds();
    module.exports = createTriangulation;
    function Triangulation(stars, edges) {
      this.stars = stars;
      this.edges = edges;
    }
    var proto = Triangulation.prototype;
    function removePair(list, j, k) {
      for (var i = 1, n = list.length; i < n; i += 2) {
        if (list[i - 1] === j && list[i] === k) {
          list[i - 1] = list[n - 2];
          list[i] = list[n - 1];
          list.length = n - 2;
          return;
        }
      }
    }
    proto.isConstraint = /* @__PURE__ */ (function() {
      var e = [0, 0];
      function compareLex(a, b) {
        return a[0] - b[0] || a[1] - b[1];
      }
      return function(i, j) {
        e[0] = Math.min(i, j);
        e[1] = Math.max(i, j);
        return bsearch.eq(this.edges, e, compareLex) >= 0;
      };
    })();
    proto.removeTriangle = function(i, j, k) {
      var stars = this.stars;
      removePair(stars[i], j, k);
      removePair(stars[j], k, i);
      removePair(stars[k], i, j);
    };
    proto.addTriangle = function(i, j, k) {
      var stars = this.stars;
      stars[i].push(j, k);
      stars[j].push(k, i);
      stars[k].push(i, j);
    };
    proto.opposite = function(j, i) {
      var list = this.stars[i];
      for (var k = 1, n = list.length; k < n; k += 2) {
        if (list[k] === j) {
          return list[k - 1];
        }
      }
      return -1;
    };
    proto.flip = function(i, j) {
      var a = this.opposite(i, j);
      var b = this.opposite(j, i);
      this.removeTriangle(i, j, a);
      this.removeTriangle(j, i, b);
      this.addTriangle(i, b, a);
      this.addTriangle(j, a, b);
    };
    proto.edges = function() {
      var stars = this.stars;
      var result = [];
      for (var i = 0, n = stars.length; i < n; ++i) {
        var list = stars[i];
        for (var j = 0, m = list.length; j < m; j += 2) {
          result.push([list[j], list[j + 1]]);
        }
      }
      return result;
    };
    proto.cells = function() {
      var stars = this.stars;
      var result = [];
      for (var i = 0, n = stars.length; i < n; ++i) {
        var list = stars[i];
        for (var j = 0, m = list.length; j < m; j += 2) {
          var s = list[j];
          var t = list[j + 1];
          if (i < Math.min(s, t)) {
            result.push([i, s, t]);
          }
        }
      }
      return result;
    };
    function createTriangulation(numVerts, edges) {
      var stars = new Array(numVerts);
      for (var i = 0; i < numVerts; ++i) {
        stars[i] = [];
      }
      return new Triangulation(stars, edges);
    }
  }
});

// node_modules/robust-in-sphere/in-sphere.js
var require_in_sphere = __commonJS({
  "node_modules/robust-in-sphere/in-sphere.js"(exports, module) {
    "use strict";
    var twoProduct = require_two_product();
    var robustSum = require_robust_sum();
    var robustDiff = require_robust_diff();
    var robustScale = require_robust_scale();
    var NUM_EXPAND = 6;
    function orientation2(n) {
      var fn = n === 3 ? inSphere3 : n === 4 ? inSphere4 : n === 5 ? inSphere5 : inSphere6;
      return fn(robustSum, robustDiff, twoProduct, robustScale);
    }
    function inSphere0() {
      return 0;
    }
    function inSphere1() {
      return 0;
    }
    function inSphere2() {
      return 0;
    }
    function inSphere3(sum, diff, prod, scale2) {
      function exactInSphere3(m0, m1, m2) {
        var w0 = prod(m0[0], m0[0]);
        var w0m1 = scale2(w0, m1[0]);
        var w0m2 = scale2(w0, m2[0]);
        var w1 = prod(m1[0], m1[0]);
        var w1m0 = scale2(w1, m0[0]);
        var w1m2 = scale2(w1, m2[0]);
        var w2 = prod(m2[0], m2[0]);
        var w2m0 = scale2(w2, m0[0]);
        var w2m1 = scale2(w2, m1[0]);
        var p = sum(diff(w2m1, w1m2), diff(w1m0, w0m1));
        var n = diff(w2m0, w0m2);
        var d = diff(p, n);
        return d[d.length - 1];
      }
      return exactInSphere3;
    }
    function inSphere4(sum, diff, prod, scale2) {
      function exactInSphere4(m0, m1, m2, m3) {
        var w0 = sum(prod(m0[0], m0[0]), prod(m0[1], m0[1]));
        var w0m1 = scale2(w0, m1[0]);
        var w0m2 = scale2(w0, m2[0]);
        var w0m3 = scale2(w0, m3[0]);
        var w1 = sum(prod(m1[0], m1[0]), prod(m1[1], m1[1]));
        var w1m0 = scale2(w1, m0[0]);
        var w1m2 = scale2(w1, m2[0]);
        var w1m3 = scale2(w1, m3[0]);
        var w2 = sum(prod(m2[0], m2[0]), prod(m2[1], m2[1]));
        var w2m0 = scale2(w2, m0[0]);
        var w2m1 = scale2(w2, m1[0]);
        var w2m3 = scale2(w2, m3[0]);
        var w3 = sum(prod(m3[0], m3[0]), prod(m3[1], m3[1]));
        var w3m0 = scale2(w3, m0[0]);
        var w3m1 = scale2(w3, m1[0]);
        var w3m2 = scale2(w3, m2[0]);
        var p = sum(sum(scale2(diff(w3m2, w2m3), m1[1]), sum(scale2(diff(w3m1, w1m3), -m2[1]), scale2(diff(w2m1, w1m2), m3[1]))), sum(scale2(diff(w3m1, w1m3), m0[1]), sum(scale2(diff(w3m0, w0m3), -m1[1]), scale2(diff(w1m0, w0m1), m3[1]))));
        var n = sum(sum(scale2(diff(w3m2, w2m3), m0[1]), sum(scale2(diff(w3m0, w0m3), -m2[1]), scale2(diff(w2m0, w0m2), m3[1]))), sum(scale2(diff(w2m1, w1m2), m0[1]), sum(scale2(diff(w2m0, w0m2), -m1[1]), scale2(diff(w1m0, w0m1), m2[1]))));
        var d = diff(p, n);
        return d[d.length - 1];
      }
      return exactInSphere4;
    }
    function inSphere5(sum, diff, prod, scale2) {
      function exactInSphere5(m0, m1, m2, m3, m4) {
        var w0 = sum(prod(m0[0], m0[0]), sum(prod(m0[1], m0[1]), prod(m0[2], m0[2])));
        var w0m1 = scale2(w0, m1[0]);
        var w0m2 = scale2(w0, m2[0]);
        var w0m3 = scale2(w0, m3[0]);
        var w0m4 = scale2(w0, m4[0]);
        var w1 = sum(prod(m1[0], m1[0]), sum(prod(m1[1], m1[1]), prod(m1[2], m1[2])));
        var w1m0 = scale2(w1, m0[0]);
        var w1m2 = scale2(w1, m2[0]);
        var w1m3 = scale2(w1, m3[0]);
        var w1m4 = scale2(w1, m4[0]);
        var w2 = sum(prod(m2[0], m2[0]), sum(prod(m2[1], m2[1]), prod(m2[2], m2[2])));
        var w2m0 = scale2(w2, m0[0]);
        var w2m1 = scale2(w2, m1[0]);
        var w2m3 = scale2(w2, m3[0]);
        var w2m4 = scale2(w2, m4[0]);
        var w3 = sum(prod(m3[0], m3[0]), sum(prod(m3[1], m3[1]), prod(m3[2], m3[2])));
        var w3m0 = scale2(w3, m0[0]);
        var w3m1 = scale2(w3, m1[0]);
        var w3m2 = scale2(w3, m2[0]);
        var w3m4 = scale2(w3, m4[0]);
        var w4 = sum(prod(m4[0], m4[0]), sum(prod(m4[1], m4[1]), prod(m4[2], m4[2])));
        var w4m0 = scale2(w4, m0[0]);
        var w4m1 = scale2(w4, m1[0]);
        var w4m2 = scale2(w4, m2[0]);
        var w4m3 = scale2(w4, m3[0]);
        var p = sum(sum(sum(scale2(sum(scale2(diff(w4m3, w3m4), m2[1]), sum(scale2(diff(w4m2, w2m4), -m3[1]), scale2(diff(w3m2, w2m3), m4[1]))), m1[2]), sum(scale2(sum(scale2(diff(w4m3, w3m4), m1[1]), sum(scale2(diff(w4m1, w1m4), -m3[1]), scale2(diff(w3m1, w1m3), m4[1]))), -m2[2]), scale2(sum(scale2(diff(w4m2, w2m4), m1[1]), sum(scale2(diff(w4m1, w1m4), -m2[1]), scale2(diff(w2m1, w1m2), m4[1]))), m3[2]))), sum(scale2(sum(scale2(diff(w3m2, w2m3), m1[1]), sum(scale2(diff(w3m1, w1m3), -m2[1]), scale2(diff(w2m1, w1m2), m3[1]))), -m4[2]), sum(scale2(sum(scale2(diff(w4m3, w3m4), m1[1]), sum(scale2(diff(w4m1, w1m4), -m3[1]), scale2(diff(w3m1, w1m3), m4[1]))), m0[2]), scale2(sum(scale2(diff(w4m3, w3m4), m0[1]), sum(scale2(diff(w4m0, w0m4), -m3[1]), scale2(diff(w3m0, w0m3), m4[1]))), -m1[2])))), sum(sum(scale2(sum(scale2(diff(w4m1, w1m4), m0[1]), sum(scale2(diff(w4m0, w0m4), -m1[1]), scale2(diff(w1m0, w0m1), m4[1]))), m3[2]), sum(scale2(sum(scale2(diff(w3m1, w1m3), m0[1]), sum(scale2(diff(w3m0, w0m3), -m1[1]), scale2(diff(w1m0, w0m1), m3[1]))), -m4[2]), scale2(sum(scale2(diff(w3m2, w2m3), m1[1]), sum(scale2(diff(w3m1, w1m3), -m2[1]), scale2(diff(w2m1, w1m2), m3[1]))), m0[2]))), sum(scale2(sum(scale2(diff(w3m2, w2m3), m0[1]), sum(scale2(diff(w3m0, w0m3), -m2[1]), scale2(diff(w2m0, w0m2), m3[1]))), -m1[2]), sum(scale2(sum(scale2(diff(w3m1, w1m3), m0[1]), sum(scale2(diff(w3m0, w0m3), -m1[1]), scale2(diff(w1m0, w0m1), m3[1]))), m2[2]), scale2(sum(scale2(diff(w2m1, w1m2), m0[1]), sum(scale2(diff(w2m0, w0m2), -m1[1]), scale2(diff(w1m0, w0m1), m2[1]))), -m3[2])))));
        var n = sum(sum(sum(scale2(sum(scale2(diff(w4m3, w3m4), m2[1]), sum(scale2(diff(w4m2, w2m4), -m3[1]), scale2(diff(w3m2, w2m3), m4[1]))), m0[2]), scale2(sum(scale2(diff(w4m3, w3m4), m0[1]), sum(scale2(diff(w4m0, w0m4), -m3[1]), scale2(diff(w3m0, w0m3), m4[1]))), -m2[2])), sum(scale2(sum(scale2(diff(w4m2, w2m4), m0[1]), sum(scale2(diff(w4m0, w0m4), -m2[1]), scale2(diff(w2m0, w0m2), m4[1]))), m3[2]), scale2(sum(scale2(diff(w3m2, w2m3), m0[1]), sum(scale2(diff(w3m0, w0m3), -m2[1]), scale2(diff(w2m0, w0m2), m3[1]))), -m4[2]))), sum(sum(scale2(sum(scale2(diff(w4m2, w2m4), m1[1]), sum(scale2(diff(w4m1, w1m4), -m2[1]), scale2(diff(w2m1, w1m2), m4[1]))), m0[2]), scale2(sum(scale2(diff(w4m2, w2m4), m0[1]), sum(scale2(diff(w4m0, w0m4), -m2[1]), scale2(diff(w2m0, w0m2), m4[1]))), -m1[2])), sum(scale2(sum(scale2(diff(w4m1, w1m4), m0[1]), sum(scale2(diff(w4m0, w0m4), -m1[1]), scale2(diff(w1m0, w0m1), m4[1]))), m2[2]), scale2(sum(scale2(diff(w2m1, w1m2), m0[1]), sum(scale2(diff(w2m0, w0m2), -m1[1]), scale2(diff(w1m0, w0m1), m2[1]))), -m4[2]))));
        var d = diff(p, n);
        return d[d.length - 1];
      }
      return exactInSphere5;
    }
    function inSphere6(sum, diff, prod, scale2) {
      function exactInSphere6(m0, m1, m2, m3, m4, m5) {
        var w0 = sum(sum(prod(m0[0], m0[0]), prod(m0[1], m0[1])), sum(prod(m0[2], m0[2]), prod(m0[3], m0[3])));
        var w0m1 = scale2(w0, m1[0]);
        var w0m2 = scale2(w0, m2[0]);
        var w0m3 = scale2(w0, m3[0]);
        var w0m4 = scale2(w0, m4[0]);
        var w0m5 = scale2(w0, m5[0]);
        var w1 = sum(sum(prod(m1[0], m1[0]), prod(m1[1], m1[1])), sum(prod(m1[2], m1[2]), prod(m1[3], m1[3])));
        var w1m0 = scale2(w1, m0[0]);
        var w1m2 = scale2(w1, m2[0]);
        var w1m3 = scale2(w1, m3[0]);
        var w1m4 = scale2(w1, m4[0]);
        var w1m5 = scale2(w1, m5[0]);
        var w2 = sum(sum(prod(m2[0], m2[0]), prod(m2[1], m2[1])), sum(prod(m2[2], m2[2]), prod(m2[3], m2[3])));
        var w2m0 = scale2(w2, m0[0]);
        var w2m1 = scale2(w2, m1[0]);
        var w2m3 = scale2(w2, m3[0]);
        var w2m4 = scale2(w2, m4[0]);
        var w2m5 = scale2(w2, m5[0]);
        var w3 = sum(sum(prod(m3[0], m3[0]), prod(m3[1], m3[1])), sum(prod(m3[2], m3[2]), prod(m3[3], m3[3])));
        var w3m0 = scale2(w3, m0[0]);
        var w3m1 = scale2(w3, m1[0]);
        var w3m2 = scale2(w3, m2[0]);
        var w3m4 = scale2(w3, m4[0]);
        var w3m5 = scale2(w3, m5[0]);
        var w4 = sum(sum(prod(m4[0], m4[0]), prod(m4[1], m4[1])), sum(prod(m4[2], m4[2]), prod(m4[3], m4[3])));
        var w4m0 = scale2(w4, m0[0]);
        var w4m1 = scale2(w4, m1[0]);
        var w4m2 = scale2(w4, m2[0]);
        var w4m3 = scale2(w4, m3[0]);
        var w4m5 = scale2(w4, m5[0]);
        var w5 = sum(sum(prod(m5[0], m5[0]), prod(m5[1], m5[1])), sum(prod(m5[2], m5[2]), prod(m5[3], m5[3])));
        var w5m0 = scale2(w5, m0[0]);
        var w5m1 = scale2(w5, m1[0]);
        var w5m2 = scale2(w5, m2[0]);
        var w5m3 = scale2(w5, m3[0]);
        var w5m4 = scale2(w5, m4[0]);
        var p = sum(sum(sum(scale2(sum(sum(scale2(sum(scale2(diff(w5m4, w4m5), m3[1]), sum(scale2(diff(w5m3, w3m5), -m4[1]), scale2(diff(w4m3, w3m4), m5[1]))), m2[2]), scale2(sum(scale2(diff(w5m4, w4m5), m2[1]), sum(scale2(diff(w5m2, w2m5), -m4[1]), scale2(diff(w4m2, w2m4), m5[1]))), -m3[2])), sum(scale2(sum(scale2(diff(w5m3, w3m5), m2[1]), sum(scale2(diff(w5m2, w2m5), -m3[1]), scale2(diff(w3m2, w2m3), m5[1]))), m4[2]), scale2(sum(scale2(diff(w4m3, w3m4), m2[1]), sum(scale2(diff(w4m2, w2m4), -m3[1]), scale2(diff(w3m2, w2m3), m4[1]))), -m5[2]))), m1[3]), sum(scale2(sum(sum(scale2(sum(scale2(diff(w5m4, w4m5), m3[1]), sum(scale2(diff(w5m3, w3m5), -m4[1]), scale2(diff(w4m3, w3m4), m5[1]))), m1[2]), scale2(sum(scale2(diff(w5m4, w4m5), m1[1]), sum(scale2(diff(w5m1, w1m5), -m4[1]), scale2(diff(w4m1, w1m4), m5[1]))), -m3[2])), sum(scale2(sum(scale2(diff(w5m3, w3m5), m1[1]), sum(scale2(diff(w5m1, w1m5), -m3[1]), scale2(diff(w3m1, w1m3), m5[1]))), m4[2]), scale2(sum(scale2(diff(w4m3, w3m4), m1[1]), sum(scale2(diff(w4m1, w1m4), -m3[1]), scale2(diff(w3m1, w1m3), m4[1]))), -m5[2]))), -m2[3]), scale2(sum(sum(scale2(sum(scale2(diff(w5m4, w4m5), m2[1]), sum(scale2(diff(w5m2, w2m5), -m4[1]), scale2(diff(w4m2, w2m4), m5[1]))), m1[2]), scale2(sum(scale2(diff(w5m4, w4m5), m1[1]), sum(scale2(diff(w5m1, w1m5), -m4[1]), scale2(diff(w4m1, w1m4), m5[1]))), -m2[2])), sum(scale2(sum(scale2(diff(w5m2, w2m5), m1[1]), sum(scale2(diff(w5m1, w1m5), -m2[1]), scale2(diff(w2m1, w1m2), m5[1]))), m4[2]), scale2(sum(scale2(diff(w4m2, w2m4), m1[1]), sum(scale2(diff(w4m1, w1m4), -m2[1]), scale2(diff(w2m1, w1m2), m4[1]))), -m5[2]))), m3[3]))), sum(sum(scale2(sum(sum(scale2(sum(scale2(diff(w5m3, w3m5), m2[1]), sum(scale2(diff(w5m2, w2m5), -m3[1]), scale2(diff(w3m2, w2m3), m5[1]))), m1[2]), scale2(sum(scale2(diff(w5m3, w3m5), m1[1]), sum(scale2(diff(w5m1, w1m5), -m3[1]), scale2(diff(w3m1, w1m3), m5[1]))), -m2[2])), sum(scale2(sum(scale2(diff(w5m2, w2m5), m1[1]), sum(scale2(diff(w5m1, w1m5), -m2[1]), scale2(diff(w2m1, w1m2), m5[1]))), m3[2]), scale2(sum(scale2(diff(w3m2, w2m3), m1[1]), sum(scale2(diff(w3m1, w1m3), -m2[1]), scale2(diff(w2m1, w1m2), m3[1]))), -m5[2]))), -m4[3]), scale2(sum(sum(scale2(sum(scale2(diff(w4m3, w3m4), m2[1]), sum(scale2(diff(w4m2, w2m4), -m3[1]), scale2(diff(w3m2, w2m3), m4[1]))), m1[2]), scale2(sum(scale2(diff(w4m3, w3m4), m1[1]), sum(scale2(diff(w4m1, w1m4), -m3[1]), scale2(diff(w3m1, w1m3), m4[1]))), -m2[2])), sum(scale2(sum(scale2(diff(w4m2, w2m4), m1[1]), sum(scale2(diff(w4m1, w1m4), -m2[1]), scale2(diff(w2m1, w1m2), m4[1]))), m3[2]), scale2(sum(scale2(diff(w3m2, w2m3), m1[1]), sum(scale2(diff(w3m1, w1m3), -m2[1]), scale2(diff(w2m1, w1m2), m3[1]))), -m4[2]))), m5[3])), sum(scale2(sum(sum(scale2(sum(scale2(diff(w5m4, w4m5), m3[1]), sum(scale2(diff(w5m3, w3m5), -m4[1]), scale2(diff(w4m3, w3m4), m5[1]))), m1[2]), scale2(sum(scale2(diff(w5m4, w4m5), m1[1]), sum(scale2(diff(w5m1, w1m5), -m4[1]), scale2(diff(w4m1, w1m4), m5[1]))), -m3[2])), sum(scale2(sum(scale2(diff(w5m3, w3m5), m1[1]), sum(scale2(diff(w5m1, w1m5), -m3[1]), scale2(diff(w3m1, w1m3), m5[1]))), m4[2]), scale2(sum(scale2(diff(w4m3, w3m4), m1[1]), sum(scale2(diff(w4m1, w1m4), -m3[1]), scale2(diff(w3m1, w1m3), m4[1]))), -m5[2]))), m0[3]), scale2(sum(sum(scale2(sum(scale2(diff(w5m4, w4m5), m3[1]), sum(scale2(diff(w5m3, w3m5), -m4[1]), scale2(diff(w4m3, w3m4), m5[1]))), m0[2]), scale2(sum(scale2(diff(w5m4, w4m5), m0[1]), sum(scale2(diff(w5m0, w0m5), -m4[1]), scale2(diff(w4m0, w0m4), m5[1]))), -m3[2])), sum(scale2(sum(scale2(diff(w5m3, w3m5), m0[1]), sum(scale2(diff(w5m0, w0m5), -m3[1]), scale2(diff(w3m0, w0m3), m5[1]))), m4[2]), scale2(sum(scale2(diff(w4m3, w3m4), m0[1]), sum(scale2(diff(w4m0, w0m4), -m3[1]), scale2(diff(w3m0, w0m3), m4[1]))), -m5[2]))), -m1[3])))), sum(sum(sum(scale2(sum(sum(scale2(sum(scale2(diff(w5m4, w4m5), m1[1]), sum(scale2(diff(w5m1, w1m5), -m4[1]), scale2(diff(w4m1, w1m4), m5[1]))), m0[2]), scale2(sum(scale2(diff(w5m4, w4m5), m0[1]), sum(scale2(diff(w5m0, w0m5), -m4[1]), scale2(diff(w4m0, w0m4), m5[1]))), -m1[2])), sum(scale2(sum(scale2(diff(w5m1, w1m5), m0[1]), sum(scale2(diff(w5m0, w0m5), -m1[1]), scale2(diff(w1m0, w0m1), m5[1]))), m4[2]), scale2(sum(scale2(diff(w4m1, w1m4), m0[1]), sum(scale2(diff(w4m0, w0m4), -m1[1]), scale2(diff(w1m0, w0m1), m4[1]))), -m5[2]))), m3[3]), scale2(sum(sum(scale2(sum(scale2(diff(w5m3, w3m5), m1[1]), sum(scale2(diff(w5m1, w1m5), -m3[1]), scale2(diff(w3m1, w1m3), m5[1]))), m0[2]), scale2(sum(scale2(diff(w5m3, w3m5), m0[1]), sum(scale2(diff(w5m0, w0m5), -m3[1]), scale2(diff(w3m0, w0m3), m5[1]))), -m1[2])), sum(scale2(sum(scale2(diff(w5m1, w1m5), m0[1]), sum(scale2(diff(w5m0, w0m5), -m1[1]), scale2(diff(w1m0, w0m1), m5[1]))), m3[2]), scale2(sum(scale2(diff(w3m1, w1m3), m0[1]), sum(scale2(diff(w3m0, w0m3), -m1[1]), scale2(diff(w1m0, w0m1), m3[1]))), -m5[2]))), -m4[3])), sum(scale2(sum(sum(scale2(sum(scale2(diff(w4m3, w3m4), m1[1]), sum(scale2(diff(w4m1, w1m4), -m3[1]), scale2(diff(w3m1, w1m3), m4[1]))), m0[2]), scale2(sum(scale2(diff(w4m3, w3m4), m0[1]), sum(scale2(diff(w4m0, w0m4), -m3[1]), scale2(diff(w3m0, w0m3), m4[1]))), -m1[2])), sum(scale2(sum(scale2(diff(w4m1, w1m4), m0[1]), sum(scale2(diff(w4m0, w0m4), -m1[1]), scale2(diff(w1m0, w0m1), m4[1]))), m3[2]), scale2(sum(scale2(diff(w3m1, w1m3), m0[1]), sum(scale2(diff(w3m0, w0m3), -m1[1]), scale2(diff(w1m0, w0m1), m3[1]))), -m4[2]))), m5[3]), scale2(sum(sum(scale2(sum(scale2(diff(w5m3, w3m5), m2[1]), sum(scale2(diff(w5m2, w2m5), -m3[1]), scale2(diff(w3m2, w2m3), m5[1]))), m1[2]), scale2(sum(scale2(diff(w5m3, w3m5), m1[1]), sum(scale2(diff(w5m1, w1m5), -m3[1]), scale2(diff(w3m1, w1m3), m5[1]))), -m2[2])), sum(scale2(sum(scale2(diff(w5m2, w2m5), m1[1]), sum(scale2(diff(w5m1, w1m5), -m2[1]), scale2(diff(w2m1, w1m2), m5[1]))), m3[2]), scale2(sum(scale2(diff(w3m2, w2m3), m1[1]), sum(scale2(diff(w3m1, w1m3), -m2[1]), scale2(diff(w2m1, w1m2), m3[1]))), -m5[2]))), m0[3]))), sum(sum(scale2(sum(sum(scale2(sum(scale2(diff(w5m3, w3m5), m2[1]), sum(scale2(diff(w5m2, w2m5), -m3[1]), scale2(diff(w3m2, w2m3), m5[1]))), m0[2]), scale2(sum(scale2(diff(w5m3, w3m5), m0[1]), sum(scale2(diff(w5m0, w0m5), -m3[1]), scale2(diff(w3m0, w0m3), m5[1]))), -m2[2])), sum(scale2(sum(scale2(diff(w5m2, w2m5), m0[1]), sum(scale2(diff(w5m0, w0m5), -m2[1]), scale2(diff(w2m0, w0m2), m5[1]))), m3[2]), scale2(sum(scale2(diff(w3m2, w2m3), m0[1]), sum(scale2(diff(w3m0, w0m3), -m2[1]), scale2(diff(w2m0, w0m2), m3[1]))), -m5[2]))), -m1[3]), scale2(sum(sum(scale2(sum(scale2(diff(w5m3, w3m5), m1[1]), sum(scale2(diff(w5m1, w1m5), -m3[1]), scale2(diff(w3m1, w1m3), m5[1]))), m0[2]), scale2(sum(scale2(diff(w5m3, w3m5), m0[1]), sum(scale2(diff(w5m0, w0m5), -m3[1]), scale2(diff(w3m0, w0m3), m5[1]))), -m1[2])), sum(scale2(sum(scale2(diff(w5m1, w1m5), m0[1]), sum(scale2(diff(w5m0, w0m5), -m1[1]), scale2(diff(w1m0, w0m1), m5[1]))), m3[2]), scale2(sum(scale2(diff(w3m1, w1m3), m0[1]), sum(scale2(diff(w3m0, w0m3), -m1[1]), scale2(diff(w1m0, w0m1), m3[1]))), -m5[2]))), m2[3])), sum(scale2(sum(sum(scale2(sum(scale2(diff(w5m2, w2m5), m1[1]), sum(scale2(diff(w5m1, w1m5), -m2[1]), scale2(diff(w2m1, w1m2), m5[1]))), m0[2]), scale2(sum(scale2(diff(w5m2, w2m5), m0[1]), sum(scale2(diff(w5m0, w0m5), -m2[1]), scale2(diff(w2m0, w0m2), m5[1]))), -m1[2])), sum(scale2(sum(scale2(diff(w5m1, w1m5), m0[1]), sum(scale2(diff(w5m0, w0m5), -m1[1]), scale2(diff(w1m0, w0m1), m5[1]))), m2[2]), scale2(sum(scale2(diff(w2m1, w1m2), m0[1]), sum(scale2(diff(w2m0, w0m2), -m1[1]), scale2(diff(w1m0, w0m1), m2[1]))), -m5[2]))), -m3[3]), scale2(sum(sum(scale2(sum(scale2(diff(w3m2, w2m3), m1[1]), sum(scale2(diff(w3m1, w1m3), -m2[1]), scale2(diff(w2m1, w1m2), m3[1]))), m0[2]), scale2(sum(scale2(diff(w3m2, w2m3), m0[1]), sum(scale2(diff(w3m0, w0m3), -m2[1]), scale2(diff(w2m0, w0m2), m3[1]))), -m1[2])), sum(scale2(sum(scale2(diff(w3m1, w1m3), m0[1]), sum(scale2(diff(w3m0, w0m3), -m1[1]), scale2(diff(w1m0, w0m1), m3[1]))), m2[2]), scale2(sum(scale2(diff(w2m1, w1m2), m0[1]), sum(scale2(diff(w2m0, w0m2), -m1[1]), scale2(diff(w1m0, w0m1), m2[1]))), -m3[2]))), m5[3])))));
        var n = sum(sum(sum(scale2(sum(sum(scale2(sum(scale2(diff(w5m4, w4m5), m3[1]), sum(scale2(diff(w5m3, w3m5), -m4[1]), scale2(diff(w4m3, w3m4), m5[1]))), m2[2]), scale2(sum(scale2(diff(w5m4, w4m5), m2[1]), sum(scale2(diff(w5m2, w2m5), -m4[1]), scale2(diff(w4m2, w2m4), m5[1]))), -m3[2])), sum(scale2(sum(scale2(diff(w5m3, w3m5), m2[1]), sum(scale2(diff(w5m2, w2m5), -m3[1]), scale2(diff(w3m2, w2m3), m5[1]))), m4[2]), scale2(sum(scale2(diff(w4m3, w3m4), m2[1]), sum(scale2(diff(w4m2, w2m4), -m3[1]), scale2(diff(w3m2, w2m3), m4[1]))), -m5[2]))), m0[3]), sum(scale2(sum(sum(scale2(sum(scale2(diff(w5m4, w4m5), m3[1]), sum(scale2(diff(w5m3, w3m5), -m4[1]), scale2(diff(w4m3, w3m4), m5[1]))), m0[2]), scale2(sum(scale2(diff(w5m4, w4m5), m0[1]), sum(scale2(diff(w5m0, w0m5), -m4[1]), scale2(diff(w4m0, w0m4), m5[1]))), -m3[2])), sum(scale2(sum(scale2(diff(w5m3, w3m5), m0[1]), sum(scale2(diff(w5m0, w0m5), -m3[1]), scale2(diff(w3m0, w0m3), m5[1]))), m4[2]), scale2(sum(scale2(diff(w4m3, w3m4), m0[1]), sum(scale2(diff(w4m0, w0m4), -m3[1]), scale2(diff(w3m0, w0m3), m4[1]))), -m5[2]))), -m2[3]), scale2(sum(sum(scale2(sum(scale2(diff(w5m4, w4m5), m2[1]), sum(scale2(diff(w5m2, w2m5), -m4[1]), scale2(diff(w4m2, w2m4), m5[1]))), m0[2]), scale2(sum(scale2(diff(w5m4, w4m5), m0[1]), sum(scale2(diff(w5m0, w0m5), -m4[1]), scale2(diff(w4m0, w0m4), m5[1]))), -m2[2])), sum(scale2(sum(scale2(diff(w5m2, w2m5), m0[1]), sum(scale2(diff(w5m0, w0m5), -m2[1]), scale2(diff(w2m0, w0m2), m5[1]))), m4[2]), scale2(sum(scale2(diff(w4m2, w2m4), m0[1]), sum(scale2(diff(w4m0, w0m4), -m2[1]), scale2(diff(w2m0, w0m2), m4[1]))), -m5[2]))), m3[3]))), sum(sum(scale2(sum(sum(scale2(sum(scale2(diff(w5m3, w3m5), m2[1]), sum(scale2(diff(w5m2, w2m5), -m3[1]), scale2(diff(w3m2, w2m3), m5[1]))), m0[2]), scale2(sum(scale2(diff(w5m3, w3m5), m0[1]), sum(scale2(diff(w5m0, w0m5), -m3[1]), scale2(diff(w3m0, w0m3), m5[1]))), -m2[2])), sum(scale2(sum(scale2(diff(w5m2, w2m5), m0[1]), sum(scale2(diff(w5m0, w0m5), -m2[1]), scale2(diff(w2m0, w0m2), m5[1]))), m3[2]), scale2(sum(scale2(diff(w3m2, w2m3), m0[1]), sum(scale2(diff(w3m0, w0m3), -m2[1]), scale2(diff(w2m0, w0m2), m3[1]))), -m5[2]))), -m4[3]), scale2(sum(sum(scale2(sum(scale2(diff(w4m3, w3m4), m2[1]), sum(scale2(diff(w4m2, w2m4), -m3[1]), scale2(diff(w3m2, w2m3), m4[1]))), m0[2]), scale2(sum(scale2(diff(w4m3, w3m4), m0[1]), sum(scale2(diff(w4m0, w0m4), -m3[1]), scale2(diff(w3m0, w0m3), m4[1]))), -m2[2])), sum(scale2(sum(scale2(diff(w4m2, w2m4), m0[1]), sum(scale2(diff(w4m0, w0m4), -m2[1]), scale2(diff(w2m0, w0m2), m4[1]))), m3[2]), scale2(sum(scale2(diff(w3m2, w2m3), m0[1]), sum(scale2(diff(w3m0, w0m3), -m2[1]), scale2(diff(w2m0, w0m2), m3[1]))), -m4[2]))), m5[3])), sum(scale2(sum(sum(scale2(sum(scale2(diff(w5m4, w4m5), m2[1]), sum(scale2(diff(w5m2, w2m5), -m4[1]), scale2(diff(w4m2, w2m4), m5[1]))), m1[2]), scale2(sum(scale2(diff(w5m4, w4m5), m1[1]), sum(scale2(diff(w5m1, w1m5), -m4[1]), scale2(diff(w4m1, w1m4), m5[1]))), -m2[2])), sum(scale2(sum(scale2(diff(w5m2, w2m5), m1[1]), sum(scale2(diff(w5m1, w1m5), -m2[1]), scale2(diff(w2m1, w1m2), m5[1]))), m4[2]), scale2(sum(scale2(diff(w4m2, w2m4), m1[1]), sum(scale2(diff(w4m1, w1m4), -m2[1]), scale2(diff(w2m1, w1m2), m4[1]))), -m5[2]))), m0[3]), scale2(sum(sum(scale2(sum(scale2(diff(w5m4, w4m5), m2[1]), sum(scale2(diff(w5m2, w2m5), -m4[1]), scale2(diff(w4m2, w2m4), m5[1]))), m0[2]), scale2(sum(scale2(diff(w5m4, w4m5), m0[1]), sum(scale2(diff(w5m0, w0m5), -m4[1]), scale2(diff(w4m0, w0m4), m5[1]))), -m2[2])), sum(scale2(sum(scale2(diff(w5m2, w2m5), m0[1]), sum(scale2(diff(w5m0, w0m5), -m2[1]), scale2(diff(w2m0, w0m2), m5[1]))), m4[2]), scale2(sum(scale2(diff(w4m2, w2m4), m0[1]), sum(scale2(diff(w4m0, w0m4), -m2[1]), scale2(diff(w2m0, w0m2), m4[1]))), -m5[2]))), -m1[3])))), sum(sum(sum(scale2(sum(sum(scale2(sum(scale2(diff(w5m4, w4m5), m1[1]), sum(scale2(diff(w5m1, w1m5), -m4[1]), scale2(diff(w4m1, w1m4), m5[1]))), m0[2]), scale2(sum(scale2(diff(w5m4, w4m5), m0[1]), sum(scale2(diff(w5m0, w0m5), -m4[1]), scale2(diff(w4m0, w0m4), m5[1]))), -m1[2])), sum(scale2(sum(scale2(diff(w5m1, w1m5), m0[1]), sum(scale2(diff(w5m0, w0m5), -m1[1]), scale2(diff(w1m0, w0m1), m5[1]))), m4[2]), scale2(sum(scale2(diff(w4m1, w1m4), m0[1]), sum(scale2(diff(w4m0, w0m4), -m1[1]), scale2(diff(w1m0, w0m1), m4[1]))), -m5[2]))), m2[3]), scale2(sum(sum(scale2(sum(scale2(diff(w5m2, w2m5), m1[1]), sum(scale2(diff(w5m1, w1m5), -m2[1]), scale2(diff(w2m1, w1m2), m5[1]))), m0[2]), scale2(sum(scale2(diff(w5m2, w2m5), m0[1]), sum(scale2(diff(w5m0, w0m5), -m2[1]), scale2(diff(w2m0, w0m2), m5[1]))), -m1[2])), sum(scale2(sum(scale2(diff(w5m1, w1m5), m0[1]), sum(scale2(diff(w5m0, w0m5), -m1[1]), scale2(diff(w1m0, w0m1), m5[1]))), m2[2]), scale2(sum(scale2(diff(w2m1, w1m2), m0[1]), sum(scale2(diff(w2m0, w0m2), -m1[1]), scale2(diff(w1m0, w0m1), m2[1]))), -m5[2]))), -m4[3])), sum(scale2(sum(sum(scale2(sum(scale2(diff(w4m2, w2m4), m1[1]), sum(scale2(diff(w4m1, w1m4), -m2[1]), scale2(diff(w2m1, w1m2), m4[1]))), m0[2]), scale2(sum(scale2(diff(w4m2, w2m4), m0[1]), sum(scale2(diff(w4m0, w0m4), -m2[1]), scale2(diff(w2m0, w0m2), m4[1]))), -m1[2])), sum(scale2(sum(scale2(diff(w4m1, w1m4), m0[1]), sum(scale2(diff(w4m0, w0m4), -m1[1]), scale2(diff(w1m0, w0m1), m4[1]))), m2[2]), scale2(sum(scale2(diff(w2m1, w1m2), m0[1]), sum(scale2(diff(w2m0, w0m2), -m1[1]), scale2(diff(w1m0, w0m1), m2[1]))), -m4[2]))), m5[3]), scale2(sum(sum(scale2(sum(scale2(diff(w4m3, w3m4), m2[1]), sum(scale2(diff(w4m2, w2m4), -m3[1]), scale2(diff(w3m2, w2m3), m4[1]))), m1[2]), scale2(sum(scale2(diff(w4m3, w3m4), m1[1]), sum(scale2(diff(w4m1, w1m4), -m3[1]), scale2(diff(w3m1, w1m3), m4[1]))), -m2[2])), sum(scale2(sum(scale2(diff(w4m2, w2m4), m1[1]), sum(scale2(diff(w4m1, w1m4), -m2[1]), scale2(diff(w2m1, w1m2), m4[1]))), m3[2]), scale2(sum(scale2(diff(w3m2, w2m3), m1[1]), sum(scale2(diff(w3m1, w1m3), -m2[1]), scale2(diff(w2m1, w1m2), m3[1]))), -m4[2]))), m0[3]))), sum(sum(scale2(sum(sum(scale2(sum(scale2(diff(w4m3, w3m4), m2[1]), sum(scale2(diff(w4m2, w2m4), -m3[1]), scale2(diff(w3m2, w2m3), m4[1]))), m0[2]), scale2(sum(scale2(diff(w4m3, w3m4), m0[1]), sum(scale2(diff(w4m0, w0m4), -m3[1]), scale2(diff(w3m0, w0m3), m4[1]))), -m2[2])), sum(scale2(sum(scale2(diff(w4m2, w2m4), m0[1]), sum(scale2(diff(w4m0, w0m4), -m2[1]), scale2(diff(w2m0, w0m2), m4[1]))), m3[2]), scale2(sum(scale2(diff(w3m2, w2m3), m0[1]), sum(scale2(diff(w3m0, w0m3), -m2[1]), scale2(diff(w2m0, w0m2), m3[1]))), -m4[2]))), -m1[3]), scale2(sum(sum(scale2(sum(scale2(diff(w4m3, w3m4), m1[1]), sum(scale2(diff(w4m1, w1m4), -m3[1]), scale2(diff(w3m1, w1m3), m4[1]))), m0[2]), scale2(sum(scale2(diff(w4m3, w3m4), m0[1]), sum(scale2(diff(w4m0, w0m4), -m3[1]), scale2(diff(w3m0, w0m3), m4[1]))), -m1[2])), sum(scale2(sum(scale2(diff(w4m1, w1m4), m0[1]), sum(scale2(diff(w4m0, w0m4), -m1[1]), scale2(diff(w1m0, w0m1), m4[1]))), m3[2]), scale2(sum(scale2(diff(w3m1, w1m3), m0[1]), sum(scale2(diff(w3m0, w0m3), -m1[1]), scale2(diff(w1m0, w0m1), m3[1]))), -m4[2]))), m2[3])), sum(scale2(sum(sum(scale2(sum(scale2(diff(w4m2, w2m4), m1[1]), sum(scale2(diff(w4m1, w1m4), -m2[1]), scale2(diff(w2m1, w1m2), m4[1]))), m0[2]), scale2(sum(scale2(diff(w4m2, w2m4), m0[1]), sum(scale2(diff(w4m0, w0m4), -m2[1]), scale2(diff(w2m0, w0m2), m4[1]))), -m1[2])), sum(scale2(sum(scale2(diff(w4m1, w1m4), m0[1]), sum(scale2(diff(w4m0, w0m4), -m1[1]), scale2(diff(w1m0, w0m1), m4[1]))), m2[2]), scale2(sum(scale2(diff(w2m1, w1m2), m0[1]), sum(scale2(diff(w2m0, w0m2), -m1[1]), scale2(diff(w1m0, w0m1), m2[1]))), -m4[2]))), -m3[3]), scale2(sum(sum(scale2(sum(scale2(diff(w3m2, w2m3), m1[1]), sum(scale2(diff(w3m1, w1m3), -m2[1]), scale2(diff(w2m1, w1m2), m3[1]))), m0[2]), scale2(sum(scale2(diff(w3m2, w2m3), m0[1]), sum(scale2(diff(w3m0, w0m3), -m2[1]), scale2(diff(w2m0, w0m2), m3[1]))), -m1[2])), sum(scale2(sum(scale2(diff(w3m1, w1m3), m0[1]), sum(scale2(diff(w3m0, w0m3), -m1[1]), scale2(diff(w1m0, w0m1), m3[1]))), m2[2]), scale2(sum(scale2(diff(w2m1, w1m2), m0[1]), sum(scale2(diff(w2m0, w0m2), -m1[1]), scale2(diff(w1m0, w0m1), m2[1]))), -m3[2]))), m4[3])))));
        var d = diff(p, n);
        return d[d.length - 1];
      }
      return exactInSphere6;
    }
    var CACHED = [
      inSphere0,
      inSphere1,
      inSphere2
    ];
    function slowInSphere(args) {
      var proc2 = CACHED[args.length];
      if (!proc2) {
        proc2 = CACHED[args.length] = orientation2(args.length);
      }
      return proc2.apply(void 0, args);
    }
    function proc(slow, o0, o1, o2, o3, o4, o5, o6) {
      function testInSphere(a0, a1, a2, a3, a4, a5) {
        switch (arguments.length) {
          case 0:
          case 1:
            return 0;
          case 2:
            return o2(a0, a1);
          case 3:
            return o3(a0, a1, a2);
          case 4:
            return o4(a0, a1, a2, a3);
          case 5:
            return o5(a0, a1, a2, a3, a4);
          case 6:
            return o6(a0, a1, a2, a3, a4, a5);
        }
        var s = new Array(arguments.length);
        for (var i = 0; i < arguments.length; ++i) {
          s[i] = arguments[i];
        }
        return slow(s);
      }
      return testInSphere;
    }
    function generateInSphereTest() {
      while (CACHED.length <= NUM_EXPAND) {
        CACHED.push(orientation2(CACHED.length));
      }
      module.exports = proc.apply(void 0, [slowInSphere].concat(CACHED));
      for (var i = 0; i <= NUM_EXPAND; ++i) {
        module.exports[i] = CACHED[i];
      }
    }
    generateInSphereTest();
  }
});

// node_modules/cdt2d/lib/delaunay.js
var require_delaunay = __commonJS({
  "node_modules/cdt2d/lib/delaunay.js"(exports, module) {
    "use strict";
    var inCircle = require_in_sphere()[4];
    var bsearch = require_search_bounds();
    module.exports = delaunayRefine;
    function testFlip(points, triangulation, stack, a, b, x) {
      var y = triangulation.opposite(a, b);
      if (y < 0) {
        return;
      }
      if (b < a) {
        var tmp = a;
        a = b;
        b = tmp;
        tmp = x;
        x = y;
        y = tmp;
      }
      if (triangulation.isConstraint(a, b)) {
        return;
      }
      if (inCircle(points[a], points[b], points[x], points[y]) < 0) {
        stack.push(a, b);
      }
    }
    function delaunayRefine(points, triangulation) {
      var stack = [];
      var numPoints = points.length;
      var stars = triangulation.stars;
      for (var a = 0; a < numPoints; ++a) {
        var star = stars[a];
        for (var j = 1; j < star.length; j += 2) {
          var b = star[j];
          if (b < a) {
            continue;
          }
          if (triangulation.isConstraint(a, b)) {
            continue;
          }
          var x = star[j - 1], y = -1;
          for (var k = 1; k < star.length; k += 2) {
            if (star[k - 1] === b) {
              y = star[k];
              break;
            }
          }
          if (y < 0) {
            continue;
          }
          if (inCircle(points[a], points[b], points[x], points[y]) < 0) {
            stack.push(a, b);
          }
        }
      }
      while (stack.length > 0) {
        var b = stack.pop();
        var a = stack.pop();
        var x = -1, y = -1;
        var star = stars[a];
        for (var i = 1; i < star.length; i += 2) {
          var s = star[i - 1];
          var t = star[i];
          if (s === b) {
            y = t;
          } else if (t === b) {
            x = s;
          }
        }
        if (x < 0 || y < 0) {
          continue;
        }
        if (inCircle(points[a], points[b], points[x], points[y]) >= 0) {
          continue;
        }
        triangulation.flip(a, b);
        testFlip(points, triangulation, stack, x, a, y);
        testFlip(points, triangulation, stack, a, y, x);
        testFlip(points, triangulation, stack, y, b, x);
        testFlip(points, triangulation, stack, b, x, y);
      }
    }
  }
});

// node_modules/cdt2d/lib/filter.js
var require_filter = __commonJS({
  "node_modules/cdt2d/lib/filter.js"(exports, module) {
    "use strict";
    var bsearch = require_search_bounds();
    module.exports = classifyFaces;
    function FaceIndex(cells, neighbor, constraint, flags, active, next, boundary) {
      this.cells = cells;
      this.neighbor = neighbor;
      this.flags = flags;
      this.constraint = constraint;
      this.active = active;
      this.next = next;
      this.boundary = boundary;
    }
    var proto = FaceIndex.prototype;
    function compareCell(a, b) {
      return a[0] - b[0] || a[1] - b[1] || a[2] - b[2];
    }
    proto.locate = /* @__PURE__ */ (function() {
      var key = [0, 0, 0];
      return function(a, b, c) {
        var x = a, y = b, z = c;
        if (b < c) {
          if (b < a) {
            x = b;
            y = c;
            z = a;
          }
        } else if (c < a) {
          x = c;
          y = a;
          z = b;
        }
        if (x < 0) {
          return -1;
        }
        key[0] = x;
        key[1] = y;
        key[2] = z;
        return bsearch.eq(this.cells, key, compareCell);
      };
    })();
    function indexCells(triangulation, infinity) {
      var cells = triangulation.cells();
      var nc = cells.length;
      for (var i = 0; i < nc; ++i) {
        var c = cells[i];
        var x = c[0], y = c[1], z = c[2];
        if (y < z) {
          if (y < x) {
            c[0] = y;
            c[1] = z;
            c[2] = x;
          }
        } else if (z < x) {
          c[0] = z;
          c[1] = x;
          c[2] = y;
        }
      }
      cells.sort(compareCell);
      var flags = new Array(nc);
      for (var i = 0; i < flags.length; ++i) {
        flags[i] = 0;
      }
      var active = [];
      var next = [];
      var neighbor = new Array(3 * nc);
      var constraint = new Array(3 * nc);
      var boundary = null;
      if (infinity) {
        boundary = [];
      }
      var index = new FaceIndex(
        cells,
        neighbor,
        constraint,
        flags,
        active,
        next,
        boundary
      );
      for (var i = 0; i < nc; ++i) {
        var c = cells[i];
        for (var j = 0; j < 3; ++j) {
          var x = c[j], y = c[(j + 1) % 3];
          var a = neighbor[3 * i + j] = index.locate(y, x, triangulation.opposite(y, x));
          var b = constraint[3 * i + j] = triangulation.isConstraint(x, y);
          if (a < 0) {
            if (b) {
              next.push(i);
            } else {
              active.push(i);
              flags[i] = 1;
            }
            if (infinity) {
              boundary.push([y, x, -1]);
            }
          }
        }
      }
      return index;
    }
    function filterCells(cells, flags, target) {
      var ptr = 0;
      for (var i = 0; i < cells.length; ++i) {
        if (flags[i] === target) {
          cells[ptr++] = cells[i];
        }
      }
      cells.length = ptr;
      return cells;
    }
    function classifyFaces(triangulation, target, infinity) {
      var index = indexCells(triangulation, infinity);
      if (target === 0) {
        if (infinity) {
          return index.cells.concat(index.boundary);
        } else {
          return index.cells;
        }
      }
      var side = 1;
      var active = index.active;
      var next = index.next;
      var flags = index.flags;
      var cells = index.cells;
      var constraint = index.constraint;
      var neighbor = index.neighbor;
      while (active.length > 0 || next.length > 0) {
        while (active.length > 0) {
          var t = active.pop();
          if (flags[t] === -side) {
            continue;
          }
          flags[t] = side;
          var c = cells[t];
          for (var j = 0; j < 3; ++j) {
            var f = neighbor[3 * t + j];
            if (f >= 0 && flags[f] === 0) {
              if (constraint[3 * t + j]) {
                next.push(f);
              } else {
                active.push(f);
                flags[f] = side;
              }
            }
          }
        }
        var tmp = next;
        next = active;
        active = tmp;
        next.length = 0;
        side = -side;
      }
      var result = filterCells(cells, flags, target);
      if (infinity) {
        return result.concat(index.boundary);
      }
      return result;
    }
  }
});

// node_modules/cdt2d/cdt2d.js
var require_cdt2d = __commonJS({
  "node_modules/cdt2d/cdt2d.js"(exports, module) {
    "use strict";
    var monotoneTriangulate = require_monotone();
    var makeIndex = require_triangulation();
    var delaunayFlip = require_delaunay();
    var filterTriangulation = require_filter();
    module.exports = cdt2d2;
    function canonicalizeEdge(e) {
      return [Math.min(e[0], e[1]), Math.max(e[0], e[1])];
    }
    function compareEdge(a, b) {
      return a[0] - b[0] || a[1] - b[1];
    }
    function canonicalizeEdges(edges) {
      return edges.map(canonicalizeEdge).sort(compareEdge);
    }
    function getDefault(options, property, dflt) {
      if (property in options) {
        return options[property];
      }
      return dflt;
    }
    function cdt2d2(points, edges, options) {
      if (!Array.isArray(edges)) {
        options = edges || {};
        edges = [];
      } else {
        options = options || {};
        edges = edges || [];
      }
      var delaunay2 = !!getDefault(options, "delaunay", true);
      var interior = !!getDefault(options, "interior", true);
      var exterior = !!getDefault(options, "exterior", true);
      var infinity = !!getDefault(options, "infinity", false);
      if (!interior && !exterior || points.length === 0) {
        return [];
      }
      var cells = monotoneTriangulate(points, edges);
      if (delaunay2 || interior !== exterior || infinity) {
        var triangulation = makeIndex(points.length, canonicalizeEdges(edges));
        for (var i = 0; i < cells.length; ++i) {
          var f = cells[i];
          triangulation.addTriangle(f[0], f[1], f[2]);
        }
        if (delaunay2) {
          delaunayFlip(points, triangulation);
        }
        if (!exterior) {
          return filterTriangulation(triangulation, -1);
        } else if (!interior) {
          return filterTriangulation(triangulation, 1, infinity);
        } else if (infinity) {
          return filterTriangulation(triangulation, 0, infinity);
        } else {
          return triangulation.cells();
        }
      } else {
        return cells;
      }
    }
  }
});

// lib/convertConnectionsToSerializedConnections.ts
var convertConnectionsToSerializedConnections = (connections) => {
  return connections.map((conn) => ({
    connectionId: conn.connectionId,
    startRegionId: conn.startRegion.regionId,
    endRegionId: conn.endRegion.regionId,
    mutuallyConnectedNetworkId: conn.mutuallyConnectedNetworkId
  }));
};

// lib/convertHyperGraphToSerializedHyperGraph.ts
var convertHyperGraphToSerializedHyperGraph = (graph) => {
  const serializedPorts = graph.ports.map((port) => ({
    portId: port.portId,
    region1Id: port.region1.regionId,
    region2Id: port.region2.regionId,
    d: port.d
  }));
  const serializedRegions = graph.regions.map(
    (region) => ({
      regionId: region.regionId,
      pointIds: region.ports.map((port) => port.portId),
      d: region.d
    })
  );
  return {
    ports: serializedPorts,
    regions: serializedRegions
  };
};

// lib/convertSerializedHyperGraphToHyperGraph.ts
var convertSerializedHyperGraphToHyperGraph = (inputGraph) => {
  if (inputGraph.ports.length > 0 && "region1" in inputGraph.ports[0] && typeof inputGraph.ports[0].region1 === "object") {
    return inputGraph;
  }
  const portMap = /* @__PURE__ */ new Map();
  const regionMap = /* @__PURE__ */ new Map();
  for (const region of inputGraph.regions) {
    const { assignments: _, ...regionWithoutAssignments } = region;
    regionMap.set(region.regionId, {
      ...regionWithoutAssignments,
      d: regionWithoutAssignments.d ? structuredClone(regionWithoutAssignments.d) : regionWithoutAssignments.d,
      ports: [],
      assignments: void 0
    });
  }
  for (const port of inputGraph.ports) {
    const region1 = regionMap.get(port.region1Id ?? port.region1?.regionId);
    const region2 = regionMap.get(port.region2Id ?? port.region2?.regionId);
    const deserializedPort = {
      portId: port.portId,
      region1,
      region2,
      d: port.d
    };
    portMap.set(port.portId, deserializedPort);
    region1.ports.push(deserializedPort);
    region2.ports.push(deserializedPort);
  }
  return {
    ports: Array.from(portMap.values()),
    regions: Array.from(regionMap.values())
  };
};

// lib/convertSerializedConnectionsToConnections.ts
var convertSerializedConnectionsToConnections = (inputConnections, graph) => {
  const connections = [];
  for (const inputConn of inputConnections) {
    if ("startRegionId" in inputConn) {
      connections.push({
        connectionId: inputConn.connectionId,
        mutuallyConnectedNetworkId: inputConn.mutuallyConnectedNetworkId ?? inputConn.connectionId,
        startRegion: graph.regions.find(
          (region) => region.regionId === inputConn.startRegionId
        ),
        endRegion: graph.regions.find(
          (region) => region.regionId === inputConn.endRegionId
        )
      });
    } else {
      connections.push(inputConn);
    }
  }
  return connections;
};

// lib/convertSerializedSolvedRoutesToSolvedRoutes.ts
var convertSerializedSolvedRoutesToSolvedRoutes = (inputSolvedRoutes, graph) => {
  const portMap = new Map(graph.ports.map((port) => [port.portId, port]));
  const regionMap = new Map(
    graph.regions.map((region) => [region.regionId, region])
  );
  const connectionMap = new Map(
    convertSerializedConnectionsToConnections(
      inputSolvedRoutes.map((route) => route.connection),
      graph
    ).map((connection) => [connection.connectionId, connection])
  );
  return inputSolvedRoutes.map((inputSolvedRoute) => {
    const path = [];
    for (const originalCandidate of inputSolvedRoute.path) {
      const port = portMap.get(originalCandidate.portId);
      if (!port) {
        throw new Error(
          `Port ${originalCandidate.portId} not found while deserializing solved route ${inputSolvedRoute.connection.connectionId}`
        );
      }
      const candidate = {
        port,
        g: originalCandidate.g,
        h: originalCandidate.h,
        f: originalCandidate.f,
        hops: originalCandidate.hops,
        ripRequired: originalCandidate.ripRequired
      };
      if (originalCandidate.lastPortId) {
        candidate.lastPort = getRequiredPort(
          portMap,
          originalCandidate.lastPortId,
          inputSolvedRoute.connection.connectionId
        );
      }
      if (originalCandidate.lastRegionId) {
        candidate.lastRegion = getRequiredRegion(
          regionMap,
          originalCandidate.lastRegionId,
          inputSolvedRoute.connection.connectionId
        );
      }
      if (originalCandidate.nextRegionId) {
        candidate.nextRegion = getRequiredRegion(
          regionMap,
          originalCandidate.nextRegionId,
          inputSolvedRoute.connection.connectionId
        );
      }
      const parent = path[path.length - 1];
      if (parent) candidate.parent = parent;
      path.push(candidate);
    }
    const connection = connectionMap.get(
      inputSolvedRoute.connection.connectionId
    );
    if (!connection) {
      throw new Error(
        `Connection ${inputSolvedRoute.connection.connectionId} not found while deserializing solved route`
      );
    }
    return {
      path,
      connection,
      requiredRip: inputSolvedRoute.requiredRip
    };
  });
};
var getRequiredPort = (portMap, portId, connectionId) => {
  const port = portMap.get(portId);
  if (!port) {
    throw new Error(
      `Port ${portId} not found while deserializing solved route ${connectionId}`
    );
  }
  return port;
};
var getRequiredRegion = (regionMap, regionId, connectionId) => {
  const region = regionMap.get(regionId);
  if (!region) {
    throw new Error(
      `Region ${regionId} not found while deserializing solved route ${connectionId}`
    );
  }
  return region;
};

// lib/createBlankHyperGraph.ts
var createBlankHyperGraph = (inputGraph) => {
  const deserializedGraph = convertSerializedHyperGraphToHyperGraph(inputGraph);
  if (!inputGraph.solvedRoutes) {
    throw new Error(
      "createBlankHyperGraph requires graph.solvedRoutes to be present"
    );
  }
  const solvedRoutes = convertSerializedSolvedRoutesToSolvedRoutes(
    inputGraph.solvedRoutes,
    deserializedGraph
  );
  const removableLeafRegionIds = getRemovableLeafRegionIds(deserializedGraph);
  const replacedEndpointRegionIds = getReplacedEndpointRegionIds(solvedRoutes);
  const blankGraph = cloneGraphExcludingRegions(
    deserializedGraph,
    removableLeafRegionIds
  );
  const connections = [];
  for (const solvedRoute of solvedRoutes) {
    const startRegion = getBlankConnectionEndpointRegion({
      solvedRoute,
      blankGraph,
      replacedEndpointRegionIds,
      endpoint: "start"
    });
    const endRegion = getBlankConnectionEndpointRegion({
      solvedRoute,
      blankGraph,
      replacedEndpointRegionIds,
      endpoint: "end"
    });
    connections.push({
      connectionId: solvedRoute.connection.connectionId,
      mutuallyConnectedNetworkId: solvedRoute.connection.mutuallyConnectedNetworkId,
      startRegion,
      endRegion
    });
  }
  return {
    ...convertHyperGraphToSerializedHyperGraph(blankGraph),
    connections: convertConnectionsToSerializedConnections(connections),
    _sectionCentralRegionId: inputGraph._sectionCentralRegionId,
    _sectionRouteBindings: inputGraph._sectionRouteBindings ? structuredClone(inputGraph._sectionRouteBindings) : void 0
  };
};
var getRemovableLeafRegionIds = (graph) => {
  return new Set(
    graph.regions.filter((region) => region.ports.length === 1).map((region) => region.regionId)
  );
};
var getReplacedEndpointRegionIds = (solvedRoutes) => {
  const replacedEndpointRegionIds = /* @__PURE__ */ new Set();
  for (const solvedRoute of solvedRoutes) {
    const startCandidate = solvedRoute.path[0];
    if (startCandidate && shouldReplaceEndpointRegion(
      solvedRoute.connection.startRegion,
      startCandidate
    )) {
      replacedEndpointRegionIds.add(solvedRoute.connection.startRegion.regionId);
    }
    const endCandidate = solvedRoute.path[solvedRoute.path.length - 1];
    if (endCandidate && shouldReplaceEndpointRegion(
      solvedRoute.connection.endRegion,
      endCandidate
    )) {
      replacedEndpointRegionIds.add(solvedRoute.connection.endRegion.regionId);
    }
  }
  return replacedEndpointRegionIds;
};
var shouldReplaceEndpointRegion = (endpointRegion, endpointCandidate) => {
  return endpointRegion.ports.length === 1 && endpointRegion.ports[0]?.portId === endpointCandidate.port.portId;
};
var cloneGraphExcludingRegions = (graph, excludedRegionIds) => {
  const clonedRegionMap = /* @__PURE__ */ new Map();
  const clonedPorts = [];
  for (const region of graph.regions) {
    if (excludedRegionIds.has(region.regionId)) continue;
    clonedRegionMap.set(region.regionId, {
      regionId: region.regionId,
      ports: [],
      d: region.d ? structuredClone(region.d) : region.d,
      assignments: []
    });
  }
  for (const port of graph.ports) {
    if (excludedRegionIds.has(port.region1.regionId) || excludedRegionIds.has(port.region2.regionId)) {
      continue;
    }
    const clonedPort = {
      portId: port.portId,
      region1: clonedRegionMap.get(port.region1.regionId),
      region2: clonedRegionMap.get(port.region2.regionId),
      d: port.d ? structuredClone(port.d) : port.d
    };
    clonedPort.region1.ports.push(clonedPort);
    clonedPort.region2.ports.push(clonedPort);
    clonedPorts.push(clonedPort);
  }
  return {
    regions: Array.from(clonedRegionMap.values()),
    ports: clonedPorts
  };
};
var getBlankConnectionEndpointRegion = (input) => {
  const { solvedRoute, blankGraph, replacedEndpointRegionIds, endpoint } = input;
  const originalRegion = endpoint === "start" ? solvedRoute.connection.startRegion : solvedRoute.connection.endRegion;
  const existingRegion = blankGraph.regions.find(
    (region) => region.regionId === originalRegion.regionId
  );
  if (existingRegion) return existingRegion;
  if (!replacedEndpointRegionIds.has(originalRegion.regionId)) {
    throw new Error(
      `Connection endpoint region ${originalRegion.regionId} is missing from blank graph`
    );
  }
  const endpointCandidate = endpoint === "start" ? solvedRoute.path[0] : solvedRoute.path[solvedRoute.path.length - 1];
  if (!endpointCandidate) {
    throw new Error(
      `Solved route ${solvedRoute.connection.connectionId} has no path candidates`
    );
  }
  const attachedRegionId = getAttachedRegionId({
    port: endpointCandidate.port,
    originalRegionId: originalRegion.regionId,
    preferredRegionId: endpoint === "start" ? endpointCandidate.nextRegion?.regionId : endpointCandidate.lastRegion?.regionId
  });
  if (!attachedRegionId) {
    throw new Error(
      `Could not determine ${endpoint} region for connection ${solvedRoute.connection.connectionId}`
    );
  }
  const attachedRegion = blankGraph.regions.find(
    (region) => region.regionId === attachedRegionId
  );
  if (!attachedRegion) {
    throw new Error(
      `Region ${attachedRegionId} not found in blank graph for connection ${solvedRoute.connection.connectionId}`
    );
  }
  const connectionRegion = {
    regionId: `connection:${solvedRoute.connection.connectionId}:${endpoint}`,
    ports: [],
    d: originalRegion.d ? structuredClone(originalRegion.d) : originalRegion.d,
    assignments: []
  };
  blankGraph.regions.push(connectionRegion);
  const connectionPort = {
    portId: `connection:${solvedRoute.connection.connectionId}:${endpoint}-port`,
    region1: connectionRegion,
    region2: attachedRegion,
    d: endpointCandidate.port.d ? structuredClone(endpointCandidate.port.d) : endpointCandidate.port.d
  };
  connectionRegion.ports.push(connectionPort);
  attachedRegion.ports.push(connectionPort);
  blankGraph.ports.push(connectionPort);
  return connectionRegion;
};
var getAttachedRegionId = (input) => {
  const { port, originalRegionId, preferredRegionId } = input;
  if (preferredRegionId && preferredRegionId !== originalRegionId) {
    return preferredRegionId;
  }
  if (port.region1.regionId !== originalRegionId) return port.region1.regionId;
  if (port.region2.regionId !== originalRegionId) return port.region2.regionId;
  return void 0;
};

// lib/HyperGraphSectionOptimizer/getOrCreateBoundaryRegion.ts
var getOrCreateBoundaryRegion = ({
  port,
  boundaryRegionMap
}) => {
  let boundaryRegion = boundaryRegionMap.get(port.portId);
  if (!boundaryRegion) {
    const x = typeof port.d?.x === "number" ? port.d.x : 0;
    const y = typeof port.d?.y === "number" ? port.d.y : 0;
    boundaryRegion = {
      regionId: `__section_boundary__${port.portId}`,
      ports: [],
      d: {
        isBoundaryRegion: true,
        boundaryPortId: port.portId,
        ...port.d,
        center: { x, y },
        bounds: {
          minX: x - 0.05,
          maxX: x + 0.05,
          minY: y - 0.05,
          maxY: y + 0.05
        }
      },
      assignments: []
    };
    boundaryRegionMap.set(port.portId, boundaryRegion);
  }
  return boundaryRegion;
};

// lib/HyperGraphSectionOptimizer/routes/sliceSolvedRouteIntoLocalSection.ts
var sliceSolvedRouteIntoLocalSection = (input) => {
  const { sectionRoute, graph } = input;
  const localPortIds = new Set(graph.ports.map((port) => port.portId));
  const originalLocalPath = sectionRoute.globalRoute.path.slice(sectionRoute.sectionStartIndex, sectionRoute.sectionEndIndex + 1).filter((candidate) => localPortIds.has(candidate.port.portId));
  const path = [];
  let currentRegion = sectionRoute.sectionConnection.startRegion;
  for (let index = 0; index < originalLocalPath.length; index++) {
    const originalCandidate = originalLocalPath[index];
    const port = graph.ports.find(
      (candidatePort) => candidatePort.portId === originalCandidate.port.portId
    );
    const nextRegion = port.region1 === currentRegion ? port.region2 : port.region1;
    path.push({
      port,
      g: 0,
      h: 0,
      f: 0,
      hops: index,
      ripRequired: originalCandidate.ripRequired,
      parent: index > 0 ? path[index - 1] : void 0,
      lastPort: index > 0 ? path[index - 1].port : void 0,
      lastRegion: index > 0 ? currentRegion : void 0,
      nextRegion
    });
    currentRegion = nextRegion;
  }
  return {
    connection: sectionRoute.sectionConnection,
    path,
    requiredRip: sectionRoute.globalRoute.requiredRip
  };
};

// lib/HyperGraphSectionOptimizer/sections/getRouteSectionSpan.ts
var getRouteSectionSpan = (route, sectionRegionIds) => {
  let startIndex = -1;
  let endIndex = -1;
  for (let i = 0; i < route.path.length; i++) {
    const candidate = route.path[i];
    const touchesSection = candidate.lastRegion && sectionRegionIds.has(candidate.lastRegion.regionId) || candidate.nextRegion && sectionRegionIds.has(candidate.nextRegion.regionId);
    if (!touchesSection) continue;
    if (startIndex === -1) startIndex = i;
    endIndex = i;
  }
  if (startIndex === -1) return null;
  return { startIndex, endIndex };
};

// lib/HyperGraphSectionOptimizer/sections/getSectionRegionIds.ts
var getSectionRegionIds = ({
  centralRegion,
  expansionHopsFromCentralRegion
}) => {
  const sectionRegionIds = /* @__PURE__ */ new Set([centralRegion.regionId]);
  const queue = [
    { region: centralRegion, hops: 0 }
  ];
  while (queue.length > 0) {
    const { region, hops } = queue.shift();
    if (hops >= expansionHopsFromCentralRegion + 1) continue;
    for (const port of region.ports) {
      const nextRegion = port.region1 === region ? port.region2 : port.region1;
      if (sectionRegionIds.has(nextRegion.regionId)) continue;
      sectionRegionIds.add(nextRegion.regionId);
      queue.push({ region: nextRegion, hops: hops + 1 });
    }
  }
  return sectionRegionIds;
};

// lib/HyperGraphSectionOptimizer/sections/getSectionOfHyperGraphAsHyperGraph.ts
var getSectionOfHyperGraphAsHyperGraph = (input) => {
  const { graph, solvedRoutes, centralRegion, expansionHopsFromCentralRegion } = input;
  const sectionRegionIds = getSectionRegionIds({
    graph,
    centralRegion,
    expansionHopsFromCentralRegion
  });
  const clonedRegionMap = /* @__PURE__ */ new Map();
  const boundaryRegionMap = /* @__PURE__ */ new Map();
  const clonedPorts = [];
  for (const region of graph.regions) {
    if (!sectionRegionIds.has(region.regionId)) continue;
    clonedRegionMap.set(region.regionId, {
      regionId: region.regionId,
      ports: [],
      d: region.d ? structuredClone(region.d) : region.d,
      assignments: []
    });
  }
  for (const port of graph.ports) {
    const region1InSection = sectionRegionIds.has(port.region1.regionId);
    const region2InSection = sectionRegionIds.has(port.region2.regionId);
    if (!region1InSection && !region2InSection) continue;
    if (region1InSection && region2InSection) {
      const clonedPort2 = {
        portId: port.portId,
        region1: clonedRegionMap.get(port.region1.regionId),
        region2: clonedRegionMap.get(port.region2.regionId),
        d: port.d
      };
      clonedPort2.region1.ports.push(clonedPort2);
      clonedPort2.region2.ports.push(clonedPort2);
      clonedPorts.push(clonedPort2);
      continue;
    }
    const insideRegion = region1InSection ? port.region1 : port.region2;
    const boundaryRegion = getOrCreateBoundaryRegion({
      port,
      boundaryRegionMap
    });
    const clonedPort = {
      portId: port.portId,
      region1: clonedRegionMap.get(insideRegion.regionId),
      region2: boundaryRegion,
      d: port.d
    };
    clonedPort.region1.ports.push(clonedPort);
    clonedPort.region2.ports.push(clonedPort);
    clonedPorts.push(clonedPort);
  }
  const sectionGraph = {
    regions: [...clonedRegionMap.values(), ...boundaryRegionMap.values()],
    ports: clonedPorts
  };
  const sectionRoutes = [];
  const sectionConnections = [];
  const sectionRouteSegments = [];
  for (const solvedRoute of solvedRoutes) {
    const routePathSegment = getRouteSectionSpan(solvedRoute, sectionRegionIds);
    if (!routePathSegment) continue;
    const startCandidate = solvedRoute.path[routePathSegment.startIndex];
    const endCandidate = solvedRoute.path[routePathSegment.endIndex];
    sectionRouteSegments.push({
      solvedRoute,
      solvedPathStartIndex: routePathSegment.startIndex,
      solvedPathEndIndex: routePathSegment.endIndex,
      startCandidate,
      endCandidate
    });
  }
  const sectionRegionMap = new Map(
    sectionGraph.regions.map((region) => [region.regionId, region])
  );
  for (const {
    solvedRoute,
    solvedPathStartIndex,
    solvedPathEndIndex,
    startCandidate,
    endCandidate
  } of sectionRouteSegments) {
    let startRegionId;
    let startRegion;
    if (sectionRegionIds.has(solvedRoute.connection.startRegion.regionId)) {
      startRegionId = solvedRoute.connection.startRegion.regionId;
      startRegion = sectionRegionMap.get(startRegionId);
    } else {
      const boundaryRegion = getOrCreateBoundaryRegion({
        port: startCandidate.port,
        boundaryRegionMap
      });
      startRegionId = boundaryRegion.regionId;
      startRegion = boundaryRegion;
      if (!sectionRegionMap.has(startRegionId)) {
        sectionRegionMap.set(startRegionId, boundaryRegion);
      }
    }
    let endRegionId;
    let endRegion;
    if (sectionRegionIds.has(solvedRoute.connection.endRegion.regionId)) {
      endRegionId = solvedRoute.connection.endRegion.regionId;
      endRegion = sectionRegionMap.get(endRegionId);
    } else {
      const boundaryRegion = getOrCreateBoundaryRegion({
        port: endCandidate.port,
        boundaryRegionMap
      });
      endRegionId = boundaryRegion.regionId;
      endRegion = boundaryRegion;
      if (!sectionRegionMap.has(endRegionId)) {
        sectionRegionMap.set(endRegionId, boundaryRegion);
      }
    }
    if (!startRegion) {
      console.error(
        `[getSectionOfHyperGraphAsHyperGraph] CRITICAL ERROR: startRegion not found!`
      );
      console.error(`  Looking for: ${startRegionId}`);
      console.error(
        `  Route connection: ${solvedRoute.connection.connectionId}`
      );
      console.error(
        `  Original startRegion: ${solvedRoute.connection.startRegion.regionId}`
      );
      console.error(`  startCandidate port: ${startCandidate.port.portId}`);
      console.error(
        `  Available regions in sectionRegionMap:`,
        Array.from(sectionRegionMap.keys())
      );
      throw new Error(
        `startRegion ${startRegionId} not found in sectionRegionMap`
      );
    }
    if (!endRegion) {
      console.error(
        `[getSectionOfHyperGraphAsHyperGraph] CRITICAL ERROR: endRegion not found!`
      );
      console.error(`  Looking for: ${endRegionId}`);
      console.error(
        `  Route connection: ${solvedRoute.connection.connectionId}`
      );
      console.error(
        `  Original endRegion: ${solvedRoute.connection.endRegion.regionId}`
      );
      console.error(`  endCandidate port: ${endCandidate.port.portId}`);
      console.error(
        `  Available regions in sectionRegionMap:`,
        Array.from(sectionRegionMap.keys())
      );
      throw new Error(`endRegion ${endRegionId} not found in sectionRegionMap`);
    }
    const sectionConnection = {
      connectionId: solvedRoute.connection.connectionId,
      mutuallyConnectedNetworkId: solvedRoute.connection.mutuallyConnectedNetworkId,
      startRegion,
      endRegion
    };
    const rawPath = solvedRoute.path.slice(
      solvedPathStartIndex,
      solvedPathEndIndex + 1
    );
    const sectionRouteBase = {
      globalRoute: solvedRoute,
      globalConnection: solvedRoute.connection,
      sectionConnection,
      sectionStartIndex: solvedPathStartIndex,
      sectionEndIndex: solvedPathEndIndex
    };
    sectionRoutes.push({
      ...sectionRouteBase,
      canRemainFixedInSectionSolve: rawPath.every(
        (candidate) => sectionGraph.ports.some(
          (port) => port.portId === candidate.port.portId
        )
      ),
      sectionRoute: sliceSolvedRouteIntoLocalSection({
        sectionRoute: sectionRouteBase,
        graph: sectionGraph
      })
    });
    sectionConnections.push(sectionConnection);
  }
  return {
    centralRegionId: centralRegion.regionId,
    sectionRegionIds,
    graph: sectionGraph,
    connections: sectionConnections,
    sectionRoutes
  };
};

// lib/convertSolvedRoutesToSerializedSolvedRoutes.ts
var convertSolvedRoutesToSerializedSolvedRoutes = (solvedRoutes) => {
  return solvedRoutes.map((solvedRoute) => ({
    path: solvedRoute.path.map((candidate) => ({
      portId: candidate.port.portId,
      g: candidate.g,
      h: candidate.h,
      f: candidate.f,
      hops: candidate.hops,
      ripRequired: candidate.ripRequired,
      lastPortId: candidate.lastPort?.portId,
      lastRegionId: candidate.lastRegion?.regionId,
      nextRegionId: candidate.nextRegion?.regionId
    })),
    connection: convertConnectionsToSerializedConnections([
      solvedRoute.connection
    ])[0],
    requiredRip: solvedRoute.requiredRip
  }));
};

// lib/extractSectionOfHyperGraph.ts
var extractSectionOfHyperGraph = (input) => {
  const deserializedGraph = convertSerializedHyperGraphToHyperGraph(input.graph);
  const centralRegion = deserializedGraph.regions.find(
    (region) => region.regionId === input.centralRegionId
  );
  if (!centralRegion) {
    throw new Error(
      `Central region ${input.centralRegionId} not found in hypergraph`
    );
  }
  if (!input.graph.solvedRoutes) {
    throw new Error(
      "extractSectionOfHyperGraph requires graph.solvedRoutes to be present"
    );
  }
  const solvedRoutes = convertSerializedSolvedRoutesToSolvedRoutes(
    input.graph.solvedRoutes,
    deserializedGraph
  );
  const section = getSectionOfHyperGraphAsHyperGraph({
    graph: deserializedGraph,
    solvedRoutes,
    centralRegion,
    expansionHopsFromCentralRegion: input.expansionHopsFromCentralRegion
  });
  return {
    ...convertHyperGraphToSerializedHyperGraph(section.graph),
    connections: convertConnectionsToSerializedConnections(section.connections),
    solvedRoutes: convertSolvedRoutesToSerializedSolvedRoutes(
      section.sectionRoutes.map((route) => route.sectionRoute)
    ),
    _sectionCentralRegionId: section.centralRegionId,
    _sectionRouteBindings: section.sectionRoutes.map((route) => ({
      connectionId: route.globalConnection.connectionId,
      solvedPathStartIndex: route.sectionStartIndex,
      solvedPathEndIndex: route.sectionEndIndex
    }))
  };
};

// lib/HyperGraphSolver.ts
import { BaseSolver } from "@tscircuit/solver-utils";

// lib/PriorityQueue.ts
var PriorityQueue = class {
  // Store the heap as an array. Index 0 is the root (highest priority/smallest 'f').
  heap = [];
  maxSize;
  /**
   * Creates a new Priority Queue.
   * @param nodes An optional initial array of nodes to populate the queue.
   * @param maxSize The maximum number of elements the queue can hold. Defaults to 10,000.
   */
  constructor(nodes = [], maxSize = 1e4) {
    this.maxSize = maxSize;
    if (nodes.length > 0) {
      this.heap = [...nodes].sort((a, b) => a.f - b.f).slice(0, this.maxSize);
      for (let i = Math.floor(this.heap.length / 2) - 1; i >= 0; i--) {
        this._siftDown(i);
      }
    }
  }
  /**
   * Returns the number of elements currently in the queue.
   */
  get size() {
    return this.heap.length;
  }
  /**
   * Checks if the queue is empty.
   */
  isEmpty() {
    return this.heap.length === 0;
  }
  /**
   * Returns the node with the highest priority (smallest 'f') without removing it.
   * Returns null if the queue is empty.
   * @returns The highest priority node or null.
   */
  peek() {
    if (this.isEmpty()) {
      return null;
    }
    return this.heap[0] ?? null;
  }
  /**
   * Returns up to N nodes with the highest priority (smallest 'f') without removing them.
   * Nodes are returned sorted by priority (smallest 'f' first).
   * @param count Maximum number of nodes to return.
   * @returns Array of nodes sorted by priority.
   */
  peekMany(count) {
    return [...this.heap].sort((a, b) => a.f - b.f).slice(0, count);
  }
  /**
   * Removes and returns the node with the highest priority (smallest 'f').
   * Returns null if the queue is empty.
   * Maintains the heap property.
   * @returns The highest priority node or null.
   */
  dequeue() {
    if (this.isEmpty()) {
      return null;
    }
    const minNode = this.heap[0];
    const lastNode = this.heap.pop();
    if (this.heap.length === 0 && lastNode !== void 0) {
      return minNode;
    }
    if (lastNode !== void 0) {
      this.heap[0] = lastNode;
      this._siftDown(0);
    }
    return minNode;
  }
  /**
   * Adds a new node to the queue.
   * Maintains the heap property.
   * If the queue is full (at maxSize), the node is not added.
   * @param node The node to add.
   */
  enqueue(node) {
    if (this.heap.length >= this.maxSize) {
      return;
    }
    this.heap.push(node);
    this._siftUp(this.heap.length - 1);
  }
  // --- Private Helper Methods ---
  /**
   * Moves the node at the given index up the heap to maintain the heap property.
   * @param index The index of the node to sift up.
   */
  _siftUp(index) {
    let currentIndex = index;
    while (currentIndex > 0) {
      const parentIndex = this._parentIndex(currentIndex);
      if (this.heap[parentIndex].f <= this.heap[currentIndex].f) {
        break;
      }
      this._swap(currentIndex, parentIndex);
      currentIndex = parentIndex;
    }
  }
  /**
   * Moves the node at the given index down the heap to maintain the heap property.
   * @param index The index of the node to sift down.
   */
  _siftDown(index) {
    let currentIndex = index;
    const heapSize = this.heap.length;
    while (true) {
      const leftChildIndex = this._leftChildIndex(currentIndex);
      const rightChildIndex = this._rightChildIndex(currentIndex);
      let smallestIndex = currentIndex;
      if (leftChildIndex < heapSize && this.heap[leftChildIndex].f < this.heap[smallestIndex].f) {
        smallestIndex = leftChildIndex;
      }
      if (rightChildIndex < heapSize && this.heap[rightChildIndex].f < this.heap[smallestIndex].f) {
        smallestIndex = rightChildIndex;
      }
      if (smallestIndex !== currentIndex) {
        this._swap(currentIndex, smallestIndex);
        currentIndex = smallestIndex;
      } else {
        break;
      }
    }
  }
  /**
   * Swaps two elements in the heap array.
   * @param i Index of the first element.
   * @param j Index of the second element.
   */
  _swap(i, j) {
    ;
    [this.heap[i], this.heap[j]] = [this.heap[j], this.heap[i]];
  }
  /** Calculates the parent index of a node. */
  _parentIndex(index) {
    return Math.floor((index - 1) / 2);
  }
  /** Calculates the left child index of a node. */
  _leftChildIndex(index) {
    return 2 * index + 1;
  }
  /** Calculates the right child index of a node. */
  _rightChildIndex(index) {
    return 2 * index + 2;
  }
};

// lib/solvedRoutes.ts
var clearAssignmentsFromGraph = (graph) => {
  for (const region of graph.regions) {
    region.assignments = [];
  }
  for (const port of graph.ports) {
    port.assignment = void 0;
  }
};
var commitSolvedRoutes = ({
  graph,
  connections,
  solvedRoutes
}) => {
  const portMap = new Map(graph.ports.map((port) => [port.portId, port]));
  const regionMap = new Map(
    graph.regions.map((region) => [region.regionId, region])
  );
  const connectionMap = new Map(
    connections.map((connection) => [connection.connectionId, connection])
  );
  const committedSolvedRoutes = solvedRoutes.map((solvedRoute) => {
    const path = [];
    for (const originalCandidate of solvedRoute.path) {
      const candidate = {
        port: portMap.get(originalCandidate.port.portId),
        g: originalCandidate.g,
        h: originalCandidate.h,
        f: originalCandidate.f,
        hops: originalCandidate.hops,
        ripRequired: originalCandidate.ripRequired
      };
      if (originalCandidate.lastPort) {
        candidate.lastPort = portMap.get(originalCandidate.lastPort.portId);
      }
      if (originalCandidate.lastRegion) {
        candidate.lastRegion = regionMap.get(
          originalCandidate.lastRegion.regionId
        );
      }
      if (originalCandidate.nextRegion) {
        candidate.nextRegion = regionMap.get(
          originalCandidate.nextRegion.regionId
        );
      }
      const parent = path[path.length - 1];
      if (parent) candidate.parent = parent;
      path.push(candidate);
    }
    return {
      path,
      connection: connectionMap.get(solvedRoute.connection.connectionId),
      requiredRip: solvedRoute.requiredRip
    };
  });
  clearAssignmentsFromGraph(graph);
  graph.solvedRoutes = committedSolvedRoutes;
  for (const solvedRoute of committedSolvedRoutes) {
    for (const candidate of solvedRoute.path) {
      candidate.port.assignment = {
        solvedRoute,
        connection: solvedRoute.connection
      };
      if (!candidate.lastPort || !candidate.lastRegion) continue;
      const regionPortAssignment = {
        regionPort1: candidate.lastPort,
        regionPort2: candidate.port,
        region: candidate.lastRegion,
        connection: solvedRoute.connection,
        solvedRoute
      };
      candidate.lastRegion.assignments ??= [];
      candidate.lastRegion.assignments.push(regionPortAssignment);
    }
  }
  return committedSolvedRoutes;
};

// lib/HyperGraphSolver.ts
var HyperGraphSolver = class extends BaseSolver {
  constructor(input) {
    super();
    this.input = input;
    this.graph = convertSerializedHyperGraphToHyperGraph(input.inputGraph);
    clearAssignmentsFromGraph(this.graph);
    this.connections = convertSerializedConnectionsToConnections(
      input.inputConnections,
      this.graph
    );
    if (input.inputSolvedRoutes) {
      this.solvedRoutes = commitSolvedRoutes({
        graph: this.graph,
        connections: this.connections,
        solvedRoutes: input.inputSolvedRoutes
      });
    } else {
      ;
      this.graph.solvedRoutes = this.solvedRoutes;
    }
    if (input.greedyMultiplier !== void 0)
      this.greedyMultiplier = input.greedyMultiplier;
    if (input.rippingEnabled !== void 0)
      this.rippingEnabled = input.rippingEnabled;
    if (input.ripCost !== void 0) this.ripCost = input.ripCost;
    const preSolvedConnectionIds = new Set(
      this.solvedRoutes.map(
        (solvedRoute) => solvedRoute.connection.connectionId
      )
    );
    this.unprocessedConnections = this.connections.filter(
      (connection) => !preSolvedConnectionIds.has(connection.connectionId)
    );
    this.candidateQueue = new PriorityQueue();
    if (this.unprocessedConnections.length === 0) {
      this.solved = true;
    } else {
      this.beginNewConnection();
    }
  }
  getSolverName() {
    return "HyperGraphSolver";
  }
  graph;
  connections;
  candidateQueue;
  unprocessedConnections;
  solvedRoutes = [];
  currentConnection = null;
  currentEndRegion = null;
  greedyMultiplier = 1;
  rippingEnabled = false;
  ripCost = 0;
  lastCandidate = null;
  visitedPointsForCurrentConnection = /* @__PURE__ */ new Map();
  getConstructorParams() {
    return {
      inputGraph: convertHyperGraphToSerializedHyperGraph(this.graph),
      inputConnections: convertConnectionsToSerializedConnections(
        this.connections
      ),
      greedyMultiplier: this.greedyMultiplier,
      rippingEnabled: this.rippingEnabled,
      ripCost: this.ripCost,
      inputSolvedRoutes: this.solvedRoutes
    };
  }
  computeH(candidate) {
    return this.estimateCostToEnd(candidate.port);
  }
  /**
   * OVERRIDE THIS
   *
   * Return the estimated remaining cost to the end of the route. You must
   * first understand the UNIT of your costs. If it's distance, then this could
   * be something like distance(port, this.currentEndRegion.d.center)
   */
  estimateCostToEnd(port) {
    return 0;
  }
  /**
   * OPTIONALLY OVERRIDE THIS
   *
   * This is a penalty for using a port that is not relative to a connection,
   * e.g. maybe this port is in a special area of congestion. Use this to
   * penalize ports that are e.g. likely to block off connections, you may want
   * to use port.ripCount to help determine this penalty, or you can use port
   * position, region volume etc.
   */
  getPortUsagePenalty(port) {
    return 0;
  }
  /**
   * OVERRIDE THIS
   *
   * Return the cost of using two ports in the region, make sure to consider
   * existing assignments. You may use this to penalize intersections
   */
  computeIncreasedRegionCostIfPortsAreUsed(region, port1, port2) {
    return 0;
  }
  /**
   * OPTIONALLY OVERRIDE THIS
   *
   * Return the assignments that would need to be ripped if the given ports
   * are used together in the region. This is used to determine if adopting
   * a route would require ripping other routes due to problematic crossings.
   */
  getRipsRequiredForPortUsage(_region, _port1, _port2) {
    return [];
  }
  /**
   * OPTIONALLY OVERRIDE THIS
   *
   * Return true if using the candidate transition should incur ripCost even
   * when there is no direct port-assignment conflict.
   */
  isRipRequiredForPortUsage(_region, _port1, _port2) {
    return false;
  }
  /**
   * OPTIONALLY OVERRIDE THIS
   *
   * Return false to prevent transitioning through a region from `_port1` to
   * `_port2`.
   */
  isTransitionAllowed(_region, _port1, _port2) {
    return true;
  }
  computeG(candidate) {
    return candidate.parent.g + this.computeIncreasedRegionCostIfPortsAreUsed(
      candidate.lastRegion,
      candidate.lastPort,
      candidate.port
    ) + (candidate.ripRequired ? this.ripCost : 0) + this.getPortUsagePenalty(candidate.port);
  }
  /**
   * Return a subset of the candidates for entering a region. These candidates
   * are all possible ways to enter the region- you can e.g. return the middle
   * port to make it so that you're not queueing candidates that are likely
   * redundant.
   */
  selectCandidatesForEnteringRegion(candidates) {
    return candidates;
  }
  /**
   * OPTIONALLY OVERRIDE THIS
   *
   * Compute the full set of solved routes that must be ripped to accept
   * `newlySolvedRoute`. By default this returns all conflicting routes
   * (always-rip behavior)
   *
   * Override this to implement partial ripping, where only a subset of
   * conflicting routes are removed.
   */
  computeRoutesToRip(newlySolvedRoute) {
    const crossingRoutesToRip = this.computeCrossingRoutes(newlySolvedRoute);
    const portReuseRoutesToRip = this.computePortOverlapRoutes(newlySolvedRoute);
    return /* @__PURE__ */ new Set([
      ...crossingRoutesToRip,
      ...portReuseRoutesToRip
    ]);
  }
  /**
   * Returns solved routes that overlap ports with the newly solved route.
   * Use this in computeRoutesToRip overrides to include port reuse rips.
   */
  computePortOverlapRoutes(newlySolvedRoute) {
    const portReuseRoutesToRip = /* @__PURE__ */ new Set();
    for (const candidate of newlySolvedRoute.path) {
      if (candidate.port.assignment && candidate.port.assignment.connection.mutuallyConnectedNetworkId !== newlySolvedRoute.connection.mutuallyConnectedNetworkId) {
        portReuseRoutesToRip.add(candidate.port.assignment.solvedRoute);
      }
    }
    return portReuseRoutesToRip;
  }
  computeCrossingRoutes(newlySolvedRoute) {
    const crossingRoutesToRip = /* @__PURE__ */ new Set();
    for (const candidate of newlySolvedRoute.path) {
      if (!candidate.lastPort || !candidate.lastRegion) continue;
      const ripsRequired = this.getRipsRequiredForPortUsage(
        candidate.lastRegion,
        candidate.lastPort,
        candidate.port
      );
      for (const assignment of ripsRequired) {
        crossingRoutesToRip.add(assignment.solvedRoute);
      }
    }
    return crossingRoutesToRip;
  }
  getNextCandidates(currentCandidate) {
    const currentRegion = currentCandidate.nextRegion;
    const currentPort = currentCandidate.port;
    const nextCandidatesByRegion = {};
    for (const port of currentRegion.ports) {
      if (port === currentCandidate.port) continue;
      if (!this.isTransitionAllowed(
        currentRegion,
        currentPort,
        port
      )) {
        continue;
      }
      const ripRequired = port.assignment && port.assignment.connection.mutuallyConnectedNetworkId !== this.currentConnection.mutuallyConnectedNetworkId || this.isRipRequiredForPortUsage(
        currentRegion,
        currentPort,
        port
      );
      const newCandidate = {
        port,
        hops: currentCandidate.hops + 1,
        parent: currentCandidate,
        lastRegion: currentRegion,
        nextRegion: port.region1 === currentRegion ? port.region2 : port.region1,
        lastPort: currentPort,
        ripRequired
      };
      if (!this.rippingEnabled && newCandidate.ripRequired) {
        continue;
      }
      nextCandidatesByRegion[newCandidate.nextRegion.regionId] ??= [];
      nextCandidatesByRegion[newCandidate.nextRegion.regionId].push(
        newCandidate
      );
    }
    const nextCandidates = [];
    for (const regionId in nextCandidatesByRegion) {
      const nextCandidatesInRegion = nextCandidatesByRegion[regionId];
      nextCandidates.push(
        ...this.selectCandidatesForEnteringRegion(nextCandidatesInRegion)
      );
    }
    for (const nextCandidate of nextCandidates) {
      nextCandidate.g = this.computeG(nextCandidate);
      nextCandidate.h = this.computeH(nextCandidate);
      nextCandidate.f = nextCandidate.g + nextCandidate.h * this.greedyMultiplier;
    }
    return nextCandidates;
  }
  processSolvedRoute(finalCandidate) {
    const solvedRoute = {
      path: [],
      connection: this.currentConnection,
      requiredRip: false
    };
    let cursorCandidate = finalCandidate;
    let anyRipsRequired = false;
    while (cursorCandidate) {
      anyRipsRequired ||= !!cursorCandidate.ripRequired;
      solvedRoute.path.unshift(cursorCandidate);
      cursorCandidate = cursorCandidate.parent;
    }
    if (anyRipsRequired) {
      solvedRoute.requiredRip = true;
    }
    const allRoutesToRip = this.computeRoutesToRip(solvedRoute);
    if (allRoutesToRip.size > 0) {
      solvedRoute.requiredRip = true;
      for (const route of allRoutesToRip) {
        this.ripSolvedRoute(route);
      }
    }
    for (const candidate of solvedRoute.path) {
      candidate.port.assignment = {
        solvedRoute,
        connection: this.currentConnection
      };
      if (!candidate.lastPort) continue;
      const regionPortAssignment = {
        regionPort1: candidate.lastPort,
        regionPort2: candidate.port,
        region: candidate.lastRegion,
        connection: this.currentConnection,
        solvedRoute
      };
      candidate.lastRegion.assignments?.push(regionPortAssignment);
    }
    this.solvedRoutes.push(solvedRoute);
    this.routeSolvedHook(solvedRoute);
  }
  /**
   * OPTIONALLY OVERRIDE THIS
   *
   * You can override this to perform actions after a route is solved, e.g.
   * you may want to detect if a solvedRoute.requiredRip is true, in which
   * case you might want to execute a "random rip" to avoid loops or check
   * if we've exceeded a maximum number of rips.
   *
   * You can also use this to shuffle unprocessed routes if a rip occurred, this
   * can also help avoid loops
   */
  routeSolvedHook(solvedRoute) {
  }
  /**
   * OPTIONALLY OVERRIDE THIS
   *
   * You can override this to perform actions when a new route begins, e.g.
   * you may want to log or track which connection is being processed.
   */
  routeStartedHook(connection) {
  }
  ripSolvedRoute(solvedRoute) {
    for (const port of solvedRoute.path.map((candidate) => candidate.port)) {
      port.ripCount = (port.ripCount ?? 0) + 1;
      port.region1.assignments = port.region1.assignments?.filter(
        (a) => a.regionPort1 !== port && a.regionPort2 !== port
      );
      port.region2.assignments = port.region2.assignments?.filter(
        (a) => a.regionPort1 !== port && a.regionPort2 !== port
      );
      port.assignment = void 0;
    }
    this.solvedRoutes = this.solvedRoutes.filter((r) => r !== solvedRoute);
    this.unprocessedConnections.push(solvedRoute.connection);
  }
  beginNewConnection() {
    this.currentConnection = this.unprocessedConnections.shift();
    this.currentEndRegion = this.currentConnection.endRegion;
    this.candidateQueue = new PriorityQueue();
    this.visitedPointsForCurrentConnection.clear();
    this.routeStartedHook(this.currentConnection);
    for (const port of this.currentConnection.startRegion.ports) {
      this.candidateQueue.enqueue({
        port,
        g: 0,
        h: 0,
        f: 0,
        hops: 0,
        ripRequired: false,
        nextRegion: port.region1 === this.currentConnection.startRegion ? port.region2 : port.region1
      });
    }
  }
  _step() {
    let currentCandidate = this.candidateQueue.dequeue();
    if (!currentCandidate) {
      this.failed = true;
      this.error = "Ran out of candidates";
      return;
    }
    let visitedPointGScore = this.visitedPointsForCurrentConnection.get(currentCandidate.port.portId);
    while (true) {
      if (!currentCandidate) break;
      if (visitedPointGScore === void 0) break;
      if (currentCandidate.g < visitedPointGScore) break;
      currentCandidate = this.candidateQueue.dequeue();
      if (!currentCandidate) break;
      visitedPointGScore = this.visitedPointsForCurrentConnection.get(
        currentCandidate.port.portId
      );
    }
    if (!currentCandidate) {
      this.failed = true;
      this.error = "Ran out of candidates";
      return;
    }
    this.lastCandidate = currentCandidate;
    this.visitedPointsForCurrentConnection.set(
      currentCandidate.port.portId,
      currentCandidate.g
    );
    if (currentCandidate.nextRegion === this.currentEndRegion) {
      this.processSolvedRoute(currentCandidate);
      if (this.unprocessedConnections.length === 0) {
        this.solved = true;
        return;
      }
      this.beginNewConnection();
      return;
    }
    const nextCandidates = this.getNextCandidates(currentCandidate);
    for (const nextCandidate of nextCandidates) {
      this.candidateQueue.enqueue(nextCandidate);
    }
  }
};

// lib/reattachSectionToGraph.ts
var reattachSectionToGraph = (input) => {
  const { fullGraph, solvedSectionGraph } = input;
  if (!fullGraph.solvedRoutes) {
    throw new Error("reattachSectionToGraph requires fullGraph.solvedRoutes");
  }
  if (!solvedSectionGraph.solvedRoutes) {
    throw new Error(
      "reattachSectionToGraph requires solvedSectionGraph.solvedRoutes"
    );
  }
  if (!solvedSectionGraph._sectionRouteBindings) {
    throw new Error(
      "reattachSectionToGraph requires solvedSectionGraph._sectionRouteBindings"
    );
  }
  const bindingByConnectionId = new Map(
    solvedSectionGraph._sectionRouteBindings.map((binding) => [
      binding.connectionId,
      binding
    ])
  );
  const replacementByConnectionId = new Map(
    solvedSectionGraph.solvedRoutes.map((route) => [
      route.connection.connectionId,
      route
    ])
  );
  return {
    ...fullGraph,
    solvedRoutes: fullGraph.solvedRoutes.map((fullSolvedRoute) => {
      const binding = bindingByConnectionId.get(
        fullSolvedRoute.connection.connectionId
      );
      if (!binding) return fullSolvedRoute;
      const replacementSolvedRoute = replacementByConnectionId.get(
        fullSolvedRoute.connection.connectionId
      );
      if (!replacementSolvedRoute) return fullSolvedRoute;
      const replacementInteriorPath = replacementSolvedRoute.path.slice(1, -1);
      const replacementPath = binding.solvedPathStartIndex === binding.solvedPathEndIndex ? [fullSolvedRoute.path[binding.solvedPathStartIndex]] : [
        fullSolvedRoute.path[binding.solvedPathStartIndex],
        ...replacementInteriorPath.map((candidate) => ({
          ...candidate
        })),
        fullSolvedRoute.path[binding.solvedPathEndIndex]
      ];
      return {
        connection: fullSolvedRoute.connection,
        requiredRip: fullSolvedRoute.requiredRip || replacementSolvedRoute.requiredRip,
        path: normalizeSerializedPath(
          [
            ...fullSolvedRoute.path.slice(0, binding.solvedPathStartIndex),
            ...replacementPath.map((candidate) => ({
              ...candidate
            })),
            ...fullSolvedRoute.path.slice(binding.solvedPathEndIndex + 1)
          ],
          fullGraph
        )
      };
    })
  };
};
var normalizeSerializedPath = (path, graph) => {
  const portMap = new Map(graph.ports.map((port) => [port.portId, port]));
  return path.map((candidate, index) => {
    const previousCandidate = index > 0 ? path[index - 1] : void 0;
    const nextCandidate = index < path.length - 1 ? path[index + 1] : void 0;
    return {
      ...candidate,
      hops: index,
      lastPortId: previousCandidate?.portId,
      lastRegionId: previousCandidate ? getSharedRegionId(portMap, previousCandidate.portId, candidate.portId) : void 0,
      nextRegionId: nextCandidate ? getSharedRegionId(portMap, candidate.portId, nextCandidate.portId) : void 0
    };
  });
};
var getSharedRegionId = (portMap, firstPortId, secondPortId) => {
  const firstPort = portMap.get(firstPortId);
  const secondPort = portMap.get(secondPortId);
  if (!firstPort || !secondPort) return void 0;
  const firstRegionIds = [firstPort.region1Id, firstPort.region2Id];
  return firstRegionIds.find(
    (regionId) => regionId === secondPort.region1Id || regionId === secondPort.region2Id
  );
};

// lib/pruneDeadEndPorts.ts
var pruneDeadEndPorts = (graph, retainedPortIds = []) => {
  const retainedPortIdSet = new Set(retainedPortIds);
  const regionPortCounts = new Map(
    graph.regions.map((region) => [region.regionId, region.ports.length])
  );
  const nextPorts = [];
  for (const region of graph.regions) {
    region.ports = [];
  }
  for (const port of graph.ports) {
    const isDeadEndPort = regionPortCounts.get(port.region1.regionId) === 1 || regionPortCounts.get(port.region2.regionId) === 1;
    if (isDeadEndPort && !retainedPortIdSet.has(port.portId)) {
      continue;
    }
    nextPorts.push(port);
    port.region1.ports.push(port);
    port.region2.ports.push(port);
  }
  graph.ports = nextPorts;
  graph.regions = graph.regions.filter((region) => region.ports.length > 0);
  return graph;
};

// lib/HyperGraphSectionOptimizer/HyperGraphSectionOptimizer.ts
import { BaseSolver as BaseSolver2 } from "@tscircuit/solver-utils";

// lib/JumperGraphSolver/perimeterChordUtils.ts
function clamp2(value, min, max) {
  return Math.max(min, Math.min(max, value));
}
function dist2(a, b) {
  const dx = a.x - b.x;
  const dy = a.y - b.y;
  return dx * dx + dy * dy;
}
function getRectanglePerimeter(xmin, xmax, ymin, ymax) {
  return 2 * (xmax - xmin) + 2 * (ymax - ymin);
}
function perimeterT(p, xmin, xmax, ymin, ymax) {
  const W = xmax - xmin;
  const H = ymax - ymin;
  const eps = 1e-6;
  if (Math.abs(p.y - ymax) < eps) return p.x - xmin;
  if (Math.abs(p.x - xmax) < eps) return W + (ymax - p.y);
  if (Math.abs(p.y - ymin) < eps) return W + H + (xmax - p.x);
  if (Math.abs(p.x - xmin) < eps) return 2 * W + H + (p.y - ymin);
  const distTop = Math.abs(p.y - ymax);
  const distRight = Math.abs(p.x - xmax);
  const distBottom = Math.abs(p.y - ymin);
  const distLeft = Math.abs(p.x - xmin);
  const minDist = Math.min(distTop, distRight, distBottom, distLeft);
  if (minDist === distTop) return Math.max(0, Math.min(W, p.x - xmin));
  if (minDist === distRight) return W + Math.max(0, Math.min(H, ymax - p.y));
  if (minDist === distBottom) {
    return W + H + Math.max(0, Math.min(W, xmax - p.x));
  }
  return 2 * W + H + Math.max(0, Math.min(H, p.y - ymin));
}
function projectToSegment(p, a, b) {
  const abx = b.x - a.x;
  const aby = b.y - a.y;
  const apx = p.x - a.x;
  const apy = p.y - a.y;
  const ab2 = abx * abx + aby * aby;
  const u = ab2 > 0 ? clamp2((apx * abx + apy * aby) / ab2, 0, 1) : 0;
  const q = { x: a.x + u * abx, y: a.y + u * aby };
  return { u, d2: dist2(p, q) };
}
function createPolygonPerimeterCache(polygon2) {
  const n = polygon2.length;
  const edgeLengths = new Array(n);
  const cumulative = new Array(n + 1);
  cumulative[0] = 0;
  for (let i = 0; i < n; i++) {
    const a = polygon2[i];
    const b = polygon2[(i + 1) % n];
    const edgeLength = Math.hypot(b.x - a.x, b.y - a.y);
    edgeLengths[i] = edgeLength;
    cumulative[i + 1] = cumulative[i] + edgeLength;
  }
  return { edgeLengths, cumulative, perimeter: cumulative[n] };
}
function perimeterTPolygonWithCache(p, polygon2, cache, eps = 1e-6) {
  let bestEdgeIndex = 0;
  let bestU = 0;
  let bestD2 = Number.POSITIVE_INFINITY;
  const eps2 = eps * eps;
  for (let i = 0; i < polygon2.length; i++) {
    const a = polygon2[i];
    const b = polygon2[(i + 1) % polygon2.length];
    const projected = projectToSegment(p, a, b);
    if (projected.d2 <= eps2) {
      bestEdgeIndex = i;
      bestU = projected.u;
      bestD2 = projected.d2;
      break;
    }
    if (projected.d2 < bestD2) {
      bestEdgeIndex = i;
      bestU = projected.u;
      bestD2 = projected.d2;
    }
  }
  return cache.cumulative[bestEdgeIndex] + bestU * cache.edgeLengths[bestEdgeIndex];
}
function getRegionPolygonCache(region) {
  const polygon2 = region.d.polygon;
  if (!polygon2 || polygon2.length < 3) return null;
  const existing = region.d.polygonPerimeterCache;
  if (existing) return existing;
  const cache = createPolygonPerimeterCache(polygon2);
  region.d.polygonPerimeterCache = cache;
  return cache;
}
function getRegionPerimeter(region) {
  const polygonCache = getRegionPolygonCache(region);
  if (polygonCache) return polygonCache.perimeter;
  const { minX, maxX, minY, maxY } = region.d.bounds;
  return getRectanglePerimeter(minX, maxX, minY, maxY);
}
function getPortPerimeterTInRegion(port, region) {
  if (port.region1 === region) {
    if (typeof port.region1T === "number") return port.region1T;
    const t = getPointPerimeterTInRegion(port.d, region);
    port.region1T = t;
    return t;
  }
  if (port.region2 === region) {
    if (typeof port.region2T === "number") return port.region2T;
    const t = getPointPerimeterTInRegion(port.d, region);
    port.region2T = t;
    return t;
  }
  return getPointPerimeterTInRegion(port.d, region);
}
function getPointPerimeterTInRegion(p, region) {
  const polygon2 = region.d.polygon;
  if (polygon2 && polygon2.length >= 3) {
    const cache = getRegionPolygonCache(region);
    if (cache) return perimeterTPolygonWithCache(p, polygon2, cache);
  }
  const { minX, maxX, minY, maxY } = region.d.bounds;
  return perimeterT(p, minX, maxX, minY, maxY);
}
function areCoincident(t1, t2, eps = 1e-6) {
  return Math.abs(t1 - t2) < eps;
}
function normalizeMod(value, modulus) {
  return (value % modulus + modulus) % modulus;
}
function areCoincidentOnCircle(t1, t2, perimeter, eps) {
  const delta = Math.abs(normalizeMod(t1 - t2, perimeter));
  return delta < eps || perimeter - delta < eps;
}
function betweenMod(x, start, end, perimeter, eps) {
  const nx = normalizeMod(x, perimeter);
  const ns = normalizeMod(start, perimeter);
  const ne = normalizeMod(end, perimeter);
  if (Math.abs(ns - ne) < eps) return false;
  if (ns < ne) return ns < nx && nx < ne;
  return nx > ns || nx < ne;
}
function chordsCross(chord1, chord2, perimeter) {
  if (typeof perimeter === "number" && perimeter > 0) {
    let [a2, b2] = chord1;
    let [c2, d2] = chord2;
    a2 = normalizeMod(a2, perimeter);
    b2 = normalizeMod(b2, perimeter);
    c2 = normalizeMod(c2, perimeter);
    d2 = normalizeMod(d2, perimeter);
    if (areCoincidentOnCircle(a2, c2, perimeter, 1e-6) || areCoincidentOnCircle(a2, d2, perimeter, 1e-6) || areCoincidentOnCircle(b2, c2, perimeter, 1e-6) || areCoincidentOnCircle(b2, d2, perimeter, 1e-6)) {
      return false;
    }
    const cInside = betweenMod(c2, a2, b2, perimeter, 1e-12);
    const dInside = betweenMod(d2, a2, b2, perimeter, 1e-12);
    return cInside !== dInside;
  }
  const [a, b] = chord1[0] < chord1[1] ? chord1 : [chord1[1], chord1[0]];
  const [c, d] = chord2[0] < chord2[1] ? chord2 : [chord2[1], chord2[0]];
  if (areCoincident(a, c) || areCoincident(a, d) || areCoincident(b, c) || areCoincident(b, d)) {
    return false;
  }
  return a < c && c < b && b < d || c < a && a < d && d < b;
}

// lib/JumperGraphSolver/jumper-graph-generator/calculateGraphBounds.ts
var calculateGraphBounds = (regions) => {
  let minX = Number.POSITIVE_INFINITY;
  let maxX = Number.NEGATIVE_INFINITY;
  let minY = Number.POSITIVE_INFINITY;
  let maxY = Number.NEGATIVE_INFINITY;
  for (const region of regions) {
    const { bounds } = region.d;
    minX = Math.min(minX, bounds.minX);
    maxX = Math.max(maxX, bounds.maxX);
    minY = Math.min(minY, bounds.minY);
    maxY = Math.max(maxY, bounds.maxY);
  }
  return { minX, maxX, minY, maxY };
};

// lib/JumperGraphSolver/jumper-graph-generator/createConnectionPort.ts
var createConnectionPort = (portId, connectionRegion, boundaryRegion, portPosition) => {
  const port = {
    portId,
    region1: connectionRegion,
    region2: boundaryRegion,
    d: { x: portPosition.x, y: portPosition.y }
  };
  connectionRegion.ports.push(port);
  boundaryRegion.ports.push(port);
  return port;
};

// lib/JumperGraphSolver/jumper-graph-generator/createConnectionRegion.ts
var CONNECTION_REGION_SIZE = 0.4;
var createConnectionRegion = (regionId, x, y) => {
  const halfSize = CONNECTION_REGION_SIZE / 2;
  return {
    regionId,
    ports: [],
    d: {
      bounds: {
        minX: x - halfSize,
        maxX: x + halfSize,
        minY: y - halfSize,
        maxY: y + halfSize
      },
      center: { x, y },
      isPad: false,
      isConnectionRegion: true
    }
  };
};

// lib/JumperGraphSolver/jumper-graph-generator/findBoundaryRegion.ts
var EPS = 0.01;
var clamp3 = (value, min, max) => {
  return Math.max(min, Math.min(max, value));
};
var getBoundarySidesForPoint = (x, y, graphBounds) => {
  const sides = [];
  if (Math.abs(x - graphBounds.minX) < EPS) sides.push("left");
  if (Math.abs(x - graphBounds.maxX) < EPS) sides.push("right");
  if (Math.abs(y - graphBounds.maxY) < EPS) sides.push("top");
  if (Math.abs(y - graphBounds.minY) < EPS) sides.push("bottom");
  return sides;
};
var isPointOnSide = (p, side, b) => {
  if (side === "left") return Math.abs(p.x - b.minX) < EPS;
  if (side === "right") return Math.abs(p.x - b.maxX) < EPS;
  if (side === "top") return Math.abs(p.y - b.maxY) < EPS;
  return Math.abs(p.y - b.minY) < EPS;
};
var projectToSegment2 = (x, y, a, b) => {
  const abx = b.x - a.x;
  const aby = b.y - a.y;
  const apx = x - a.x;
  const apy = y - a.y;
  const ab2 = abx * abx + aby * aby;
  const t = ab2 > 0 ? clamp3((apx * abx + apy * aby) / ab2, 0, 1) : 0;
  const px = a.x + t * abx;
  const py = a.y + t * aby;
  const dx = x - px;
  const dy = y - py;
  return {
    x: px,
    y: py,
    d2: dx * dx + dy * dy
  };
};
var getRegionBoundaryProjection = (x, y, region, graphBounds, preferredSides) => {
  const polygon2 = region.d.polygon;
  if (polygon2 && polygon2.length >= 3) {
    const sideSet = new Set(preferredSides);
    let best2 = null;
    for (let i = 0; i < polygon2.length; i++) {
      const a = polygon2[i];
      const b = polygon2[(i + 1) % polygon2.length];
      if (preferredSides.length > 0) {
        const edgeOnPreferredSide = preferredSides.some(
          (side) => isPointOnSide(a, side, graphBounds) && isPointOnSide(b, side, graphBounds) && sideSet.has(side)
        );
        if (!edgeOnPreferredSide) continue;
      }
      const p = projectToSegment2(x, y, a, b);
      if (!best2 || p.d2 < best2.d2) {
        best2 = p;
      }
    }
    if (best2) return best2;
  }
  const bounds = region.d.bounds;
  const sideCandidates = [];
  if (preferredSides.length > 0) {
    for (const side of preferredSides) {
      if (side === "left") {
        sideCandidates.push({
          side,
          x: bounds.minX,
          y: clamp3(y, bounds.minY, bounds.maxY)
        });
      } else if (side === "right") {
        sideCandidates.push({
          side,
          x: bounds.maxX,
          y: clamp3(y, bounds.minY, bounds.maxY)
        });
      } else if (side === "top") {
        sideCandidates.push({
          side,
          x: clamp3(x, bounds.minX, bounds.maxX),
          y: bounds.maxY
        });
      } else {
        sideCandidates.push({
          side,
          x: clamp3(x, bounds.minX, bounds.maxX),
          y: bounds.minY
        });
      }
    }
  }
  if (sideCandidates.length === 0) {
    sideCandidates.push(
      { side: "left", x: bounds.minX, y: clamp3(y, bounds.minY, bounds.maxY) },
      {
        side: "right",
        x: bounds.maxX,
        y: clamp3(y, bounds.minY, bounds.maxY)
      },
      { side: "top", x: clamp3(x, bounds.minX, bounds.maxX), y: bounds.maxY },
      {
        side: "bottom",
        x: clamp3(x, bounds.minX, bounds.maxX),
        y: bounds.minY
      }
    );
  }
  let best = null;
  for (const c of sideCandidates) {
    if (preferredSides.length > 0 && !preferredSides.includes(c.side)) continue;
    const dx = x - c.x;
    const dy = y - c.y;
    const d2 = dx * dx + dy * dy;
    if (!best || d2 < best.d2) {
      best = { x: c.x, y: c.y, d2 };
    }
  }
  return best;
};
var findBoundaryRegion = (x, y, regions, graphBounds) => {
  const preferredSides = getBoundarySidesForPoint(x, y, graphBounds);
  let closestRegion = null;
  let closestDistance = Number.POSITIVE_INFINITY;
  let closestPortPosition = { x, y };
  for (const region of regions) {
    if (region.d.isPad || region.d.isThroughJumper) continue;
    const bounds = region.d.bounds;
    const isOuterRegion = Math.abs(bounds.minX - graphBounds.minX) < 0.01 || Math.abs(bounds.maxX - graphBounds.maxX) < 0.01 || Math.abs(bounds.minY - graphBounds.minY) < 0.01 || Math.abs(bounds.maxY - graphBounds.maxY) < 0.01;
    if (!isOuterRegion) continue;
    const projection = getRegionBoundaryProjection(
      x,
      y,
      region,
      graphBounds,
      preferredSides
    );
    if (!projection) continue;
    const dist = Math.sqrt(projection.d2);
    if (dist < closestDistance) {
      closestDistance = dist;
      closestRegion = region;
      closestPortPosition = { x: projection.x, y: projection.y };
    }
  }
  if (closestRegion) {
    return { region: closestRegion, portPosition: closestPortPosition };
  }
  return null;
};

// lib/JumperGraphSolver/jumper-graph-generator/createGraphWithConnectionsFromBaseGraph.ts
var createGraphWithConnectionsFromBaseGraph = (baseGraph, xyConnections) => {
  const regions = [...baseGraph.regions];
  const ports = [...baseGraph.ports];
  const connections = [];
  const graphBounds = calculateGraphBounds(baseGraph.regions);
  for (const xyConn of xyConnections) {
    const { start, end, connectionId } = xyConn;
    const startRegion = createConnectionRegion(
      `conn:${connectionId}:start`,
      start.x,
      start.y
    );
    regions.push(startRegion);
    const endRegion = createConnectionRegion(
      `conn:${connectionId}:end`,
      end.x,
      end.y
    );
    regions.push(endRegion);
    const startBoundary = findBoundaryRegion(
      start.x,
      start.y,
      baseGraph.regions,
      graphBounds
    );
    if (startBoundary) {
      const startPort = createConnectionPort(
        `conn:${connectionId}:start-port`,
        startRegion,
        startBoundary.region,
        startBoundary.portPosition
      );
      ports.push(startPort);
    }
    const endBoundary = findBoundaryRegion(
      end.x,
      end.y,
      baseGraph.regions,
      graphBounds
    );
    if (endBoundary) {
      const endPort = createConnectionPort(
        `conn:${connectionId}:end-port`,
        endRegion,
        endBoundary.region,
        endBoundary.portPosition
      );
      ports.push(endPort);
    }
    const connection = {
      connectionId,
      mutuallyConnectedNetworkId: connectionId,
      startRegion,
      endRegion
    };
    connections.push(connection);
  }
  return {
    regions,
    ports,
    connections
  };
};

// lib/JumperGraphSolver/jumper-graph-generator/createProblemFromBaseGraph.ts
var createSeededRandom = (seed) => {
  let state = seed;
  return () => {
    state = state * 1664525 + 1013904223 >>> 0;
    return state / 4294967295;
  };
};

// lib/HyperGraphSectionOptimizer/routes/previewSectionReplacement.ts
var previewSectionReplacement = (input) => {
  const { solvedRoutes, section, replacementSolvedRoutes } = input;
  const replacementByConnectionId = new Map(
    replacementSolvedRoutes.map((route) => [
      route.connection.connectionId,
      route
    ])
  );
  return solvedRoutes.map((solvedRoute) => {
    const sectionRoute = section.sectionRoutes.find(
      (route) => route.globalConnection.connectionId === solvedRoute.connection.connectionId
    );
    if (!sectionRoute) return solvedRoute;
    const replacementSolvedRoute = replacementByConnectionId.get(
      solvedRoute.connection.connectionId
    );
    if (!replacementSolvedRoute) return solvedRoute;
    const path = [
      ...solvedRoute.path.slice(0, sectionRoute.sectionStartIndex),
      ...replacementSolvedRoute.path,
      ...solvedRoute.path.slice(sectionRoute.sectionEndIndex + 1)
    ];
    const copiedPath = path.map((candidate) => ({
      port: candidate.port,
      g: candidate.g,
      h: candidate.h,
      f: candidate.f,
      hops: candidate.hops,
      ripRequired: candidate.ripRequired,
      lastPort: candidate.lastPort,
      lastRegion: candidate.lastRegion,
      nextRegion: candidate.nextRegion
    }));
    for (let i = 0; i < copiedPath.length; i++) {
      copiedPath[i].parent = i > 0 ? copiedPath[i - 1] : void 0;
    }
    return {
      connection: solvedRoute.connection,
      path: copiedPath,
      requiredRip: solvedRoute.requiredRip || replacementSolvedRoute.requiredRip
    };
  });
};

// lib/HyperGraphSectionOptimizer/HyperGraphSectionOptimizer.ts
var HyperGraphSectionOptimizer = class extends BaseSolver2 {
  constructor(input) {
    super();
    this.input = input;
    this.graph = input.hyperGraphSolver.graph;
    const initialSolvedRoutes = input.inputSolvedRoutes;
    const inputConnections = input.hyperGraphSolver.connections;
    this.connections = inputConnections;
    this.solvedRoutes = commitSolvedRoutes({
      graph: this.graph,
      connections: this.connections,
      solvedRoutes: initialSolvedRoutes
    });
    this.maxAttemptsPerRegion = input.MAX_ATTEMPTS_PER_REGION;
    this.maxSectionAttempts = input.MAX_ATTEMPTS_PER_SECTION ?? 500;
    this.iterations += this.iterations * (input.effort ?? 1);
    this.fractionToReplace = input.FRACTION_TO_REPLACE ?? 0.2;
    this.alwaysRipConflicts = input.alwaysRipConflicts ?? true;
  }
  graph;
  connections;
  solvedRoutes;
  activeSection = null;
  baselineSectionCost = Infinity;
  baselineGlobalCost = Infinity;
  regionAttemptCounts = /* @__PURE__ */ new Map();
  sectionAttempts = 0;
  maxAttemptsPerRegion;
  maxSectionAttempts;
  fractionToReplace;
  alwaysRipConflicts;
  random = createSeededRandom(31337);
  getSolverName() {
    return "HyperGraphSectionOptimizer";
  }
  getConstructorParams() {
    return {
      inputGraph: convertHyperGraphToSerializedHyperGraph(this.graph),
      inputConnections: convertConnectionsToSerializedConnections(
        this.connections
      ),
      inputSolvedRoutes: this.solvedRoutes,
      expansionHopsFromCentralRegion: this.input.expansionHopsFromCentralRegion,
      maxAttemptsPerRegion: this.maxAttemptsPerRegion,
      maxSectionAttempts: this.maxSectionAttempts,
      effort: this.input.effort,
      fractionToReplace: this.fractionToReplace,
      alwaysRipConflicts: this.alwaysRipConflicts,
      ACCEPTABLE_COST: this.input.ACCEPTABLE_REGION_COST
    };
  }
  getOutput() {
    return this.solvedRoutes;
  }
  _setup() {
    this.beginSectionSolve();
  }
  visualize() {
    if (this.activeSubSolver) {
      return this.activeSubSolver.visualize();
    }
    return {
      title: "HyperGraphSectionOptimizer",
      points: [],
      lines: [],
      rects: [],
      circles: [],
      texts: [],
      polygons: [],
      arrows: []
    };
  }
  getCostOfRegionWithAttempts(region) {
    const attempts = this.regionAttemptCounts.get(region.regionId) ?? 0;
    return this.input.regionCost(region) + attempts * 1e4;
  }
  computeCostOfSection({
    section,
    solvedRoutes
  }) {
    if (this.input.computeSolvedGraphCost) {
      return this.input.computeSolvedGraphCost(solvedRoutes);
    }
    const solver = this.input.createHyperGraphSolver({
      inputGraph: section.graph,
      inputConnections: section.connections,
      inputSolvedRoutes: solvedRoutes
    });
    let totalCost = 0;
    for (const region of solver.graph.regions) {
      totalCost += this.input.regionCost(region);
    }
    return totalCost;
  }
  computeSolvedGraphCost(solvedRoutes) {
    if (this.input.computeSolvedGraphCost) {
      return this.input.computeSolvedGraphCost(solvedRoutes);
    }
    const solver = this.input.createHyperGraphSolver({
      inputGraph: this.graph,
      inputConnections: this.connections,
      inputSolvedRoutes: solvedRoutes
    });
    let totalCost = 0;
    for (const region of solver.graph.regions) {
      totalCost += this.input.regionCost(region);
    }
    return totalCost;
  }
  /**
   * TODO default behavior should be to rip entire section
   */
  determineConnectionsToRip(section, evaluationSolver) {
    const allConnectionIds = section.sectionRoutes.map(
      (route) => route.globalConnection.connectionId
    );
    if (this.fractionToReplace >= 1) {
      return new Set(allConnectionIds);
    }
    const shuffledConnectionIds = [...allConnectionIds];
    for (let index = shuffledConnectionIds.length - 1; index > 0; index--) {
      const swapIndex = Math.floor(this.random() * (index + 1));
      [shuffledConnectionIds[index], shuffledConnectionIds[swapIndex]] = [
        shuffledConnectionIds[swapIndex],
        shuffledConnectionIds[index]
      ];
    }
    const ripCount = Math.max(
      1,
      Math.ceil(shuffledConnectionIds.length * this.fractionToReplace)
    );
    const connectionsToReroute = new Set(
      shuffledConnectionIds.slice(0, ripCount)
    );
    if (!this.alwaysRipConflicts) {
      return connectionsToReroute;
    }
    const localRegionMap = new Map(
      section.graph.regions.map((region) => [region.regionId, region])
    );
    for (const route of section.sectionRoutes) {
      for (const candidate of route.sectionRoute.path) {
        if (!candidate.lastPort || !candidate.lastRegion) continue;
        const sectionRegion = localRegionMap.get(candidate.lastRegion.regionId);
        if (!sectionRegion) continue;
        evaluationSolver.currentConnection = route.globalConnection;
        const conflictingAssignments = evaluationSolver.getRipsRequiredForPortUsage(
          sectionRegion,
          candidate.lastPort,
          candidate.port
        );
        for (const conflict of conflictingAssignments) {
          const firstId = route.globalConnection.connectionId;
          const secondId = conflict.connection.connectionId;
          if (connectionsToReroute.has(firstId) || connectionsToReroute.has(secondId)) {
            continue;
          }
          connectionsToReroute.add(this.random() < 0.5 ? firstId : secondId);
        }
      }
    }
    return connectionsToReroute;
  }
  getNextCentralRegion() {
    let bestRegion = null;
    let bestCost = Infinity;
    for (const region of this.graph.regions) {
      if ((region.assignments?.length ?? 0) === 0) continue;
      if ((this.regionAttemptCounts.get(region.regionId) ?? 0) >= this.maxAttemptsPerRegion) {
        continue;
      }
      const regionCost = this.input.regionCost(region);
      if (regionCost < this.input.ACCEPTABLE_REGION_COST) continue;
      const cost = this.getCostOfRegionWithAttempts(region);
      if (cost >= bestCost) continue;
      bestCost = cost;
      bestRegion = region;
    }
    return bestRegion;
  }
  beginSectionSolve() {
    if (this.sectionAttempts >= this.maxSectionAttempts) {
      console.log(
        `Reached max section attempts (${this.maxSectionAttempts}), stopping optimization`
      );
      this.solved = true;
      return;
    }
    const centralRegion = this.getNextCentralRegion();
    if (!centralRegion) {
      this.solved = true;
      return;
    }
    this.sectionAttempts++;
    this.activeSection = getSectionOfHyperGraphAsHyperGraph({
      graph: this.graph,
      solvedRoutes: this.solvedRoutes,
      centralRegion,
      expansionHopsFromCentralRegion: this.input.expansionHopsFromCentralRegion
    });
    if (!this.activeSection) {
      return;
    }
    if (this.activeSection.connections.length === 0) {
      this.regionAttemptCounts.set(
        centralRegion.regionId,
        (this.regionAttemptCounts.get(centralRegion.regionId) ?? 0) + 1
      );
      this.activeSection = null;
      return;
    }
    const fixedSectionRoutes = this.activeSection.sectionRoutes.filter(
      (route) => route.canRemainFixedInSectionSolve
    );
    const baselineSolver = this.input.createHyperGraphSolver({
      inputGraph: this.activeSection.graph,
      inputConnections: this.activeSection.connections,
      inputSolvedRoutes: fixedSectionRoutes.map((route) => route.sectionRoute)
    });
    const connectionsToReroute = this.determineConnectionsToRip(
      this.activeSection,
      baselineSolver
    );
    for (const route of this.activeSection.sectionRoutes) {
      if (!route.canRemainFixedInSectionSolve) {
        connectionsToReroute.add(route.globalConnection.connectionId);
      }
    }
    const remainingSectionRoutes = this.activeSection.sectionRoutes.filter(
      (route) => route.canRemainFixedInSectionSolve && !connectionsToReroute.has(route.globalConnection.connectionId)
    );
    const fixedSectionSolvedRoutes = remainingSectionRoutes.map(
      (route) => route.sectionRoute
    );
    const baselineSectionSolvedRoutes = [
      ...fixedSectionSolvedRoutes,
      ...this.activeSection.sectionRoutes.filter(
        (route) => connectionsToReroute.has(route.globalConnection.connectionId)
      ).map((route) => route.sectionRoute)
    ];
    this.baselineSectionCost = this.computeCostOfSection({
      section: this.activeSection,
      solvedRoutes: baselineSectionSolvedRoutes
    });
    this.baselineGlobalCost = this.computeSolvedGraphCost(this.solvedRoutes);
    this.activeSubSolver = this.input.createHyperGraphSolver({
      inputGraph: this.activeSection.graph,
      inputConnections: this.activeSection.connections,
      inputSolvedRoutes: fixedSectionSolvedRoutes
    });
    for (const conn of this.activeSubSolver.connections) {
      if (!conn.startRegion || !conn.endRegion) {
        console.error({
          startRegion: conn.startRegion?.regionId,
          endRegion: conn.endRegion?.regionId
        });
      }
    }
  }
  _step() {
    if (!this.activeSubSolver) {
      this.beginSectionSolve();
      return;
    }
    this.activeSubSolver.step();
    if (!this.activeSection) {
      return;
    }
    if (this.activeSubSolver.failed) {
      this.failedSubSolvers ??= [];
      this.failedSubSolvers.push(this.activeSubSolver);
      const attempts = this.regionAttemptCounts.get(this.activeSection.centralRegionId) ?? 0;
      this.regionAttemptCounts.set(
        this.activeSection.centralRegionId,
        attempts + 1
      );
      this.activeSubSolver = null;
      this.activeSection = null;
      this.baselineSectionCost = Infinity;
      this.baselineGlobalCost = Infinity;
      return;
    }
    if (!this.activeSubSolver.solved) return;
    const candidateSectionSolvedRoutes = this.activeSubSolver.solvedRoutes;
    const candidateCost = this.computeCostOfSection({
      section: this.activeSection,
      solvedRoutes: candidateSectionSolvedRoutes
    });
    const replacementAppliedSolvedRoutes = previewSectionReplacement({
      solvedRoutes: this.solvedRoutes,
      section: this.activeSection,
      replacementSolvedRoutes: candidateSectionSolvedRoutes
    });
    const candidateGlobalCost = this.computeSolvedGraphCost(
      replacementAppliedSolvedRoutes
    );
    const sectionNotWorse = candidateCost <= this.baselineSectionCost;
    const globalImproved = candidateGlobalCost < this.baselineGlobalCost;
    if (sectionNotWorse && globalImproved) {
      this.solvedRoutes = replacementAppliedSolvedRoutes;
      const sourceSolver = this.input.hyperGraphSolver;
      if (!sourceSolver) return;
      sourceSolver.solvedRoutes = commitSolvedRoutes({
        graph: sourceSolver.graph,
        connections: sourceSolver.connections,
        solvedRoutes: this.solvedRoutes
      });
      for (const regionId of this.activeSection.sectionRegionIds) {
        this.regionAttemptCounts.set(regionId, 0);
      }
      this.baselineSectionCost = candidateCost;
      this.baselineGlobalCost = candidateGlobalCost;
    } else {
      const attempts = this.regionAttemptCounts.get(this.activeSection.centralRegionId) ?? 0;
      this.regionAttemptCounts.set(
        this.activeSection.centralRegionId,
        attempts + 1
      );
    }
    this.activeSubSolver = null;
    this.activeSection = null;
    this.baselineSectionCost = Infinity;
    this.baselineGlobalCost = Infinity;
  }
};

// lib/HyperGraphSectionOptimizer/HyperGraphSectionOptimizer2.ts
import { BaseSolver as BaseSolver3 } from "@tscircuit/solver-utils";
var HyperGraphSectionOptimizer2 = class extends BaseSolver3 {
  config;
  rootSolver;
  graph;
  connections;
  solvedRoutes;
  activeAttempt = null;
  targetRegionAttemptCounts = /* @__PURE__ */ new Map();
  attemptedSectionCount = 0;
  constructor(input) {
    super();
    this.config = normalizeInput(input);
    this.rootSolver = this.createHyperGraphSolver({
      inputGraph: this.config.inputGraph,
      inputConnections: this.config.inputConnections,
      inputSolvedRoutes: this.config.inputSolvedRoutes
    });
    this.graph = this.rootSolver.graph;
    this.connections = this.rootSolver.connections;
    this.solvedRoutes = this.rootSolver.solvedRoutes;
    this.MAX_ITERATIONS = Math.ceil(this.MAX_ITERATIONS * this.config.effort);
  }
  getSolverName() {
    return "HyperGraphSectionOptimizer2";
  }
  getConstructorParams() {
    return {
      inputGraph: convertHyperGraphToSerializedHyperGraph(this.graph),
      inputConnections: convertConnectionsToSerializedConnections(
        this.connections
      ),
      inputSolvedRoutes: convertSolvedRoutesToSerializedSolvedRoutes(
        this.solvedRoutes
      ),
      sectionExpansionHops: this.config.sectionExpansionHops,
      maxTargetRegionAttempts: this.config.maxTargetRegionAttempts,
      maxSectionAttempts: this.config.maxSectionAttempts,
      minCentralRegionCost: this.config.minCentralRegionCost,
      ACCEPTABLE_CENTRAL_REGION_COST_START: this.config.centralRegionCostStart,
      ACCEPTABLE_CENTRAL_REGION_COST_END: this.config.centralRegionCostEnd,
      effort: this.config.effort
    };
  }
  getOutput() {
    return this.solvedRoutes;
  }
  _setup() {
    this.startNextSectionAttempt();
  }
  visualize() {
    if (this.activeSubSolver) {
      return this.activeSubSolver.visualize();
    }
    return {
      title: "HyperGraphSectionOptimizer2",
      points: [],
      lines: [],
      rects: [],
      circles: [],
      texts: [],
      polygons: [],
      arrows: []
    };
  }
  createHyperGraphSolver(input) {
    const graph = convertSerializedHyperGraphToHyperGraph(input.inputGraph);
    return new HyperGraphSolver({
      inputGraph: graph,
      inputConnections: input.inputConnections,
      inputSolvedRoutes: convertSerializedSolvedRoutesToSolvedRoutes(
        input.inputSolvedRoutes,
        graph
      )
    });
  }
  getCostOfCentralRegion(region) {
    const attempts = this.targetRegionAttemptCounts.get(region.regionId) ?? 0;
    return this.getRegionSolutionCost(this.rootSolver, region) + attempts * 1e4;
  }
  getSectionCost(input) {
    const sectionSolver = this.createHyperGraphSolver({
      inputGraph: input.solvedGraph,
      inputConnections: input.solvedGraph.connections ?? [],
      inputSolvedRoutes: input.solvedGraph.solvedRoutes ?? []
    });
    let totalCost = 0;
    for (const region of sectionSolver.graph.regions) {
      if (!input.sectionRegionIds.has(region.regionId)) continue;
      totalCost += this.getRegionSolutionCost(sectionSolver, region);
    }
    return totalCost;
  }
  _step() {
    if (!this.activeSubSolver) {
      this.startNextSectionAttempt();
      return;
    }
    this.activeSubSolver.step();
    if (!this.activeAttempt) return;
    if (this.activeSubSolver.failed) {
      this.rejectActiveAttempt();
      return;
    }
    if (!this.activeSubSolver.solved) return;
    const solvedBlankSection = {
      ...this.activeAttempt.blankSectionProblem,
      solvedRoutes: convertSolvedRoutesToSerializedSolvedRoutes(
        this.activeSubSolver.solvedRoutes
      )
    };
    const mergedGraph = reattachSectionToGraph({
      fullGraph: this.activeAttempt.fullGraphSnapshot,
      solvedSectionGraph: solvedBlankSection
    });
    const mergedSectionCost = this.getSectionCost({
      solvedGraph: mergedGraph,
      sectionRegionIds: this.activeAttempt.sectionRegionIds
    });
    if (mergedSectionCost < this.activeAttempt.currentSectionCost) {
      this.acceptMergedGraph(mergedGraph);
      return;
    }
    this.rejectActiveAttempt();
  }
  startNextSectionAttempt() {
    if (this.attemptedSectionCount >= this.config.maxSectionAttempts) {
      this.solved = true;
      return;
    }
    const targetRegion = this.selectTargetRegion();
    if (!targetRegion) {
      this.solved = true;
      return;
    }
    this.attemptedSectionCount += 1;
    const nextAttempt = this.createSectionSolveAttempt(targetRegion);
    if (!nextAttempt) {
      this.bumpTargetRegionAttemptCount(targetRegion.regionId);
      return;
    }
    this.activeAttempt = nextAttempt;
    this.activeSubSolver = this.createHyperGraphSolver({
      inputGraph: nextAttempt.blankSectionProblem,
      inputConnections: nextAttempt.blankSectionProblem.connections ?? [],
      inputSolvedRoutes: []
    });
  }
  selectTargetRegion() {
    let bestRegion = null;
    let bestCost = Infinity;
    const minCentralRegionCost = this.getMinCentralRegionCost();
    for (const region of this.graph.regions) {
      if ((region.assignments?.length ?? 0) === 0) continue;
      if ((this.targetRegionAttemptCounts.get(region.regionId) ?? 0) >= this.config.maxTargetRegionAttempts) {
        continue;
      }
      const cost = this.getCostOfCentralRegion(region);
      if (cost <= minCentralRegionCost) continue;
      if (cost >= bestCost) continue;
      bestCost = cost;
      bestRegion = region;
    }
    return bestRegion;
  }
  getMinCentralRegionCost() {
    const { centralRegionCostStart, centralRegionCostEnd } = this.config;
    if (centralRegionCostStart === void 0 || centralRegionCostEnd === void 0) {
      return this.config.minCentralRegionCost;
    }
    return this.interpolateCentralRegionCost(
      centralRegionCostStart,
      centralRegionCostEnd
    );
  }
  interpolateCentralRegionCost(start, end) {
    const attemptsToMax = Math.max(1, this.config.maxSectionAttempts - 1);
    const progress = Math.min(1, this.attemptedSectionCount / attemptsToMax);
    return start + (end - start) * progress;
  }
  createSectionSolveAttempt(targetRegion) {
    const fullGraphSnapshot = this.serializeSolvedGraph();
    const extractedSection = extractSectionOfHyperGraph({
      graph: fullGraphSnapshot,
      centralRegionId: targetRegion.regionId,
      expansionHopsFromCentralRegion: this.config.sectionExpansionHops
    });
    const prunedSection = this.pruneSectionForBlanking(extractedSection);
    if ((prunedSection.connections?.length ?? 0) === 0) {
      return null;
    }
    const sectionRegionIds = this.getSectionRegionIds(extractedSection);
    return {
      targetRegionId: targetRegion.regionId,
      sectionRegionIds,
      fullGraphSnapshot,
      blankSectionProblem: createBlankHyperGraph(prunedSection),
      currentSectionCost: this.getSectionCost({
        solvedGraph: fullGraphSnapshot,
        sectionRegionIds
      })
    };
  }
  acceptMergedGraph(mergedGraph) {
    this.rootSolver.solvedRoutes = commitSolvedRoutes({
      graph: this.rootSolver.graph,
      connections: this.rootSolver.connections,
      solvedRoutes: this.deserializeSolvedRoutes(mergedGraph)
    });
    this.solvedRoutes = this.rootSolver.solvedRoutes;
    this.graph = this.rootSolver.graph;
    this.connections = this.rootSolver.connections;
    for (const regionId of this.activeAttempt?.sectionRegionIds ?? []) {
      this.targetRegionAttemptCounts.set(regionId, 0);
    }
    this.clearActiveAttempt();
  }
  rejectActiveAttempt() {
    if (this.activeSubSolver?.failed) {
      this.failedSubSolvers ??= [];
      this.failedSubSolvers.push(this.activeSubSolver);
    }
    if (this.activeAttempt) {
      this.bumpTargetRegionAttemptCount(this.activeAttempt.targetRegionId);
    }
    this.clearActiveAttempt();
  }
  clearActiveAttempt() {
    this.activeSubSolver = null;
    this.activeAttempt = null;
  }
  bumpTargetRegionAttemptCount(regionId) {
    this.targetRegionAttemptCounts.set(
      regionId,
      (this.targetRegionAttemptCounts.get(regionId) ?? 0) + 1
    );
  }
  serializeSolvedGraph() {
    return {
      ...convertHyperGraphToSerializedHyperGraph(this.graph),
      connections: convertConnectionsToSerializedConnections(this.connections),
      solvedRoutes: convertSolvedRoutesToSerializedSolvedRoutes(
        this.solvedRoutes
      )
    };
  }
  deserializeSolvedRoutes(graph) {
    if (!graph.solvedRoutes) return [];
    return convertSerializedSolvedRoutesToSolvedRoutes(
      graph.solvedRoutes,
      convertSerializedHyperGraphToHyperGraph(graph)
    );
  }
  getSectionRegionIds(sectionGraph) {
    const fullRegionIds = new Set(
      this.graph.regions.map((region) => region.regionId)
    );
    return new Set(
      sectionGraph.regions.map((region) => region.regionId).filter((regionId) => fullRegionIds.has(regionId))
    );
  }
  pruneSectionForBlanking(extractedSection) {
    const mutableSectionGraph = convertSerializedHyperGraphToHyperGraph(extractedSection);
    const retainedPortIds = extractedSection.solvedRoutes?.flatMap((solvedRoute) => {
      const firstPortId = solvedRoute.path[0]?.portId;
      const lastPortId = solvedRoute.path[solvedRoute.path.length - 1]?.portId;
      return [firstPortId, lastPortId].filter(
        (portId) => Boolean(portId)
      );
    }) ?? [];
    pruneDeadEndPorts(mutableSectionGraph, retainedPortIds);
    return {
      ...convertHyperGraphToSerializedHyperGraph(mutableSectionGraph),
      connections: extractedSection.connections ? structuredClone(extractedSection.connections) : void 0,
      solvedRoutes: extractedSection.solvedRoutes ? structuredClone(extractedSection.solvedRoutes) : void 0,
      _sectionCentralRegionId: extractedSection._sectionCentralRegionId,
      _sectionRouteBindings: extractedSection._sectionRouteBindings ? structuredClone(extractedSection._sectionRouteBindings) : void 0
    };
  }
  getRegionSolutionCost(solver, region) {
    const previousConnection = solver.currentConnection;
    let totalCost = 0;
    for (const assignment of region.assignments ?? []) {
      solver.currentConnection = assignment.connection;
      totalCost += solver.computeIncreasedRegionCostIfPortsAreUsed(
        region,
        assignment.regionPort1,
        assignment.regionPort2
      );
    }
    solver.currentConnection = previousConnection;
    return totalCost;
  }
};
var normalizeInput = (input) => {
  const inputConnections = input.inputConnections ?? input.inputGraph.connections;
  const inputSolvedRoutes = input.inputSolvedRoutes ?? input.inputGraph.solvedRoutes;
  const sectionExpansionHops = input.sectionExpansionHops ?? input.expansionHopsFromCentralRegion;
  const maxTargetRegionAttempts = input.maxTargetRegionAttempts ?? input.MAX_ATTEMPTS_PER_REGION;
  if (!inputConnections) {
    throw new Error("HyperGraphSectionOptimizer2 requires inputConnections");
  }
  if (!inputSolvedRoutes) {
    throw new Error("HyperGraphSectionOptimizer2 requires inputSolvedRoutes");
  }
  if (sectionExpansionHops === void 0) {
    throw new Error("HyperGraphSectionOptimizer2 requires sectionExpansionHops");
  }
  if (maxTargetRegionAttempts === void 0) {
    throw new Error(
      "HyperGraphSectionOptimizer2 requires maxTargetRegionAttempts"
    );
  }
  const acceptableCentralRegionCostStart = input.ACCEPTABLE_CENTRAL_REGION_COST_START;
  const acceptableCentralRegionCostEnd = input.ACCEPTABLE_CENTRAL_REGION_COST_END;
  if (acceptableCentralRegionCostStart === void 0 !== (acceptableCentralRegionCostEnd === void 0)) {
    throw new Error(
      "HyperGraphSectionOptimizer2 requires both ACCEPTABLE_CENTRAL_REGION_COST_START and ACCEPTABLE_CENTRAL_REGION_COST_END"
    );
  }
  return {
    inputGraph: {
      ...input.inputGraph,
      connections: void 0,
      solvedRoutes: void 0
    },
    inputConnections: structuredClone(inputConnections),
    inputSolvedRoutes: structuredClone(inputSolvedRoutes),
    sectionExpansionHops,
    maxTargetRegionAttempts,
    maxSectionAttempts: input.maxSectionAttempts ?? input.MAX_ATTEMPTS_PER_SECTION ?? 500,
    minCentralRegionCost: input.minCentralRegionCost ?? input.ACCEPTABLE_CENTRAL_REGION_COST ?? 0,
    centralRegionCostStart: acceptableCentralRegionCostStart,
    centralRegionCostEnd: acceptableCentralRegionCostEnd,
    effort: input.effort ?? 1
  };
};

// node_modules/transformation-matrix/src/applyToPoint.js
function applyToPoint(matrix2, point2) {
  return Array.isArray(point2) ? [
    matrix2.a * point2[0] + matrix2.c * point2[1] + matrix2.e,
    matrix2.b * point2[0] + matrix2.d * point2[1] + matrix2.f
  ] : {
    x: matrix2.a * point2.x + matrix2.c * point2.y + matrix2.e,
    y: matrix2.b * point2.x + matrix2.d * point2.y + matrix2.f
  };
}

// node_modules/transformation-matrix/src/utils.js
function isUndefined(val) {
  return typeof val === "undefined";
}

// node_modules/transformation-matrix/src/translate.js
function translate(tx, ty = 0) {
  return {
    a: 1,
    c: 0,
    e: tx,
    b: 0,
    d: 1,
    f: ty
  };
}

// node_modules/transformation-matrix/src/transform.js
function transform(...matrices) {
  matrices = Array.isArray(matrices[0]) ? matrices[0] : matrices;
  const multiply = (m1, m2) => {
    return {
      a: m1.a * m2.a + m1.c * m2.b,
      c: m1.a * m2.c + m1.c * m2.d,
      e: m1.a * m2.e + m1.c * m2.f + m1.e,
      b: m1.b * m2.a + m1.d * m2.b,
      d: m1.b * m2.c + m1.d * m2.d,
      f: m1.b * m2.e + m1.d * m2.f + m1.f
    };
  };
  switch (matrices.length) {
    case 0:
      throw new Error("no matrices provided");
    case 1:
      return matrices[0];
    case 2:
      return multiply(matrices[0], matrices[1]);
    default: {
      const [m1, m2, ...rest] = matrices;
      const m = multiply(m1, m2);
      return transform(m, ...rest);
    }
  }
}
function compose(...matrices) {
  return transform(...matrices);
}

// node_modules/transformation-matrix/src/rotate.js
var { cos, sin, PI } = Math;
function rotate(angle, cx, cy) {
  const cosAngle = cos(angle);
  const sinAngle = sin(angle);
  const rotationMatrix = {
    a: cosAngle,
    c: -sinAngle,
    e: 0,
    b: sinAngle,
    d: cosAngle,
    f: 0
  };
  if (isUndefined(cx) || isUndefined(cy)) {
    return rotationMatrix;
  }
  return transform([
    translate(cx, cy),
    rotationMatrix,
    translate(-cx, -cy)
  ]);
}

// node_modules/transformation-matrix/src/skew.js
var { tan } = Math;

// lib/JumperGraphSolver/geometry/getBoundsCenter.ts
var computeBoundsCenter = (bounds) => {
  return {
    x: (bounds.minX + bounds.maxX) / 2,
    y: (bounds.minY + bounds.maxY) / 2
  };
};

// lib/JumperGraphSolver/geometry/applyTransformToGraph.ts
var applyTransformToGraph = (graph, matrix2) => {
  const transformedRegions = graph.regions.map((region) => {
    const { bounds, center, ...rest } = region.d;
    const corners = [
      { x: bounds.minX, y: bounds.minY },
      { x: bounds.maxX, y: bounds.minY },
      { x: bounds.minX, y: bounds.maxY },
      { x: bounds.maxX, y: bounds.maxY }
    ].map((corner) => applyToPoint(matrix2, corner));
    const newBounds = {
      minX: Math.min(...corners.map((c) => c.x)),
      maxX: Math.max(...corners.map((c) => c.x)),
      minY: Math.min(...corners.map((c) => c.y)),
      maxY: Math.max(...corners.map((c) => c.y))
    };
    const newCenter = applyToPoint(matrix2, center);
    return {
      ...region,
      // Clear ports array - will be rebuilt with new port objects
      ports: [],
      d: {
        ...rest,
        bounds: newBounds,
        center: newCenter
      }
    };
  });
  const regionMap = /* @__PURE__ */ new Map();
  for (let i = 0; i < graph.regions.length; i++) {
    regionMap.set(graph.regions[i], transformedRegions[i]);
  }
  const transformedPorts = graph.ports.map((port) => {
    const newPosition = applyToPoint(matrix2, port.d);
    const newRegion1 = regionMap.get(port.region1);
    const newRegion2 = regionMap.get(port.region2);
    const newPort = {
      ...port,
      region1: newRegion1,
      region2: newRegion2,
      d: newPosition
    };
    newRegion1.ports.push(newPort);
    newRegion2.ports.push(newPort);
    return newPort;
  });
  const transformedJumperLocations = graph.jumperLocations?.map((loc) => {
    const newCenter = applyToPoint(matrix2, loc.center);
    const newPadRegions = loc.padRegions.map(
      (region) => regionMap.get(region)
    );
    const unitX = applyToPoint(matrix2, { x: 1, y: 0 });
    const origin = applyToPoint(matrix2, { x: 0, y: 0 });
    const dx = unitX.x - origin.x;
    const dy = unitX.y - origin.y;
    const isRotated90 = Math.abs(dy) > Math.abs(dx);
    const newOrientation = isRotated90 ? loc.orientation === "horizontal" ? "vertical" : "horizontal" : loc.orientation;
    return {
      center: newCenter,
      orientation: newOrientation,
      padRegions: newPadRegions
    };
  });
  return {
    regions: transformedRegions,
    ports: transformedPorts,
    ...transformedJumperLocations && {
      jumperLocations: transformedJumperLocations
    }
  };
};
var rotateGraph90Degrees = (graph) => {
  const bounds = calculateGraphBounds(graph.regions);
  const center = computeBoundsCenter(bounds);
  const matrix2 = compose(
    translate(center.x, center.y),
    rotate(-Math.PI / 2),
    // -90 degrees (clockwise)
    translate(-center.x, -center.y)
  );
  return applyTransformToGraph(graph, matrix2);
};

// lib/JumperGraphSolver/computeCrossingAssignments.ts
function computeCrossingAssignments(region, port1, port2) {
  const perimeter = getRegionPerimeter(region);
  const t1 = getPortPerimeterTInRegion(port1, region);
  const t2 = getPortPerimeterTInRegion(port2, region);
  const newChord = [t1, t2];
  const crossingAssignments = [];
  const assignments = region.assignments ?? [];
  for (const assignment of assignments) {
    const existingT1 = getPortPerimeterTInRegion(
      assignment.regionPort1,
      region
    );
    const existingT2 = getPortPerimeterTInRegion(
      assignment.regionPort2,
      region
    );
    const existingChord = [existingT1, existingT2];
    if (chordsCross(newChord, existingChord, perimeter)) {
      crossingAssignments.push(assignment);
    }
  }
  return crossingAssignments;
}

// lib/JumperGraphSolver/computeDifferentNetCrossings.ts
function computeDifferentNetCrossings(region, port1, port2) {
  const perimeter = getRegionPerimeter(region);
  const t1 = getPortPerimeterTInRegion(port1, region);
  const t2 = getPortPerimeterTInRegion(port2, region);
  const newChord = [t1, t2];
  let crossings = 0;
  const assignments = region.assignments ?? [];
  for (const assignment of assignments) {
    const existingT1 = getPortPerimeterTInRegion(
      assignment.regionPort1,
      region
    );
    const existingT2 = getPortPerimeterTInRegion(
      assignment.regionPort2,
      region
    );
    const existingChord = [existingT1, existingT2];
    if (chordsCross(newChord, existingChord, perimeter)) {
      crossings++;
    }
  }
  return crossings;
}

// lib/JumperGraphSolver/countInputConnectionCrossings.ts
function countInputConnectionCrossings(graph, connections) {
  if (connections.length < 2) {
    return 0;
  }
  let minX = Infinity;
  let maxX = -Infinity;
  let minY = Infinity;
  let maxY = -Infinity;
  for (const region of graph.regions) {
    const jRegion = region;
    if (jRegion.d?.bounds) {
      minX = Math.min(minX, jRegion.d.bounds.minX);
      maxX = Math.max(maxX, jRegion.d.bounds.maxX);
      minY = Math.min(minY, jRegion.d.bounds.minY);
      maxY = Math.max(maxY, jRegion.d.bounds.maxY);
    } else if (jRegion.d?.center) {
      minX = Math.min(minX, jRegion.d.center.x);
      maxX = Math.max(maxX, jRegion.d.center.x);
      minY = Math.min(minY, jRegion.d.center.y);
      maxY = Math.max(maxY, jRegion.d.center.y);
    }
  }
  const regionCenterMap = /* @__PURE__ */ new Map();
  for (const region of graph.regions) {
    const jRegion = region;
    if (jRegion.d?.center) {
      regionCenterMap.set(region.regionId, jRegion.d.center);
    }
  }
  const chords = [];
  const perimeter = 2 * (maxX - minX) + 2 * (maxY - minY);
  for (const conn of connections) {
    let startCenter;
    let endCenter;
    if ("startRegion" in conn && conn.startRegion) {
      const startRegion = conn.startRegion;
      const endRegion = conn.endRegion;
      startCenter = startRegion.d?.center;
      endCenter = endRegion.d?.center;
    } else if ("startRegionId" in conn) {
      startCenter = regionCenterMap.get(conn.startRegionId);
      endCenter = regionCenterMap.get(conn.endRegionId);
    }
    if (!startCenter || !endCenter) {
      continue;
    }
    const t1 = perimeterT(startCenter, minX, maxX, minY, maxY);
    const t2 = perimeterT(endCenter, minX, maxX, minY, maxY);
    chords.push([t1, t2]);
  }
  let crossings = 0;
  for (let i = 0; i < chords.length; i++) {
    for (let j = i + 1; j < chords.length; j++) {
      if (chordsCross(chords[i], chords[j], perimeter)) {
        crossings++;
      }
    }
  }
  return crossings;
}

// lib/JumperGraphSolver/visualizeJumperGraph.ts
var visualizeJumperGraph = (graph, options) => {
  const graphics = {
    arrows: [],
    circles: [],
    title: "Jumper Graph",
    lines: [],
    points: [],
    rects: [],
    texts: [],
    polygons: [],
    coordinateSystem: "cartesian"
  };
  for (const region of graph.regions) {
    const { bounds, isPad, isThroughJumper, isConnectionRegion, polygon: polygon2 } = region.d;
    const centerX = (bounds.minX + bounds.maxX) / 2;
    const centerY = (bounds.minY + bounds.maxY) / 2;
    const width = bounds.maxX - bounds.minX;
    const height = bounds.maxY - bounds.minY;
    let fill;
    if (isConnectionRegion) {
      fill = "rgba(255, 100, 255, 0.6)";
    } else if (isThroughJumper) {
      fill = "rgba(100, 200, 100, 0.5)";
    } else if (isPad) {
      fill = "rgba(255, 200, 100, 0.5)";
    } else {
      fill = "rgba(200, 200, 255, 0.1)";
    }
    if (polygon2 && polygon2.length >= 3) {
      const points = polygon2;
      graphics.polygons.push({
        points,
        fill
      });
    } else {
      graphics.rects.push({
        center: { x: centerX, y: centerY },
        width: width - 0.1,
        height: height - 0.1,
        fill
      });
    }
  }
  if (!options?.hidePortPoints) {
    for (const port of graph.ports) {
      const r1Name = port.region1.regionId.split(":").pop() ?? port.region1.regionId;
      const r2Name = port.region2.regionId.split(":").pop() ?? port.region2.regionId;
      graphics.circles.push({
        center: { x: port.d.x, y: port.d.y },
        radius: 0.05,
        fill: "rgba(128, 128, 128, 0.5)",
        label: `${r1Name}-${r2Name}`
      });
    }
  }
  if (!options?.hideRegionPortLines) {
    for (const port of graph.ports) {
      const r1Center = {
        x: (port.region1.d.bounds.minX + port.region1.d.bounds.maxX) / 2,
        y: (port.region1.d.bounds.minY + port.region1.d.bounds.maxY) / 2
      };
      const r2Center = {
        x: (port.region2.d.bounds.minX + port.region2.d.bounds.maxX) / 2,
        y: (port.region2.d.bounds.minY + port.region2.d.bounds.maxY) / 2
      };
      graphics.lines.push({
        points: [r1Center, { x: port.d.x, y: port.d.y }, r2Center],
        strokeColor: "rgba(100, 100, 100, 0.3)"
      });
    }
  }
  if (options?.connections && !options?.hideConnectionLines) {
    for (const connection of options.connections) {
      const startRegion = connection.startRegion;
      const endRegion = connection.endRegion;
      const startCenter = {
        x: (startRegion.d.bounds.minX + startRegion.d.bounds.maxX) / 2,
        y: (startRegion.d.bounds.minY + startRegion.d.bounds.maxY) / 2
      };
      const endCenter = {
        x: (endRegion.d.bounds.minX + endRegion.d.bounds.maxX) / 2,
        y: (endRegion.d.bounds.minY + endRegion.d.bounds.maxY) / 2
      };
      const midX = (startCenter.x + endCenter.x) / 2;
      const midY = (startCenter.y + endCenter.y) / 2;
      graphics.lines.push({
        points: [startCenter, endCenter],
        strokeColor: "rgba(255, 50, 150, 0.8)",
        strokeDash: "3 3"
      });
      graphics.points.push({
        x: midX,
        y: midY,
        color: "rgba(200, 0, 100, 1)",
        label: connection.connectionId
      });
    }
  }
  return graphics;
};

// lib/JumperGraphSolver/visualizeJumperGraphSolver.ts
var getConnectionColor = (connectionId, alpha = 0.8) => {
  let hash = 0;
  for (let i = 0; i < connectionId.length; i++) {
    hash = connectionId.charCodeAt(i) * 17777 + ((hash << 5) - hash);
  }
  const hue = Math.abs(hash) % 360;
  return `hsla(${hue}, 70%, 50%, ${alpha})`;
};
var visualizeJumperGraphWithSolvedRoutes = (input) => {
  const graphics = visualizeJumperGraph(input.graph, {
    connections: input.connections,
    ...input.hideInitialGeometry ? {
      hideRegionPortLines: true,
      hideConnectionLines: true,
      hidePortPoints: true
    } : {}
  });
  if (!input.hideInitialGeometry) {
    for (const polygon2 of graphics.polygons) {
      polygon2.stroke = "rgba(128, 128, 128, 0.5)";
      polygon2.strokeWidth = 0.03;
    }
  }
  if (input.title) {
    graphics.title = input.title;
  }
  for (const solvedRoute of input.priorSolvedRoutes ?? []) {
    const pathPoints = solvedRoute.path.map((candidate) => {
      const port = candidate.port;
      return { x: port.d.x, y: port.d.y };
    });
    if (pathPoints.length === 0) continue;
    graphics.lines.push({
      points: pathPoints,
      strokeColor: "rgba(80, 80, 80, 0.45)",
      strokeDash: "4 4"
    });
  }
  for (const solvedRoute of input.solvedRoutes) {
    const connectionColor = getConnectionColor(
      solvedRoute.connection.connectionId
    );
    const pathPoints = [];
    for (const candidate of solvedRoute.path) {
      const port = candidate.port;
      pathPoints.push({ x: port.d.x, y: port.d.y });
    }
    if (pathPoints.length > 0) {
      graphics.lines.push({
        points: pathPoints,
        strokeColor: connectionColor
      });
    }
  }
  return graphics;
};
var visualizeJumperGraphSolver = (solver) => {
  const jumperGraph = {
    regions: solver.graph.regions,
    ports: solver.graph.ports
  };
  const graphics = visualizeJumperGraphWithSolvedRoutes({
    graph: jumperGraph,
    connections: solver.connections,
    solvedRoutes: solver.solvedRoutes,
    hideInitialGeometry: solver.iterations > 0
  });
  if (solver.currentConnection && !solver.solved) {
    const connectionColor = getConnectionColor(
      solver.currentConnection.connectionId
    );
    const startRegion = solver.currentConnection.startRegion;
    const endRegion = solver.currentConnection.endRegion;
    if (!startRegion?.d || !endRegion?.d) {
      return graphics;
    }
    const startCenter = {
      x: (startRegion.d.bounds.minX + startRegion.d.bounds.maxX) / 2,
      y: (startRegion.d.bounds.minY + startRegion.d.bounds.maxY) / 2
    };
    const endCenter = {
      x: (endRegion.d.bounds.minX + endRegion.d.bounds.maxX) / 2,
      y: (endRegion.d.bounds.minY + endRegion.d.bounds.maxY) / 2
    };
    graphics.lines.push({
      points: [startCenter, endCenter],
      strokeColor: connectionColor,
      strokeDash: "10 5"
    });
    graphics.points.push({
      x: startCenter.x - 0.1,
      y: startCenter.y + 0.1,
      color: connectionColor,
      label: [solver.currentConnection.connectionId, "start"].join("\n")
    });
    graphics.points.push({
      x: endCenter.x - 0.1,
      y: endCenter.y + 0.1,
      color: connectionColor,
      label: [solver.currentConnection.connectionId, "end"].join("\n")
    });
  }
  const candidates = solver.candidateQueue.peekMany(10);
  for (let candidateIndex = 0; candidateIndex < candidates.length; candidateIndex++) {
    const candidate = candidates[candidateIndex];
    const port = candidate.port;
    const isNext = candidateIndex === 0;
    graphics.points.push({
      x: port.d.x,
      y: port.d.y,
      color: isNext ? "green" : "rgba(128, 128, 128, 0.25)",
      label: [
        candidate.port.portId,
        `g: ${candidate.g.toFixed(2)}`,
        `h: ${candidate.h.toFixed(2)}`,
        `f: ${candidate.f.toFixed(2)}`
      ].join("\n")
    });
  }
  const nextCandidate = candidates[0];
  if (!solver.solved && nextCandidate && solver.currentConnection) {
    const connectionColor = getConnectionColor(
      solver.currentConnection.connectionId
    );
    const activePath = [];
    let cursor = nextCandidate;
    while (cursor) {
      const port = cursor.port;
      activePath.unshift({ x: port.d.x, y: port.d.y });
      cursor = cursor.parent;
    }
    if (activePath.length > 1) {
      graphics.lines.push({
        points: activePath,
        strokeColor: connectionColor
      });
    }
  }
  return graphics;
};

// lib/JumperGraphSolver/JumperGraphSolver.ts
var JUMPER_GRAPH_SOLVER_DEFAULTS = {
  portUsagePenalty: 0.034685181009478865,
  // portUsagePenaltySq: 0.06194817180037216,
  portUsagePenaltySq: 0,
  crossingPenalty: 4.072520483177124,
  crossingPenaltySq: 0,
  // crossingPenaltySq: 0.1315528159128946,
  ripCost: 35.38577539020022,
  greedyMultiplier: 0.5518001238069296
};
var JumperGraphSolver = class extends HyperGraphSolver {
  getSolverName() {
    return "JumperGraphSolver";
  }
  UNIT_OF_COST = "hops";
  portUsagePenalty = JUMPER_GRAPH_SOLVER_DEFAULTS.portUsagePenalty;
  portUsagePenaltySq = JUMPER_GRAPH_SOLVER_DEFAULTS.portUsagePenaltySq;
  crossingPenalty = JUMPER_GRAPH_SOLVER_DEFAULTS.crossingPenalty;
  crossingPenaltySq = JUMPER_GRAPH_SOLVER_DEFAULTS.crossingPenaltySq;
  ripCost = JUMPER_GRAPH_SOLVER_DEFAULTS.ripCost;
  baseMaxIterations = 4e3;
  additionalMaxIterationsPerConnection = 2e3;
  additionalMaxIterationsPerCrossing = 2e3;
  constructor(input) {
    super({
      greedyMultiplier: JUMPER_GRAPH_SOLVER_DEFAULTS.greedyMultiplier,
      rippingEnabled: true,
      ...input
    });
    this.ripCost = input.ripCost ?? this.ripCost;
    this.portUsagePenalty = input.portUsagePenalty ?? this.portUsagePenalty;
    this.crossingPenalty = input.crossingPenalty ?? this.crossingPenalty;
    this.baseMaxIterations = input.baseMaxIterations ?? this.baseMaxIterations;
    this.additionalMaxIterationsPerConnection = input.additionalMaxIterationsPerConnection ?? this.additionalMaxIterationsPerConnection;
    const crossings = countInputConnectionCrossings(
      this.graph,
      input.inputConnections
    );
    this.MAX_ITERATIONS = this.baseMaxIterations + input.inputConnections.length * this.additionalMaxIterationsPerConnection + crossings * this.additionalMaxIterationsPerCrossing;
    this.populateDistanceToEndMaps();
  }
  populateDistanceToEndMaps() {
    const endRegions = new Set(this.connections.map((c) => c.endRegion));
    for (const endRegion of endRegions) {
      const regionDistanceMap = /* @__PURE__ */ new Map();
      const queue = [];
      regionDistanceMap.set(endRegion.regionId, 0);
      queue.push({ region: endRegion, distance: 0 });
      while (queue.length > 0) {
        const { region, distance: dist } = queue.shift();
        for (const port of region.ports) {
          const otherRegion = port.region1 === region ? port.region2 : port.region1;
          if (!regionDistanceMap.has(otherRegion.regionId)) {
            regionDistanceMap.set(otherRegion.regionId, dist + 1);
            queue.push({ region: otherRegion, distance: dist + 1 });
          }
        }
      }
      for (const port of this.graph.ports) {
        if (!port.distanceToEndMap) {
          port.distanceToEndMap = {};
        }
        const d1 = regionDistanceMap.get(port.region1.regionId) ?? Infinity;
        const d2 = regionDistanceMap.get(port.region2.regionId) ?? Infinity;
        port.distanceToEndMap[endRegion.regionId] = Math.min(d1, d2);
      }
    }
  }
  estimateCostToEnd(port) {
    const endRegionId = this.currentEndRegion.regionId;
    const hopDistance = port.distanceToEndMap[endRegionId];
    return hopDistance;
  }
  getPortUsagePenalty(port) {
    const ripCount = port.ripCount ?? 0;
    return ripCount * this.portUsagePenalty + ripCount * this.portUsagePenaltySq;
  }
  isTransitionAllowed(region, port1, port2) {
    if (!region.d.isPad) return true;
    const usesThroughJumper = (port) => {
      const otherRegion = port.region1 === region ? port.region2 : port.region1;
      return Boolean(otherRegion.d.isThroughJumper);
    };
    return usesThroughJumper(port1) || usesThroughJumper(port2);
  }
  computeIncreasedRegionCostIfPortsAreUsed(region, port1, port2) {
    if (region.d.isPad) {
      const assignments = region.assignments ?? [];
      const differentNetCount = assignments.filter(
        (a) => a.connection.mutuallyConnectedNetworkId !== this.currentConnection.mutuallyConnectedNetworkId
      ).length;
      if (differentNetCount > 0) {
        return differentNetCount * this.crossingPenalty + differentNetCount * this.crossingPenaltySq;
      }
      return 0;
    }
    const crossings = computeDifferentNetCrossings(region, port1, port2);
    return crossings * this.crossingPenalty + crossings * this.crossingPenaltySq;
  }
  getRipsRequiredForPortUsage(region, port1, port2) {
    if (region.d.isPad) {
      const assignments = region.assignments ?? [];
      return assignments.filter(
        (a) => a.connection.mutuallyConnectedNetworkId !== this.currentConnection.mutuallyConnectedNetworkId
      );
    }
    const crossingAssignments = computeCrossingAssignments(region, port1, port2);
    const conflictingAssignments = crossingAssignments.filter(
      (a) => a.connection.mutuallyConnectedNetworkId !== this.currentConnection.mutuallyConnectedNetworkId
    );
    if (!region.d.isThroughJumper) return conflictingAssignments;
    for (const assignment of region.assignments ?? []) {
      if (assignment.connection.mutuallyConnectedNetworkId === this.currentConnection.mutuallyConnectedNetworkId) {
        continue;
      }
      conflictingAssignments.push(assignment);
    }
    return conflictingAssignments;
  }
  isRipRequiredForPortUsage(region, _port1, _port2) {
    if (!region.d.isThroughJumper && !region.d.isPad) return false;
    for (const assignment of region.assignments ?? []) {
      if (assignment.connection.mutuallyConnectedNetworkId !== this.currentConnection.mutuallyConnectedNetworkId) {
        return true;
      }
    }
    return false;
  }
  routeSolvedHook(solvedRoute) {
  }
  routeStartedHook(connection) {
  }
  visualize() {
    return visualizeJumperGraphSolver(this);
  }
};

// lib/JumperGraphSolver/jumper-graph-generator/generateSingleJumperRegions.ts
var dims0603 = {
  padToPad: 1.65,
  padLength: 0.8,
  padWidth: 0.95
};

// lib/JumperGraphSolver/jumper-graph-generator/generateJumperGrid.ts
var generateJumperGrid = ({
  cols,
  rows,
  marginX,
  marginY,
  innerColChannelPointCount = 1,
  innerRowChannelPointCount = 1,
  outerPaddingX = 0.5,
  outerPaddingY = 0.5,
  outerChannelXPoints,
  outerChannelYPoints,
  orientation: orientation2 = "vertical"
}) => {
  const effectiveOuterChannelXPoints = outerChannelXPoints ?? Math.max(1, Math.floor(outerPaddingX / 0.4));
  const effectiveOuterChannelYPoints = outerChannelYPoints ?? Math.max(1, Math.floor(outerPaddingY / 0.4));
  const regions = [];
  const ports = [];
  const { padToPad, padLength, padWidth } = dims0603;
  const padHalfLength = padLength / 2;
  const padHalfWidth = padWidth / 2;
  const horizontalSpacing = padToPad + padLength + marginX;
  const verticalSpacing = padWidth + marginY;
  const cells = [];
  const createRegion = (id, bounds, isPad, isThroughJumper) => ({
    regionId: id,
    ports: [],
    d: { bounds, center: computeBoundsCenter(bounds), isPad, isThroughJumper }
  });
  const createPort = (id, region1, region2) => {
    const b1 = region1.d.bounds;
    const b2 = region2.d.bounds;
    let x;
    let y;
    if (Math.abs(b1.maxX - b2.minX) < 1e-3) {
      x = b1.maxX;
      y = (Math.max(b1.minY, b2.minY) + Math.min(b1.maxY, b2.maxY)) / 2;
    } else if (Math.abs(b1.minX - b2.maxX) < 1e-3) {
      x = b1.minX;
      y = (Math.max(b1.minY, b2.minY) + Math.min(b1.maxY, b2.maxY)) / 2;
    } else if (Math.abs(b1.maxY - b2.minY) < 1e-3) {
      x = (Math.max(b1.minX, b2.minX) + Math.min(b1.maxX, b2.maxX)) / 2;
      y = b1.maxY;
    } else {
      x = (Math.max(b1.minX, b2.minX) + Math.min(b1.maxX, b2.maxX)) / 2;
      y = b1.minY;
    }
    const port = {
      portId: id,
      region1,
      region2,
      d: { x, y }
    };
    region1.ports.push(port);
    region2.ports.push(port);
    return port;
  };
  const createMultiplePorts = (idPrefix, region1, region2, count) => {
    if (count <= 0) return [];
    if (count === 1) {
      return [createPort(idPrefix, region1, region2)];
    }
    const b1 = region1.d.bounds;
    const b2 = region2.d.bounds;
    const result = [];
    let isVerticalBoundary;
    let boundaryCoord;
    let sharedMin;
    let sharedMax;
    if (Math.abs(b1.maxX - b2.minX) < 1e-3) {
      isVerticalBoundary = true;
      boundaryCoord = b1.maxX;
      sharedMin = Math.max(b1.minY, b2.minY);
      sharedMax = Math.min(b1.maxY, b2.maxY);
    } else if (Math.abs(b1.minX - b2.maxX) < 1e-3) {
      isVerticalBoundary = true;
      boundaryCoord = b1.minX;
      sharedMin = Math.max(b1.minY, b2.minY);
      sharedMax = Math.min(b1.maxY, b2.maxY);
    } else if (Math.abs(b1.maxY - b2.minY) < 1e-3) {
      isVerticalBoundary = false;
      boundaryCoord = b1.maxY;
      sharedMin = Math.max(b1.minX, b2.minX);
      sharedMax = Math.min(b1.maxX, b2.maxX);
    } else {
      isVerticalBoundary = false;
      boundaryCoord = b1.minY;
      sharedMin = Math.max(b1.minX, b2.minX);
      sharedMax = Math.min(b1.maxX, b2.maxX);
    }
    for (let i = 0; i < count; i++) {
      const t = (i + 0.5) / count;
      const coord = sharedMin + t * (sharedMax - sharedMin);
      const x = isVerticalBoundary ? boundaryCoord : coord;
      const y = isVerticalBoundary ? coord : boundaryCoord;
      const port = {
        portId: `${idPrefix}:${i}`,
        region1,
        region2,
        d: { x, y }
      };
      region1.ports.push(port);
      region2.ports.push(port);
      result.push(port);
    }
    return result;
  };
  for (let row = 0; row < rows; row++) {
    cells[row] = [];
    for (let col = 0; col < cols; col++) {
      const idPrefix = `cell_${row}_${col}`;
      const centerX = col * horizontalSpacing;
      const centerY = -row * verticalSpacing;
      const leftPadCenterX = centerX - padToPad / 2;
      const rightPadCenterX = centerX + padToPad / 2;
      const leftPadBounds = {
        minX: leftPadCenterX - padHalfLength,
        maxX: leftPadCenterX + padHalfLength,
        minY: centerY - padHalfWidth,
        maxY: centerY + padHalfWidth
      };
      const rightPadBounds = {
        minX: rightPadCenterX - padHalfLength,
        maxX: rightPadCenterX + padHalfLength,
        minY: centerY - padHalfWidth,
        maxY: centerY + padHalfWidth
      };
      const underjumperBounds = {
        minX: leftPadBounds.maxX,
        maxX: rightPadBounds.minX,
        minY: centerY - padHalfWidth,
        maxY: centerY + padHalfWidth
      };
      const throughjumperHeight = 0.3;
      const throughjumperBounds = {
        minX: leftPadCenterX,
        maxX: rightPadCenterX,
        minY: centerY - throughjumperHeight / 2,
        maxY: centerY + throughjumperHeight / 2
      };
      const mainMinX = leftPadBounds.minX;
      const mainMaxX = rightPadBounds.maxX;
      const mainMinY = leftPadBounds.minY;
      const mainMaxY = leftPadBounds.maxY;
      const leftPad = createRegion(`${idPrefix}:leftPad`, leftPadBounds, true);
      const rightPad = createRegion(
        `${idPrefix}:rightPad`,
        rightPadBounds,
        true
      );
      const underjumper = createRegion(
        `${idPrefix}:underjumper`,
        underjumperBounds,
        false
      );
      const throughjumper = createRegion(
        `${idPrefix}:throughjumper`,
        throughjumperBounds,
        false,
        true
      );
      regions.push(leftPad, rightPad, underjumper, throughjumper);
      const isFirstRow = row === 0;
      const isFirstCol = col === 0;
      const isLastRow = row === rows - 1;
      const isLastCol = col === cols - 1;
      let frameRightEdge;
      if (isLastCol) {
        frameRightEdge = mainMaxX + outerPaddingX;
      } else {
        const nextCenterX = (col + 1) * horizontalSpacing;
        const nextLeftPadCenterX = nextCenterX - padToPad / 2;
        frameRightEdge = nextLeftPadCenterX - padHalfLength;
      }
      let top = null;
      if (isFirstRow) {
        top = createRegion(
          `${idPrefix}:T`,
          {
            minX: isFirstCol ? mainMinX - outerPaddingX : mainMinX,
            maxX: frameRightEdge,
            minY: mainMaxY,
            maxY: mainMaxY + outerPaddingY
          },
          false
        );
        regions.push(top);
      }
      let bottom = null;
      const bottomHeight = isLastRow ? outerPaddingY : marginY;
      bottom = createRegion(
        `${idPrefix}:B`,
        {
          minX: isFirstCol ? mainMinX - outerPaddingX : mainMinX,
          maxX: frameRightEdge,
          minY: mainMinY - bottomHeight,
          maxY: mainMinY
        },
        false
      );
      regions.push(bottom);
      let left = null;
      if (isFirstCol) {
        left = createRegion(
          `${idPrefix}:L`,
          {
            minX: mainMinX - outerPaddingX,
            maxX: mainMinX,
            minY: mainMinY,
            maxY: mainMaxY
          },
          false
        );
        regions.push(left);
      }
      const right = createRegion(
        `${idPrefix}:R`,
        {
          minX: mainMaxX,
          maxX: frameRightEdge,
          minY: mainMinY,
          maxY: mainMaxY
        },
        false
      );
      regions.push(right);
      cells[row][col] = {
        leftPad,
        rightPad,
        underjumper,
        throughjumper,
        top,
        bottom,
        left,
        right
      };
      if (top) {
        if (left) {
          ports.push(
            ...createMultiplePorts(
              `${idPrefix}:T-L`,
              top,
              left,
              effectiveOuterChannelXPoints
            )
          );
        }
        ports.push(
          ...createMultiplePorts(
            `${idPrefix}:T-R`,
            top,
            right,
            isLastCol ? effectiveOuterChannelXPoints : innerColChannelPointCount
          )
        );
        ports.push(createPort(`${idPrefix}:T-UJ`, top, underjumper));
      }
      if (bottom) {
        if (left) {
          ports.push(
            ...createMultiplePorts(
              `${idPrefix}:B-L`,
              bottom,
              left,
              effectiveOuterChannelXPoints
            )
          );
        }
        ports.push(
          ...createMultiplePorts(
            `${idPrefix}:B-R`,
            bottom,
            right,
            isLastCol ? effectiveOuterChannelXPoints : innerColChannelPointCount
          )
        );
        ports.push(createPort(`${idPrefix}:B-UJ`, bottom, underjumper));
      }
      if (left) {
        ports.push(createPort(`${idPrefix}:L-LP`, left, leftPad));
      }
      ports.push(createPort(`${idPrefix}:R-RP`, right, rightPad));
      const leftThroughPort = {
        portId: `${idPrefix}:TJ-LP`,
        region1: throughjumper,
        region2: leftPad,
        d: { x: leftPadCenterX, y: centerY }
      };
      throughjumper.ports.push(leftThroughPort);
      leftPad.ports.push(leftThroughPort);
      ports.push(leftThroughPort);
      const rightThroughPort = {
        portId: `${idPrefix}:TJ-RP`,
        region1: throughjumper,
        region2: rightPad,
        d: { x: rightPadCenterX, y: centerY }
      };
      throughjumper.ports.push(rightThroughPort);
      rightPad.ports.push(rightThroughPort);
      ports.push(rightThroughPort);
      if (col > 0) {
        const prevCell = cells[row][col - 1];
        ports.push(
          createPort(
            `cell_${row}_${col - 1}->cell_${row}_${col}:R-LP`,
            prevCell.right,
            leftPad
          )
        );
        if (top && prevCell.top) {
          ports.push(
            ...createMultiplePorts(
              `cell_${row}_${col - 1}->cell_${row}_${col}:T-T`,
              prevCell.top,
              top,
              innerRowChannelPointCount
            )
          );
        }
        if (bottom && prevCell.bottom) {
          ports.push(
            ...createMultiplePorts(
              `cell_${row}_${col - 1}->cell_${row}_${col}:B-B`,
              prevCell.bottom,
              bottom,
              innerRowChannelPointCount
            )
          );
        }
      }
      if (row > 0) {
        const aboveCell = cells[row - 1][col];
        if (left) {
          ports.push(
            ...createMultiplePorts(
              `cell_${row - 1}_${col}->cell_${row}_${col}:B-L`,
              aboveCell.bottom,
              left,
              effectiveOuterChannelXPoints
            )
          );
        }
        ports.push(
          createPort(
            `cell_${row - 1}_${col}->cell_${row}_${col}:B-UJ`,
            aboveCell.bottom,
            underjumper
          )
        );
        ports.push(
          ...createMultiplePorts(
            `cell_${row - 1}_${col}->cell_${row}_${col}:B-R`,
            aboveCell.bottom,
            right,
            isLastCol ? effectiveOuterChannelXPoints : innerColChannelPointCount
          )
        );
      }
    }
  }
  let graph = {
    regions,
    ports
  };
  if (orientation2 === "horizontal") {
    const currentBounds = calculateGraphBounds(graph.regions);
    const currentCenter = computeBoundsCenter(currentBounds);
    const matrix2 = compose(
      translate(currentCenter.x, currentCenter.y),
      rotate(-Math.PI / 2),
      translate(-currentCenter.x, -currentCenter.y)
    );
    graph = applyTransformToGraph(graph, matrix2);
  }
  return graph;
};

// lib/JumperGraphSolver/jumper-graph-generator/generateSingleJumperX4Regions.ts
var dims1206x4 = {
  padWidth: 0.8,
  // X direction (horizontal)
  outerPadHeight: 0.5,
  // Y direction (vertical) for rows 1 and 4
  innerPadHeight: 0.4,
  // Y direction (vertical) for rows 2 and 3
  leftPadCenterX: -0.9,
  // X position of left pads (P1, P2, P3, P4)
  rightPadCenterX: 0.9,
  // X position of right pads (P5, P6, P7, P8)
  row1CenterY: -1.2,
  // Y position of row 1 (P1, P8)
  row2CenterY: -0.4,
  // Y position of row 2 (P2, P7)
  row3CenterY: 0.4,
  // Y position of row 3 (P3, P6)
  row4CenterY: 1.2
  // Y position of row 4 (P4, P5)
};

// lib/JumperGraphSolver/jumper-graph-generator/generateJumperX4Grid.ts
var generateJumperX4Grid = ({
  cols,
  rows,
  marginX,
  marginY,
  innerColChannelPointCount = 1,
  innerRowChannelPointCount = 1,
  regionsBetweenPads = false,
  outerPaddingX: outerPaddingXParam = 0.5,
  outerPaddingY: outerPaddingYParam = 0.5,
  outerChannelXPointCount,
  outerChannelYPointCount,
  orientation: orientation2 = "vertical",
  center,
  bounds,
  parallelTracesUnderJumperCount = 2
}) => {
  const regions = [];
  const ports = [];
  const {
    padWidth,
    outerPadHeight,
    innerPadHeight,
    leftPadCenterX,
    rightPadCenterX,
    row1CenterY,
    row2CenterY,
    row3CenterY,
    row4CenterY
  } = dims1206x4;
  const padHalfWidth = padWidth / 2;
  const outerPadHalfHeight = outerPadHeight / 2;
  const innerPadHalfHeight = innerPadHeight / 2;
  const cellWidth = rightPadCenterX - leftPadCenterX + padWidth;
  const horizontalSpacing = cellWidth + marginX;
  const cellHeight = row4CenterY - row1CenterY + outerPadHeight;
  const verticalSpacing = cellHeight + marginY;
  let outerPaddingX = outerPaddingXParam;
  let outerPaddingY = outerPaddingYParam;
  if (bounds) {
    const contentWidth = cols * cellWidth + (cols - 1) * marginX;
    const contentHeight = rows * cellHeight + (rows - 1) * marginY;
    const boundsWidth = orientation2 === "horizontal" ? bounds.maxY - bounds.minY : bounds.maxX - bounds.minX;
    const boundsHeight = orientation2 === "horizontal" ? bounds.maxX - bounds.minX : bounds.maxY - bounds.minY;
    outerPaddingX = (boundsWidth - contentWidth) / 2;
    outerPaddingY = (boundsHeight - contentHeight) / 2;
  }
  const effectiveOuterChannelXPoints = outerChannelXPointCount ?? Math.max(1, Math.floor(outerPaddingX / 0.4));
  const effectiveOuterChannelYPoints = outerChannelYPointCount ?? Math.max(1, Math.floor(outerPaddingY / 0.4));
  const cells = [];
  const collectedJumperLocations = [];
  const createRegion = (id, bounds2, isPad, isThroughJumper) => ({
    regionId: id,
    ports: [],
    d: { bounds: bounds2, center: computeBoundsCenter(bounds2), isPad, isThroughJumper }
  });
  const createPort = (id, region1, region2) => {
    const b1 = region1.d.bounds;
    const b2 = region2.d.bounds;
    let x;
    let y;
    if (Math.abs(b1.maxX - b2.minX) < 1e-3) {
      x = b1.maxX;
      y = (Math.max(b1.minY, b2.minY) + Math.min(b1.maxY, b2.maxY)) / 2;
    } else if (Math.abs(b1.minX - b2.maxX) < 1e-3) {
      x = b1.minX;
      y = (Math.max(b1.minY, b2.minY) + Math.min(b1.maxY, b2.maxY)) / 2;
    } else if (Math.abs(b1.maxY - b2.minY) < 1e-3) {
      x = (Math.max(b1.minX, b2.minX) + Math.min(b1.maxX, b2.maxX)) / 2;
      y = b1.maxY;
    } else {
      x = (Math.max(b1.minX, b2.minX) + Math.min(b1.maxX, b2.maxX)) / 2;
      y = b1.minY;
    }
    const port = {
      portId: id,
      region1,
      region2,
      d: { x, y }
    };
    region1.ports.push(port);
    region2.ports.push(port);
    return port;
  };
  const createMultiplePorts = (idPrefix, region1, region2, count) => {
    if (count <= 0) return [];
    if (count === 1) {
      return [createPort(idPrefix, region1, region2)];
    }
    const b1 = region1.d.bounds;
    const b2 = region2.d.bounds;
    const result = [];
    let isVerticalBoundary;
    let boundaryCoord;
    let sharedMin;
    let sharedMax;
    if (Math.abs(b1.maxX - b2.minX) < 1e-3) {
      isVerticalBoundary = true;
      boundaryCoord = b1.maxX;
      sharedMin = Math.max(b1.minY, b2.minY);
      sharedMax = Math.min(b1.maxY, b2.maxY);
    } else if (Math.abs(b1.minX - b2.maxX) < 1e-3) {
      isVerticalBoundary = true;
      boundaryCoord = b1.minX;
      sharedMin = Math.max(b1.minY, b2.minY);
      sharedMax = Math.min(b1.maxY, b2.maxY);
    } else if (Math.abs(b1.maxY - b2.minY) < 1e-3) {
      isVerticalBoundary = false;
      boundaryCoord = b1.maxY;
      sharedMin = Math.max(b1.minX, b2.minX);
      sharedMax = Math.min(b1.maxX, b2.maxX);
    } else {
      isVerticalBoundary = false;
      boundaryCoord = b1.minY;
      sharedMin = Math.max(b1.minX, b2.minX);
      sharedMax = Math.min(b1.maxX, b2.maxX);
    }
    for (let i = 0; i < count; i++) {
      const t = (i + 0.5) / count;
      const coord = sharedMin + t * (sharedMax - sharedMin);
      const x = isVerticalBoundary ? boundaryCoord : coord;
      const y = isVerticalBoundary ? coord : boundaryCoord;
      const port = {
        portId: `${idPrefix}:${i}`,
        region1,
        region2,
        d: { x, y }
      };
      region1.ports.push(port);
      region2.ports.push(port);
      result.push(port);
    }
    return result;
  };
  for (let row = 0; row < rows; row++) {
    cells[row] = [];
    for (let col = 0; col < cols; col++) {
      const idPrefix = `cell_${row}_${col}`;
      const centerX = col * horizontalSpacing;
      const centerY = -row * verticalSpacing;
      const p1CenterX = centerX + leftPadCenterX;
      const p1CenterY = centerY + row1CenterY;
      const p2CenterX = centerX + leftPadCenterX;
      const p2CenterY = centerY + row2CenterY;
      const p3CenterX = centerX + leftPadCenterX;
      const p3CenterY = centerY + row3CenterY;
      const p4CenterX = centerX + leftPadCenterX;
      const p4CenterY = centerY + row4CenterY;
      const p5CenterX = centerX + rightPadCenterX;
      const p5CenterY = centerY + row4CenterY;
      const p6CenterX = centerX + rightPadCenterX;
      const p6CenterY = centerY + row3CenterY;
      const p7CenterX = centerX + rightPadCenterX;
      const p7CenterY = centerY + row2CenterY;
      const p8CenterX = centerX + rightPadCenterX;
      const p8CenterY = centerY + row1CenterY;
      const createPadBounds = (padCenterX, padCenterY, halfHeight) => ({
        minX: padCenterX - padHalfWidth,
        maxX: padCenterX + padHalfWidth,
        minY: padCenterY - halfHeight,
        maxY: padCenterY + halfHeight
      });
      const pad1Bounds = createPadBounds(
        p1CenterX,
        p1CenterY,
        outerPadHalfHeight
      );
      const pad2Bounds = createPadBounds(
        p2CenterX,
        p2CenterY,
        innerPadHalfHeight
      );
      const pad3Bounds = createPadBounds(
        p3CenterX,
        p3CenterY,
        innerPadHalfHeight
      );
      const pad4Bounds = createPadBounds(
        p4CenterX,
        p4CenterY,
        outerPadHalfHeight
      );
      const pad5Bounds = createPadBounds(
        p5CenterX,
        p5CenterY,
        outerPadHalfHeight
      );
      const pad6Bounds = createPadBounds(
        p6CenterX,
        p6CenterY,
        innerPadHalfHeight
      );
      const pad7Bounds = createPadBounds(
        p7CenterX,
        p7CenterY,
        innerPadHalfHeight
      );
      const pad8Bounds = createPadBounds(
        p8CenterX,
        p8CenterY,
        outerPadHalfHeight
      );
      const underjumperBounds = {
        minX: pad1Bounds.maxX,
        maxX: pad8Bounds.minX,
        minY: pad1Bounds.minY,
        // row 1 is now at bottom (Y=-1.2)
        maxY: pad4Bounds.maxY
        // row 4 is now at top (Y=1.2)
      };
      const throughjumperHeight = 0.3;
      const throughjumper1Bounds = {
        minX: p1CenterX,
        maxX: p8CenterX,
        minY: p1CenterY - throughjumperHeight / 2,
        maxY: p1CenterY + throughjumperHeight / 2
      };
      const throughjumper2Bounds = {
        minX: p2CenterX,
        maxX: p7CenterX,
        minY: p2CenterY - throughjumperHeight / 2,
        maxY: p2CenterY + throughjumperHeight / 2
      };
      const throughjumper3Bounds = {
        minX: p3CenterX,
        maxX: p6CenterX,
        minY: p3CenterY - throughjumperHeight / 2,
        maxY: p3CenterY + throughjumperHeight / 2
      };
      const throughjumper4Bounds = {
        minX: p4CenterX,
        maxX: p5CenterX,
        minY: p4CenterY - throughjumperHeight / 2,
        maxY: p4CenterY + throughjumperHeight / 2
      };
      const mainMinX = pad1Bounds.minX;
      const mainMaxX = pad8Bounds.maxX;
      const mainMinY = pad1Bounds.minY;
      const mainMaxY = pad4Bounds.maxY;
      const pad1 = createRegion(`${idPrefix}:pad1`, pad1Bounds, true);
      const pad2 = createRegion(`${idPrefix}:pad2`, pad2Bounds, true);
      const pad3 = createRegion(`${idPrefix}:pad3`, pad3Bounds, true);
      const pad4 = createRegion(`${idPrefix}:pad4`, pad4Bounds, true);
      const pad5 = createRegion(`${idPrefix}:pad5`, pad5Bounds, true);
      const pad6 = createRegion(`${idPrefix}:pad6`, pad6Bounds, true);
      const pad7 = createRegion(`${idPrefix}:pad7`, pad7Bounds, true);
      const pad8 = createRegion(`${idPrefix}:pad8`, pad8Bounds, true);
      const underjumper = createRegion(
        `${idPrefix}:underjumper`,
        underjumperBounds,
        false
      );
      const throughjumper1 = createRegion(
        `${idPrefix}:throughjumper1`,
        throughjumper1Bounds,
        false,
        true
      );
      const throughjumper2 = createRegion(
        `${idPrefix}:throughjumper2`,
        throughjumper2Bounds,
        false,
        true
      );
      const throughjumper3 = createRegion(
        `${idPrefix}:throughjumper3`,
        throughjumper3Bounds,
        false,
        true
      );
      const throughjumper4 = createRegion(
        `${idPrefix}:throughjumper4`,
        throughjumper4Bounds,
        false,
        true
      );
      regions.push(
        pad1,
        pad2,
        pad3,
        pad4,
        pad5,
        pad6,
        pad7,
        pad8,
        underjumper,
        throughjumper1,
        throughjumper2,
        throughjumper3,
        throughjumper4
      );
      const jumperCenterX = (p1CenterX + p8CenterX) / 2;
      const jumperCenterY = (p1CenterY + p4CenterY) / 2;
      collectedJumperLocations.push({
        center: { x: jumperCenterX, y: jumperCenterY },
        orientation: "vertical",
        padRegions: [pad1, pad2, pad3, pad4, pad5, pad6, pad7, pad8]
      });
      let leftBP12 = null;
      let leftBP23 = null;
      let leftBP34 = null;
      let rightBP87 = null;
      let rightBP76 = null;
      let rightBP65 = null;
      if (regionsBetweenPads) {
        leftBP12 = createRegion(
          `${idPrefix}:L-BP12`,
          {
            minX: pad1Bounds.minX,
            maxX: pad1Bounds.maxX,
            minY: pad1Bounds.maxY,
            // top of pad1
            maxY: pad2Bounds.minY
            // bottom of pad2
          },
          false
        );
        leftBP23 = createRegion(
          `${idPrefix}:L-BP23`,
          {
            minX: pad2Bounds.minX,
            maxX: pad2Bounds.maxX,
            minY: pad2Bounds.maxY,
            // top of pad2
            maxY: pad3Bounds.minY
            // bottom of pad3
          },
          false
        );
        leftBP34 = createRegion(
          `${idPrefix}:L-BP34`,
          {
            minX: pad3Bounds.minX,
            maxX: pad3Bounds.maxX,
            minY: pad3Bounds.maxY,
            // top of pad3
            maxY: pad4Bounds.minY
            // bottom of pad4
          },
          false
        );
        rightBP87 = createRegion(
          `${idPrefix}:R-BP87`,
          {
            minX: pad8Bounds.minX,
            maxX: pad8Bounds.maxX,
            minY: pad8Bounds.maxY,
            // top of pad8
            maxY: pad7Bounds.minY
            // bottom of pad7
          },
          false
        );
        rightBP76 = createRegion(
          `${idPrefix}:R-BP76`,
          {
            minX: pad7Bounds.minX,
            maxX: pad7Bounds.maxX,
            minY: pad7Bounds.maxY,
            // top of pad7
            maxY: pad6Bounds.minY
            // bottom of pad6
          },
          false
        );
        rightBP65 = createRegion(
          `${idPrefix}:R-BP65`,
          {
            minX: pad6Bounds.minX,
            maxX: pad6Bounds.maxX,
            minY: pad6Bounds.maxY,
            // top of pad6
            maxY: pad5Bounds.minY
            // bottom of pad5
          },
          false
        );
        regions.push(
          leftBP12,
          leftBP23,
          leftBP34,
          rightBP87,
          rightBP76,
          rightBP65
        );
      }
      const isFirstRow = row === 0;
      const isFirstCol = col === 0;
      const isLastRow = row === rows - 1;
      const isLastCol = col === cols - 1;
      let frameRightEdge;
      if (isLastCol) {
        frameRightEdge = mainMaxX + outerPaddingX;
      } else {
        const nextCenterX = (col + 1) * horizontalSpacing;
        const nextP1CenterX = nextCenterX + leftPadCenterX;
        frameRightEdge = nextP1CenterX - padHalfWidth;
      }
      let top = null;
      if (isFirstRow) {
        top = createRegion(
          `${idPrefix}:T`,
          {
            minX: isFirstCol ? mainMinX - outerPaddingX : mainMinX,
            maxX: frameRightEdge,
            minY: mainMaxY,
            maxY: mainMaxY + outerPaddingY
          },
          false
        );
        regions.push(top);
      }
      let bottom = null;
      const bottomHeight = isLastRow ? outerPaddingY : marginY;
      bottom = createRegion(
        `${idPrefix}:B`,
        {
          minX: isFirstCol ? mainMinX - outerPaddingX : mainMinX,
          maxX: frameRightEdge,
          minY: mainMinY - bottomHeight,
          maxY: mainMinY
        },
        false
      );
      regions.push(bottom);
      let left = null;
      if (isFirstCol) {
        left = createRegion(
          `${idPrefix}:L`,
          {
            minX: mainMinX - outerPaddingX,
            maxX: mainMinX,
            minY: mainMinY,
            maxY: mainMaxY
          },
          false
        );
        regions.push(left);
      }
      const right = createRegion(
        `${idPrefix}:R`,
        {
          minX: mainMaxX,
          maxX: frameRightEdge,
          minY: mainMinY,
          maxY: mainMaxY
        },
        false
      );
      regions.push(right);
      cells[row][col] = {
        pad1,
        pad2,
        pad3,
        pad4,
        pad5,
        pad6,
        pad7,
        pad8,
        underjumper,
        throughjumper1,
        throughjumper2,
        throughjumper3,
        throughjumper4,
        top,
        bottom,
        left,
        right,
        leftBP12,
        leftBP23,
        leftBP34,
        rightBP87,
        rightBP76,
        rightBP65
      };
      if (top) {
        if (left) {
          ports.push(
            ...createMultiplePorts(
              `${idPrefix}:T-L`,
              top,
              left,
              effectiveOuterChannelXPoints
            )
          );
        }
        ports.push(
          ...createMultiplePorts(
            `${idPrefix}:T-R`,
            top,
            right,
            isLastCol ? effectiveOuterChannelXPoints : innerColChannelPointCount
          )
        );
        ports.push(createPort(`${idPrefix}:T-P4`, top, pad4));
        ports.push(createPort(`${idPrefix}:T-P5`, top, pad5));
        if (regionsBetweenPads) {
          const ujBounds = underjumper.d.bounds;
          const ujWidth = ujBounds.maxX - ujBounds.minX;
          const portSpacing = ujWidth / (parallelTracesUnderJumperCount + 1);
          for (let i = 1; i <= parallelTracesUnderJumperCount; i++) {
            const portX = ujBounds.minX + portSpacing * i;
            const topUJPort = {
              portId: `${idPrefix}:T-UJ${i}`,
              region1: top,
              region2: underjumper,
              d: { x: portX, y: ujBounds.maxY }
            };
            top.ports.push(topUJPort);
            underjumper.ports.push(topUJPort);
            ports.push(topUJPort);
          }
        } else {
          ports.push(createPort(`${idPrefix}:T-UJ`, top, underjumper));
        }
      }
      if (bottom) {
        if (left) {
          ports.push(
            ...createMultiplePorts(
              `${idPrefix}:B-L`,
              bottom,
              left,
              effectiveOuterChannelXPoints
            )
          );
        }
        ports.push(
          ...createMultiplePorts(
            `${idPrefix}:B-R`,
            bottom,
            right,
            isLastCol ? effectiveOuterChannelXPoints : innerColChannelPointCount
          )
        );
        ports.push(createPort(`${idPrefix}:B-P1`, bottom, pad1));
        ports.push(createPort(`${idPrefix}:B-P8`, bottom, pad8));
        if (regionsBetweenPads) {
          const ujBounds = underjumper.d.bounds;
          const ujWidth = ujBounds.maxX - ujBounds.minX;
          const portSpacing = ujWidth / (parallelTracesUnderJumperCount + 1);
          for (let i = 1; i <= parallelTracesUnderJumperCount; i++) {
            const portX = ujBounds.minX + portSpacing * i;
            const bottomUJPort = {
              portId: `${idPrefix}:B-UJ${i}`,
              region1: bottom,
              region2: underjumper,
              d: { x: portX, y: ujBounds.minY }
            };
            bottom.ports.push(bottomUJPort);
            underjumper.ports.push(bottomUJPort);
            ports.push(bottomUJPort);
          }
        } else {
          ports.push(createPort(`${idPrefix}:B-UJ`, bottom, underjumper));
        }
      }
      if (left) {
        ports.push(createPort(`${idPrefix}:L-P1`, left, pad1));
        ports.push(createPort(`${idPrefix}:L-P2`, left, pad2));
        ports.push(createPort(`${idPrefix}:L-P3`, left, pad3));
        ports.push(createPort(`${idPrefix}:L-P4`, left, pad4));
      }
      ports.push(createPort(`${idPrefix}:R-P5`, right, pad5));
      ports.push(createPort(`${idPrefix}:R-P6`, right, pad6));
      ports.push(createPort(`${idPrefix}:R-P7`, right, pad7));
      ports.push(createPort(`${idPrefix}:R-P8`, right, pad8));
      if (regionsBetweenPads) {
        if (left) {
          ports.push(createPort(`${idPrefix}:L-BP12`, left, leftBP12));
          ports.push(createPort(`${idPrefix}:L-BP23`, left, leftBP23));
          ports.push(createPort(`${idPrefix}:L-BP34`, left, leftBP34));
        }
        ports.push(createPort(`${idPrefix}:UJ-LBP12`, leftBP12, underjumper));
        ports.push(createPort(`${idPrefix}:UJ-LBP23`, leftBP23, underjumper));
        ports.push(createPort(`${idPrefix}:UJ-LBP34`, leftBP34, underjumper));
        ports.push(createPort(`${idPrefix}:R-BP87`, right, rightBP87));
        ports.push(createPort(`${idPrefix}:R-BP76`, right, rightBP76));
        ports.push(createPort(`${idPrefix}:R-BP65`, right, rightBP65));
        ports.push(createPort(`${idPrefix}:UJ-RBP87`, rightBP87, underjumper));
        ports.push(createPort(`${idPrefix}:UJ-RBP76`, rightBP76, underjumper));
        ports.push(createPort(`${idPrefix}:UJ-RBP65`, rightBP65, underjumper));
      }
      const tj1LeftPort = {
        portId: `${idPrefix}:TJ1-P1`,
        region1: throughjumper1,
        region2: pad1,
        d: { x: p1CenterX, y: p1CenterY }
      };
      throughjumper1.ports.push(tj1LeftPort);
      pad1.ports.push(tj1LeftPort);
      ports.push(tj1LeftPort);
      const tj1RightPort = {
        portId: `${idPrefix}:TJ1-P8`,
        region1: throughjumper1,
        region2: pad8,
        d: { x: p8CenterX, y: p8CenterY }
      };
      throughjumper1.ports.push(tj1RightPort);
      pad8.ports.push(tj1RightPort);
      ports.push(tj1RightPort);
      const tj2LeftPort = {
        portId: `${idPrefix}:TJ2-P2`,
        region1: throughjumper2,
        region2: pad2,
        d: { x: p2CenterX, y: p2CenterY }
      };
      throughjumper2.ports.push(tj2LeftPort);
      pad2.ports.push(tj2LeftPort);
      ports.push(tj2LeftPort);
      const tj2RightPort = {
        portId: `${idPrefix}:TJ2-P7`,
        region1: throughjumper2,
        region2: pad7,
        d: { x: p7CenterX, y: p7CenterY }
      };
      throughjumper2.ports.push(tj2RightPort);
      pad7.ports.push(tj2RightPort);
      ports.push(tj2RightPort);
      const tj3LeftPort = {
        portId: `${idPrefix}:TJ3-P3`,
        region1: throughjumper3,
        region2: pad3,
        d: { x: p3CenterX, y: p3CenterY }
      };
      throughjumper3.ports.push(tj3LeftPort);
      pad3.ports.push(tj3LeftPort);
      ports.push(tj3LeftPort);
      const tj3RightPort = {
        portId: `${idPrefix}:TJ3-P6`,
        region1: throughjumper3,
        region2: pad6,
        d: { x: p6CenterX, y: p6CenterY }
      };
      throughjumper3.ports.push(tj3RightPort);
      pad6.ports.push(tj3RightPort);
      ports.push(tj3RightPort);
      const tj4LeftPort = {
        portId: `${idPrefix}:TJ4-P4`,
        region1: throughjumper4,
        region2: pad4,
        d: { x: p4CenterX, y: p4CenterY }
      };
      throughjumper4.ports.push(tj4LeftPort);
      pad4.ports.push(tj4LeftPort);
      ports.push(tj4LeftPort);
      const tj4RightPort = {
        portId: `${idPrefix}:TJ4-P5`,
        region1: throughjumper4,
        region2: pad5,
        d: { x: p5CenterX, y: p5CenterY }
      };
      throughjumper4.ports.push(tj4RightPort);
      pad5.ports.push(tj4RightPort);
      ports.push(tj4RightPort);
      if (col > 0) {
        const prevCell = cells[row][col - 1];
        ports.push(
          createPort(
            `cell_${row}_${col - 1}->cell_${row}_${col}:R-P1`,
            prevCell.right,
            pad1
          )
        );
        ports.push(
          createPort(
            `cell_${row}_${col - 1}->cell_${row}_${col}:R-P2`,
            prevCell.right,
            pad2
          )
        );
        ports.push(
          createPort(
            `cell_${row}_${col - 1}->cell_${row}_${col}:R-P3`,
            prevCell.right,
            pad3
          )
        );
        ports.push(
          createPort(
            `cell_${row}_${col - 1}->cell_${row}_${col}:R-P4`,
            prevCell.right,
            pad4
          )
        );
        if (regionsBetweenPads) {
          ports.push(
            createPort(
              `cell_${row}_${col - 1}->cell_${row}_${col}:R-LBP12`,
              prevCell.right,
              leftBP12
            )
          );
          ports.push(
            createPort(
              `cell_${row}_${col - 1}->cell_${row}_${col}:R-LBP23`,
              prevCell.right,
              leftBP23
            )
          );
          ports.push(
            createPort(
              `cell_${row}_${col - 1}->cell_${row}_${col}:R-LBP34`,
              prevCell.right,
              leftBP34
            )
          );
        }
        if (top && prevCell.top) {
          ports.push(
            ...createMultiplePorts(
              `cell_${row}_${col - 1}->cell_${row}_${col}:T-T`,
              prevCell.top,
              top,
              effectiveOuterChannelYPoints
            )
          );
        }
        if (bottom && prevCell.bottom) {
          ports.push(
            ...createMultiplePorts(
              `cell_${row}_${col - 1}->cell_${row}_${col}:B-B`,
              prevCell.bottom,
              bottom,
              isLastRow ? effectiveOuterChannelYPoints : innerRowChannelPointCount
            )
          );
        }
      }
      if (row > 0) {
        const aboveCell = cells[row - 1][col];
        if (left) {
          ports.push(
            ...createMultiplePorts(
              `cell_${row - 1}_${col}->cell_${row}_${col}:B-L`,
              aboveCell.bottom,
              left,
              effectiveOuterChannelXPoints
            )
          );
        }
        ports.push(
          createPort(
            `cell_${row - 1}_${col}->cell_${row}_${col}:B-P4`,
            aboveCell.bottom,
            pad4
          )
        );
        if (regionsBetweenPads) {
          const ujBounds = underjumper.d.bounds;
          const ujWidth = ujBounds.maxX - ujBounds.minX;
          const portSpacing = ujWidth / (parallelTracesUnderJumperCount + 1);
          for (let i = 1; i <= parallelTracesUnderJumperCount; i++) {
            const portX = ujBounds.minX + portSpacing * i;
            const aboveUJPort = {
              portId: `cell_${row - 1}_${col}->cell_${row}_${col}:B-UJ${i}`,
              region1: aboveCell.bottom,
              region2: underjumper,
              d: { x: portX, y: ujBounds.maxY }
            };
            aboveCell.bottom.ports.push(aboveUJPort);
            underjumper.ports.push(aboveUJPort);
            ports.push(aboveUJPort);
          }
        } else {
          ports.push(
            createPort(
              `cell_${row - 1}_${col}->cell_${row}_${col}:B-UJ`,
              aboveCell.bottom,
              underjumper
            )
          );
        }
        ports.push(
          createPort(
            `cell_${row - 1}_${col}->cell_${row}_${col}:B-P5`,
            aboveCell.bottom,
            pad5
          )
        );
        ports.push(
          ...createMultiplePorts(
            `cell_${row - 1}_${col}->cell_${row}_${col}:B-R`,
            aboveCell.bottom,
            right,
            isLastCol ? effectiveOuterChannelXPoints : innerColChannelPointCount
          )
        );
      }
    }
  }
  let graph = {
    regions,
    ports,
    jumperLocations: collectedJumperLocations
  };
  const needsRotation = orientation2 === "horizontal";
  const needsCentering = center !== void 0;
  const needsBoundsTransform = bounds !== void 0;
  if (needsRotation || needsCentering || needsBoundsTransform) {
    const currentBounds = calculateGraphBounds(graph.regions);
    const currentCenter = computeBoundsCenter(currentBounds);
    const matrices = [];
    let targetCenter;
    if (center) {
      targetCenter = center;
    } else if (bounds) {
      targetCenter = computeBoundsCenter(bounds);
    } else {
      targetCenter = currentCenter;
    }
    matrices.push(translate(targetCenter.x, targetCenter.y));
    if (needsRotation) {
      matrices.push(rotate(-Math.PI / 2));
    }
    matrices.push(translate(-currentCenter.x, -currentCenter.y));
    const matrix2 = compose(...matrices);
    graph = applyTransformToGraph(graph, matrix2);
  }
  return graph;
};

// lib/topology/types.ts
var TopologyError = class extends Error {
  constructor(message, details) {
    super(message);
    this.details = details;
    this.name = "TopologyError";
  }
};

// lib/topology/RegionBuilder.ts
var RegionBuilder = class {
  data;
  constructor(id) {
    this.data = {
      id,
      bounds: null,
      polygon: null,
      center: null,
      width: null,
      height: null,
      anchor: "center",
      isPad: false,
      isThroughJumper: false,
      isConnectionRegion: false,
      meta: {}
    };
  }
  get id() {
    return this.data.id;
  }
  // Geometry methods
  rect(b) {
    this.data.bounds = { ...b };
    this.data.polygon = null;
    this.data.center = null;
    this.data.width = null;
    this.data.height = null;
    return this;
  }
  polygon(points) {
    if (points.length < 3) {
      throw new TopologyError(
        `Region "${this.data.id}" has invalid polygon: at least 3 points required`,
        {
          regionIds: [this.data.id],
          suggestion: "Provide at least three polygon vertices"
        }
      );
    }
    for (const point2 of points) {
      if (!Number.isFinite(point2.x) || !Number.isFinite(point2.y)) {
        throw new TopologyError(
          `Region "${this.data.id}" has invalid polygon point`,
          {
            regionIds: [this.data.id],
            suggestion: "Use finite numeric x/y values"
          }
        );
      }
    }
    this.data.polygon = points.map((p) => ({ x: p.x, y: p.y }));
    this.data.bounds = null;
    this.data.center = null;
    this.data.width = null;
    this.data.height = null;
    return this;
  }
  center(x, y) {
    this.data.center = { x, y };
    this.data.bounds = null;
    this.data.polygon = null;
    return this;
  }
  size(w, h, anchor = "center") {
    if (w <= 0 || h <= 0) {
      throw new TopologyError(
        `Region "${this.data.id}" has invalid size: width (${w}) and height (${h}) must be positive`,
        {
          regionIds: [this.data.id],
          suggestion: "Use positive values for width and height"
        }
      );
    }
    this.data.width = w;
    this.data.height = h;
    this.data.anchor = anchor;
    this.data.bounds = null;
    this.data.polygon = null;
    return this;
  }
  // Semantic methods
  pad(isPad = true) {
    this.data.isPad = isPad;
    return this;
  }
  throughJumper(isTJ = true) {
    this.data.isThroughJumper = isTJ;
    return this;
  }
  connectionRegion(isConn = true) {
    this.data.isConnectionRegion = isConn;
    return this;
  }
  meta(extra) {
    this.data.meta = { ...this.data.meta, ...extra };
    return this;
  }
  // Get the internal data (used by Topology)
  getData() {
    return this.data;
  }
  // Get a reference to this region
  ref() {
    return { id: this.data.id };
  }
};

// lib/topology/utils.ts
var DEFAULT_TOLERANCE = 1e-3;
function computeBoundsFromRegionData(data) {
  if (data.bounds) {
    return data.bounds;
  }
  if (data.polygon && data.polygon.length > 0) {
    let minX = data.polygon[0].x;
    let maxX = data.polygon[0].x;
    let minY = data.polygon[0].y;
    let maxY = data.polygon[0].y;
    for (let i = 1; i < data.polygon.length; i++) {
      const point2 = data.polygon[i];
      minX = Math.min(minX, point2.x);
      maxX = Math.max(maxX, point2.x);
      minY = Math.min(minY, point2.y);
      maxY = Math.max(maxY, point2.y);
    }
    return { minX, maxX, minY, maxY };
  }
  if (data.center && data.width !== null && data.height !== null) {
    const halfW = data.width / 2;
    const halfH = data.height / 2;
    if (data.anchor === "center") {
      return {
        minX: data.center.x - halfW,
        maxX: data.center.x + halfW,
        minY: data.center.y - halfH,
        maxY: data.center.y + halfH
      };
    } else {
      return {
        minX: data.center.x,
        maxX: data.center.x + data.width,
        minY: data.center.y,
        maxY: data.center.y + data.height
      };
    }
  }
  throw new TopologyError(`Region "${data.id}" has incomplete geometry`, {
    regionIds: [data.id],
    suggestion: "Use .rect() or .center().size() to define the region geometry"
  });
}
function computeCenterFromBounds(bounds) {
  return {
    x: (bounds.minX + bounds.maxX) / 2,
    y: (bounds.minY + bounds.maxY) / 2
  };
}
function validateBounds(bounds, regionId) {
  if (bounds.minX >= bounds.maxX) {
    throw new TopologyError(
      `Region "${regionId}" has invalid bounds: minX (${bounds.minX}) >= maxX (${bounds.maxX})`,
      {
        regionIds: [regionId],
        suggestion: "Ensure minX < maxX"
      }
    );
  }
  if (bounds.minY >= bounds.maxY) {
    throw new TopologyError(
      `Region "${regionId}" has invalid bounds: minY (${bounds.minY}) >= maxY (${bounds.maxY})`,
      {
        regionIds: [regionId],
        suggestion: "Ensure minY < maxY"
      }
    );
  }
}
function findSharedBoundary(boundsA, boundsB, regionIdA, regionIdB, tolerance = DEFAULT_TOLERANCE) {
  const verticalOverlapMin = Math.max(boundsA.minY, boundsB.minY);
  const verticalOverlapMax = Math.min(boundsA.maxY, boundsB.maxY);
  const verticalOverlapLength = verticalOverlapMax - verticalOverlapMin;
  const horizontalOverlapMin = Math.max(boundsA.minX, boundsB.minX);
  const horizontalOverlapMax = Math.min(boundsA.maxX, boundsB.maxX);
  const horizontalOverlapLength = horizontalOverlapMax - horizontalOverlapMin;
  if (Math.abs(boundsA.maxX - boundsB.minX) < tolerance && verticalOverlapLength > tolerance) {
    return {
      axis: "vertical",
      position: boundsA.maxX,
      min: verticalOverlapMin,
      max: verticalOverlapMax
    };
  }
  if (Math.abs(boundsA.minX - boundsB.maxX) < tolerance && verticalOverlapLength > tolerance) {
    return {
      axis: "vertical",
      position: boundsA.minX,
      min: verticalOverlapMin,
      max: verticalOverlapMax
    };
  }
  if (Math.abs(boundsA.maxY - boundsB.minY) < tolerance && horizontalOverlapLength > tolerance) {
    return {
      axis: "horizontal",
      position: boundsA.maxY,
      min: horizontalOverlapMin,
      max: horizontalOverlapMax
    };
  }
  if (Math.abs(boundsA.minY - boundsB.maxY) < tolerance && horizontalOverlapLength > tolerance) {
    return {
      axis: "horizontal",
      position: boundsA.minY,
      min: horizontalOverlapMin,
      max: horizontalOverlapMax
    };
  }
  const relationship = describeRelationship(boundsA, boundsB);
  throw new TopologyError(
    `Regions "${regionIdA}" and "${regionIdB}" do not share a boundary`,
    {
      regionIds: [regionIdA, regionIdB],
      relationship,
      suggestion: "Use .port().between().at() for non-boundary ports, or check region positions"
    }
  );
}
function describeRelationship(boundsA, boundsB) {
  const centerA = computeCenterFromBounds(boundsA);
  const centerB = computeCenterFromBounds(boundsB);
  const dx = centerB.x - centerA.x;
  const dy = centerB.y - centerA.y;
  let direction;
  if (Math.abs(dx) > Math.abs(dy)) {
    direction = dx > 0 ? "to the right of" : "to the left of";
  } else {
    direction = dy > 0 ? "above" : "below";
  }
  const overlapsX = boundsA.maxX > boundsB.minX && boundsB.maxX > boundsA.minX;
  const overlapsY = boundsA.maxY > boundsB.minY && boundsB.maxY > boundsA.minY;
  if (overlapsX && overlapsY) {
    return `Regions overlap (A center: ${centerA.x.toFixed(2)}, ${centerA.y.toFixed(2)}; B center: ${centerB.x.toFixed(2)}, ${centerB.y.toFixed(2)})`;
  }
  const touchesAtCornerX = Math.abs(boundsA.maxX - boundsB.minX) < 1e-3 || Math.abs(boundsA.minX - boundsB.maxX) < 1e-3;
  const touchesAtCornerY = Math.abs(boundsA.maxY - boundsB.minY) < 1e-3 || Math.abs(boundsA.minY - boundsB.maxY) < 1e-3;
  if (touchesAtCornerX && touchesAtCornerY) {
    return `Regions touch only at a corner (B is ${direction} A)`;
  }
  return `B is ${direction} A with no shared edge`;
}
function computePortPositionOnBoundary(boundary, t) {
  const pos = boundary.min + t * (boundary.max - boundary.min);
  if (boundary.axis === "vertical") {
    return { x: boundary.position, y: pos };
  } else {
    return { x: pos, y: boundary.position };
  }
}
function computeEvenPortPositions(boundary, count, inset = "half") {
  const positions = [];
  const length = boundary.max - boundary.min;
  for (let i = 0; i < count; i++) {
    let t;
    if (inset === "half") {
      t = (i + 0.5) / count;
    } else {
      const insetRatio = inset / length;
      const usableRange = 1 - 2 * insetRatio;
      if (count === 1) {
        t = 0.5;
      } else {
        t = insetRatio + i / (count - 1) * usableRange;
      }
    }
    positions.push(computePortPositionOnBoundary(boundary, t));
  }
  return positions;
}
function pointOnBoundary(point2, bounds, tolerance = DEFAULT_TOLERANCE) {
  const onVerticalEdge = (Math.abs(point2.x - bounds.minX) < tolerance || Math.abs(point2.x - bounds.maxX) < tolerance) && point2.y >= bounds.minY - tolerance && point2.y <= bounds.maxY + tolerance;
  const onHorizontalEdge = (Math.abs(point2.y - bounds.minY) < tolerance || Math.abs(point2.y - bounds.maxY) < tolerance) && point2.x >= bounds.minX - tolerance && point2.x <= bounds.maxX + tolerance;
  return onVerticalEdge || onHorizontalEdge;
}

// lib/topology/ConnectBuilder.ts
var ConnectBuilder = class {
  region1Id;
  region2Id;
  bounds1;
  bounds2;
  tolerance;
  prefix;
  prefixIdFn;
  addPortFn;
  portIds = [];
  boundary = null;
  prefixWasExplicitlySet = false;
  constructor(region1Id, region2Id, bounds1, bounds2, addPortFn, prefixIdFn, opts) {
    this.region1Id = region1Id;
    this.region2Id = region2Id;
    this.bounds1 = bounds1;
    this.bounds2 = bounds2;
    this.addPortFn = addPortFn;
    this.prefixIdFn = prefixIdFn;
    this.tolerance = opts?.tolerance ?? 1e-3;
    this.prefix = opts?.idPrefix ?? `${region1Id.split(":").pop()}-${region2Id.split(":").pop()}`;
  }
  ensureBoundary() {
    if (!this.boundary) {
      this.boundary = findSharedBoundary(
        this.bounds1,
        this.bounds2,
        this.region1Id,
        this.region2Id,
        this.tolerance
      );
    }
    return this.boundary;
  }
  idPrefix(prefix) {
    this.prefix = prefix;
    this.prefixWasExplicitlySet = true;
    return this;
  }
  getFullPrefix() {
    if (this.prefixWasExplicitlySet) {
      return this.prefixIdFn(this.prefix);
    }
    return this.prefixIdFn(this.prefix);
  }
  ports(count, spread) {
    if (count <= 0) {
      throw new TopologyError(
        `Invalid port count: ${count}. Must be at least 1`,
        {
          regionIds: [this.region1Id, this.region2Id],
          suggestion: "Use a positive integer for port count"
        }
      );
    }
    const boundary = this.ensureBoundary();
    let positions;
    if (!spread || spread.kind === "midpoint") {
      if (count === 1) {
        positions = [computePortPositionOnBoundary(boundary, 0.5)];
      } else {
        positions = computeEvenPortPositions(boundary, count, "half");
      }
    } else if (spread.kind === "even") {
      positions = computeEvenPortPositions(boundary, count, spread.inset);
    } else if (spread.kind === "fractions") {
      if (spread.ts.length !== count) {
        throw new TopologyError(
          `Port count (${count}) doesn't match fractions array length (${spread.ts.length})`,
          {
            regionIds: [this.region1Id, this.region2Id],
            suggestion: "Ensure fractions array has exactly `count` elements"
          }
        );
      }
      positions = spread.ts.map((t) => {
        if (t < 0 || t > 1) {
          throw new TopologyError(
            `Fraction value ${t} is out of range [0, 1]`,
            {
              regionIds: [this.region1Id, this.region2Id],
              suggestion: "Use values between 0 and 1 for fractions"
            }
          );
        }
        return computePortPositionOnBoundary(boundary, t);
      });
    } else {
      throw new TopologyError(`Unknown spread kind`, {
        regionIds: [this.region1Id, this.region2Id]
      });
    }
    const fullPrefix = this.getFullPrefix();
    for (let i = 0; i < positions.length; i++) {
      const portId = count === 1 ? fullPrefix : `${fullPrefix}:${i}`;
      this.addPortFn({
        id: portId,
        region1Id: this.region1Id,
        region2Id: this.region2Id,
        x: positions[i].x,
        y: positions[i].y
      });
      this.portIds.push(portId);
    }
    return this;
  }
  at(t) {
    if (t < 0 || t > 1) {
      throw new TopologyError(`Position t=${t} is out of range [0, 1]`, {
        regionIds: [this.region1Id, this.region2Id],
        suggestion: "Use a value between 0 and 1"
      });
    }
    const boundary = this.ensureBoundary();
    const position = computePortPositionOnBoundary(boundary, t);
    const fullPrefix = this.getFullPrefix();
    this.addPortFn({
      id: fullPrefix,
      region1Id: this.region1Id,
      region2Id: this.region2Id,
      x: position.x,
      y: position.y
    });
    this.portIds.push(fullPrefix);
    return this;
  }
  atXY(p) {
    const fullPrefix = this.getFullPrefix();
    this.addPortFn({
      id: fullPrefix,
      region1Id: this.region1Id,
      region2Id: this.region2Id,
      x: p.x,
      y: p.y
    });
    this.portIds.push(fullPrefix);
    return this;
  }
  getPortIds() {
    if (this.portIds.length === 0) {
      this.ports(1);
    }
    return [...this.portIds];
  }
  // Called by Topology.toJumperGraph() to ensure default ports are created
  finalizeIfNeeded() {
    if (this.portIds.length === 0) {
      this.ports(1);
    }
  }
  // Check if ports have already been added
  hasPortsAdded() {
    return this.portIds.length > 0;
  }
};

// lib/topology/PortBuilder.ts
var PortBuilder = class {
  portId;
  region1Id = null;
  region2Id = null;
  position = null;
  tValue = null;
  resolveRegionFn;
  addPortFn;
  tolerance;
  constructor(id, resolveRegionFn, addPortFn, tolerance = 1e-3) {
    this.portId = id;
    this.resolveRegionFn = resolveRegionFn;
    this.addPortFn = addPortFn;
    this.tolerance = tolerance;
  }
  id(id) {
    this.portId = id;
    return this;
  }
  between(a, b) {
    this.region1Id = typeof a === "string" ? a : a.id;
    this.region2Id = typeof b === "string" ? b : b.id;
    return this;
  }
  onSharedEdge(t = 0.5) {
    if (t < 0 || t > 1) {
      throw new TopologyError(`Position t=${t} is out of range [0, 1]`, {
        suggestion: "Use a value between 0 and 1"
      });
    }
    this.tValue = t;
    this.position = null;
    return this;
  }
  at(p) {
    this.position = { x: p.x, y: p.y };
    this.tValue = null;
    return this;
  }
  done() {
    if (!this.region1Id || !this.region2Id) {
      throw new TopologyError(
        `Port "${this.portId}" must be between two regions`,
        {
          suggestion: "Use .between(regionA, regionB) before .done()"
        }
      );
    }
    const region1 = this.resolveRegionFn(this.region1Id);
    const region2 = this.resolveRegionFn(this.region2Id);
    let finalPosition;
    if (this.position) {
      finalPosition = this.position;
      const onBoundary1 = pointOnBoundary(
        this.position,
        region1.bounds,
        this.tolerance
      );
      const onBoundary2 = pointOnBoundary(
        this.position,
        region2.bounds,
        this.tolerance
      );
      if (!onBoundary1 && !onBoundary2) {
      }
    } else {
      const t = this.tValue ?? 0.5;
      try {
        const boundary = findSharedBoundary(
          region1.bounds,
          region2.bounds,
          this.region1Id,
          this.region2Id,
          this.tolerance
        );
        finalPosition = computePortPositionOnBoundary(boundary, t);
      } catch (e) {
        if (e instanceof TopologyError && this.position === null) {
          throw new TopologyError(
            `Port "${this.portId}": ${e.message}. No explicit position provided.`,
            {
              ...e.details,
              suggestion: "Use .at({ x, y }) to specify position for non-adjacent regions"
            }
          );
        }
        throw e;
      }
    }
    this.addPortFn({
      id: this.portId,
      region1Id: this.region1Id,
      region2Id: this.region2Id,
      x: finalPosition.x,
      y: finalPosition.y
    });
  }
};

// lib/topology/Topology.ts
var Topology = class {
  regions = /* @__PURE__ */ new Map();
  ports = [];
  portIds = /* @__PURE__ */ new Set();
  pendingConnections = [];
  scopePrefix = "";
  defaultTolerance = 1e-3;
  prefixId(id) {
    return this.scopePrefix ? `${this.scopePrefix}:${id}` : id;
  }
  generateRegionId() {
    let counter = 0;
    while (true) {
      const id = this.prefixId(`region_${counter}`);
      if (!this.regions.has(id)) {
        return id;
      }
      counter++;
    }
  }
  generatePortId() {
    let counter = 0;
    while (true) {
      const id = this.prefixId(`port_${counter}`);
      if (!this.portIds.has(id)) {
        return id;
      }
      counter++;
    }
  }
  region(id) {
    const fullId = id ? this.prefixId(id) : this.generateRegionId();
    if (this.regions.has(fullId)) {
      throw new TopologyError(`Region "${fullId}" already exists`, {
        regionIds: [fullId],
        suggestion: "Use a unique region ID or omit to auto-generate"
      });
    }
    const builder = new RegionBuilder(fullId);
    this.regions.set(fullId, builder);
    return builder;
  }
  getRegion(id) {
    const fullId = this.prefixId(id);
    const region = this.regions.get(fullId);
    if (!region) {
      throw new TopologyError(`Region "${fullId}" not found`, {
        regionIds: [fullId],
        suggestion: "Create the region first with .region(id)"
      });
    }
    return region.ref();
  }
  resolveRegion(ref) {
    const id = typeof ref === "string" ? this.prefixId(ref) : ref.id;
    const region = this.regions.get(id);
    if (!region) {
      throw new TopologyError(`Region "${id}" not found`, {
        regionIds: [id],
        suggestion: "Create the region first with .region(id)"
      });
    }
    const data = region.getData();
    const bounds = computeBoundsFromRegionData(data);
    return { id, bounds };
  }
  addPort(port) {
    if (this.portIds.has(port.id)) {
      throw new TopologyError(`Port "${port.id}" already exists`, {
        suggestion: "Use a unique port ID"
      });
    }
    this.portIds.add(port.id);
    this.ports.push(port);
  }
  connect(a, b, opts) {
    const region1 = this.resolveRegion(a);
    const region2 = this.resolveRegion(b);
    const currentScopePrefix = this.scopePrefix;
    const builder = new ConnectBuilder(
      region1.id,
      region2.id,
      region1.bounds,
      region2.bounds,
      (port) => this.addPort(port),
      (id) => currentScopePrefix ? `${currentScopePrefix}:${id}` : id,
      {
        idPrefix: opts?.idPrefix,
        tolerance: opts?.tolerance ?? this.defaultTolerance
      }
    );
    this.pendingConnections.push(builder);
    return builder;
  }
  port(id) {
    const fullId = id ? this.prefixId(id) : this.generatePortId();
    return new PortBuilder(
      fullId,
      (ref) => this.resolveRegion(ref),
      (port) => this.addPort(port),
      this.defaultTolerance
    );
  }
  scope(prefix, fn) {
    const previousPrefix = this.scopePrefix;
    this.scopePrefix = previousPrefix ? `${previousPrefix}:${prefix}` : prefix;
    try {
      fn(this);
    } finally {
      this.scopePrefix = previousPrefix;
    }
  }
  validate(opts) {
    const tolerance = opts?.tolerance ?? this.defaultTolerance;
    const allowNonBoundaryPorts = opts?.allowNonBoundaryPorts ?? true;
    const errors = [];
    for (const [id, builder] of this.regions) {
      const data = builder.getData();
      try {
        const bounds = computeBoundsFromRegionData(data);
        validateBounds(bounds, id);
      } catch (e) {
        if (e instanceof TopologyError) {
          errors.push(e.message);
        } else {
          throw e;
        }
      }
    }
    for (const port of this.ports) {
      if (!this.regions.has(port.region1Id)) {
        errors.push(
          `Port "${port.id}" references non-existent region "${port.region1Id}"`
        );
      }
      if (!this.regions.has(port.region2Id)) {
        errors.push(
          `Port "${port.id}" references non-existent region "${port.region2Id}"`
        );
      }
      if (this.regions.has(port.region1Id) && this.regions.has(port.region2Id)) {
        const region1 = this.resolveRegion(port.region1Id);
        const region2 = this.resolveRegion(port.region2Id);
        const onBoundary1 = pointOnBoundary(
          { x: port.x, y: port.y },
          region1.bounds,
          tolerance
        );
        const onBoundary2 = pointOnBoundary(
          { x: port.x, y: port.y },
          region2.bounds,
          tolerance
        );
        if (!allowNonBoundaryPorts && !onBoundary1 && !onBoundary2) {
          errors.push(
            `Port "${port.id}" at (${port.x}, ${port.y}) is not on the boundary of either region "${port.region1Id}" or "${port.region2Id}"`
          );
        }
        try {
          findSharedBoundary(
            region1.bounds,
            region2.bounds,
            port.region1Id,
            port.region2Id,
            tolerance
          );
        } catch {
        }
      }
    }
    if (errors.length > 0) {
      throw new TopologyError(
        `Topology validation failed with ${errors.length} error(s):
${errors.map((e) => `  - ${e}`).join("\n")}`
      );
    }
  }
  toJumperGraph(opts) {
    for (const connection of this.pendingConnections) {
      connection.finalizeIfNeeded();
    }
    this.pendingConnections = [];
    if (opts?.validate !== false) {
      this.validate({ tolerance: opts?.tolerance });
    }
    const jregions = /* @__PURE__ */ new Map();
    const regionsList = [];
    for (const [id, builder] of this.regions) {
      const data = builder.getData();
      const bounds = computeBoundsFromRegionData(data);
      const center = computeCenterFromBounds(bounds);
      const jregion = {
        regionId: id,
        ports: [],
        d: {
          bounds,
          center,
          isPad: data.isPad,
          ...data.polygon && { polygon: data.polygon },
          ...data.isThroughJumper && { isThroughJumper: true },
          ...data.isConnectionRegion && { isConnectionRegion: true },
          ...data.meta
        }
      };
      jregions.set(id, jregion);
      regionsList.push(jregion);
    }
    const portsList = [];
    for (const portData of this.ports) {
      const region1 = jregions.get(portData.region1Id);
      const region2 = jregions.get(portData.region2Id);
      if (!region1 || !region2) {
        throw new TopologyError(
          `Port "${portData.id}" references non-existent region`,
          {
            regionIds: [portData.region1Id, portData.region2Id]
          }
        );
      }
      const jport = {
        portId: portData.id,
        region1,
        region2,
        d: {
          x: portData.x,
          y: portData.y
        }
      };
      region1.ports.push(jport);
      region2.ports.push(jport);
      portsList.push(jport);
    }
    return {
      regions: regionsList,
      ports: portsList
    };
  }
  // Utility method to merge an existing JumperGraph
  merge(graph, opts) {
    const prefix = opts?.prefix ?? "";
    const transform2 = opts?.transform ?? ((p) => p);
    const regionIdMap = /* @__PURE__ */ new Map();
    for (const region of graph.regions) {
      const newId = prefix ? `${prefix}:${region.regionId}` : region.regionId;
      if (this.regions.has(newId)) {
        throw new TopologyError(
          `Region "${newId}" already exists during merge`,
          {
            regionIds: [newId]
          }
        );
      }
      regionIdMap.set(region.regionId, newId);
      const builder = new RegionBuilder(newId);
      const transformedBounds = {
        minX: Math.min(
          transform2({ x: region.d.bounds.minX, y: region.d.bounds.minY }).x,
          transform2({ x: region.d.bounds.maxX, y: region.d.bounds.maxY }).x
        ),
        maxX: Math.max(
          transform2({ x: region.d.bounds.minX, y: region.d.bounds.minY }).x,
          transform2({ x: region.d.bounds.maxX, y: region.d.bounds.maxY }).x
        ),
        minY: Math.min(
          transform2({ x: region.d.bounds.minX, y: region.d.bounds.minY }).y,
          transform2({ x: region.d.bounds.maxX, y: region.d.bounds.maxY }).y
        ),
        maxY: Math.max(
          transform2({ x: region.d.bounds.minX, y: region.d.bounds.minY }).y,
          transform2({ x: region.d.bounds.maxX, y: region.d.bounds.maxY }).y
        )
      };
      builder.rect(transformedBounds);
      if (region.d.isPad) builder.pad();
      if (region.d.isThroughJumper) builder.throughJumper();
      if (region.d.isConnectionRegion) builder.connectionRegion();
      const {
        bounds,
        center,
        isPad,
        isThroughJumper,
        isConnectionRegion,
        ...rest
      } = region.d;
      if (Object.keys(rest).length > 0) {
        builder.meta(rest);
      }
      this.regions.set(newId, builder);
    }
    for (const port of graph.ports) {
      const newId = prefix ? `${prefix}:${port.portId}` : port.portId;
      if (this.portIds.has(newId)) {
        throw new TopologyError(`Port "${newId}" already exists during merge`, {
          suggestion: "Use a different prefix"
        });
      }
      const newRegion1Id = regionIdMap.get(port.region1.regionId);
      const newRegion2Id = regionIdMap.get(port.region2.regionId);
      if (!newRegion1Id || !newRegion2Id) {
        throw new TopologyError(
          `Port "${port.portId}" references region not in the merged graph`
        );
      }
      const transformedPos = transform2({ x: port.d.x, y: port.d.y });
      this.portIds.add(newId);
      this.ports.push({
        id: newId,
        region1Id: newRegion1Id,
        region2Id: newRegion2Id,
        x: transformedPos.x,
        y: transformedPos.y
      });
    }
  }
  // Get all region IDs (useful for debugging)
  getRegionIds() {
    return Array.from(this.regions.keys());
  }
  // Get all port IDs (useful for debugging)
  getPortIds() {
    return Array.from(this.portIds);
  }
};

// assets/ViaGraphSolver/via-tile-4-regions.json
var via_tile_4_regions_default = {
  viasByNet: {
    net1: [
      {
        viaId: "14ee4bf1-e7e7-4351-ad16-ba1a8aac0af3",
        diameter: 0.3,
        position: {
          x: 0.815244,
          y: -0.055081
        }
      },
      {
        viaId: "8a898812-db2b-4b81-899d-f953b3222f9a",
        diameter: 0.3,
        position: {
          x: -0.528763,
          y: 0.676055
        }
      }
    ],
    net3: [
      {
        viaId: "13cd75da-d582-4eed-bc2c-fee6fa78bc6a",
        diameter: 0.3,
        position: {
          x: -0.808222,
          y: -0.726499
        }
      },
      {
        viaId: "9f188f9d-bce8-46c7-b9e8-542b8599d48d",
        diameter: 0.3,
        position: {
          x: 0.901143,
          y: 0.437488
        }
      }
    ],
    net4: [
      {
        viaId: "2ef3b96b-58c4-4150-b5d1-e90f74b92b25",
        diameter: 0.3,
        position: {
          x: -0.029,
          y: 0.691542
        }
      },
      {
        viaId: "37a70467-7553-415f-8ad7-8b88a5e56ca8",
        diameter: 0.3,
        position: {
          x: -0.824388,
          y: 0.272808
        }
      },
      {
        viaId: "6d182b7d-a260-427b-8c43-a09409422252",
        diameter: 0.3,
        position: {
          x: 0.075,
          y: -0.806274
        }
      }
    ],
    net5: [
      {
        viaId: "346c301a-f2b4-44d7-b975-5438ddaa0bde",
        diameter: 0.3,
        position: {
          x: 0.517145,
          y: -0.456503
        }
      },
      {
        viaId: "c54b4b94-90e0-4240-97ef-883cf097d79d",
        diameter: 0.3,
        position: {
          x: 0.471002,
          y: 0.692404
        }
      },
      {
        viaId: "f3cb916e-b0fd-4c5e-b14b-3779f4f9bd01",
        diameter: 0.3,
        position: {
          x: -0.833162,
          y: -0.227118
        }
      }
    ]
  },
  routeSegments: [
    {
      routeId: "net1:route_0",
      fromPort: "14ee4bf1-e7e7-4351-ad16-ba1a8aac0af3",
      toPort: "8a898812-db2b-4b81-899d-f953b3222f9a",
      layer: "bottom",
      segments: [
        {
          x: 0.815244,
          y: -0.055081
        },
        {
          x: 0.893145,
          y: -0.132982
        },
        {
          x: 0.893145,
          y: -0.753669
        },
        {
          x: 0.465539,
          y: -1.181274
        },
        {
          x: -0.113744,
          y: -1.181274
        },
        {
          x: -0.4,
          y: -0.895018
        },
        {
          x: -0.4,
          y: 0.547292
        },
        {
          x: -0.528763,
          y: 0.676055
        }
      ]
    },
    {
      routeId: "net3:route_0",
      fromPort: "13cd75da-d582-4eed-bc2c-fee6fa78bc6a",
      toPort: "9f188f9d-bce8-46c7-b9e8-542b8599d48d",
      layer: "bottom",
      segments: [
        {
          x: -0.808222,
          y: -0.726499
        },
        {
          x: -0.808222,
          y: -0.912474
        },
        {
          x: -0.238422,
          y: -1.482274
        },
        {
          x: 0.590217,
          y: -1.482274
        },
        {
          x: 1.36382,
          y: -0.708672
        },
        {
          x: 1.36382,
          y: -1202e-6
        },
        {
          x: 0.92513,
          y: 0.437488
        },
        {
          x: 0.901143,
          y: 0.437488
        }
      ]
    },
    {
      routeId: "net4:route_0",
      fromPort: "2ef3b96b-58c4-4150-b5d1-e90f74b92b25",
      toPort: "6d182b7d-a260-427b-8c43-a09409422252",
      layer: "bottom",
      segments: [
        {
          x: -0.029,
          y: 0.691542
        },
        {
          x: 0.075,
          y: 0.587542
        },
        {
          x: 0.075,
          y: -0.806274
        }
      ]
    },
    {
      routeId: "net4:route_1",
      fromPort: "2ef3b96b-58c4-4150-b5d1-e90f74b92b25",
      toPort: "37a70467-7553-415f-8ad7-8b88a5e56ca8",
      layer: "bottom",
      segments: [
        {
          x: -0.029,
          y: 0.691542
        },
        {
          x: -0.029,
          y: 0.778747
        },
        {
          x: -0.352308,
          y: 1.102055
        },
        {
          x: -0.705218,
          y: 1.102055
        },
        {
          x: -0.954763,
          y: 0.85251
        },
        {
          x: -0.954763,
          y: 0.403183
        },
        {
          x: -0.824388,
          y: 0.272808
        }
      ]
    },
    {
      routeId: "net5:route_0",
      fromPort: "346c301a-f2b4-44d7-b975-5438ddaa0bde",
      toPort: "c54b4b94-90e0-4240-97ef-883cf097d79d",
      layer: "bottom",
      segments: [
        {
          x: 0.517145,
          y: -0.456503
        },
        {
          x: 0.389244,
          y: -0.328602
        },
        {
          x: 0.389244,
          y: 0.610646
        },
        {
          x: 0.471002,
          y: 0.692404
        }
      ]
    },
    {
      routeId: "net5:route_1",
      fromPort: "c54b4b94-90e0-4240-97ef-883cf097d79d",
      toPort: "f3cb916e-b0fd-4c5e-b14b-3779f4f9bd01",
      layer: "bottom",
      segments: [
        {
          x: 0.471002,
          y: 0.692404
        },
        {
          x: 0.471002,
          y: 1.111132
        },
        {
          x: 0.129079,
          y: 1.453055
        },
        {
          x: -0.850606,
          y: 1.453055
        },
        {
          x: -1.305763,
          y: 0.997899
        },
        {
          x: -1.305763,
          y: 0.151728
        },
        {
          x: -0.926917,
          y: -0.227118
        },
        {
          x: -0.833162,
          y: -0.227118
        }
      ]
    }
  ],
  tileWidth: 2.9695829999999996,
  tileHeight: 3.2353289999999997
};

// lib/ViaGraphSolver/via-graph-generator/generateViaTopologyRegions.ts
var TRACE_PITCH = 0.4;
var generateViaTopologyRegions = (viaTile, opts) => {
  const viasByNet = viaTile.viasByNet;
  const graphSize = opts?.graphSize ?? 5;
  const idPrefix = opts?.idPrefix ?? "via";
  const half = graphSize / 2;
  const topSegments = [];
  const bottomSegments = [];
  const leftSegments = [];
  const rightSegments = [];
  for (const vias of Object.values(viasByNet)) {
    if (vias.length === 0) continue;
    const topVia = vias.reduce(
      (best, v) => v.position.y > best.position.y ? v : best
    );
    const topY = topVia.position.y + topVia.diameter / 2;
    topSegments.push({
      xStart: topVia.position.x - topVia.diameter / 2,
      xEnd: topVia.position.x + topVia.diameter / 2,
      y: topY
    });
    const bottomVia = vias.reduce(
      (best, v) => v.position.y < best.position.y ? v : best
    );
    const botY = bottomVia.position.y - bottomVia.diameter / 2;
    bottomSegments.push({
      xStart: bottomVia.position.x - bottomVia.diameter / 2,
      xEnd: bottomVia.position.x + bottomVia.diameter / 2,
      y: botY
    });
    const leftVia = vias.reduce(
      (best, v) => v.position.x < best.position.x ? v : best
    );
    const leftX = leftVia.position.x - leftVia.diameter / 2;
    leftSegments.push({
      x: leftX,
      yStart: leftVia.position.y - leftVia.diameter / 2,
      yEnd: leftVia.position.y + leftVia.diameter / 2
    });
    const rightVia = vias.reduce(
      (best, v) => v.position.x > best.position.x ? v : best
    );
    const rightX = rightVia.position.x + rightVia.diameter / 2;
    rightSegments.push({
      x: rightX,
      yStart: rightVia.position.y - rightVia.diameter / 2,
      yEnd: rightVia.position.y + rightVia.diameter / 2
    });
  }
  topSegments.sort((a, b) => a.xStart - b.xStart);
  bottomSegments.sort((a, b) => a.xStart - b.xStart);
  leftSegments.sort((a, b) => a.yStart - b.yStart);
  rightSegments.sort((a, b) => a.yStart - b.yStart);
  const lTop = leftSegments[leftSegments.length - 1];
  const lBot = leftSegments[0];
  const rTop = rightSegments[rightSegments.length - 1];
  const rBot = rightSegments[0];
  const boundsFromPolygon2 = (points) => {
    let minX = Infinity;
    let maxX = -Infinity;
    let minY = Infinity;
    let maxY = -Infinity;
    for (const p of points) {
      if (p.x < minX) minX = p.x;
      if (p.x > maxX) maxX = p.x;
      if (p.y < minY) minY = p.y;
      if (p.y > maxY) maxY = p.y;
    }
    return { minX, maxX, minY, maxY };
  };
  const createRegion = (id, polygon2, opts2) => {
    const bounds = boundsFromPolygon2(polygon2);
    return {
      regionId: `${idPrefix}:${id}`,
      ports: [],
      d: {
        bounds,
        center: {
          x: (bounds.minX + bounds.maxX) / 2,
          y: (bounds.minY + bounds.maxY) / 2
        },
        polygon: polygon2,
        isPad: false,
        isViaRegion: opts2?.isViaRegion
      }
    };
  };
  const topPolygon = [];
  topPolygon.push({ x: -half, y: half });
  topPolygon.push({ x: half, y: half });
  topPolygon.push({ x: half, y: rTop.yEnd });
  topPolygon.push({ x: rTop.x, y: rTop.yEnd });
  const nTop = topSegments.length;
  for (let i = nTop - 1; i >= 0; i--) {
    topPolygon.push({ x: topSegments[i].xEnd, y: topSegments[i].y });
    topPolygon.push({ x: topSegments[i].xStart, y: topSegments[i].y });
  }
  topPolygon.push({ x: lTop.x, y: lTop.yEnd });
  topPolygon.push({ x: -half, y: lTop.yEnd });
  const topRegion = createRegion("T", topPolygon);
  const bottomPolygon = [];
  bottomPolygon.push({ x: -half, y: -half });
  bottomPolygon.push({ x: half, y: -half });
  bottomPolygon.push({ x: half, y: rBot.yStart });
  bottomPolygon.push({ x: rBot.x, y: rBot.yStart });
  const nBot = bottomSegments.length;
  for (let i = nBot - 1; i >= 0; i--) {
    bottomPolygon.push({ x: bottomSegments[i].xEnd, y: bottomSegments[i].y });
    bottomPolygon.push({
      x: bottomSegments[i].xStart,
      y: bottomSegments[i].y
    });
  }
  bottomPolygon.push({ x: lBot.x, y: lBot.yStart });
  bottomPolygon.push({ x: -half, y: lBot.yStart });
  const bottomRegion = createRegion("B", bottomPolygon);
  const rightPolygon = [];
  rightPolygon.push({ x: half, y: rBot.yStart });
  rightPolygon.push({ x: rBot.x, y: rBot.yStart });
  for (let i = 0; i < rightSegments.length; i++) {
    rightPolygon.push({ x: rightSegments[i].x, y: rightSegments[i].yStart });
    rightPolygon.push({ x: rightSegments[i].x, y: rightSegments[i].yEnd });
  }
  rightPolygon.push({ x: half, y: rTop.yEnd });
  const rightRegion = createRegion("R", rightPolygon);
  const leftPolygon = [];
  leftPolygon.push({ x: -half, y: lBot.yStart });
  leftPolygon.push({ x: lBot.x, y: lBot.yStart });
  for (let i = 0; i < leftSegments.length; i++) {
    leftPolygon.push({ x: leftSegments[i].x, y: leftSegments[i].yStart });
    leftPolygon.push({ x: leftSegments[i].x, y: leftSegments[i].yEnd });
  }
  leftPolygon.push({ x: -half, y: lTop.yEnd });
  const leftRegion = createRegion("L", leftPolygon);
  const regions = [topRegion, bottomRegion, leftRegion, rightRegion];
  const ports = [];
  const createPort = (id, region1, region2, x, y) => {
    const port = {
      portId: `${idPrefix}:${id}`,
      region1,
      region2,
      d: { x, y }
    };
    region1.ports.push(port);
    region2.ports.push(port);
    return port;
  };
  const createHorizontalPorts = (groupId, region1, region2, xStart, xEnd, y) => {
    const length = Math.abs(xEnd - xStart);
    const count = Math.max(1, Math.floor(length / TRACE_PITCH));
    const minX = Math.min(xStart, xEnd);
    for (let i = 0; i < count; i++) {
      const t = (i + 0.5) / count;
      const x = minX + t * length;
      const portId = count === 1 ? groupId : `${groupId}_${i}`;
      ports.push(createPort(portId, region1, region2, x, y));
    }
  };
  createHorizontalPorts("T-R", topRegion, rightRegion, rTop.x, half, rTop.yEnd);
  createHorizontalPorts("T-L", topRegion, leftRegion, -half, lTop.x, lTop.yEnd);
  createHorizontalPorts(
    "B-R",
    bottomRegion,
    rightRegion,
    rBot.x,
    half,
    rBot.yStart
  );
  createHorizontalPorts(
    "B-L",
    bottomRegion,
    leftRegion,
    -half,
    lBot.x,
    lBot.yStart
  );
  for (const [netName, vias] of Object.entries(viasByNet)) {
    if (vias.length === 0) continue;
    const topVia = vias.reduce(
      (best, v) => v.position.y > best.position.y ? v : best
    );
    const bottomVia = vias.reduce(
      (best, v) => v.position.y < best.position.y ? v : best
    );
    const leftVia = vias.reduce(
      (best, v) => v.position.x < best.position.x ? v : best
    );
    const rightVia = vias.reduce(
      (best, v) => v.position.x > best.position.x ? v : best
    );
    const netTopSeg = {
      xStart: topVia.position.x - topVia.diameter / 2,
      xEnd: topVia.position.x + topVia.diameter / 2,
      y: topVia.position.y + topVia.diameter / 2
    };
    const netBotSeg = {
      xStart: bottomVia.position.x - bottomVia.diameter / 2,
      xEnd: bottomVia.position.x + bottomVia.diameter / 2,
      y: bottomVia.position.y - bottomVia.diameter / 2
    };
    const netLeftSeg = {
      x: leftVia.position.x - leftVia.diameter / 2,
      yStart: leftVia.position.y - leftVia.diameter / 2,
      yEnd: leftVia.position.y + leftVia.diameter / 2
    };
    const netRightSeg = {
      x: rightVia.position.x + rightVia.diameter / 2,
      yStart: rightVia.position.y - rightVia.diameter / 2,
      yEnd: rightVia.position.y + rightVia.diameter / 2
    };
    const netPolygon = [
      { x: netTopSeg.xStart, y: netTopSeg.y },
      { x: netTopSeg.xEnd, y: netTopSeg.y },
      { x: netRightSeg.x, y: netRightSeg.yEnd },
      { x: netRightSeg.x, y: netRightSeg.yStart },
      { x: netBotSeg.xEnd, y: netBotSeg.y },
      { x: netBotSeg.xStart, y: netBotSeg.y },
      { x: netLeftSeg.x, y: netLeftSeg.yStart },
      { x: netLeftSeg.x, y: netLeftSeg.yEnd }
    ];
    const netRegion = createRegion(netName, netPolygon, { isViaRegion: true });
    regions.push(netRegion);
    ports.push(
      createPort(
        `${netName}-T`,
        netRegion,
        topRegion,
        (netTopSeg.xStart + netTopSeg.xEnd) / 2,
        netTopSeg.y
      )
    );
    ports.push(
      createPort(
        `${netName}-B`,
        netRegion,
        bottomRegion,
        (netBotSeg.xStart + netBotSeg.xEnd) / 2,
        netBotSeg.y
      )
    );
    ports.push(
      createPort(
        `${netName}-L`,
        netRegion,
        leftRegion,
        netLeftSeg.x,
        (netLeftSeg.yStart + netLeftSeg.yEnd) / 2
      )
    );
    ports.push(
      createPort(
        `${netName}-R`,
        netRegion,
        rightRegion,
        netRightSeg.x,
        (netRightSeg.yStart + netRightSeg.yEnd) / 2
      )
    );
  }
  return { regions, ports };
};

// lib/ViaGraphSolver/defaultTopology.ts
function generateDefaultViaTopologyRegions(opts) {
  return generateViaTopologyRegions(via_tile_4_regions_default, opts);
}

// lib/ViaGraphSolver/polygonPerimeterUtils.ts
function lineSegmentsIntersect(p1, p2, p3, p4, eps = 1e-9) {
  const pointsCoincident = (a, b) => Math.abs(a.x - b.x) < eps && Math.abs(a.y - b.y) < eps;
  if (pointsCoincident(p1, p3) || pointsCoincident(p1, p4) || pointsCoincident(p2, p3) || pointsCoincident(p2, p4)) {
    return false;
  }
  const cross2 = (o, a, b) => (a.x - o.x) * (b.y - o.y) - (a.y - o.y) * (b.x - o.x);
  const d1 = cross2(p3, p4, p1);
  const d2 = cross2(p3, p4, p2);
  const d3 = cross2(p1, p2, p3);
  const d4 = cross2(p1, p2, p4);
  if (d1 * d2 < 0 && d3 * d4 < 0) {
    return true;
  }
  const pointOnSegment = (point2, segStart, segEnd, crossProduct) => {
    if (Math.abs(crossProduct) > eps) return false;
    const minX = Math.min(segStart.x, segEnd.x) - eps;
    const maxX = Math.max(segStart.x, segEnd.x) + eps;
    const minY = Math.min(segStart.y, segEnd.y) - eps;
    const maxY = Math.max(segStart.y, segEnd.y) + eps;
    return point2.x >= minX && point2.x <= maxX && point2.y >= minY && point2.y <= maxY;
  };
  if (pointOnSegment(p1, p3, p4, d1)) {
    if (!pointsCoincident(p1, p3) && !pointsCoincident(p1, p4)) {
      return true;
    }
  }
  if (pointOnSegment(p2, p3, p4, d2)) {
    if (!pointsCoincident(p2, p3) && !pointsCoincident(p2, p4)) {
      return true;
    }
  }
  if (pointOnSegment(p3, p1, p2, d3)) {
    if (!pointsCoincident(p3, p1) && !pointsCoincident(p3, p2)) {
      return true;
    }
  }
  if (pointOnSegment(p4, p1, p2, d4)) {
    if (!pointsCoincident(p4, p1) && !pointsCoincident(p4, p2)) {
      return true;
    }
  }
  return false;
}
function chordsIntersect(newChord, existingChord, perimeter, newPort1, newPort2, existingPort1, existingPort2) {
  if (chordsCross(newChord, existingChord, perimeter)) {
    return true;
  }
  return lineSegmentsIntersect(
    newPort1.d,
    newPort2.d,
    existingPort1.d,
    existingPort2.d
  );
}
function computeDifferentNetCrossingsForPolygon(region, port1, port2) {
  const polygon2 = region.d.polygon;
  if (!polygon2 || polygon2.length < 3) {
    return 0;
  }
  const perimeter = getRegionPerimeter(region);
  const t1 = getPortPerimeterTInRegion(port1, region);
  const t2 = getPortPerimeterTInRegion(port2, region);
  const newChord = [t1, t2];
  let crossings = 0;
  const assignments = region.assignments ?? [];
  for (const assignment of assignments) {
    const existingPort1 = assignment.regionPort1;
    const existingPort2 = assignment.regionPort2;
    const existingT1 = getPortPerimeterTInRegion(existingPort1, region);
    const existingT2 = getPortPerimeterTInRegion(existingPort2, region);
    const existingChord = [existingT1, existingT2];
    if (chordsIntersect(
      newChord,
      existingChord,
      perimeter,
      port1,
      port2,
      existingPort1,
      existingPort2
    )) {
      crossings++;
    }
  }
  return crossings;
}
function computeCrossingAssignmentsForPolygon(region, port1, port2) {
  const polygon2 = region.d.polygon;
  if (!polygon2 || polygon2.length < 3) {
    return [];
  }
  const perimeter = getRegionPerimeter(region);
  const t1 = getPortPerimeterTInRegion(port1, region);
  const t2 = getPortPerimeterTInRegion(port2, region);
  const newChord = [t1, t2];
  const crossingAssignments = [];
  const assignments = region.assignments ?? [];
  for (const assignment of assignments) {
    const existingPort1 = assignment.regionPort1;
    const existingPort2 = assignment.regionPort2;
    const existingT1 = getPortPerimeterTInRegion(existingPort1, region);
    const existingT2 = getPortPerimeterTInRegion(existingPort2, region);
    const existingChord = [existingT1, existingT2];
    if (chordsIntersect(
      newChord,
      existingChord,
      perimeter,
      port1,
      port2,
      existingPort1,
      existingPort2
    )) {
      crossingAssignments.push(assignment);
    }
  }
  return crossingAssignments;
}

// lib/ViaGraphSolver/resolveSolvedRoutePoints.ts
var POINT_EPSILON = 1e-6;
function arePointsEqual(a, b) {
  return Math.abs(a.x - b.x) <= POINT_EPSILON && Math.abs(a.y - b.y) <= POINT_EPSILON;
}
function appendPoint(points, point2) {
  const lastPoint = points[points.length - 1];
  if (lastPoint && arePointsEqual(lastPoint, point2)) return;
  points.push(point2);
}
function findNearestVia(vias, point2) {
  let bestVia = null;
  let bestDistance = Infinity;
  for (const via of vias) {
    const dx = via.position.x - point2.x;
    const dy = via.position.y - point2.y;
    const distance3 = Math.hypot(dx, dy);
    if (distance3 < bestDistance) {
      bestDistance = distance3;
      bestVia = via;
    }
  }
  return bestVia;
}
function parseViaRegionNetName(regionId) {
  const marker = ":v:";
  const markerIndex = regionId.lastIndexOf(marker);
  if (markerIndex !== -1) {
    return regionId.slice(markerIndex + marker.length);
  }
  const lastColonIndex = regionId.lastIndexOf(":");
  if (lastColonIndex === -1) return regionId;
  return regionId.slice(lastColonIndex + 1);
}
function parseViaRegionTilePrefix(regionId) {
  const marker = ":v:";
  const markerIndex = regionId.lastIndexOf(marker);
  if (markerIndex <= 0) return null;
  return regionId.slice(0, markerIndex);
}
function getBottomRouteSegmentsForVias(viaTile, vias) {
  const viaIdSet = new Set(vias.map((via) => via.viaId));
  return viaTile.routeSegments.filter(
    (routeSegment) => routeSegment.layer === "bottom" && viaIdSet.has(routeSegment.fromPort) && viaIdSet.has(routeSegment.toPort) && routeSegment.segments.length >= 2
  );
}
function selectViasForTraversedRegion(viaTile, viaRegion) {
  const netName = parseViaRegionNetName(viaRegion.regionId);
  if (!netName) return [];
  const viasForNet = viaTile.viasByNet[netName];
  if (!viasForNet || viasForNet.length === 0) return [];
  const tilePrefix = parseViaRegionTilePrefix(viaRegion.regionId);
  if (!tilePrefix) return viasForNet;
  const tileScopedVias = viasForNet.filter(
    (via) => via.viaId.startsWith(`${tilePrefix}:`)
  );
  return tileScopedVias.length > 0 ? tileScopedVias : viasForNet;
}
function normalizeSegmentPoints(points) {
  const normalized = [];
  for (const point2 of points) appendPoint(normalized, point2);
  return normalized;
}
function appendLineSegment(lineSegments, points, layer) {
  const normalized = normalizeSegmentPoints(points);
  if (normalized.length < 2) return;
  const lastLine = lineSegments[lineSegments.length - 1];
  if (!lastLine || lastLine.layer !== layer) {
    lineSegments.push({ points: normalized, layer });
    return;
  }
  const lastPoint = lastLine.points[lastLine.points.length - 1];
  const firstPoint = normalized[0];
  if (!lastPoint || !firstPoint || !arePointsEqual(lastPoint, firstPoint)) {
    lineSegments.push({ points: normalized, layer });
    return;
  }
  const continuation = normalized.slice(1);
  for (const point2 of continuation) {
    appendPoint(lastLine.points, point2);
  }
}
function flattenLineSegments(lineSegments) {
  const points = [];
  for (const lineSegment of lineSegments) {
    for (const point2 of lineSegment.points) {
      appendPoint(points, point2);
    }
  }
  return points;
}
function resolveSolvedRouteLineSegments(solvedRoute, viaTile) {
  if (solvedRoute.path.length === 0) return [];
  const path = solvedRoute.path;
  const lineSegments = [];
  const drawnViaRegionIds = /* @__PURE__ */ new Set();
  for (let index = 1; index < path.length; index++) {
    const previousCandidate = path[index - 1];
    const currentCandidate = path[index];
    const previousPoint = {
      x: previousCandidate.port.d.x,
      y: previousCandidate.port.d.y
    };
    const currentPoint = {
      x: currentCandidate.port.d.x,
      y: currentCandidate.port.d.y
    };
    const traversedRegion = currentCandidate.lastRegion;
    const isViaRegionTraversal = !!viaTile && !!traversedRegion?.d?.isViaRegion;
    if (!isViaRegionTraversal) {
      appendLineSegment(lineSegments, [previousPoint, currentPoint], "top");
      continue;
    }
    const viasForRegion = selectViasForTraversedRegion(viaTile, traversedRegion);
    if (viasForRegion.length === 0) continue;
    const entryVia = findNearestVia(viasForRegion, previousPoint);
    const exitVia = findNearestVia(viasForRegion, currentPoint);
    if (entryVia) {
      appendLineSegment(lineSegments, [previousPoint, entryVia.position], "top");
    }
    const bottomRouteSegments = getBottomRouteSegmentsForVias(
      viaTile,
      viasForRegion
    );
    if (bottomRouteSegments.length > 0 && !drawnViaRegionIds.has(traversedRegion.regionId)) {
      drawnViaRegionIds.add(traversedRegion.regionId);
      for (const routeSegment of bottomRouteSegments) {
        appendLineSegment(lineSegments, routeSegment.segments, "bottom");
      }
    }
    if (exitVia) {
      appendLineSegment(lineSegments, [exitVia.position, currentPoint], "top");
    }
  }
  return lineSegments;
}
function resolveSolvedRoutePoints(solvedRoute, viaTile) {
  const lineSegments = resolveSolvedRouteLineSegments(solvedRoute, viaTile);
  return flattenLineSegments(lineSegments);
}

// lib/ViaGraphSolver/visualizeViaGraphSolver.ts
var getConnectionColor2 = (connectionId, alpha = 0.8) => {
  let hash = 0;
  for (let i = 0; i < connectionId.length; i++) {
    hash = connectionId.charCodeAt(i) * 17777 + ((hash << 5) - hash);
  }
  const hue = Math.abs(hash) % 360;
  return `hsla(${hue}, 70%, 50%, ${alpha})`;
};
var NET_COLOR_PALETTE = [
  "rgba(231, 76, 60, 0.35)",
  // red
  "rgba(46, 204, 113, 0.35)",
  // green
  "rgba(52, 152, 219, 0.35)",
  // blue
  "rgba(243, 156, 18, 0.35)",
  // orange
  "rgba(155, 89, 182, 0.35)",
  // purple
  "rgba(26, 188, 156, 0.35)",
  // teal
  "rgba(241, 196, 15, 0.35)",
  // yellow
  "rgba(230, 126, 34, 0.35)"
  // dark orange
];
var BOTTOM_LAYER_TRACE_COLOR = "rgba(52, 152, 219, 0.95)";
var BOTTOM_LAYER_TRACE_DASH = "3 2";
var visualizeViaGraphSolver = (solver) => {
  const graph = {
    regions: solver.graph.regions,
    ports: solver.graph.ports
  };
  const graphics = visualizeJumperGraph(graph, {
    connections: solver.connections,
    ...solver.iterations > 0 ? {
      hideRegionPortLines: true,
      hideConnectionLines: true,
      hidePortPoints: true
    } : {}
  });
  if (solver.iterations === 0) {
    for (const polygon2 of graphics.polygons) {
      polygon2.stroke = "rgba(128, 128, 128, 0.5)";
      polygon2.strokeWidth = 0.03;
    }
  }
  const outerIds = /* @__PURE__ */ new Set(["T", "B", "L", "R"]);
  let netColorIndex = 0;
  const netColorMap = /* @__PURE__ */ new Map();
  let polyIndex = 0;
  for (const region of graph.regions) {
    const jRegion = region;
    const hasPolygon = jRegion.d.polygon && jRegion.d.polygon.length >= 3;
    if (!hasPolygon) continue;
    const suffix = jRegion.regionId.split(":").pop() ?? "";
    const isOuter = outerIds.has(suffix);
    if (!isOuter && !jRegion.d.isConnectionRegion) {
      if (!netColorMap.has(suffix)) {
        netColorMap.set(
          suffix,
          NET_COLOR_PALETTE[netColorIndex % NET_COLOR_PALETTE.length]
        );
        netColorIndex++;
      }
      if (graphics.polygons[polyIndex]) {
        graphics.polygons[polyIndex].fill = netColorMap.get(suffix);
      }
    }
    polyIndex++;
  }
  if (solver.currentConnection && !solver.solved) {
    const connectionColor = getConnectionColor2(
      solver.currentConnection.connectionId
    );
    const startRegion = solver.currentConnection.startRegion;
    const endRegion = solver.currentConnection.endRegion;
    const startCenter = {
      x: (startRegion.d.bounds.minX + startRegion.d.bounds.maxX) / 2,
      y: (startRegion.d.bounds.minY + startRegion.d.bounds.maxY) / 2
    };
    const endCenter = {
      x: (endRegion.d.bounds.minX + endRegion.d.bounds.maxX) / 2,
      y: (endRegion.d.bounds.minY + endRegion.d.bounds.maxY) / 2
    };
    graphics.lines.push({
      points: [startCenter, endCenter],
      strokeColor: connectionColor,
      strokeDash: "10 5"
    });
    graphics.points.push({
      x: startCenter.x - 0.1,
      y: startCenter.y + 0.1,
      color: connectionColor,
      label: [solver.currentConnection.connectionId, "start"].join("\n")
    });
    graphics.points.push({
      x: endCenter.x - 0.1,
      y: endCenter.y + 0.1,
      color: connectionColor,
      label: [solver.currentConnection.connectionId, "end"].join("\n")
    });
  }
  for (const solvedRoute of solver.solvedRoutes) {
    const connectionColor = getConnectionColor2(
      solvedRoute.connection.connectionId
    );
    const lineSegments = solver.getSolvedRouteLineSegments(solvedRoute);
    for (const lineSegment of lineSegments) {
      const isBottomLayer = lineSegment.layer === "bottom";
      graphics.lines.push({
        points: lineSegment.points,
        strokeColor: isBottomLayer ? BOTTOM_LAYER_TRACE_COLOR : connectionColor,
        ...isBottomLayer ? { strokeDash: BOTTOM_LAYER_TRACE_DASH } : {}
      });
    }
  }
  const candidates = solver.candidateQueue.peekMany(10);
  for (let candidateIndex = 0; candidateIndex < candidates.length; candidateIndex++) {
    const candidate = candidates[candidateIndex];
    const port = candidate.port;
    const isNext = candidateIndex === 0;
    graphics.points.push({
      x: port.d.x,
      y: port.d.y,
      color: isNext ? "green" : "rgba(128, 128, 128, 0.25)",
      label: [
        candidate.port.portId,
        `g: ${candidate.g.toFixed(2)}`,
        `h: ${candidate.h.toFixed(2)}`,
        `f: ${candidate.f.toFixed(2)}`
      ].join("\n")
    });
  }
  const nextCandidate = candidates[0];
  if (!solver.solved && nextCandidate && solver.currentConnection) {
    const connectionColor = getConnectionColor2(
      solver.currentConnection.connectionId
    );
    const activePath = [];
    let cursor = nextCandidate;
    while (cursor) {
      const port = cursor.port;
      activePath.unshift({ x: port.d.x, y: port.d.y });
      cursor = cursor.parent;
    }
    if (activePath.length > 1) {
      graphics.lines.push({
        points: activePath,
        strokeColor: connectionColor
      });
    }
  }
  if (solver.viaTile) {
    if (!graphics.circles) graphics.circles = [];
    for (const [netName, vias] of Object.entries(solver.viaTile.viasByNet)) {
      const netColor = netColorMap.get(netName);
      const viaFill = netColor ? netColor.replace("0.35", "0.5") : "rgba(255, 0, 0, 0.3)";
      for (const via of vias) {
        graphics.circles.push({
          center: via.position,
          radius: via.diameter / 2,
          fill: viaFill,
          label: netName
        });
      }
    }
  }
  return graphics;
};

// lib/ViaGraphSolver/ViaGraphSolver.ts
var VIA_GRAPH_SOLVER_DEFAULTS = {
  portUsagePenalty: 0.034685181009478865,
  portUsagePenaltySq: 0,
  crossingPenalty: 4.072520483177124,
  crossingPenaltySq: 0,
  ripCost: 35.38577539020022,
  greedyMultiplier: 0.5518001238069296
};
var ViaGraphSolver = class extends HyperGraphSolver {
  getSolverName() {
    return "ViaGraphSolver";
  }
  UNIT_OF_COST = "hops";
  viaTile;
  portUsagePenalty = VIA_GRAPH_SOLVER_DEFAULTS.portUsagePenalty;
  portUsagePenaltySq = VIA_GRAPH_SOLVER_DEFAULTS.portUsagePenaltySq;
  crossingPenalty = VIA_GRAPH_SOLVER_DEFAULTS.crossingPenalty;
  crossingPenaltySq = VIA_GRAPH_SOLVER_DEFAULTS.crossingPenaltySq;
  ripCost = VIA_GRAPH_SOLVER_DEFAULTS.ripCost;
  baseMaxIterations = 9e5;
  additionalMaxIterationsPerConnection = 2e3;
  additionalMaxIterationsPerCrossing = 2e3;
  constructor(input) {
    super({
      greedyMultiplier: VIA_GRAPH_SOLVER_DEFAULTS.greedyMultiplier,
      rippingEnabled: true,
      ...input
    });
    this.viaTile = input.viaTile;
    this.ripCost = input.ripCost ?? this.ripCost;
    this.portUsagePenalty = input.portUsagePenalty ?? this.portUsagePenalty;
    this.crossingPenalty = input.crossingPenalty ?? this.crossingPenalty;
    this.baseMaxIterations = input.baseMaxIterations ?? this.baseMaxIterations;
    this.additionalMaxIterationsPerConnection = input.additionalMaxIterationsPerConnection ?? this.additionalMaxIterationsPerConnection;
    const crossings = countInputConnectionCrossings(
      this.graph,
      input.inputConnections
    );
    this.MAX_ITERATIONS = this.baseMaxIterations + input.inputConnections.length * this.additionalMaxIterationsPerConnection + crossings * this.additionalMaxIterationsPerCrossing;
    this.populateDistanceToEndMaps();
  }
  populateDistanceToEndMaps() {
    const endRegions = new Set(this.connections.map((c) => c.endRegion));
    for (const endRegion of endRegions) {
      const regionDistanceMap = /* @__PURE__ */ new Map();
      const queue = [];
      regionDistanceMap.set(endRegion.regionId, 0);
      queue.push({ region: endRegion, distance: 0 });
      while (queue.length > 0) {
        const { region, distance: dist } = queue.shift();
        for (const port of region.ports) {
          const otherRegion = port.region1 === region ? port.region2 : port.region1;
          if (!regionDistanceMap.has(otherRegion.regionId)) {
            regionDistanceMap.set(otherRegion.regionId, dist + 1);
            queue.push({ region: otherRegion, distance: dist + 1 });
          }
        }
      }
      for (const port of this.graph.ports) {
        if (!port.distanceToEndMap) {
          port.distanceToEndMap = {};
        }
        const d1 = regionDistanceMap.get(port.region1.regionId) ?? Infinity;
        const d2 = regionDistanceMap.get(port.region2.regionId) ?? Infinity;
        port.distanceToEndMap[endRegion.regionId] = Math.min(d1, d2);
      }
    }
  }
  estimateCostToEnd(port) {
    const endRegionId = this.currentEndRegion.regionId;
    const hopDistance = port.distanceToEndMap[endRegionId];
    return hopDistance;
  }
  getPortUsagePenalty(port) {
    const ripCount = port.ripCount ?? 0;
    return ripCount * this.portUsagePenalty + ripCount * this.portUsagePenaltySq;
  }
  computeIncreasedRegionCostIfPortsAreUsed(region, port1, port2) {
    if (region.d.isViaRegion) {
      const assignments = region.assignments ?? [];
      const differentNetCount = assignments.filter(
        (a) => a.connection.mutuallyConnectedNetworkId !== this.currentConnection.mutuallyConnectedNetworkId
      ).length;
      if (differentNetCount > 0) {
        return differentNetCount * this.crossingPenalty + differentNetCount * this.crossingPenaltySq;
      }
      return 0;
    }
    const crossings = computeDifferentNetCrossingsForPolygon(
      region,
      port1,
      port2
    );
    return crossings * this.crossingPenalty + crossings * this.crossingPenaltySq;
  }
  isRipRequiredForPortUsage(region, _port1, _port2) {
    if (region.d.isViaRegion) {
      const assignments = region.assignments ?? [];
      return assignments.some(
        (a) => a.connection.mutuallyConnectedNetworkId !== this.currentConnection.mutuallyConnectedNetworkId
      );
    }
    return false;
  }
  getRipsRequiredForPortUsage(region, port1, port2) {
    if (region.d.isViaRegion) {
      const assignments = region.assignments ?? [];
      return assignments.filter(
        (a) => a.connection.mutuallyConnectedNetworkId !== this.currentConnection.mutuallyConnectedNetworkId
      );
    }
    const crossingAssignments = computeCrossingAssignmentsForPolygon(
      region,
      port1,
      port2
    );
    return crossingAssignments.filter(
      (a) => a.connection.mutuallyConnectedNetworkId !== this.currentConnection.mutuallyConnectedNetworkId
    );
  }
  routeSolvedHook(solvedRoute) {
  }
  getSolvedRoutePoints(solvedRoute) {
    return resolveSolvedRoutePoints(solvedRoute, this.viaTile);
  }
  getSolvedRouteLineSegments(solvedRoute) {
    return resolveSolvedRouteLineSegments(solvedRoute, this.viaTile);
  }
  routeStartedHook(connection) {
  }
  visualize() {
    return visualizeViaGraphSolver(this);
  }
};

// lib/ViaGraphSolver/via-graph-generator/findBoundaryRegionForPolygons.ts
function closestPointOnPolygonEdge(point2, polygon2) {
  let bestDist = Infinity;
  let bestPoint = { x: point2.x, y: point2.y };
  for (let i = 0; i < polygon2.length; i++) {
    const a = polygon2[i];
    const b = polygon2[(i + 1) % polygon2.length];
    const dx = b.x - a.x;
    const dy = b.y - a.y;
    const lenSq = dx * dx + dy * dy;
    if (lenSq < 1e-10) continue;
    const t = Math.max(
      0,
      Math.min(1, ((point2.x - a.x) * dx + (point2.y - a.y) * dy) / lenSq)
    );
    const projX = a.x + t * dx;
    const projY = a.y + t * dy;
    const dist = Math.sqrt((point2.x - projX) ** 2 + (point2.y - projY) ** 2);
    if (dist < bestDist) {
      bestDist = dist;
      bestPoint = { x: projX, y: projY };
    }
  }
  return { ...bestPoint, dist: bestDist };
}
var findBoundaryRegionForPolygons = (params) => {
  const { x, y, regions } = params;
  const hasFillerRegions = regions.some((r) => r.regionId.startsWith("filler:"));
  let closestRegion = null;
  let closestDistance = Infinity;
  let closestPortPosition = { x, y };
  for (const region of regions) {
    if (region.d.isPad || region.d.isThroughJumper || region.d.isConnectionRegion)
      continue;
    if (hasFillerRegions && !region.regionId.startsWith("filler:")) continue;
    const polygon2 = region.d.polygon;
    if (!polygon2 || polygon2.length < 3) continue;
    const result = closestPointOnPolygonEdge({ x, y }, polygon2);
    if (result.dist < closestDistance) {
      closestDistance = result.dist;
      closestRegion = region;
      closestPortPosition = { x: result.x, y: result.y };
    }
  }
  if (closestRegion) {
    return { region: closestRegion, portPosition: closestPortPosition };
  }
  return null;
};

// lib/ViaGraphSolver/via-graph-generator/createViaGraphWithConnections.ts
var createViaGraphWithConnections = (baseGraph, xyConnections) => {
  const regions = [...baseGraph.regions];
  const ports = [...baseGraph.ports];
  const connections = [];
  for (const xyConn of xyConnections) {
    const { start, end, connectionId } = xyConn;
    const startRegion = createConnectionRegion(
      `conn:${connectionId}:start`,
      start.x,
      start.y
    );
    regions.push(startRegion);
    const endRegion = createConnectionRegion(
      `conn:${connectionId}:end`,
      end.x,
      end.y
    );
    regions.push(endRegion);
    const startBoundary = findBoundaryRegionForPolygons({
      x: start.x,
      y: start.y,
      regions: baseGraph.regions
    });
    if (startBoundary) {
      const startPort = createConnectionPort(
        `conn:${connectionId}:start-port`,
        startRegion,
        startBoundary.region,
        startBoundary.portPosition
      );
      ports.push(startPort);
    }
    const endBoundary = findBoundaryRegionForPolygons({
      x: end.x,
      y: end.y,
      regions: baseGraph.regions
    });
    if (endBoundary) {
      const endPort = createConnectionPort(
        `conn:${connectionId}:end-port`,
        endRegion,
        endBoundary.region,
        endBoundary.portPosition
      );
      ports.push(endPort);
    }
    const connection = {
      connectionId,
      mutuallyConnectedNetworkId: connectionId,
      startRegion,
      endRegion
    };
    connections.push(connection);
  }
  return {
    regions,
    ports,
    connections
  };
};

// node_modules/@flatten-js/core/dist/main.mjs
var CCW = true;
var CW = false;
var ORIENTATION = { CCW: -1, CW: 1, NOT_ORIENTABLE: 0 };
var PIx2 = 2 * Math.PI;
var INSIDE$2 = 1;
var OUTSIDE$1 = 0;
var BOUNDARY$1 = 2;
var CONTAINS = 3;
var INTERLACE = 4;
var OVERLAP_SAME$1 = 1;
var OVERLAP_OPPOSITE$1 = 2;
var NOT_VERTEX$1 = 0;
var START_VERTEX$1 = 1;
var END_VERTEX$1 = 2;
var Constants = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  BOUNDARY: BOUNDARY$1,
  CCW,
  CONTAINS,
  CW,
  END_VERTEX: END_VERTEX$1,
  INSIDE: INSIDE$2,
  INTERLACE,
  NOT_VERTEX: NOT_VERTEX$1,
  ORIENTATION,
  OUTSIDE: OUTSIDE$1,
  OVERLAP_OPPOSITE: OVERLAP_OPPOSITE$1,
  OVERLAP_SAME: OVERLAP_SAME$1,
  PIx2,
  START_VERTEX: START_VERTEX$1
});
var DP_TOL = 1e-6;
function setTolerance(tolerance) {
  DP_TOL = tolerance;
}
function getTolerance() {
  return DP_TOL;
}
var DECIMALS = 3;
function EQ_0(x) {
  return x < DP_TOL && x > -DP_TOL;
}
function EQ(x, y) {
  return x - y < DP_TOL && x - y > -DP_TOL;
}
function GT(x, y) {
  return x - y > DP_TOL;
}
function GE(x, y) {
  return x - y > -DP_TOL;
}
function LT(x, y) {
  return x - y < -DP_TOL;
}
function LE(x, y) {
  return x - y < DP_TOL;
}
var Utils$1 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  DECIMALS,
  EQ,
  EQ_0,
  GE,
  GT,
  LE,
  LT,
  getTolerance,
  setTolerance
});
var Flatten = {
  Utils: Utils$1,
  Errors: void 0,
  Matrix: void 0,
  Planar_set: void 0,
  Point: void 0,
  Vector: void 0,
  Line: void 0,
  Circle: void 0,
  Segment: void 0,
  Arc: void 0,
  Box: void 0,
  Edge: void 0,
  Face: void 0,
  Ray: void 0,
  Ray_shooting: void 0,
  Multiline: void 0,
  Polygon: void 0,
  Distance: void 0,
  Inversion: void 0
};
for (let c in Constants) {
  Flatten[c] = Constants[c];
}
Object.defineProperty(Flatten, "DP_TOL", {
  get: function() {
    return getTolerance();
  },
  set: function(value) {
    setTolerance(value);
  }
});
var Errors = class {
  /**
   * Throw error ILLEGAL_PARAMETERS when cannot instantiate from given parameter
   * @returns {ReferenceError}
   */
  static get ILLEGAL_PARAMETERS() {
    return new ReferenceError("Illegal Parameters");
  }
  /**
   * Throw error ZERO_DIVISION to catch situation of zero division
   * @returns {Error}
   */
  static get ZERO_DIVISION() {
    return new Error("Zero division");
  }
  /**
   * Error to throw from BooleanOperations module in case when fixBoundaryConflicts not capable to fix it
   * @returns {Error}
   */
  static get UNRESOLVED_BOUNDARY_CONFLICT() {
    return new Error("Unresolved boundary conflict in boolean operation");
  }
  /**
   * Error to throw from LinkedList:testInfiniteLoop static method
   * in case when circular loop detected in linked list
   * @returns {Error}
   */
  static get INFINITE_LOOP() {
    return new Error("Infinite loop");
  }
  static get CANNOT_COMPLETE_BOOLEAN_OPERATION() {
    return new Error("Cannot complete boolean operation");
  }
  static get CANNOT_INVOKE_ABSTRACT_METHOD() {
    return new Error("Abstract method cannot be invoked");
  }
  static get OPERATION_IS_NOT_SUPPORTED() {
    return new Error("Operation is not supported");
  }
  static get UNSUPPORTED_SHAPE_TYPE() {
    return new Error("Unsupported shape type");
  }
};
Flatten.Errors = Errors;
var LinkedList = class {
  constructor(first, last) {
    this.first = first;
    this.last = last || this.first;
  }
  [Symbol.iterator]() {
    let value = void 0;
    return {
      next: () => {
        value = value ? value.next : this.first;
        return { value, done: value === void 0 };
      }
    };
  }
  /**
   * Return number of elements in the list
   * @returns {number}
   */
  get size() {
    let counter = 0;
    for (let edge of this) {
      counter++;
    }
    return counter;
  }
  /**
   * Return array of elements from start to end,
   * If start or end not defined, take first as start, last as end
   * @returns {Array}
   */
  toArray(start = void 0, end = void 0) {
    let elements = [];
    let from = start || this.first;
    let to = end || this.last;
    let element = from;
    if (element === void 0) return elements;
    do {
      elements.push(element);
      element = element.next;
    } while (element !== to.next);
    return elements;
  }
  /**
   * Append new element to the end of the list
   * @param {LinkedListElement} element
   * @returns {LinkedList}
   */
  append(element) {
    if (this.isEmpty()) {
      this.first = element;
    } else {
      element.prev = this.last;
      this.last.next = element;
    }
    this.last = element;
    this.last.next = void 0;
    this.first.prev = void 0;
    return this;
  }
  /**
   * Insert new element to the list after elementBefore
   * @param {LinkedListElement} newElement
   * @param {LinkedListElement} elementBefore
   * @returns {LinkedList}
   */
  insert(newElement, elementBefore) {
    if (this.isEmpty()) {
      this.first = newElement;
      this.last = newElement;
    } else if (elementBefore === null || elementBefore === void 0) {
      newElement.next = this.first;
      this.first.prev = newElement;
      this.first = newElement;
    } else {
      let elementAfter = elementBefore.next;
      elementBefore.next = newElement;
      if (elementAfter) elementAfter.prev = newElement;
      newElement.prev = elementBefore;
      newElement.next = elementAfter;
      if (this.last === elementBefore)
        this.last = newElement;
    }
    this.last.next = void 0;
    this.first.prev = void 0;
    return this;
  }
  /**
   * Remove element from the list
   * @param {LinkedListElement} element
   * @returns {LinkedList}
   */
  remove(element) {
    if (element === this.first && element === this.last) {
      this.first = void 0;
      this.last = void 0;
    } else {
      if (element.prev) element.prev.next = element.next;
      if (element.next) element.next.prev = element.prev;
      if (element === this.first) {
        this.first = element.next;
      }
      if (element === this.last) {
        this.last = element.prev;
      }
    }
    return this;
  }
  /**
   * Return true if list is empty
   * @returns {boolean}
   */
  isEmpty() {
    return this.first === void 0;
  }
  /**
   * Throw an error if circular loop detected in the linked list
   * @param {LinkedListElement} first element to start iteration
   * @throws {Errors.INFINITE_LOOP}
   */
  static testInfiniteLoop(first) {
    let edge = first;
    let controlEdge = first;
    do {
      if (edge != first && edge === controlEdge) {
        throw Errors.INFINITE_LOOP;
      }
      edge = edge.next;
      controlEdge = controlEdge.next.next;
    } while (edge != first);
  }
};
var defaultAttributes = {
  stroke: "black"
};
var SVGAttributes = class {
  constructor(args = defaultAttributes) {
    for (const property in args) {
      this[property] = args[property];
    }
    this.stroke = args.stroke ?? defaultAttributes.stroke;
  }
  toAttributesString() {
    return Object.keys(this).reduce(
      (acc, key) => acc + (this[key] !== void 0 ? this.toAttrString(key, this[key]) : ""),
      ``
    );
  }
  toAttrString(key, value) {
    const SVGKey = key === "className" ? "class" : this.convertCamelToKebabCase(key);
    return value === null ? `${SVGKey} ` : `${SVGKey}="${value.toString()}" `;
  }
  convertCamelToKebabCase(str) {
    return str.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g).join("-").toLowerCase();
  }
};
function convertToString(attrs) {
  return new SVGAttributes(attrs).toAttributesString();
}
function intersectLine2Line(line1, line2) {
  let ip = [];
  let [A1, B1, C1] = line1.standard;
  let [A2, B2, C2] = line2.standard;
  let det = A1 * B2 - B1 * A2;
  let detX = C1 * B2 - B1 * C2;
  let detY = A1 * C2 - C1 * A2;
  if (!Flatten.Utils.EQ_0(det)) {
    let x, y;
    if (B1 === 0) {
      x = C1 / A1;
      y = detY / det;
    } else if (B2 === 0) {
      x = C2 / A2;
      y = detY / det;
    } else if (A1 === 0) {
      x = detX / det;
      y = C1 / B1;
    } else if (A2 === 0) {
      x = detX / det;
      y = C2 / B2;
    } else {
      x = detX / det;
      y = detY / det;
    }
    ip.push(new Flatten.Point(x, y));
  }
  return ip;
}
function intersectLine2Circle(line2, circle2) {
  let ip = [];
  let prj = circle2.pc.projectionOn(line2);
  let dist = circle2.pc.distanceTo(prj)[0];
  if (Flatten.Utils.EQ(dist, circle2.r)) {
    ip.push(prj);
  } else if (Flatten.Utils.LT(dist, circle2.r)) {
    let delta = Math.sqrt(circle2.r * circle2.r - dist * dist);
    let v_trans, pt;
    v_trans = line2.norm.rotate90CCW().multiply(delta);
    pt = prj.translate(v_trans);
    ip.push(pt);
    v_trans = line2.norm.rotate90CW().multiply(delta);
    pt = prj.translate(v_trans);
    ip.push(pt);
  }
  return ip;
}
function intersectLine2Box(line2, box2) {
  let ips = [];
  for (let seg of box2.toSegments()) {
    let ips_tmp = intersectSegment2Line(seg, line2);
    for (let pt of ips_tmp) {
      if (!ptInIntPoints(pt, ips)) {
        ips.push(pt);
      }
    }
  }
  return ips;
}
function intersectLine2Arc(line2, arc2) {
  let ip = [];
  if (intersectLine2Box(line2, arc2.box).length === 0) {
    return ip;
  }
  let circle2 = new Flatten.Circle(arc2.pc, arc2.r);
  let ip_tmp = intersectLine2Circle(line2, circle2);
  for (let pt of ip_tmp) {
    if (pt.on(arc2)) {
      ip.push(pt);
    }
  }
  return ip;
}
function intersectSegment2Line(seg, line2) {
  let ip = [];
  if (seg.ps.on(line2)) {
    ip.push(seg.ps);
  }
  if (seg.pe.on(line2) && !seg.isZeroLength()) {
    ip.push(seg.pe);
  }
  if (ip.length > 0) {
    return ip;
  }
  if (seg.isZeroLength()) {
    return ip;
  }
  if (seg.ps.leftTo(line2) && seg.pe.leftTo(line2) || !seg.ps.leftTo(line2) && !seg.pe.leftTo(line2)) {
    return ip;
  }
  let line1 = new Flatten.Line(seg.ps, seg.pe);
  return intersectLine2Line(line1, line2);
}
function intersectSegment2Segment(seg1, seg2) {
  let ip = [];
  if (seg1.isZeroLength()) {
    if (seg1.ps.on(seg2)) {
      ip.push(seg1.ps);
    }
    return ip;
  }
  if (seg2.isZeroLength()) {
    if (seg2.ps.on(seg1)) {
      ip.push(seg2.ps);
    }
    return ip;
  }
  let line1 = new Flatten.Line(seg1.ps, seg1.pe);
  let line2 = new Flatten.Line(seg2.ps, seg2.pe);
  if (line1.incidentTo(line2)) {
    if (seg1.ps.on(seg2)) {
      ip.push(seg1.ps);
    }
    if (seg1.pe.on(seg2)) {
      ip.push(seg1.pe);
    }
    if (seg2.ps.on(seg1) && !seg2.ps.equalTo(seg1.ps) && !seg2.ps.equalTo(seg1.pe)) {
      ip.push(seg2.ps);
    }
    if (seg2.pe.on(seg1) && !seg2.pe.equalTo(seg1.ps) && !seg2.pe.equalTo(seg1.pe)) {
      ip.push(seg2.pe);
    }
  } else {
    let new_ip = intersectLine2Line(line1, line2);
    if (new_ip.length > 0) {
      if (isPointInSegmentBox(new_ip[0], seg1) && isPointInSegmentBox(new_ip[0], seg2)) {
        ip.push(new_ip[0]);
      }
    }
  }
  return ip;
}
function isPointInSegmentBox(point2, segment2) {
  const box2 = segment2.box;
  return Flatten.Utils.LE(point2.x, box2.xmax) && Flatten.Utils.GE(point2.x, box2.xmin) && Flatten.Utils.LE(point2.y, box2.ymax) && Flatten.Utils.GE(point2.y, box2.ymin);
}
function intersectSegment2Circle(segment2, circle2) {
  let ips = [];
  if (segment2.isZeroLength()) {
    let [dist, _] = segment2.ps.distanceTo(circle2.pc);
    if (Flatten.Utils.EQ(dist, circle2.r)) {
      ips.push(segment2.ps);
    }
    return ips;
  }
  let line2 = new Flatten.Line(segment2.ps, segment2.pe);
  let ips_tmp = intersectLine2Circle(line2, circle2);
  for (let ip of ips_tmp) {
    if (ip.on(segment2)) {
      ips.push(ip);
    }
  }
  return ips;
}
function intersectSegment2Arc(segment2, arc2) {
  let ip = [];
  if (segment2.isZeroLength()) {
    if (segment2.ps.on(arc2)) {
      ip.push(segment2.ps);
    }
    return ip;
  }
  let line2 = new Flatten.Line(segment2.ps, segment2.pe);
  let circle2 = new Flatten.Circle(arc2.pc, arc2.r);
  let ip_tmp = intersectLine2Circle(line2, circle2);
  for (let pt of ip_tmp) {
    if (pt.on(segment2) && pt.on(arc2)) {
      ip.push(pt);
    }
  }
  return ip;
}
function intersectSegment2Box(segment2, box2) {
  let ips = [];
  for (let seg of box2.toSegments()) {
    let ips_tmp = intersectSegment2Segment(seg, segment2);
    for (let ip of ips_tmp) {
      ips.push(ip);
    }
  }
  return ips;
}
function intersectCircle2Circle(circle1, circle2) {
  let ip = [];
  let vec = new Flatten.Vector(circle1.pc, circle2.pc);
  let r1 = circle1.r;
  let r2 = circle2.r;
  if (Flatten.Utils.EQ_0(r1) || Flatten.Utils.EQ_0(r2))
    return ip;
  if (Flatten.Utils.EQ_0(vec.x) && Flatten.Utils.EQ_0(vec.y) && Flatten.Utils.EQ(r1, r2)) {
    ip.push(circle1.pc.translate(-r1, 0));
    return ip;
  }
  let dist = circle1.pc.distanceTo(circle2.pc)[0];
  if (Flatten.Utils.GT(dist, r1 + r2))
    return ip;
  if (Flatten.Utils.LT(dist, Math.abs(r1 - r2)))
    return ip;
  vec.x /= dist;
  vec.y /= dist;
  let pt;
  if (Flatten.Utils.EQ(dist, r1 + r2) || Flatten.Utils.EQ(dist, Math.abs(r1 - r2))) {
    pt = circle1.pc.translate(r1 * vec.x, r1 * vec.y);
    ip.push(pt);
    return ip;
  }
  let a = r1 * r1 / (2 * dist) - r2 * r2 / (2 * dist) + dist / 2;
  let mid_pt = circle1.pc.translate(a * vec.x, a * vec.y);
  let h = Math.sqrt(r1 * r1 - a * a);
  pt = mid_pt.translate(vec.rotate90CCW().multiply(h));
  ip.push(pt);
  pt = mid_pt.translate(vec.rotate90CW().multiply(h));
  ip.push(pt);
  return ip;
}
function intersectCircle2Box(circle2, box2) {
  let ips = [];
  for (let seg of box2.toSegments()) {
    let ips_tmp = intersectSegment2Circle(seg, circle2);
    for (let ip of ips_tmp) {
      ips.push(ip);
    }
  }
  return ips;
}
function intersectArc2Arc(arc1, arc2) {
  let ip = [];
  if (arc1.pc.equalTo(arc2.pc) && Flatten.Utils.EQ(arc1.r, arc2.r)) {
    let pt;
    pt = arc1.start;
    if (pt.on(arc2))
      ip.push(pt);
    pt = arc1.end;
    if (pt.on(arc2))
      ip.push(pt);
    pt = arc2.start;
    if (pt.on(arc1)) ip.push(pt);
    pt = arc2.end;
    if (pt.on(arc1)) ip.push(pt);
    return ip;
  }
  let circle1 = new Flatten.Circle(arc1.pc, arc1.r);
  let circle2 = new Flatten.Circle(arc2.pc, arc2.r);
  let ip_tmp = circle1.intersect(circle2);
  for (let pt of ip_tmp) {
    if (pt.on(arc1) && pt.on(arc2)) {
      ip.push(pt);
    }
  }
  return ip;
}
function intersectArc2Circle(arc2, circle2) {
  let ip = [];
  if (circle2.pc.equalTo(arc2.pc) && Flatten.Utils.EQ(circle2.r, arc2.r)) {
    ip.push(arc2.start);
    ip.push(arc2.end);
    return ip;
  }
  let circle1 = circle2;
  let circle22 = new Flatten.Circle(arc2.pc, arc2.r);
  let ip_tmp = intersectCircle2Circle(circle1, circle22);
  for (let pt of ip_tmp) {
    if (pt.on(arc2)) {
      ip.push(pt);
    }
  }
  return ip;
}
function intersectArc2Box(arc2, box2) {
  let ips = [];
  for (let seg of box2.toSegments()) {
    let ips_tmp = intersectSegment2Arc(seg, arc2);
    for (let ip of ips_tmp) {
      ips.push(ip);
    }
  }
  return ips;
}
function intersectEdge2Segment(edge, segment2) {
  return edge.isSegment ? intersectSegment2Segment(edge.shape, segment2) : intersectSegment2Arc(segment2, edge.shape);
}
function intersectEdge2Arc(edge, arc2) {
  return edge.isSegment ? intersectSegment2Arc(edge.shape, arc2) : intersectArc2Arc(edge.shape, arc2);
}
function intersectEdge2Line(edge, line2) {
  return edge.isSegment ? intersectSegment2Line(edge.shape, line2) : intersectLine2Arc(line2, edge.shape);
}
function intersectEdge2Ray(edge, ray2) {
  return edge.isSegment ? intersectRay2Segment(ray2, edge.shape) : intersectRay2Arc(ray2, edge.shape);
}
function intersectEdge2Circle(edge, circle2) {
  return edge.isSegment ? intersectSegment2Circle(edge.shape, circle2) : intersectArc2Circle(edge.shape, circle2);
}
function intersectSegment2Polygon(segment2, polygon2) {
  let ip = [];
  for (let edge of polygon2.edges) {
    for (let pt of intersectEdge2Segment(edge, segment2)) {
      ip.push(pt);
    }
  }
  return ip;
}
function intersectArc2Polygon(arc2, polygon2) {
  let ip = [];
  for (let edge of polygon2.edges) {
    for (let pt of intersectEdge2Arc(edge, arc2)) {
      ip.push(pt);
    }
  }
  return ip;
}
function intersectLine2Polygon(line2, polygon2) {
  let ip = [];
  if (polygon2.isEmpty()) {
    return ip;
  }
  for (let edge of polygon2.edges) {
    for (let pt of intersectEdge2Line(edge, line2)) {
      if (!ptInIntPoints(pt, ip)) {
        ip.push(pt);
      }
    }
  }
  return line2.sortPoints(ip);
}
function intersectCircle2Polygon(circle2, polygon2) {
  let ip = [];
  if (polygon2.isEmpty()) {
    return ip;
  }
  for (let edge of polygon2.edges) {
    for (let pt of intersectEdge2Circle(edge, circle2)) {
      ip.push(pt);
    }
  }
  return ip;
}
function intersectEdge2Edge(edge1, edge2) {
  if (edge1.isSegment) {
    return intersectEdge2Segment(edge2, edge1.shape);
  } else if (edge1.isArc) {
    return intersectEdge2Arc(edge2, edge1.shape);
  } else if (edge1.isLine) {
    return intersectEdge2Line(edge2, edge1.shape);
  } else if (edge1.isRay) {
    return intersectEdge2Ray(edge2, edge1.shape);
  }
  return [];
}
function intersectEdge2Polygon(edge, polygon2) {
  let ip = [];
  if (polygon2.isEmpty() || edge.shape.box.not_intersect(polygon2.box)) {
    return ip;
  }
  let resp_edges = polygon2.edges.search(edge.shape.box);
  for (let resp_edge of resp_edges) {
    ip = [...ip, ...intersectEdge2Edge(edge, resp_edge)];
  }
  return ip;
}
function intersectMultiline2Polygon(multiline2, polygon2) {
  let ip = [];
  if (polygon2.isEmpty() || multiline2.size === 0) {
    return ip;
  }
  for (let edge of multiline2) {
    ip = [...ip, ...intersectEdge2Polygon(edge, polygon2)];
  }
  return ip;
}
function intersectPolygon2Polygon(polygon1, polygon2) {
  let ip = [];
  if (polygon1.isEmpty() || polygon2.isEmpty()) {
    return ip;
  }
  if (polygon1.box.not_intersect(polygon2.box)) {
    return ip;
  }
  for (let edge1 of polygon1.edges) {
    ip = [...ip, ...intersectEdge2Polygon(edge1, polygon2)];
  }
  return ip;
}
function intersectShape2Polygon(shape, polygon2) {
  if (shape instanceof Flatten.Line) {
    return intersectLine2Polygon(shape, polygon2);
  } else if (shape instanceof Flatten.Segment) {
    return intersectSegment2Polygon(shape, polygon2);
  } else if (shape instanceof Flatten.Arc) {
    return intersectArc2Polygon(shape, polygon2);
  } else {
    return [];
  }
}
function ptInIntPoints(new_pt, ip) {
  return ip.some((pt) => pt.equalTo(new_pt));
}
function createLineFromRay(ray2) {
  return new Flatten.Line(ray2.start, ray2.norm);
}
function intersectRay2Segment(ray2, segment2) {
  return intersectSegment2Line(segment2, createLineFromRay(ray2)).filter((pt) => ray2.contains(pt));
}
function intersectRay2Arc(ray2, arc2) {
  return intersectLine2Arc(createLineFromRay(ray2), arc2).filter((pt) => ray2.contains(pt));
}
function intersectRay2Circle(ray2, circle2) {
  return intersectLine2Circle(createLineFromRay(ray2), circle2).filter((pt) => ray2.contains(pt));
}
function intersectRay2Box(ray2, box2) {
  return intersectLine2Box(createLineFromRay(ray2), box2).filter((pt) => ray2.contains(pt));
}
function intersectRay2Line(ray2, line2) {
  return intersectLine2Line(createLineFromRay(ray2), line2).filter((pt) => ray2.contains(pt));
}
function intersectRay2Ray(ray1, ray2) {
  return intersectLine2Line(createLineFromRay(ray1), createLineFromRay(ray2)).filter((pt) => ray1.contains(pt)).filter((pt) => ray2.contains(pt));
}
function intersectRay2Polygon(ray2, polygon2) {
  return intersectLine2Polygon(createLineFromRay(ray2), polygon2).filter((pt) => ray2.contains(pt));
}
function intersectShape2Shape(shape1, shape2) {
  if (shape1.intersect && shape1.intersect instanceof Function) {
    return shape1.intersect(shape2);
  }
  throw Errors.UNSUPPORTED_SHAPE_TYPE;
}
function intersectShape2Multiline(shape, multiline2) {
  let ip = [];
  for (let edge of multiline2) {
    ip = [...ip, ...intersectShape2Shape(shape, edge.shape)];
  }
  return ip;
}
function intersectMultiline2Multiline(multiline1, multiline2) {
  let ip = [];
  for (let edge1 of multiline1) {
    for (let edge2 of multiline2) {
      ip = [...ip, ...intersectShape2Shape(edge1.shape, edge2.shape)];
    }
  }
  return ip;
}
var Multiline$1 = class Multiline extends LinkedList {
  constructor(...args) {
    super();
    this.isInfinite = false;
    if (args.length === 1 && args[0] instanceof Array && args[0].length > 0) {
      const shapes = args[0];
      const L = shapes.length;
      const anyShape = (s) => s instanceof Flatten.Segment || s instanceof Flatten.Arc || s instanceof Flatten.Ray || s instanceof Flatten.Line;
      const anyShapeExceptLine = (s) => s instanceof Flatten.Segment || s instanceof Flatten.Arc || s instanceof Flatten.Ray;
      const shapeSegmentOrArc = (s) => s instanceof Flatten.Segment || s instanceof Flatten.Arc;
      const validShapes = L === 1 && anyShape(shapes[0]) || L > 1 && anyShapeExceptLine(shapes[0]) && anyShapeExceptLine(shapes[L - 1]) && shapes.slice(1, L - 1).every(shapeSegmentOrArc);
      if (validShapes) {
        this.isInfinite = shapes.some(
          (shape) => shape instanceof Flatten.Ray || shape instanceof Flatten.Line
        );
        for (let shape of shapes) {
          let edge = new Flatten.Edge(shape);
          this.append(edge);
        }
        this.setArcLength();
      } else {
        throw Flatten.Errors.ILLEGAL_PARAMETERS;
      }
    }
  }
  /**
   * (Getter) Return array of edges
   * @returns {Edge[]}
   */
  get edges() {
    return [...this];
  }
  /**
   * (Getter) Return bounding box of the multiline
   * @returns {Box}
   */
  get box() {
    return this.edges.reduce((acc, edge) => acc.merge(edge.box), new Flatten.Box());
  }
  /**
   * (Getter) Returns array of vertices
   * @returns {Point[]}
   */
  get vertices() {
    let v = this.edges.map((edge) => edge.start);
    v.push(this.last.end);
    return v;
  }
  /**
   * (Getter) Returns length of the multiline, return POSITIVE_INFINITY if multiline is infinite
   * @returns {number}
   */
  get length() {
    if (this.isEmpty()) return 0;
    if (this.isInfinite) return Number.POSITIVE_INFINITY;
    let len = 0;
    for (let edge of this) {
      len += edge.length;
    }
    return len;
  }
  /**
   * Return new cloned instance of Multiline
   * @returns {Multiline}
   */
  clone() {
    return new Multiline(this.toShapes());
  }
  /**
   * Set arc_length property for each of the edges in the multiline.
   * Arc_length of the edge is the arc length from the multiline start vertex to the edge start vertex
   */
  setArcLength() {
    for (let edge of this) {
      this.setOneEdgeArcLength(edge);
    }
  }
  setOneEdgeArcLength(edge) {
    if (edge === this.first) {
      edge.arc_length = 0;
    } else {
      edge.arc_length = edge.prev.arc_length + edge.prev.length;
    }
  }
  /**
   * Return point on multiline at given length from the start of the multiline
   * @param length
   * @returns {Point | null}
   */
  pointAtLength(length) {
    if (length > this.length || length < 0) return null;
    if (this.isInfinite) return null;
    let point2 = null;
    for (let edge of this) {
      if (length >= edge.arc_length && (edge === this.last || length < edge.next.arc_length)) {
        point2 = edge.pointAtLength(length - edge.arc_length);
        break;
      }
    }
    return point2;
  }
  /**
   * Split edge and add new vertex, return new edge inserted
   * @param {Point} pt - point on edge that will be added as new vertex
   * @param {Edge} edge - edge to split
   * @returns {Edge}
   */
  addVertex(pt, edge) {
    let shapes = edge.shape.split(pt);
    if (shapes[0] === null)
      return edge.prev;
    if (shapes[1] === null)
      return edge;
    let newEdge = new Flatten.Edge(shapes[0]);
    let edgeBefore = edge.prev;
    this.insert(newEdge, edgeBefore);
    edge.shape = shapes[1];
    return newEdge;
  }
  getChain(edgeFrom, edgeTo) {
    let edges = [];
    for (let edge = edgeFrom; edge !== edgeTo.next; edge = edge.next) {
      edges.push(edge);
    }
    return edges;
  }
  /**
   * Split edges of multiline with intersection points and return mutated multiline
   * @param {Point[]} ip - array of points to be added as new vertices
   * @returns {Multiline}
   */
  split(ip) {
    for (let pt of ip) {
      let edge = this.findEdgeByPoint(pt);
      this.addVertex(pt, edge);
    }
    return this;
  }
  /**
   * Returns edge which contains given point
   * @param {Point} pt
   * @returns {Edge}
   */
  findEdgeByPoint(pt) {
    let edgeFound;
    for (let edge of this) {
      if (edge.shape.contains(pt)) {
        edgeFound = edge;
        break;
      }
    }
    return edgeFound;
  }
  /**
   * Calculate distance and shortest segment from any shape to multiline
   * @param shape
   * @returns {[number,Flatten.Segment]}
   */
  distanceTo(shape) {
    if (shape instanceof Point) {
      const [dist, shortest_segment] = Flatten.Distance.shape2multiline(shape, this);
      return [dist, shortest_segment.reverse()];
    }
    if (shape instanceof Flatten.Line) {
      const [dist, shortest_segment] = Flatten.Distance.shape2multiline(shape, this);
      return [dist, shortest_segment.reverse()];
    }
    if (shape instanceof Flatten.Circle) {
      const [dist, shortest_segment] = Flatten.Distance.shape2multiline(shape, this);
      return [dist, shortest_segment.reverse()];
    }
    if (shape instanceof Flatten.Segment) {
      const [dist, shortest_segment] = Flatten.Distance.shape2multiline(shape, this);
      return [dist, shortest_segment.reverse()];
    }
    if (shape instanceof Flatten.Arc) {
      const [dist, shortest_segment] = Flatten.Distance.shape2multiline(shape, this);
      return [dist, shortest_segment.reverse()];
    }
    if (shape instanceof Flatten.Multiline) {
      return Flatten.Distance.multiline2multiline(this, shape);
    }
    throw Flatten.Errors.UNSUPPORTED_SHAPE_TYPE;
  }
  /**
   * Calculate intersection of multiline with other shape
   * @param {Shape} shape
   * @returns {Point[]}
   */
  intersect(shape) {
    if (shape instanceof Flatten.Multiline) {
      return intersectMultiline2Multiline(this, shape);
    } else {
      return intersectShape2Multiline(shape, this);
    }
  }
  /**
   * Return true if multiline contains the shape: no point of shape lies outside
   * @param shape
   * @returns {boolean}
   */
  contains(shape) {
    if (shape instanceof Flatten.Point) {
      return this.edges.some((edge) => edge.shape.contains(shape));
    }
    throw Flatten.Errors.UNSUPPORTED_SHAPE_TYPE;
  }
  /**
   * Returns new multiline translated by vector vec
   * @param {Vector} vec
   * @returns {Multiline}
   */
  translate(vec) {
    return new Multiline(this.edges.map((edge) => edge.shape.translate(vec)));
  }
  /**
   * Return new multiline rotated by given angle around given point
   * If point omitted, rotate around origin (0,0)
   * Positive value of angle defines rotation counterclockwise, negative - clockwise
   * @param {number} angle - rotation angle in radians
   * @param {Point} center - rotation center, default is (0,0)
   * @returns {Multiline} - new rotated polygon
   */
  rotate(angle = 0, center = new Flatten.Point()) {
    return new Multiline(this.edges.map((edge) => edge.shape.rotate(angle, center)));
  }
  /**
   * Return new multiline transformed using affine transformation matrix
   * Method does not support unbounded shapes
   * @param {Matrix} matrix - affine transformation matrix
   * @returns {Multiline} - new multiline
   */
  transform(matrix2 = new Flatten.Matrix()) {
    return new Multiline(this.edges.map((edge) => edge.shape.transform(matrix2)));
  }
  /**
   * Transform multiline into array of shapes
   * @returns {Shape[]}
   */
  toShapes() {
    return this.edges.map((edge) => edge.shape.clone());
  }
  /**
   * This method returns an object that defines how data will be
   * serialized when called JSON.stringify() method
   * @returns {Object}
   */
  toJSON() {
    return this.edges.map((edge) => edge.toJSON());
  }
  /**
   * Return string to be inserted into 'points' attribute of <polyline> element
   * @returns {string}
   */
  svgPoints() {
    return this.vertices.map((p) => `${p.x},${p.y}`).join(" ");
  }
  /**
   * Return string to be assigned to 'd' attribute of <path> element
   * @returns {string}
   */
  dpath() {
    let dPathStr = `M${this.first.start.x},${this.first.start.y}`;
    for (let edge of this) {
      dPathStr += edge.svg();
    }
    return dPathStr;
  }
  /**
   * Return string to draw multiline in svg
   * @param attrs  - an object with attributes for svg path element
   * TODO: support semi-infinite Ray and infinite Line
   * @returns {string}
   */
  svg(attrs = {}) {
    let svgStr = `
<path ${convertToString({ fill: "none", ...attrs })} d="`;
    svgStr += `
M${this.first.start.x},${this.first.start.y}`;
    for (let edge of this) {
      svgStr += edge.svg();
    }
    svgStr += `" >
</path>`;
    return svgStr;
  }
};
Flatten.Multiline = Multiline$1;
var multiline = (...args) => new Flatten.Multiline(...args);
Flatten.multiline = multiline;
function addToIntPoints(edge, pt, int_points) {
  let id = int_points.length;
  let shapes = edge.shape.split(pt);
  if (shapes.length === 0) return;
  let len = 0;
  if (shapes[0] === null) {
    len = 0;
  } else if (shapes[1] === null) {
    len = edge.shape.length;
  } else {
    len = shapes[0].length;
  }
  let is_vertex = NOT_VERTEX$1;
  if (EQ(len, 0)) {
    is_vertex |= START_VERTEX$1;
  }
  if (EQ(len, edge.shape.length)) {
    is_vertex |= END_VERTEX$1;
  }
  let arc_length;
  if (len === Infinity) {
    arc_length = shapes[0].coord(pt);
  } else {
    arc_length = is_vertex & END_VERTEX$1 && edge.next && edge.next.arc_length === 0 ? 0 : edge.arc_length + len;
  }
  int_points.push({
    id,
    pt,
    arc_length,
    edge_before: edge,
    edge_after: void 0,
    face: edge.face,
    is_vertex
  });
}
function sortIntersections(intersections) {
  intersections.int_points1_sorted = getSortedArray(intersections.int_points1);
  intersections.int_points2_sorted = getSortedArray(intersections.int_points2);
}
function getSortedArray(int_points) {
  let faceMap = /* @__PURE__ */ new Map();
  let id = 0;
  for (let ip of int_points) {
    if (!faceMap.has(ip.face)) {
      faceMap.set(ip.face, id);
      id++;
    }
  }
  for (let ip of int_points) {
    ip.faceId = faceMap.get(ip.face);
  }
  let int_points_sorted = int_points.slice().sort(compareFn);
  return int_points_sorted;
}
function compareFn(ip1, ip2) {
  if (ip1.faceId < ip2.faceId) {
    return -1;
  }
  if (ip1.faceId > ip2.faceId) {
    return 1;
  }
  if (ip1.arc_length < ip2.arc_length) {
    return -1;
  }
  if (ip1.arc_length > ip2.arc_length) {
    return 1;
  }
  return 0;
}
function filterDuplicatedIntersections(intersections) {
  if (intersections.int_points1.length < 2) return;
  let do_squeeze = false;
  let int_point_ref1;
  let int_point_ref2;
  let int_point_cur1;
  let int_point_cur2;
  for (let i = 0; i < intersections.int_points1_sorted.length; i++) {
    if (intersections.int_points1_sorted[i].id === -1)
      continue;
    int_point_ref1 = intersections.int_points1_sorted[i];
    int_point_ref2 = intersections.int_points2[int_point_ref1.id];
    for (let j = i + 1; j < intersections.int_points1_sorted.length; j++) {
      int_point_cur1 = intersections.int_points1_sorted[j];
      if (!EQ(int_point_cur1.arc_length, int_point_ref1.arc_length)) {
        break;
      }
      if (int_point_cur1.id === -1)
        continue;
      int_point_cur2 = intersections.int_points2[int_point_cur1.id];
      if (int_point_cur2.id === -1)
        continue;
      if (int_point_cur1.edge_before === int_point_ref1.edge_before && int_point_cur1.edge_after === int_point_ref1.edge_after && int_point_cur2.edge_before === int_point_ref2.edge_before && int_point_cur2.edge_after === int_point_ref2.edge_after) {
        int_point_cur1.id = -1;
        int_point_cur2.id = -1;
        do_squeeze = true;
      }
    }
  }
  int_point_ref2 = intersections.int_points2_sorted[0];
  int_point_ref1 = intersections.int_points1[int_point_ref2.id];
  for (let i = 1; i < intersections.int_points2_sorted.length; i++) {
    let int_point_cur22 = intersections.int_points2_sorted[i];
    if (int_point_cur22.id === -1) continue;
    if (int_point_ref2.id === -1 || /* can't be reference if already deleted */
    !EQ(int_point_cur22.arc_length, int_point_ref2.arc_length)) {
      int_point_ref2 = int_point_cur22;
      int_point_ref1 = intersections.int_points1[int_point_ref2.id];
      continue;
    }
    let int_point_cur12 = intersections.int_points1[int_point_cur22.id];
    if (int_point_cur12.edge_before === int_point_ref1.edge_before && int_point_cur12.edge_after === int_point_ref1.edge_after && int_point_cur22.edge_before === int_point_ref2.edge_before && int_point_cur22.edge_after === int_point_ref2.edge_after) {
      int_point_cur12.id = -1;
      int_point_cur22.id = -1;
      do_squeeze = true;
    }
  }
  if (do_squeeze) {
    intersections.int_points1 = intersections.int_points1.filter((int_point) => int_point.id >= 0);
    intersections.int_points2 = intersections.int_points2.filter((int_point) => int_point.id >= 0);
    intersections.int_points1.forEach((int_point, index) => int_point.id = index);
    intersections.int_points2.forEach((int_point, index) => int_point.id = index);
  }
}
function initializeInclusionFlags(int_points) {
  for (let int_point of int_points) {
    if (int_point.edge_before) {
      int_point.edge_before.bvStart = void 0;
      int_point.edge_before.bvEnd = void 0;
      int_point.edge_before.bv = void 0;
      int_point.edge_before.overlap = void 0;
    }
    if (int_point.edge_after) {
      int_point.edge_after.bvStart = void 0;
      int_point.edge_after.bvEnd = void 0;
      int_point.edge_after.bv = void 0;
      int_point.edge_after.overlap = void 0;
    }
  }
  for (let int_point of int_points) {
    if (int_point.edge_before) int_point.edge_before.bvEnd = BOUNDARY$1;
    if (int_point.edge_after) int_point.edge_after.bvStart = BOUNDARY$1;
  }
}
function calculateInclusionFlags(int_points, polygon2) {
  for (let int_point of int_points) {
    if (int_point.edge_before) int_point.edge_before.setInclusion(polygon2);
    if (int_point.edge_after) int_point.edge_after.setInclusion(polygon2);
  }
}
function setOverlappingFlags(intersections) {
  let cur_face = void 0;
  let first_int_point_in_face_id = void 0;
  let next_int_point1 = void 0;
  let num_int_points = intersections.int_points1.length;
  for (let i = 0; i < num_int_points; i++) {
    let cur_int_point1 = intersections.int_points1_sorted[i];
    if (cur_int_point1.face !== cur_face) {
      first_int_point_in_face_id = i;
      cur_face = cur_int_point1.face;
    }
    let int_points_cur_pool_start = i;
    let int_points_cur_pool_num = intPointsPoolCount(intersections.int_points1_sorted, i, cur_face);
    let next_int_point_id;
    if (int_points_cur_pool_start + int_points_cur_pool_num < num_int_points && intersections.int_points1_sorted[int_points_cur_pool_start + int_points_cur_pool_num].face === cur_face) {
      next_int_point_id = int_points_cur_pool_start + int_points_cur_pool_num;
    } else {
      next_int_point_id = first_int_point_in_face_id;
    }
    let int_points_next_pool_num = intPointsPoolCount(intersections.int_points1_sorted, next_int_point_id, cur_face);
    next_int_point1 = null;
    for (let j = next_int_point_id; j < next_int_point_id + int_points_next_pool_num; j++) {
      let next_int_point1_tmp = intersections.int_points1_sorted[j];
      if (next_int_point1_tmp.face === cur_face && intersections.int_points2[next_int_point1_tmp.id].face === intersections.int_points2[cur_int_point1.id].face) {
        next_int_point1 = next_int_point1_tmp;
        break;
      }
    }
    if (next_int_point1 === null)
      continue;
    let edge_from1 = cur_int_point1.edge_after;
    let edge_to1 = next_int_point1.edge_before;
    if (!(edge_from1.bv === BOUNDARY$1 && edge_to1.bv === BOUNDARY$1))
      continue;
    if (edge_from1 !== edge_to1)
      continue;
    let cur_int_point2 = intersections.int_points2[cur_int_point1.id];
    let next_int_point2 = intersections.int_points2[next_int_point1.id];
    let edge_from2 = cur_int_point2.edge_after;
    let edge_to2 = next_int_point2.edge_before;
    if (!(edge_from2.bv === BOUNDARY$1 && edge_to2.bv === BOUNDARY$1 && edge_from2 === edge_to2)) {
      cur_int_point2 = intersections.int_points2[next_int_point1.id];
      next_int_point2 = intersections.int_points2[cur_int_point1.id];
      edge_from2 = cur_int_point2.edge_after;
      edge_to2 = next_int_point2.edge_before;
    }
    if (!(edge_from2.bv === BOUNDARY$1 && edge_to2.bv === BOUNDARY$1 && edge_from2 === edge_to2))
      continue;
    edge_from1.setOverlap(edge_from2);
  }
}
function intPointsPoolCount(int_points, cur_int_point_num, cur_face) {
  let int_point_current;
  let int_point_next;
  let int_points_pool_num = 1;
  if (int_points.length === 1) return 1;
  int_point_current = int_points[cur_int_point_num];
  for (let i = cur_int_point_num + 1; i < int_points.length; i++) {
    if (int_point_current.face !== cur_face) {
      break;
    }
    int_point_next = int_points[i];
    if (!(int_point_next.pt.equalTo(int_point_current.pt) && int_point_next.edge_before === int_point_current.edge_before && int_point_next.edge_after === int_point_current.edge_after)) {
      break;
    }
    int_points_pool_num++;
  }
  return int_points_pool_num;
}
function splitByIntersections(polygon2, int_points) {
  if (!int_points) return;
  for (let int_point of int_points) {
    let edge = int_point.edge_before;
    int_point.is_vertex = NOT_VERTEX$1;
    if (edge.shape.start && edge.shape.start.equalTo(int_point.pt)) {
      int_point.is_vertex |= START_VERTEX$1;
    }
    if (edge.shape.end && edge.shape.end.equalTo(int_point.pt)) {
      int_point.is_vertex |= END_VERTEX$1;
    }
    if (int_point.is_vertex & START_VERTEX$1) {
      int_point.edge_before = edge.prev;
      if (edge.prev) {
        int_point.is_vertex = END_VERTEX$1;
      }
      continue;
    }
    if (int_point.is_vertex & END_VERTEX$1) {
      continue;
    }
    let newEdge = polygon2.addVertex(int_point.pt, edge);
    int_point.edge_before = newEdge;
  }
  for (let int_point of int_points) {
    if (int_point.edge_before) {
      int_point.edge_after = int_point.edge_before.next;
    } else {
      if (polygon2 instanceof Multiline$1 && int_point.is_vertex & START_VERTEX$1) {
        int_point.edge_after = polygon2.first;
      }
    }
  }
}
function insertBetweenIntPoints(int_point1, int_point2, new_edges) {
  const edge_before = int_point1.edge_before;
  const edge_after = int_point2.edge_after;
  const len = new_edges.length;
  edge_before.next = new_edges[0];
  new_edges[0].prev = edge_before;
  new_edges[len - 1].next = edge_after;
  edge_after.prev = new_edges[len - 1];
}
var { INSIDE: INSIDE$1, OUTSIDE, BOUNDARY, OVERLAP_SAME, OVERLAP_OPPOSITE } = Constants;
var { NOT_VERTEX, START_VERTEX, END_VERTEX } = Constants;
var BOOLEAN_UNION = 1;
var BOOLEAN_INTERSECT = 2;
var BOOLEAN_SUBTRACT = 3;
function unify(polygon1, polygon2) {
  let [res_poly, wrk_poly] = booleanOpBinary(polygon1, polygon2, BOOLEAN_UNION, true);
  return res_poly;
}
function subtract(polygon1, polygon2) {
  let polygon2_tmp = polygon2.clone();
  let polygon2_reversed = polygon2_tmp.reverse();
  let [res_poly, wrk_poly] = booleanOpBinary(polygon1, polygon2_reversed, BOOLEAN_SUBTRACT, true);
  return res_poly;
}
function intersect$1(polygon1, polygon2) {
  let [res_poly, wrk_poly] = booleanOpBinary(polygon1, polygon2, BOOLEAN_INTERSECT, true);
  return res_poly;
}
function innerClip(polygon1, polygon2) {
  let [res_poly, wrk_poly] = booleanOpBinary(polygon1, polygon2, BOOLEAN_INTERSECT, false);
  let clip_shapes1 = [];
  for (let face of res_poly.faces) {
    clip_shapes1 = [...clip_shapes1, ...[...face.edges].map((edge) => edge.shape)];
  }
  let clip_shapes2 = [];
  for (let face of wrk_poly.faces) {
    clip_shapes2 = [...clip_shapes2, ...[...face.edges].map((edge) => edge.shape)];
  }
  return [clip_shapes1, clip_shapes2];
}
function outerClip(polygon1, polygon2) {
  let [res_poly, wrk_poly] = booleanOpBinary(polygon1, polygon2, BOOLEAN_SUBTRACT, false);
  let clip_shapes1 = [];
  for (let face of res_poly.faces) {
    clip_shapes1 = [...clip_shapes1, ...[...face.edges].map((edge) => edge.shape)];
  }
  return clip_shapes1;
}
function calculateIntersections(polygon1, polygon2) {
  let res_poly = polygon1.clone();
  let wrk_poly = polygon2.clone();
  let intersections = getIntersections(res_poly, wrk_poly);
  sortIntersections(intersections);
  splitByIntersections(res_poly, intersections.int_points1_sorted);
  splitByIntersections(wrk_poly, intersections.int_points2_sorted);
  filterDuplicatedIntersections(intersections);
  sortIntersections(intersections);
  let ip_sorted1 = intersections.int_points1_sorted.map((int_point) => int_point.pt);
  let ip_sorted2 = intersections.int_points2_sorted.map((int_point) => int_point.pt);
  return [ip_sorted1, ip_sorted2];
}
function filterNotRelevantEdges(res_poly, wrk_poly, intersections, op) {
  let notIntersectedFacesRes = getNotIntersectedFaces(res_poly, intersections.int_points1);
  let notIntersectedFacesWrk = getNotIntersectedFaces(wrk_poly, intersections.int_points2);
  calcInclusionForNotIntersectedFaces(notIntersectedFacesRes, wrk_poly);
  calcInclusionForNotIntersectedFaces(notIntersectedFacesWrk, res_poly);
  initializeInclusionFlags(intersections.int_points1);
  initializeInclusionFlags(intersections.int_points2);
  calculateInclusionFlags(intersections.int_points1, wrk_poly);
  calculateInclusionFlags(intersections.int_points2, res_poly);
  while (fixBoundaryConflicts(res_poly, wrk_poly, intersections.int_points1, intersections.int_points1_sorted, intersections.int_points2, intersections)) ;
  setOverlappingFlags(intersections);
  removeNotRelevantChains(res_poly, op, intersections.int_points1_sorted, true);
  removeNotRelevantChains(wrk_poly, op, intersections.int_points2_sorted, false);
  removeNotRelevantNotIntersectedFaces(res_poly, notIntersectedFacesRes, op, true);
  removeNotRelevantNotIntersectedFaces(wrk_poly, notIntersectedFacesWrk, op, false);
}
function swapLinksAndRestore(res_poly, wrk_poly, intersections, op) {
  copyWrkToRes(res_poly, wrk_poly, op, intersections.int_points2);
  swapLinks(res_poly, wrk_poly, intersections);
  removeOldFaces(res_poly, intersections.int_points1);
  removeOldFaces(wrk_poly, intersections.int_points2);
  restoreFaces(res_poly, intersections.int_points1, intersections.int_points2);
  restoreFaces(res_poly, intersections.int_points2, intersections.int_points1);
}
function booleanOpBinary(polygon1, polygon2, op, restore) {
  let res_poly = polygon1.clone();
  let wrk_poly = polygon2.clone();
  let intersections = getIntersections(res_poly, wrk_poly);
  sortIntersections(intersections);
  splitByIntersections(res_poly, intersections.int_points1_sorted);
  splitByIntersections(wrk_poly, intersections.int_points2_sorted);
  filterDuplicatedIntersections(intersections);
  sortIntersections(intersections);
  filterNotRelevantEdges(res_poly, wrk_poly, intersections, op);
  if (restore) {
    swapLinksAndRestore(res_poly, wrk_poly, intersections, op);
  }
  return [res_poly, wrk_poly];
}
function getIntersections(polygon1, polygon2) {
  let intersections = {
    int_points1: [],
    int_points2: []
  };
  for (let edge1 of polygon1.edges) {
    let resp = polygon2.edges.search(edge1.box);
    for (let edge2 of resp) {
      let ip = edge1.shape.intersect(edge2.shape);
      for (let pt of ip) {
        addToIntPoints(edge1, pt, intersections.int_points1);
        addToIntPoints(edge2, pt, intersections.int_points2);
      }
    }
  }
  return intersections;
}
function getNotIntersectedFaces(poly, int_points) {
  let notIntersected = [];
  for (let face of poly.faces) {
    if (!int_points.find((ip) => ip.face === face)) {
      notIntersected.push(face);
    }
  }
  return notIntersected;
}
function calcInclusionForNotIntersectedFaces(notIntersectedFaces, poly2) {
  for (let face of notIntersectedFaces) {
    face.first.bv = face.first.bvStart = face.first.bvEnd = void 0;
    face.first.setInclusion(poly2);
  }
}
function fixBoundaryConflicts(poly1, poly2, int_points1, int_points1_sorted, int_points2, intersections) {
  let cur_face;
  let first_int_point_in_face_id;
  let next_int_point1;
  let num_int_points = int_points1_sorted.length;
  let iterate_more = false;
  for (let i = 0; i < num_int_points; i++) {
    let cur_int_point1 = int_points1_sorted[i];
    if (cur_int_point1.face !== cur_face) {
      first_int_point_in_face_id = i;
      cur_face = cur_int_point1.face;
    }
    let int_points_cur_pool_start = i;
    let int_points_cur_pool_num = intPointsPoolCount(int_points1_sorted, i, cur_face);
    let next_int_point_id;
    if (int_points_cur_pool_start + int_points_cur_pool_num < num_int_points && int_points1_sorted[int_points_cur_pool_start + int_points_cur_pool_num].face === cur_face) {
      next_int_point_id = int_points_cur_pool_start + int_points_cur_pool_num;
    } else {
      next_int_point_id = first_int_point_in_face_id;
    }
    let int_points_next_pool_num = intPointsPoolCount(int_points1_sorted, next_int_point_id, cur_face);
    next_int_point1 = null;
    for (let j = next_int_point_id; j < next_int_point_id + int_points_next_pool_num; j++) {
      let next_int_point1_tmp = int_points1_sorted[j];
      if (next_int_point1_tmp.face === cur_face && int_points2[next_int_point1_tmp.id].face === int_points2[cur_int_point1.id].face) {
        next_int_point1 = next_int_point1_tmp;
        break;
      }
    }
    if (next_int_point1 === null)
      continue;
    let edge_from1 = cur_int_point1.edge_after;
    let edge_to1 = next_int_point1.edge_before;
    if (edge_from1.bv === BOUNDARY && edge_to1.bv != BOUNDARY) {
      edge_from1.bv = edge_to1.bv;
      continue;
    }
    if (edge_from1.bv != BOUNDARY && edge_to1.bv === BOUNDARY) {
      edge_to1.bv = edge_from1.bv;
      continue;
    }
    if (edge_from1.bv === BOUNDARY && edge_to1.bv === BOUNDARY && edge_from1 != edge_to1 || (edge_from1.bv === INSIDE$1 && edge_to1.bv === OUTSIDE || edge_from1.bv === OUTSIDE && edge_to1.bv === INSIDE$1)) {
      let edge_tmp = edge_from1.next;
      while (edge_tmp != edge_to1) {
        edge_tmp.bvStart = void 0;
        edge_tmp.bvEnd = void 0;
        edge_tmp.bv = void 0;
        edge_tmp.setInclusion(poly2);
        edge_tmp = edge_tmp.next;
      }
    }
    if (edge_from1.bv === BOUNDARY && edge_to1.bv === BOUNDARY && edge_from1 != edge_to1) {
      let edge_tmp = edge_from1.next;
      let new_bv;
      while (edge_tmp != edge_to1) {
        if (edge_tmp.bv != BOUNDARY) {
          if (new_bv === void 0) {
            new_bv = edge_tmp.bv;
          } else {
            if (edge_tmp.bv != new_bv) {
              throw Errors.UNRESOLVED_BOUNDARY_CONFLICT;
            }
          }
        }
        edge_tmp = edge_tmp.next;
      }
      if (new_bv != void 0) {
        edge_from1.bv = new_bv;
        edge_to1.bv = new_bv;
      }
      continue;
    }
    if (edge_from1.bv === INSIDE$1 && edge_to1.bv === OUTSIDE || edge_from1.bv === OUTSIDE && edge_to1.bv === INSIDE$1) {
      let edge_tmp = edge_from1;
      while (edge_tmp != edge_to1) {
        if (edge_tmp.bvStart === edge_from1.bv && edge_tmp.bvEnd === edge_to1.bv) {
          let [dist, segment2] = edge_tmp.shape.distanceTo(poly2);
          if (dist < 10 * Flatten.DP_TOL) {
            addToIntPoints(edge_tmp, segment2.ps, int_points1);
            let int_point1 = int_points1[int_points1.length - 1];
            if (int_point1.is_vertex & START_VERTEX) {
              int_point1.edge_after = edge_tmp;
              int_point1.edge_before = edge_tmp.prev;
              edge_tmp.bvStart = BOUNDARY;
              edge_tmp.bv = void 0;
              edge_tmp.setInclusion(poly2);
            } else if (int_point1.is_vertex & END_VERTEX) {
              int_point1.edge_after = edge_tmp.next;
              edge_tmp.bvEnd = BOUNDARY;
              edge_tmp.bv = void 0;
              edge_tmp.setInclusion(poly2);
            } else {
              let newEdge1 = poly2.addVertex(int_point1.pt, edge_tmp);
              int_point1.edge_before = newEdge1;
              int_point1.edge_after = newEdge1.next;
              newEdge1.setInclusion(poly2);
              newEdge1.next.bvStart = BOUNDARY;
              newEdge1.next.bvEnd = void 0;
              newEdge1.next.bv = void 0;
              newEdge1.next.setInclusion(poly2);
            }
            let edge2 = poly2.findEdgeByPoint(segment2.pe);
            addToIntPoints(edge2, segment2.pe, int_points2);
            let int_point2 = int_points2[int_points2.length - 1];
            if (int_point2.is_vertex & START_VERTEX) {
              int_point2.edge_after = edge2;
              int_point2.edge_before = edge2.prev;
            } else if (int_point2.is_vertex & END_VERTEX) {
              int_point2.edge_after = edge2.next;
            } else {
              let int_point2_edge_after = int_points2.find((int_point) => int_point.edge_after === edge2);
              let newEdge2 = poly2.addVertex(int_point2.pt, edge2);
              int_point2.edge_before = newEdge2;
              int_point2.edge_after = newEdge2.next;
              if (int_point2_edge_after)
                int_point2_edge_after.edge_after = newEdge2;
              newEdge2.bvStart = void 0;
              newEdge2.bvEnd = BOUNDARY;
              newEdge2.bv = void 0;
              newEdge2.setInclusion(poly1);
              newEdge2.next.bvStart = BOUNDARY;
              newEdge2.next.bvEnd = void 0;
              newEdge2.next.bv = void 0;
              newEdge2.next.setInclusion(poly1);
            }
            sortIntersections(intersections);
            iterate_more = true;
            break;
          }
        }
        edge_tmp = edge_tmp.next;
      }
      if (iterate_more)
        break;
      throw Errors.UNRESOLVED_BOUNDARY_CONFLICT;
    }
  }
  return iterate_more;
}
function removeNotRelevantChains(polygon2, op, int_points, is_res_polygon) {
  if (!int_points) return;
  let cur_face = void 0;
  let first_int_point_in_face_num = void 0;
  let int_point_current;
  let int_point_next;
  for (let i = 0; i < int_points.length; i++) {
    int_point_current = int_points[i];
    if (int_point_current.face !== cur_face) {
      first_int_point_in_face_num = i;
      cur_face = int_point_current.face;
    }
    if (cur_face.isEmpty())
      continue;
    let int_points_from_pull_start = i;
    let int_points_from_pull_num = intPointsPoolCount(int_points, i, cur_face);
    let next_int_point_num;
    if (int_points_from_pull_start + int_points_from_pull_num < int_points.length && int_points[int_points_from_pull_start + int_points_from_pull_num].face === int_point_current.face) {
      next_int_point_num = int_points_from_pull_start + int_points_from_pull_num;
    } else {
      next_int_point_num = first_int_point_in_face_num;
    }
    int_point_next = int_points[next_int_point_num];
    let int_points_to_pull_start = next_int_point_num;
    let int_points_to_pull_num = intPointsPoolCount(int_points, int_points_to_pull_start, cur_face);
    let edge_from = int_point_current.edge_after;
    let edge_to = int_point_next.edge_before;
    if (edge_from.bv === INSIDE$1 && edge_to.bv === INSIDE$1 && op === BOOLEAN_UNION || edge_from.bv === OUTSIDE && edge_to.bv === OUTSIDE && op === BOOLEAN_INTERSECT || (edge_from.bv === OUTSIDE || edge_to.bv === OUTSIDE) && op === BOOLEAN_SUBTRACT && !is_res_polygon || (edge_from.bv === INSIDE$1 || edge_to.bv === INSIDE$1) && op === BOOLEAN_SUBTRACT && is_res_polygon || edge_from.bv === BOUNDARY && edge_to.bv === BOUNDARY && edge_from.overlap & OVERLAP_SAME && is_res_polygon || edge_from.bv === BOUNDARY && edge_to.bv === BOUNDARY && edge_from.overlap & OVERLAP_OPPOSITE) {
      polygon2.removeChain(cur_face, edge_from, edge_to);
      for (let k = int_points_from_pull_start; k < int_points_from_pull_start + int_points_from_pull_num; k++) {
        int_points[k].edge_after = void 0;
      }
      for (let k = int_points_to_pull_start; k < int_points_to_pull_start + int_points_to_pull_num; k++) {
        int_points[k].edge_before = void 0;
      }
    }
    i += int_points_from_pull_num - 1;
  }
}
function copyWrkToRes(res_polygon, wrk_polygon, op, int_points) {
  for (let face of wrk_polygon.faces) {
    for (let edge of face) {
      res_polygon.edges.add(edge);
    }
    if (
      /*(op === BOOLEAN_UNION || op == BOOLEAN_SUBTRACT) &&*/
      int_points.find((ip) => ip.face === face) === void 0
    ) {
      res_polygon.addFace(face.first, face.last);
    }
  }
}
function swapLinks(res_polygon, wrk_polygon, intersections) {
  if (intersections.int_points1.length === 0) return;
  for (let i = 0; i < intersections.int_points1.length; i++) {
    let int_point1 = intersections.int_points1[i];
    let int_point2 = intersections.int_points2[i];
    if (int_point1.edge_before !== void 0 && int_point1.edge_after === void 0) {
      if (int_point2.edge_before === void 0 && int_point2.edge_after !== void 0) {
        int_point1.edge_before.next = int_point2.edge_after;
        int_point2.edge_after.prev = int_point1.edge_before;
        int_point1.edge_after = int_point2.edge_after;
        int_point2.edge_before = int_point1.edge_before;
      }
    }
    if (int_point2.edge_before !== void 0 && int_point2.edge_after === void 0) {
      if (int_point1.edge_before === void 0 && int_point1.edge_after !== void 0) {
        int_point2.edge_before.next = int_point1.edge_after;
        int_point1.edge_after.prev = int_point2.edge_before;
        int_point2.edge_after = int_point1.edge_after;
        int_point1.edge_before = int_point2.edge_before;
      }
    }
    if (int_point1.edge_before !== void 0 && int_point1.edge_after === void 0) {
      for (let int_point of intersections.int_points1_sorted) {
        if (int_point === int_point1) continue;
        if (int_point.edge_before === void 0 && int_point.edge_after !== void 0) {
          if (int_point.pt.equalTo(int_point1.pt)) {
            int_point1.edge_before.next = int_point.edge_after;
            int_point.edge_after.prev = int_point1.edge_before;
            int_point1.edge_after = int_point.edge_after;
            int_point.edge_before = int_point1.edge_before;
          }
        }
      }
    }
    if (int_point2.edge_before !== void 0 && int_point2.edge_after === void 0) {
      for (let int_point of intersections.int_points2_sorted) {
        if (int_point === int_point2) continue;
        if (int_point.edge_before === void 0 && int_point.edge_after !== void 0) {
          if (int_point.pt.equalTo(int_point2.pt)) {
            int_point2.edge_before.next = int_point.edge_after;
            int_point.edge_after.prev = int_point2.edge_before;
            int_point2.edge_after = int_point.edge_after;
            int_point.edge_before = int_point2.edge_before;
          }
        }
      }
    }
  }
}
function removeOldFaces(polygon2, int_points) {
  for (let int_point of int_points) {
    polygon2.faces.delete(int_point.face);
    int_point.face = void 0;
    if (int_point.edge_before)
      int_point.edge_before.face = void 0;
    if (int_point.edge_after)
      int_point.edge_after.face = void 0;
  }
}
function restoreFaces(polygon2, int_points, other_int_points) {
  for (let int_point of int_points) {
    if (int_point.edge_before === void 0 || int_point.edge_after === void 0)
      continue;
    if (int_point.face)
      continue;
    if (int_point.edge_after.face || int_point.edge_before.face)
      continue;
    let first = int_point.edge_after;
    let last = int_point.edge_before;
    try {
      LinkedList.testInfiniteLoop(first);
    } catch (error) {
      throw Errors.CANNOT_COMPLETE_BOOLEAN_OPERATION;
    }
    let face = polygon2.addFace(first, last);
    for (let int_point_tmp of int_points) {
      if (int_point_tmp.edge_before && int_point_tmp.edge_after && int_point_tmp.edge_before.face === face && int_point_tmp.edge_after.face === face) {
        int_point_tmp.face = face;
      }
    }
    for (let int_point_tmp of other_int_points) {
      if (int_point_tmp.edge_before && int_point_tmp.edge_after && int_point_tmp.edge_before.face === face && int_point_tmp.edge_after.face === face) {
        int_point_tmp.face = face;
      }
    }
  }
}
function removeNotRelevantNotIntersectedFaces(polygon2, notIntersectedFaces, op, is_res_polygon) {
  for (let face of notIntersectedFaces) {
    let rel = face.first.bv;
    if (op === BOOLEAN_UNION && rel === INSIDE$1 || op === BOOLEAN_SUBTRACT && rel === INSIDE$1 && is_res_polygon || op === BOOLEAN_SUBTRACT && rel === OUTSIDE && !is_res_polygon || op === BOOLEAN_INTERSECT && rel === OUTSIDE) {
      polygon2.deleteFace(face);
    }
  }
}
var BooleanOperations = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  BOOLEAN_INTERSECT,
  BOOLEAN_SUBTRACT,
  BOOLEAN_UNION,
  calculateIntersections,
  innerClip,
  intersect: intersect$1,
  outerClip,
  removeNotRelevantChains,
  removeOldFaces,
  restoreFaces,
  subtract,
  unify
});
var EQUAL = RegExp("T.F..FFF.|T.F...F..");
var INTERSECT = RegExp("T........|.T.......|...T.....|....T....");
var TOUCH = RegExp("FT.......|F..T.....|F...T....");
var INSIDE = RegExp("T.F..F...");
var COVERED = RegExp("T.F..F...|.TF..F...|..FT.F...|..F.TF...");
var DE9IM = class {
  /**
   * Create new instance of DE9IM matrix
   */
  constructor() {
    this.m = new Array(9).fill(void 0);
  }
  /**
   * Get Interior To Interior intersection
   * @returns {Shape[] | undefined}
   */
  get I2I() {
    return this.m[0];
  }
  /**
   * Set Interior To Interior intersection
   * @param geom
   */
  set I2I(geom) {
    this.m[0] = geom;
  }
  /**
   * Get Interior To Boundary intersection
   * @returns {Shape[] | undefined}
   */
  get I2B() {
    return this.m[1];
  }
  /**
   * Set Interior to Boundary intersection
   * @param geomc
   */
  set I2B(geom) {
    this.m[1] = geom;
  }
  /**
   * Get Interior To Exterior intersection
   * @returns {Shape[] | undefined}
   */
  get I2E() {
    return this.m[2];
  }
  /**
   * Set Interior to Exterior intersection
   * @param geom
   */
  set I2E(geom) {
    this.m[2] = geom;
  }
  /**
   * Get Boundary To Interior intersection
   * @returns {Shape[] | undefined}
   */
  get B2I() {
    return this.m[3];
  }
  /**
   * Set Boundary to Interior intersection
   * @param geom
   */
  set B2I(geom) {
    this.m[3] = geom;
  }
  /**
   * Get Boundary To Boundary intersection
   * @returns {Shape[] | undefined}
   */
  get B2B() {
    return this.m[4];
  }
  /**
   * Set Boundary to Boundary intersection
   * @param geom
   */
  set B2B(geom) {
    this.m[4] = geom;
  }
  /**
   * Get Boundary To Exterior intersection
   * @returns {Shape[] | undefined}
   */
  get B2E() {
    return this.m[5];
  }
  /**
   * Set Boundary to Exterior intersection
   * @param geom
   */
  set B2E(geom) {
    this.m[5] = geom;
  }
  /**
   * Get Exterior To Interior intersection
   * @returns {Shape[] | undefined}
   */
  get E2I() {
    return this.m[6];
  }
  /**
   * Set Exterior to Interior intersection
   * @param geom
   */
  set E2I(geom) {
    this.m[6] = geom;
  }
  /**
   * Get Exterior To Boundary intersection
   * @returns {Shape[] | undefined}
   */
  get E2B() {
    return this.m[7];
  }
  /**
   * Set Exterior to Boundary intersection
   * @param geom
   */
  set E2B(geom) {
    this.m[7] = geom;
  }
  /**
   * Get Exterior to Exterior intersection
   * @returns {Shape[] | undefined}
   */
  get E2E() {
    return this.m[8];
  }
  /**
   * Set Exterior to Exterior intersection
   * @param geom
   */
  set E2E(geom) {
    this.m[8] = geom;
  }
  /**
   * Return de9im matrix as string where<br/>
   * - intersection is 'T'<br/>
   * - not intersected is 'F'<br/>
   * - not relevant is '*'<br/>
   * For example, string 'FF**FF****' means 'DISJOINT'
   * @returns {string}
   */
  toString() {
    return this.m.map((e) => {
      if (e instanceof Array && e.length > 0) {
        return "T";
      } else if (e instanceof Array && e.length === 0) {
        return "F";
      } else {
        return "*";
      }
    }).join("");
  }
  equal() {
    return EQUAL.test(this.toString());
  }
  intersect() {
    return INTERSECT.test(this.toString());
  }
  touch() {
    return TOUCH.test(this.toString());
  }
  inside() {
    return INSIDE.test(this.toString());
  }
  covered() {
    return COVERED.test(this.toString());
  }
};
function ray_shoot(polygon2, point2) {
  let contains = void 0;
  let ray2 = new Flatten.Ray(point2);
  let line2 = new Flatten.Line(ray2.pt, ray2.norm);
  const searchBox = new Flatten.Box(
    ray2.box.xmin - Flatten.DP_TOL,
    ray2.box.ymin - Flatten.DP_TOL,
    ray2.box.xmax + Flatten.DP_TOL,
    ray2.box.ymax + Flatten.DP_TOL
  );
  if (polygon2.box.not_intersect(searchBox)) {
    return Flatten.OUTSIDE;
  }
  let resp_edges = polygon2.edges.search(searchBox);
  if (resp_edges.length === 0) {
    return Flatten.OUTSIDE;
  }
  for (let edge of resp_edges) {
    if (edge.shape.contains(point2)) {
      return Flatten.BOUNDARY;
    }
  }
  let faces = [...polygon2.faces];
  let intersections = [];
  for (let edge of resp_edges) {
    for (let ip of ray2.intersect(edge.shape)) {
      if (ip.equalTo(point2)) {
        return Flatten.BOUNDARY;
      }
      intersections.push({
        pt: ip,
        edge,
        face_index: faces.indexOf(edge.face)
      });
    }
  }
  intersections.sort((i1, i2) => {
    if (LT(i1.pt.x, i2.pt.x)) {
      return -1;
    }
    if (GT(i1.pt.x, i2.pt.x)) {
      return 1;
    }
    if (i1.face_index < i2.face_index) {
      return -1;
    }
    if (i1.face_index > i2.face_index) {
      return 1;
    }
    if (i1.edge.arc_length < i2.edge.arc_length) {
      return -1;
    }
    if (i1.edge.arc_length > i2.edge.arc_length) {
      return 1;
    }
    return 0;
  });
  let counter = 0;
  for (let i = 0; i < intersections.length; i++) {
    let intersection = intersections[i];
    if (intersection.pt.equalTo(intersection.edge.shape.start)) {
      if (i > 0 && intersection.pt.equalTo(intersections[i - 1].pt) && intersection.face_index === intersections[i - 1].face_index && intersection.edge.prev === intersections[i - 1].edge) {
        continue;
      }
      let prev_edge = intersection.edge.prev;
      while (EQ_0(prev_edge.length)) {
        prev_edge = prev_edge.prev;
      }
      let prev_tangent = prev_edge.shape.tangentInEnd();
      let prev_point = intersection.pt.translate(prev_tangent);
      let cur_tangent = intersection.edge.shape.tangentInStart();
      let cur_point = intersection.pt.translate(cur_tangent);
      let prev_on_the_left = prev_point.leftTo(line2);
      let cur_on_the_left = cur_point.leftTo(line2);
      if (prev_on_the_left && !cur_on_the_left || !prev_on_the_left && cur_on_the_left) {
        counter++;
      }
    } else if (intersection.pt.equalTo(intersection.edge.shape.end)) {
      if (i > 0 && intersection.pt.equalTo(intersections[i - 1].pt) && intersection.face_index === intersections[i - 1].face_index && intersection.edge.next === intersections[i - 1].edge) {
        continue;
      }
      let next_edge = intersection.edge.next;
      while (EQ_0(next_edge.length)) {
        next_edge = next_edge.next;
      }
      let next_tangent = next_edge.shape.tangentInStart();
      let next_point = intersection.pt.translate(next_tangent);
      let cur_tangent = intersection.edge.shape.tangentInEnd();
      let cur_point = intersection.pt.translate(cur_tangent);
      let next_on_the_left = next_point.leftTo(line2);
      let cur_on_the_left = cur_point.leftTo(line2);
      if (next_on_the_left && !cur_on_the_left || !next_on_the_left && cur_on_the_left) {
        counter++;
      }
    } else {
      if (intersection.edge.shape instanceof Flatten.Segment) {
        counter++;
      } else {
        let box2 = intersection.edge.shape.box;
        if (!(EQ(intersection.pt.y, box2.ymin) || EQ(intersection.pt.y, box2.ymax))) {
          counter++;
        }
      }
    }
  }
  contains = counter % 2 === 1 ? INSIDE$2 : OUTSIDE$1;
  return contains;
}
function equal(shape1, shape2) {
  return relate(shape1, shape2).equal();
}
function intersect(shape1, shape2) {
  return relate(shape1, shape2).intersect();
}
function touch(shape1, shape2) {
  return relate(shape1, shape2).touch();
}
function disjoint(shape1, shape2) {
  return !intersect(shape1, shape2);
}
function inside(shape1, shape2) {
  return relate(shape1, shape2).inside();
}
function covered(shape1, shape2) {
  return relate(shape1, shape2).covered();
}
function contain(shape1, shape2) {
  return inside(shape2, shape1);
}
function cover(shape1, shape2) {
  return covered(shape2, shape1);
}
function relate(shape1, shape2) {
  if (shape1 instanceof Flatten.Line && shape2 instanceof Flatten.Line) {
    return relateLine2Line(shape1, shape2);
  } else if (shape1 instanceof Flatten.Line && shape2 instanceof Flatten.Circle) {
    return relateLine2Circle(shape1, shape2);
  } else if (shape1 instanceof Flatten.Line && shape2 instanceof Flatten.Box) {
    return relateLine2Box(shape1, shape2);
  } else if (shape1 instanceof Flatten.Line && shape2 instanceof Flatten.Polygon) {
    return relateLine2Polygon(shape1, shape2);
  } else if ((shape1 instanceof Flatten.Segment || shape1 instanceof Flatten.Arc) && shape2 instanceof Flatten.Polygon) {
    return relateShape2Polygon(shape1, shape2);
  } else if ((shape1 instanceof Flatten.Segment || shape1 instanceof Flatten.Arc) && (shape2 instanceof Flatten.Circle || shape2 instanceof Flatten.Box)) {
    return relateShape2Polygon(shape1, new Flatten.Polygon(shape2));
  } else if (shape1 instanceof Flatten.Polygon && shape2 instanceof Flatten.Polygon) {
    return relatePolygon2Polygon(shape1, shape2);
  } else if ((shape1 instanceof Flatten.Circle || shape1 instanceof Flatten.Box) && (shape2 instanceof Flatten.Circle || shape2 instanceof Flatten.Box)) {
    return relatePolygon2Polygon(new Flatten.Polygon(shape1), new Flatten.Polygon(shape2));
  } else if ((shape1 instanceof Flatten.Circle || shape1 instanceof Flatten.Box) && shape2 instanceof Flatten.Polygon) {
    return relatePolygon2Polygon(new Flatten.Polygon(shape1), shape2);
  } else if (shape1 instanceof Flatten.Polygon && (shape2 instanceof Flatten.Circle || shape2 instanceof Flatten.Box)) {
    return relatePolygon2Polygon(shape1, new Flatten.Polygon(shape2));
  }
}
function relateLine2Line(line1, line2) {
  let denim = new DE9IM();
  let ip = intersectLine2Line(line1, line2);
  if (ip.length === 0) {
    if (line1.contains(line2.pt) && line2.contains(line1.pt)) {
      denim.I2I = [line1];
      denim.I2E = [];
      denim.E2I = [];
    } else {
      denim.I2I = [];
      denim.I2E = [line1];
      denim.E2I = [line2];
    }
  } else {
    denim.I2I = ip;
    denim.I2E = line1.split(ip);
    denim.E2I = line2.split(ip);
  }
  return denim;
}
function relateLine2Circle(line2, circle2) {
  let denim = new DE9IM();
  let ip = intersectLine2Circle(line2, circle2);
  if (ip.length === 0) {
    denim.I2I = [];
    denim.I2B = [];
    denim.I2E = [line2];
    denim.E2I = [circle2];
  } else if (ip.length === 1) {
    denim.I2I = [];
    denim.I2B = ip;
    denim.I2E = line2.split(ip);
    denim.E2I = [circle2];
  } else {
    let multiline2 = new Multiline$1([line2]);
    let ip_sorted = line2.sortPoints(ip);
    multiline2.split(ip_sorted);
    let splitShapes = multiline2.toShapes();
    denim.I2I = [splitShapes[1]];
    denim.I2B = ip_sorted;
    denim.I2E = [splitShapes[0], splitShapes[2]];
    denim.E2I = new Flatten.Polygon([circle2.toArc()]).cutWithLine(line2);
  }
  return denim;
}
function relateLine2Box(line2, box2) {
  let denim = new DE9IM();
  let ip = intersectLine2Box(line2, box2);
  if (ip.length === 0) {
    denim.I2I = [];
    denim.I2B = [];
    denim.I2E = [line2];
    denim.E2I = [box2];
  } else if (ip.length === 1) {
    denim.I2I = [];
    denim.I2B = ip;
    denim.I2E = line2.split(ip);
    denim.E2I = [box2];
  } else {
    let multiline2 = new Multiline$1([line2]);
    let ip_sorted = line2.sortPoints(ip);
    multiline2.split(ip_sorted);
    let splitShapes = multiline2.toShapes();
    if (box2.toSegments().some((segment2) => segment2.contains(ip[0]) && segment2.contains(ip[1]))) {
      denim.I2I = [];
      denim.I2B = [splitShapes[1]];
      denim.I2E = [splitShapes[0], splitShapes[2]];
      denim.E2I = [box2];
    } else {
      denim.I2I = [splitShapes[1]];
      denim.I2B = ip_sorted;
      denim.I2E = [splitShapes[0], splitShapes[2]];
      denim.E2I = new Flatten.Polygon(box2.toSegments()).cutWithLine(line2);
    }
  }
  return denim;
}
function relateLine2Polygon(line2, polygon2) {
  let denim = new DE9IM();
  let ip = intersectLine2Polygon(line2, polygon2);
  let multiline2 = new Multiline$1([line2]);
  let ip_sorted = ip.length > 0 ? ip.slice() : line2.sortPoints(ip);
  multiline2.split(ip_sorted);
  [...multiline2].forEach((edge) => edge.setInclusion(polygon2));
  denim.I2I = [...multiline2].filter((edge) => edge.bv === Flatten.INSIDE).map((edge) => edge.shape);
  denim.I2B = [...multiline2].slice(1).map((edge) => edge.bv === Flatten.BOUNDARY ? edge.shape : edge.shape.start);
  denim.I2E = [...multiline2].filter((edge) => edge.bv === Flatten.OUTSIDE).map((edge) => edge.shape);
  denim.E2I = polygon2.cutWithLine(line2);
  return denim;
}
function relateShape2Polygon(shape, polygon2) {
  let denim = new DE9IM();
  let ip = intersectShape2Polygon(shape, polygon2);
  let ip_sorted = ip.length > 0 ? ip.slice() : shape.sortPoints(ip);
  let multiline2 = new Multiline$1([shape]);
  multiline2.split(ip_sorted);
  [...multiline2].forEach((edge) => edge.setInclusion(polygon2));
  denim.I2I = [...multiline2].filter((edge) => edge.bv === Flatten.INSIDE).map((edge) => edge.shape);
  denim.I2B = [...multiline2].slice(1).map((edge) => edge.bv === Flatten.BOUNDARY ? edge.shape : edge.shape.start);
  denim.I2E = [...multiline2].filter((edge) => edge.bv === Flatten.OUTSIDE).map((edge) => edge.shape);
  denim.B2I = [];
  denim.B2B = [];
  denim.B2E = [];
  for (let pt of [shape.start, shape.end]) {
    switch (ray_shoot(polygon2, pt)) {
      case Flatten.INSIDE:
        denim.B2I.push(pt);
        break;
      case Flatten.BOUNDARY:
        denim.B2B.push(pt);
        break;
      case Flatten.OUTSIDE:
        denim.B2E.push(pt);
        break;
    }
  }
  return denim;
}
function relatePolygon2Polygon(polygon1, polygon2) {
  let denim = new DE9IM();
  let [ip_sorted1, ip_sorted2] = calculateIntersections(polygon1, polygon2);
  let boolean_intersection = intersect$1(polygon1, polygon2);
  let boolean_difference1 = subtract(polygon1, polygon2);
  let boolean_difference2 = subtract(polygon2, polygon1);
  let [inner_clip_shapes1, inner_clip_shapes2] = innerClip(polygon1, polygon2);
  let outer_clip_shapes1 = outerClip(polygon1, polygon2);
  let outer_clip_shapes2 = outerClip(polygon2, polygon1);
  denim.I2I = boolean_intersection.isEmpty() ? [] : [boolean_intersection];
  denim.I2B = inner_clip_shapes2;
  denim.I2E = boolean_difference1.isEmpty() ? [] : [boolean_difference1];
  denim.B2I = inner_clip_shapes1;
  denim.B2B = ip_sorted1;
  denim.B2E = outer_clip_shapes1;
  denim.E2I = boolean_difference2.isEmpty() ? [] : [boolean_difference2];
  denim.E2B = outer_clip_shapes2;
  return denim;
}
var Relations = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  contain,
  cover,
  covered,
  disjoint,
  equal,
  inside,
  intersect,
  relate,
  touch
});
var Matrix = class _Matrix {
  /**
   * Construct new instance of affine transformation matrix <br/>
   * If parameters omitted, construct identity matrix a = 1, d = 1
   * @param {number} a - position(0,0)   sx*cos(alpha)
   * @param {number} c - position (1,0)  -sy*sin(alpha)
   * @param {number} b - position (0,1)  sx*sin(alpha)
   * @param {number} d - position (1,1)  sy*cos(alpha)
   * @param {number} tx - position (2,0) translation by x
   * @param {number} ty - position (2,1) translation by y
   */
  constructor(a = 1, b = 0, c = 0, d = 1, tx = 0, ty = 0) {
    this.a = a;
    this.b = b;
    this.c = c;
    this.d = d;
    this.tx = tx;
    this.ty = ty;
  }
  /**
   * Return new matrix from 3x3 affine transformation matrix
   * @param {AffineMatrix3x3} matrix3x3
   * @returns {Matrix}
   */
  fromMatrix3x3(matrix3x3) {
    const [a, c, tx] = matrix3x3[0];
    const [b, d, ty] = matrix3x3[1];
    return new _Matrix(a, b, c, d, tx, ty);
  }
  /**
   * Return 3x3 affine transformation matrix
   * @returns {AffineMatrix3x3}
   */
  toMatrix3x3() {
    return [
      [this.a, this.c, this.tx],
      [this.b, this.d, this.ty],
      [0, 0, 1]
    ];
  }
  /**
   * Return new cloned instance of matrix
   * @return {Matrix}
   **/
  clone() {
    return new _Matrix(this.a, this.b, this.c, this.d, this.tx, this.ty);
  }
  /**
   * Transform vector [x,y] using transformation matrix. <br/>
   * Vector [x,y] is an abstract array[2] of numbers and not a FlattenJS object <br/>
   * The result is also an abstract vector [x',y'] = A * [x,y]:
   * <code>
   * [x'       [ ax + cy + tx
   *  y'   =     bx + dy + ty
   *  1]                    1 ]
   * </code>
   * @param {number[]} vector - array[2] of numbers
   * @returns {number[]} transformation result - array[2] of numbers
   */
  transform(vector2) {
    return [
      vector2[0] * this.a + vector2[1] * this.c + this.tx,
      vector2[0] * this.b + vector2[1] * this.d + this.ty
    ];
  }
  /**
   * Returns result of multiplication of this matrix by other matrix
   * @param {Matrix} other_matrix - matrix to multiply by
   * @returns {Matrix}
   */
  multiply(other_matrix) {
    return new _Matrix(
      this.a * other_matrix.a + this.c * other_matrix.b,
      this.b * other_matrix.a + this.d * other_matrix.b,
      this.a * other_matrix.c + this.c * other_matrix.d,
      this.b * other_matrix.c + this.d * other_matrix.d,
      this.a * other_matrix.tx + this.c * other_matrix.ty + this.tx,
      this.b * other_matrix.tx + this.d * other_matrix.ty + this.ty
    );
  }
  /**
   * Return new matrix as a result of multiplication of the current matrix
   * by the matrix(1,0,0,1,tx,ty)
   * @param {Vector} vector - Translation by vector or
   * @param {number} tx - translation by x-axis
   * @param {number} ty - translation by y-axis
   * @returns {Matrix}
   */
  translate(...args) {
    let tx, ty;
    if (args.length == 1 && !isNaN(args[0].x) && !isNaN(args[0].y)) {
      tx = args[0].x;
      ty = args[0].y;
    } else if (args.length === 2 && typeof args[0] == "number" && typeof args[1] == "number") {
      tx = args[0];
      ty = args[1];
    } else {
      throw Errors.ILLEGAL_PARAMETERS;
    }
    return this.multiply(new _Matrix(1, 0, 0, 1, tx, ty));
  }
  /**
   * Return new matrix as a result of multiplication of the current matrix
   * by the matrix that defines rotation by given angle (in radians) around
   * center of rotation (centerX,centerY) in counterclockwise direction
   * @param {number} angle - angle in radians
   * @param {number} centerX - center of rotation
   * @param {number} centerY - center of rotation
   * @returns {Matrix}
   */
  rotate(angle, centerX = 0, centerY = 0) {
    let cos3 = Math.cos(angle);
    let sin3 = Math.sin(angle);
    return this.translate(centerX, centerY).multiply(new _Matrix(cos3, sin3, -sin3, cos3, 0, 0)).translate(-centerX, -centerY);
  }
  /**
   * Return new matrix as a result of multiplication of the current matrix
   * by the matrix (sx,0,0,sy,0,0) that defines scaling
   * @param {number} sx
   * @param {number} sy
   * @returns {Matrix}
   */
  scale(sx, sy) {
    return this.multiply(new _Matrix(sx, 0, 0, sy, 0, 0));
  }
  /**
   * Returns true if two matrix are equal parameter by parameter
   * @param {Matrix} matrix - other matrix
   * @returns {boolean} true if equal, false otherwise
   */
  equalTo(matrix2) {
    if (!Flatten.Utils.EQ(this.tx, matrix2.tx)) return false;
    if (!Flatten.Utils.EQ(this.ty, matrix2.ty)) return false;
    if (!Flatten.Utils.EQ(this.a, matrix2.a)) return false;
    if (!Flatten.Utils.EQ(this.b, matrix2.b)) return false;
    if (!Flatten.Utils.EQ(this.c, matrix2.c)) return false;
    if (!Flatten.Utils.EQ(this.d, matrix2.d)) return false;
    return true;
  }
};
Flatten.Matrix = Matrix;
var matrix = (...args) => new Flatten.Matrix(...args);
Flatten.matrix = matrix;
var IntervalBase = class {
  constructor(low, high) {
    this.low = low;
    this.high = high;
  }
  get max() {
    return this.clone();
  }
  // Default numeric/date comparison (lexicographic by low then high)
  less_than(other_interval) {
    return this.low < other_interval.low || this.low === other_interval.low && this.high < other_interval.high;
  }
  equal_to(other_interval) {
    return this.low === other_interval.low && this.high === other_interval.high;
  }
  intersect(other_interval) {
    return !this.not_intersect(other_interval);
  }
  not_intersect(other_interval) {
    return this.high < other_interval.low || other_interval.high < this.low;
  }
  merge(other_interval) {
    const low = this.low === void 0 ? other_interval.low : this.low < other_interval.low ? this.low : other_interval.low;
    const high = this.high === void 0 ? other_interval.high : this.high > other_interval.high ? this.high : other_interval.high;
    const cloned = this.clone();
    cloned.low = low;
    cloned.high = high;
    return cloned;
  }
  output() {
    return [this.low, this.high];
  }
  // Instance-level comparator so child classes can customize value comparison semantics
  comparable_less_than(val1, val2) {
    return val1 < val2;
  }
};
var Interval = class _Interval extends IntervalBase {
  clone() {
    return new _Interval(this.low, this.high);
  }
};
var RB_TREE_COLOR_RED = 1;
var RB_TREE_COLOR_BLACK = 0;
var Node = class {
  constructor(key, value, left = null, right = null, parent = null, color = RB_TREE_COLOR_BLACK) {
    this.left = left;
    this.right = right;
    this.parent = parent;
    this.color = color;
    this.item = { key: void 0, values: [] };
    if (value !== void 0) {
      this.item.values.push(value);
    }
    if (key !== void 0) {
      if (Array.isArray(key)) {
        const [rawLow, rawHigh] = key;
        if (!Number.isNaN(rawLow) && !Number.isNaN(rawHigh)) {
          let low = rawLow;
          let high = rawHigh;
          if (low > high)
            [low, high] = [high, low];
          this.item.key = new Interval(low, high);
        }
      } else {
        this.item.key = key;
      }
    }
    this.max = this.item.key ? this.item.key.max : void 0;
  }
  isNil() {
    return this.item.key === void 0 && this.item.values.length === 0 && this.left === null && this.right === null && this.color === RB_TREE_COLOR_BLACK;
  }
  requireKey() {
    if (!this.item.key) {
      throw new Error("Node key is undefined (nil/sentinel). Operation is not applicable.");
    }
    return this.item.key;
  }
  less_than(other_node) {
    const a = this.requireKey();
    const b = other_node.requireKey();
    return a.less_than(b);
  }
  _value_equal(other_node) {
    const a = this.item.values[0];
    const b = other_node.item.values[0];
    return a && b && a.equal_to ? a.equal_to(b) : a === b;
  }
  equal_to(other_node) {
    const a = this.requireKey();
    const b = other_node.requireKey();
    return a.equal_to(b);
  }
  intersect(other_node) {
    const a = this.requireKey();
    const b = other_node.requireKey();
    return a.intersect(b);
  }
  copy_data(other_node) {
    this.item.key = other_node.item.key;
    this.item.values = other_node.item.values.slice();
  }
  update_max() {
    this.max = this.item.key ? this.item.key.max : void 0;
    if (this.right && this.right.max) {
      this.max = this.max ? this.max.merge(this.right.max) : this.right.max;
    }
    if (this.left && this.left.max) {
      this.max = this.max ? this.max.merge(this.left.max) : this.left.max;
    }
  }
  // Other_node does not intersect any node of left subtree
  not_intersect_left_subtree(search_node) {
    if (!this.left)
      return true;
    const high = this.left.max ? this.left.max.high : this.left.item.key.high;
    const selfKey = this.requireKey();
    const searchKey = search_node.requireKey();
    return selfKey.comparable_less_than(high, searchKey.low);
  }
  // Other_node does not intersect right subtree
  not_intersect_right_subtree(search_node) {
    if (!this.right)
      return true;
    const low = this.right.max ? this.right.max.low : this.right.item.key.low;
    const selfKey = this.requireKey();
    const searchKey = search_node.requireKey();
    return selfKey.comparable_less_than(searchKey.high, low);
  }
};
var IntervalTree = class _IntervalTree {
  /**
   * Construct new empty instance of IntervalTree
   */
  constructor() {
    this.root = null;
    this.nil_node = new Node();
  }
  /**
   * Returns number of items stored in the interval tree
   * @returns {number}
   */
  get size() {
    let count = 0;
    this.tree_walk(this.root, (node) => count += node.item.values.length);
    return count;
  }
  /**
   * Returns array of sorted keys in the ascending order
   * @returns {Array}
   */
  get keys() {
    const res = [];
    this.tree_walk(this.root, (node) => res.push(node.item.key.output()));
    return res;
  }
  /**
   * Return array of values in the ascending keys order
   * @returns {Array}
   */
  get values() {
    const res = [];
    this.tree_walk(this.root, (node) => {
      for (const v of node.item.values)
        res.push(v);
    });
    return res;
  }
  /**
   * Returns array of items (<key,value> pairs) in the ascended keys order
   * @returns {Array}
   */
  get items() {
    const res = [];
    this.tree_walk(this.root, (node) => {
      const keyOut = node.item.key.output();
      for (const v of node.item.values) {
        res.push({ key: keyOut, value: v });
      }
    });
    return res;
  }
  /**
   * Returns true if tree is empty
   * @returns {boolean}
   */
  isEmpty() {
    return this.root == null || this.root === this.nil_node;
  }
  /**
   * Clear tree
   */
  clear() {
    this.root = null;
  }
  /**
   * Insert new item into interval tree
   * @param key - interval object or array of two numbers [low, high]
   * @param value - value representing any object (optional)
   * @returns returns reference to inserted node
   */
  insert(key, value = key) {
    if (key === void 0)
      return;
    const existing = this.tree_search(this.root, new Node(key));
    if (existing) {
      existing.item.values.push(value);
      return existing;
    }
    const insert_node = new Node(key, value, this.nil_node, this.nil_node, null, RB_TREE_COLOR_RED);
    this.tree_insert(insert_node);
    this.recalc_max(insert_node);
    return insert_node;
  }
  /**
   * Returns true if item {key,value} exist in the tree
   * @param key - interval correspondent to keys stored in the tree
   * @param value - value object to be checked
   * @returns true if item {key, value} exist in the tree, false otherwise
   */
  exist(key, value = key) {
    const node = this.tree_search(this.root, new Node(key));
    if (!node)
      return false;
    if (arguments.length < 2 || value === key)
      return true;
    return node.item.values.some((v) => v && v.equal_to ? v.equal_to(value) : v === value);
  }
  /**
   * Remove entry {key, value} from the tree
   * @param key - interval correspondent to keys stored in the tree
   * @param value - value object
   * @returns deleted node or undefined if not found
   */
  remove(key, value = key) {
    const node = this.tree_search(this.root, new Node(key));
    if (!node)
      return void 0;
    if (arguments.length < 2) {
      this.tree_delete(node);
      return node;
    }
    const idx = node.item.values.findIndex((v) => v && v.equal_to ? v.equal_to(value) : v === value);
    if (idx >= 0) {
      node.item.values.splice(idx, 1);
      if (node.item.values.length === 0) {
        this.tree_delete(node);
      }
      return node;
    }
    return void 0;
  }
  search(interval, outputMapperFn = (value, key) => value === key ? key.output() : value) {
    const search_node = new Node(interval);
    const resp_nodes = [];
    this.tree_search_interval(this.root, search_node, resp_nodes);
    const res = [];
    for (const node of resp_nodes) {
      for (const v of node.item.values) {
        res.push(outputMapperFn(v, node.item.key));
      }
    }
    return res;
  }
  /**
   * Returns true if intersection between given and any interval stored in the tree found
   * @param interval - search interval or tuple [low, high]
   * @returns {boolean}
   */
  intersect_any(interval) {
    const search_node = new Node(interval);
    return this.tree_find_any_interval(this.root, search_node);
  }
  /**
   * Tree visitor. For each node implement a callback function.
   * Method calls a callback function with two parameters (key, value)
   * @param visitor - function to be called for each tree item
   */
  forEach(visitor) {
    this.tree_walk(this.root, (node) => {
      for (const v of node.item.values)
        visitor(node.item.key, v);
    });
  }
  /**
   * Value Mapper. Walk through every node and map node value to another value
   * @param callback - function to be called for each tree item
   */
  map(callback) {
    const tree = new _IntervalTree();
    this.tree_walk(this.root, (node) => {
      for (const v of node.item.values) {
        tree.insert(node.item.key, callback(v, node.item.key));
      }
    });
    return tree;
  }
  *iterate(interval, outputMapperFn = (value, key) => value === key ? key.output() : value) {
    let node = null;
    if (interval) {
      node = this.tree_search_nearest_forward(this.root, new Node(interval));
    } else if (this.root) {
      node = this.local_minimum(this.root);
    }
    while (node) {
      for (const v of node.item.values) {
        yield outputMapperFn(v, node.item.key);
      }
      node = this.tree_successor(node);
    }
  }
  /**
   * Recalculate max property upward from given node to root
   * @param node - starting node
   */
  recalc_max(node) {
    let node_current = node;
    while (node_current.parent != null) {
      node_current.parent.update_max();
      node_current = node_current.parent;
    }
  }
  /**
   * Insert node into tree and rebalance
   * @param insert_node - node to insert
   */
  tree_insert(insert_node) {
    let current_node = this.root;
    let parent_node = null;
    if (this.root == null || this.root === this.nil_node) {
      this.root = insert_node;
    } else {
      while (current_node !== this.nil_node) {
        parent_node = current_node;
        if (insert_node.less_than(current_node)) {
          current_node = current_node.left;
        } else {
          current_node = current_node.right;
        }
      }
      insert_node.parent = parent_node;
      if (insert_node.less_than(parent_node)) {
        parent_node.left = insert_node;
      } else {
        parent_node.right = insert_node;
      }
    }
    this.insert_fixup(insert_node);
  }
  /**
   * Restore red-black tree properties after insertion
   * @param insert_node - inserted node
   */
  insert_fixup(insert_node) {
    let current_node;
    let uncle_node;
    current_node = insert_node;
    while (current_node !== this.root && current_node.parent.color === RB_TREE_COLOR_RED) {
      if (current_node.parent === current_node.parent.parent.left) {
        uncle_node = current_node.parent.parent.right;
        if (uncle_node.color === RB_TREE_COLOR_RED) {
          current_node.parent.color = RB_TREE_COLOR_BLACK;
          uncle_node.color = RB_TREE_COLOR_BLACK;
          current_node.parent.parent.color = RB_TREE_COLOR_RED;
          current_node = current_node.parent.parent;
        } else {
          if (current_node === current_node.parent.right) {
            current_node = current_node.parent;
            this.rotate_left(current_node);
          }
          current_node.parent.color = RB_TREE_COLOR_BLACK;
          current_node.parent.parent.color = RB_TREE_COLOR_RED;
          this.rotate_right(current_node.parent.parent);
        }
      } else {
        uncle_node = current_node.parent.parent.left;
        if (uncle_node.color === RB_TREE_COLOR_RED) {
          current_node.parent.color = RB_TREE_COLOR_BLACK;
          uncle_node.color = RB_TREE_COLOR_BLACK;
          current_node.parent.parent.color = RB_TREE_COLOR_RED;
          current_node = current_node.parent.parent;
        } else {
          if (current_node === current_node.parent.left) {
            current_node = current_node.parent;
            this.rotate_right(current_node);
          }
          current_node.parent.color = RB_TREE_COLOR_BLACK;
          current_node.parent.parent.color = RB_TREE_COLOR_RED;
          this.rotate_left(current_node.parent.parent);
        }
      }
    }
    this.root.color = RB_TREE_COLOR_BLACK;
  }
  /**
   * Delete node from tree and rebalance
   * @param delete_node - node to delete
   */
  tree_delete(delete_node) {
    let cut_node;
    let fix_node;
    if (delete_node.left === this.nil_node || delete_node.right === this.nil_node) {
      cut_node = delete_node;
    } else {
      cut_node = this.tree_successor(delete_node);
    }
    if (cut_node.left !== this.nil_node) {
      fix_node = cut_node.left;
    } else {
      fix_node = cut_node.right;
    }
    fix_node.parent = cut_node.parent;
    if (cut_node === this.root) {
      this.root = fix_node;
    } else {
      if (cut_node === cut_node.parent.left) {
        cut_node.parent.left = fix_node;
      } else {
        cut_node.parent.right = fix_node;
      }
      cut_node.parent.update_max();
    }
    this.recalc_max(fix_node);
    if (cut_node !== delete_node) {
      delete_node.copy_data(cut_node);
      delete_node.update_max();
      this.recalc_max(delete_node);
    }
    if (cut_node.color === RB_TREE_COLOR_BLACK) {
      this.delete_fixup(fix_node);
    }
  }
  /**
   * Restore red-black tree properties after deletion
   * @param fix_node - node to fix from
   */
  delete_fixup(fix_node) {
    let current_node = fix_node;
    let brother_node;
    while (current_node !== this.root && current_node.parent != null && current_node.color === RB_TREE_COLOR_BLACK) {
      if (current_node === current_node.parent.left) {
        brother_node = current_node.parent.right;
        if (brother_node.color === RB_TREE_COLOR_RED) {
          brother_node.color = RB_TREE_COLOR_BLACK;
          current_node.parent.color = RB_TREE_COLOR_RED;
          this.rotate_left(current_node.parent);
          brother_node = current_node.parent.right;
        }
        if (brother_node.left.color === RB_TREE_COLOR_BLACK && brother_node.right.color === RB_TREE_COLOR_BLACK) {
          brother_node.color = RB_TREE_COLOR_RED;
          current_node = current_node.parent;
        } else {
          if (brother_node.right.color === RB_TREE_COLOR_BLACK) {
            brother_node.color = RB_TREE_COLOR_RED;
            brother_node.left.color = RB_TREE_COLOR_BLACK;
            this.rotate_right(brother_node);
            brother_node = current_node.parent.right;
          }
          brother_node.color = current_node.parent.color;
          current_node.parent.color = RB_TREE_COLOR_BLACK;
          brother_node.right.color = RB_TREE_COLOR_BLACK;
          this.rotate_left(current_node.parent);
          current_node = this.root;
        }
      } else {
        brother_node = current_node.parent.left;
        if (brother_node.color === RB_TREE_COLOR_RED) {
          brother_node.color = RB_TREE_COLOR_BLACK;
          current_node.parent.color = RB_TREE_COLOR_RED;
          this.rotate_right(current_node.parent);
          brother_node = current_node.parent.left;
        }
        if (brother_node.left.color === RB_TREE_COLOR_BLACK && brother_node.right.color === RB_TREE_COLOR_BLACK) {
          brother_node.color = RB_TREE_COLOR_RED;
          current_node = current_node.parent;
        } else {
          if (brother_node.left.color === RB_TREE_COLOR_BLACK) {
            brother_node.color = RB_TREE_COLOR_RED;
            brother_node.right.color = RB_TREE_COLOR_BLACK;
            this.rotate_left(brother_node);
            brother_node = current_node.parent.left;
          }
          brother_node.color = current_node.parent.color;
          current_node.parent.color = RB_TREE_COLOR_BLACK;
          brother_node.left.color = RB_TREE_COLOR_BLACK;
          this.rotate_right(current_node.parent);
          current_node = this.root;
        }
      }
    }
    current_node.color = RB_TREE_COLOR_BLACK;
  }
  /**
   * Search for node with given key and value
   * @param node - starting node
   * @param search_node - node to search for
   * @returns found node or undefined
   */
  tree_search(node, search_node) {
    if (node == null || node === this.nil_node)
      return void 0;
    if (search_node.equal_to(node)) {
      return node;
    }
    if (search_node.less_than(node)) {
      return this.tree_search(node.left, search_node);
    } else {
      return this.tree_search(node.right, search_node);
    }
  }
  /**
   * Find nearest forward node from given interval
   * @param node - starting node
   * @param search_node - search interval as node
   * @returns nearest forward node or null
   */
  tree_search_nearest_forward(node, search_node) {
    let best = null;
    let curr = node;
    while (curr && curr !== this.nil_node) {
      if (curr.less_than(search_node)) {
        if (curr.intersect(search_node)) {
          best = curr;
          curr = curr.left;
        } else {
          curr = curr.right;
        }
      } else {
        if (!best || curr.less_than(best))
          best = curr;
        curr = curr.left;
      }
    }
    return best || null;
  }
  /**
   * Search all intervals intersecting given interval
   * @param node - starting node
   * @param search_node - search interval as node
   * @param res - result array to collect found nodes
   */
  tree_search_interval(node, search_node, res) {
    if (node != null && node !== this.nil_node) {
      if (node.left !== this.nil_node && !node.not_intersect_left_subtree(search_node)) {
        this.tree_search_interval(node.left, search_node, res);
      }
      if (node.intersect(search_node)) {
        res.push(node);
      }
      if (node.right !== this.nil_node && !node.not_intersect_right_subtree(search_node)) {
        this.tree_search_interval(node.right, search_node, res);
      }
    }
  }
  /**
   * Check if any interval intersects with given interval
   * @param node - starting node
   * @param search_node - search interval as node
   * @returns true if intersection found
   */
  tree_find_any_interval(node, search_node) {
    let found = false;
    if (node != null && node !== this.nil_node) {
      if (node.left !== this.nil_node && !node.not_intersect_left_subtree(search_node)) {
        found = this.tree_find_any_interval(node.left, search_node);
      }
      if (!found) {
        found = node.intersect(search_node);
      }
      if (!found && node.right !== this.nil_node && !node.not_intersect_right_subtree(search_node)) {
        found = this.tree_find_any_interval(node.right, search_node);
      }
    }
    return found;
  }
  /**
   * Find node with minimum key in subtree
   * @param node - root of subtree
   * @returns node with minimum key
   */
  local_minimum(node) {
    let node_min = node;
    while (node_min.left != null && node_min.left !== this.nil_node) {
      node_min = node_min.left;
    }
    return node_min;
  }
  /**
   * Find node with maximum key in subtree
   * @param node - root of subtree
   * @returns node with maximum key
   */
  local_maximum(node) {
    let node_max = node;
    while (node_max.right != null && node_max.right !== this.nil_node) {
      node_max = node_max.right;
    }
    return node_max;
  }
  /**
   * Find successor node (next in sorted order)
   * @param node - current node
   * @returns successor node or null
   */
  tree_successor(node) {
    let node_successor;
    let current_node;
    let parent_node;
    if (node.right !== this.nil_node) {
      node_successor = this.local_minimum(node.right);
    } else {
      current_node = node;
      parent_node = node.parent;
      while (parent_node != null && parent_node.right === current_node) {
        current_node = parent_node;
        parent_node = parent_node.parent;
      }
      node_successor = parent_node;
    }
    return node_successor;
  }
  /**
   * Left rotation around node x
   * @param x - node to rotate
   */
  rotate_left(x) {
    const y = x.right;
    x.right = y.left;
    if (y.left !== this.nil_node) {
      y.left.parent = x;
    }
    y.parent = x.parent;
    if (x === this.root) {
      this.root = y;
    } else {
      if (x === x.parent.left) {
        x.parent.left = y;
      } else {
        x.parent.right = y;
      }
    }
    y.left = x;
    x.parent = y;
    if (x !== null && x !== this.nil_node) {
      x.update_max();
    }
    if (y != null && y !== this.nil_node) {
      y.update_max();
    }
  }
  /**
   * Right rotation around node y
   * @param y - node to rotate
   */
  rotate_right(y) {
    const x = y.left;
    y.left = x.right;
    if (x.right !== this.nil_node) {
      x.right.parent = y;
    }
    x.parent = y.parent;
    if (y === this.root) {
      this.root = x;
    } else {
      if (y === y.parent.left) {
        y.parent.left = x;
      } else {
        y.parent.right = x;
      }
    }
    x.right = y;
    y.parent = x;
    if (y !== null && y !== this.nil_node) {
      y.update_max();
    }
    if (x != null && x !== this.nil_node) {
      x.update_max();
    }
  }
  /**
   * Performs in-order traversal of the tree
   * Applies action callback to each node in ascending order of keys
   * @param node - starting node for traversal (typically root)
   * @param action - callback function to be executed for each node
   */
  tree_walk(node, action) {
    if (node != null && node !== this.nil_node) {
      this.tree_walk(node.left, action);
      action(node);
      this.tree_walk(node.right, action);
    }
  }
  /**
   * Test red-black tree property: all red nodes have exactly two black child nodes
   * @returns true if property holds
   */
  testRedBlackProperty() {
    let res = true;
    this.tree_walk(this.root, function(node) {
      if (node.color === RB_TREE_COLOR_RED) {
        if (!(node.left.color === RB_TREE_COLOR_BLACK && node.right.color === RB_TREE_COLOR_BLACK)) {
          res = false;
        }
      }
    });
    return res;
  }
  /**
   * Test red-black tree property: every path from root to leaf has same black height
   * @param node - starting node
   * @returns black height
   * @throws Error if property is violated
   */
  testBlackHeightProperty(node) {
    let height = 0;
    let heightLeft = 0;
    let heightRight = 0;
    if (node.color === RB_TREE_COLOR_BLACK) {
      height++;
    }
    if (node.left !== this.nil_node) {
      heightLeft = this.testBlackHeightProperty(node.left);
    } else {
      heightLeft = 1;
    }
    if (node.right !== this.nil_node) {
      heightRight = this.testBlackHeightProperty(node.right);
    } else {
      heightRight = 1;
    }
    if (heightLeft !== heightRight) {
      throw new Error("Red-black height property violated");
    }
    height += heightLeft;
    return height;
  }
};
var PlanarSet = class extends Set {
  /**
   * Create new instance of PlanarSet
   * @param shapes - array or set of geometric objects to store in planar set
   * Each object should have a <b>box</b> property
   */
  constructor(shapes) {
    super(shapes);
    this.index = new IntervalTree();
    this.forEach((shape) => this.index.insert(shape));
  }
  /**
   * Add new shape to planar set and to its spatial index.<br/>
   * If shape already exist, it will not be added again.
   * This happens with no error, it is possible to use <i>size</i> property to check if
   * a shape was actually added.<br/>
   * Method returns planar set object updated and may be chained
   * @param {AnyShape | {Box, AnyShape}} entry - shape to be added, should have valid <i>box</i> property
   * Another option to transfer as an object {key: Box, value: AnyShape}
   * @returns {PlanarSet}
   */
  add(entry) {
    let size = this.size;
    const { key, value } = entry;
    const box2 = key || entry.box;
    const shape = value || entry;
    super.add(shape);
    if (this.size > size) {
      this.index.insert(box2, shape);
    }
    return this;
  }
  /**
   * Delete shape from planar set. Returns true if shape was actually deleted, false otherwise
   * @param {AnyShape | {Box, AnyShape}} entry - shape to be deleted
   * @returns {boolean}
   */
  delete(entry) {
    const { key, value } = entry;
    const box2 = key || entry.box;
    const shape = value || entry;
    let deleted = super.delete(shape);
    if (deleted) {
      this.index.remove(box2, shape);
    }
    return deleted;
  }
  /**
   * Clear planar set
   */
  clear() {
    super.clear();
    this.index = new IntervalTree();
  }
  /**
   * 2d range search in planar set.<br/>
   * Returns array of all shapes in planar set which bounding box is intersected with query box
   * @param {Box} box - query box
   * @returns {AnyShape[]}
   */
  search(box2) {
    let resp = this.index.search(box2);
    return resp;
  }
  /**
   * Point location test. Returns array of shapes which contains given point
   * @param {Point} point - query point
   * @returns {AnyShape[]}
   */
  hit(point2) {
    let box2 = new Flatten.Box(point2.x - 1, point2.y - 1, point2.x + 1, point2.y + 1);
    let resp = this.index.search(box2);
    return resp.filter((shape) => point2.on(shape));
  }
  /**
   * Returns svg string to draw all shapes in planar set
   * @returns {String}
   */
  svg() {
    let svgcontent = [...this].reduce((acc, shape) => acc + shape.svg(), "");
    return svgcontent;
  }
};
Flatten.PlanarSet = PlanarSet;
var Shape = class {
  get name() {
    throw Errors.CANNOT_INVOKE_ABSTRACT_METHOD;
  }
  get box() {
    throw Errors.CANNOT_INVOKE_ABSTRACT_METHOD;
  }
  clone() {
    throw Errors.CANNOT_INVOKE_ABSTRACT_METHOD;
  }
  /**
   * Returns new shape translated by given vector.
   * Translation vector may be also defined by a pair of numbers.
   * @param {Vector | (number, number) } args - Translation vector
   * or tuple of numbers
   * @returns {Shape}
   */
  translate(...args) {
    return this.transform(new Matrix().translate(...args));
  }
  /**
   * Returns new shape rotated by given angle around given center point.
   * If center point is omitted, rotates around zero point (0,0).
   * Positive value of angle defines rotation in counterclockwise direction,
   * negative angle defines rotation in clockwise direction
   * @param {number} angle - angle in radians
   * @param {Point} [center=(0,0)] center
   * @returns {Shape}
   */
  rotate(angle, center = new Flatten.Point()) {
    return this.transform(new Matrix().rotate(angle, center.x, center.y));
  }
  /**
   * Return new shape with coordinates multiplied by scaling factor
   * @param {number} sx - x-axis scaling factor
   * @param {number} sy - y-axis scaling factor
   * @returns {Shape}
   */
  scale(sx, sy) {
    return this.transform(new Matrix().scale(sx, sy));
  }
  transform(...args) {
    throw Errors.CANNOT_INVOKE_ABSTRACT_METHOD;
  }
  /**
   * This method returns an object that defines how data will be
   * serialized when called JSON.stringify() method
   * @returns {Object}
   */
  toJSON() {
    return Object.assign({}, this, { name: this.name });
  }
  svg(attrs = {}) {
    throw Errors.CANNOT_INVOKE_ABSTRACT_METHOD;
  }
};
var Point$3 = class Point2 extends Shape {
  /**
   * Point may be constructed by two numbers, or by array of two numbers
   * @param {number} x - x-coordinate (float number)
   * @param {number} y - y-coordinate (float number)
   */
  constructor(...args) {
    super();
    this.x = 0;
    this.y = 0;
    if (args.length === 0) {
      return;
    }
    if (args.length === 1 && args[0] instanceof Array && args[0].length === 2) {
      let arr = args[0];
      if (typeof arr[0] == "number" && typeof arr[1] == "number") {
        this.x = arr[0];
        this.y = arr[1];
        return;
      }
    }
    if (args.length === 1 && args[0] instanceof Object && args[0].name === "point") {
      let { x, y } = args[0];
      this.x = x;
      this.y = y;
      return;
    }
    if (args.length === 2) {
      if (typeof args[0] == "number" && typeof args[1] == "number") {
        this.x = args[0];
        this.y = args[1];
        return;
      }
    }
    throw Errors.ILLEGAL_PARAMETERS;
  }
  /**
   * Returns bounding box of a point
   * @returns {Box}
   */
  get box() {
    return new Flatten.Box(this.x, this.y, this.x, this.y);
  }
  /**
   * Return new cloned instance of point
   * @returns {Point}
   */
  clone() {
    return new Flatten.Point(this.x, this.y);
  }
  get vertices() {
    return [this.clone()];
  }
  /**
   * Returns true if points are equal up to [Flatten.Utils.DP_TOL]{@link DP_TOL} tolerance
   * @param {Point} pt Query point
   * @returns {boolean}
   */
  equalTo(pt) {
    return Flatten.Utils.EQ(this.x, pt.x) && Flatten.Utils.EQ(this.y, pt.y);
  }
  /**
   * Defines predicate "less than" between points. Returns true if the point is less than query points, false otherwise <br/>
   * By definition point1 < point2 if {point1.y < point2.y || point1.y == point2.y && point1.x < point2.x <br/>
   * Numeric values compared with [Flatten.Utils.DP_TOL]{@link DP_TOL} tolerance
   * @param {Point} pt Query point
   * @returns {boolean}
   */
  lessThan(pt) {
    if (Flatten.Utils.LT(this.y, pt.y))
      return true;
    if (Flatten.Utils.EQ(this.y, pt.y) && Flatten.Utils.LT(this.x, pt.x))
      return true;
    return false;
  }
  /**
   * Return new point transformed by affine transformation matrix
   * @param {Matrix} m - affine transformation matrix (a,b,c,d,tx,ty)
   * @returns {Point}
   */
  transform(m) {
    return new Flatten.Point(m.transform([this.x, this.y]));
  }
  /**
   * Returns projection point on given line
   * @param {Line} line Line this point be projected on
   * @returns {Point}
   */
  projectionOn(line2) {
    if (this.equalTo(line2.pt))
      return this.clone();
    let vec = new Flatten.Vector(this, line2.pt);
    if (Flatten.Utils.EQ_0(vec.cross(line2.norm)))
      return line2.pt.clone();
    let dist = vec.dot(line2.norm);
    let proj_vec = line2.norm.multiply(dist);
    return this.translate(proj_vec);
  }
  /**
   * Returns true if point belongs to the "left" semi-plane, which means, point belongs to the same semi plane where line normal vector points to
   * Return false if point belongs to the "right" semi-plane or to the line itself
   * @param {Line} line Query line
   * @returns {boolean}
   */
  leftTo(line2) {
    let vec = new Flatten.Vector(line2.pt, this);
    let onLeftSemiPlane = Flatten.Utils.GT(vec.dot(line2.norm), 0);
    return onLeftSemiPlane;
  }
  /**
   * Calculate distance and shortest segment from point to shape and return as array [distance, shortest segment]
   * @param {Shape} shape Shape of the one of supported types Point, Line, Circle, Segment, Arc, Polygon or Planar Set
   * @returns {number} distance from point to shape
   * @returns {Segment} shortest segment between point and shape (started at point, ended at shape)
   */
  distanceTo(shape) {
    if (shape instanceof Point2) {
      let dx = shape.x - this.x;
      let dy = shape.y - this.y;
      return [Math.sqrt(dx * dx + dy * dy), new Flatten.Segment(this, shape)];
    }
    if (shape instanceof Flatten.Line) {
      return Flatten.Distance.point2line(this, shape);
    }
    if (shape instanceof Flatten.Circle) {
      return Flatten.Distance.point2circle(this, shape);
    }
    if (shape instanceof Flatten.Segment) {
      return Flatten.Distance.point2segment(this, shape);
    }
    if (shape instanceof Flatten.Arc) {
      return Flatten.Distance.point2arc(this, shape);
    }
    if (shape instanceof Flatten.Polygon) {
      return Flatten.Distance.point2polygon(this, shape);
    }
    if (shape instanceof Flatten.PlanarSet) {
      return Flatten.Distance.shape2planarSet(this, shape);
    }
    if (shape instanceof Flatten.Multiline) {
      return Flatten.Distance.shape2multiline(this, shape);
    }
  }
  /**
   * Returns true if point is on a shape, false otherwise
   * @param {Shape} shape
   * @returns {boolean}
   */
  on(shape) {
    if (shape instanceof Flatten.Point) {
      return this.equalTo(shape);
    }
    if (shape.contains && shape.contains instanceof Function) {
      return shape.contains(this);
    }
    throw Flatten.Errors.UNSUPPORTED_SHAPE_TYPE;
  }
  get name() {
    return "point";
  }
  /**
   * Return string to draw point in svg as circle with radius "r" <br/>
   * Accept any valid attributes of svg elements as svg object
   * Defaults attribues are: <br/>
   * {
   *    r:"3",
   *    stroke:"black",
   *    strokeWidth:"1",
   *    fill:"red"
   * }
   * @param {Object} attrs - Any valid attributes of svg circle element, like "r", "stroke", "strokeWidth", "fill"
   * @returns {String}
   */
  svg(attrs = {}) {
    const r = attrs.r ?? 3;
    return `
<circle cx="${this.x}" cy="${this.y}" r="${r}"
            ${convertToString({ fill: "red", ...attrs })} />`;
  }
};
Flatten.Point = Point$3;
var point = (...args) => new Flatten.Point(...args);
Flatten.point = point;
var Vector$1 = class Vector extends Shape {
  /**
   * Vector may be constructed by two points, or by two float numbers,
   * or by array of two numbers or by segment
   * @param {Point} ps - start point
   * @param {Point} pe - end point
   */
  constructor(...args) {
    super();
    this.x = 0;
    this.y = 0;
    if (args.length === 0) {
      return;
    }
    if (args.length === 1 && args[0] instanceof Array && args[0].length === 2) {
      let arr = args[0];
      if (typeof arr[0] == "number" && typeof arr[1] == "number") {
        this.x = arr[0];
        this.y = arr[1];
        return;
      }
    }
    if (args.length === 1 && args[0] instanceof Object && args[0].name === "vector") {
      let { x, y } = args[0];
      this.x = x;
      this.y = y;
      return;
    }
    if (args.length === 1 && args[0] instanceof Object && args[0].name === "segment") {
      let { start, end } = args[0];
      this.x = end.x - start.x;
      this.y = end.y - start.y;
      return;
    }
    if (args.length === 2) {
      let a1 = args[0];
      let a2 = args[1];
      if (typeof a1 == "number" && typeof a2 == "number") {
        this.x = a1;
        this.y = a2;
        return;
      }
      if (a1 instanceof Flatten.Point && a2 instanceof Flatten.Point) {
        this.x = a2.x - a1.x;
        this.y = a2.y - a1.y;
        return;
      }
    }
    throw Errors.ILLEGAL_PARAMETERS;
  }
  /**
   * Method clone returns new instance of Vector
   * @returns {Vector}
   */
  clone() {
    return new Flatten.Vector(this.x, this.y);
  }
  /**
   * Slope of the vector in radians from 0 to 2PI
   * @returns {number}
   */
  get slope() {
    let angle = Math.atan2(this.y, this.x);
    if (angle < 0) angle = 2 * Math.PI + angle;
    return angle;
  }
  /**
   * Length of vector
   * @returns {number}
   */
  get length() {
    return Math.sqrt(this.dot(this));
  }
  /**
   * Returns true if the vector is zero length
   * @returns {boolean}
   */
  isZeroLength() {
    return Flatten.Utils.EQ_0(this.length);
  }
  /**
   * Returns true if vectors are equal up to [DP_TOL]{@link http://localhost:63342/flatten-js/docs/global.html#DP_TOL}
   * tolerance
   * @param {Vector} v
   * @returns {boolean}
   */
  equalTo(v) {
    return Flatten.Utils.EQ(this.x, v.x) && Flatten.Utils.EQ(this.y, v.y);
  }
  /**
   * Returns new vector multiplied by scalar
   * @param {number} scalar
   * @returns {Vector}
   */
  multiply(scalar) {
    return new Flatten.Vector(scalar * this.x, scalar * this.y);
  }
  /**
   * Returns scalar product (dot product) of two vectors <br/>
   * <code>dot_product = (this * v)</code>
   * @param {Vector} v Other vector
   * @returns {number}
   */
  dot(v) {
    return this.x * v.x + this.y * v.y;
  }
  /**
   * Returns vector product (cross product) of two vectors <br/>
   * <code>cross_product = (this x v)</code>
   * @param {Vector} v Other vector
   * @returns {number}
   */
  cross(v) {
    return this.x * v.y - this.y * v.x;
  }
  /**
   * Returns unit vector.<br/>
   * Throw error if given vector has zero length
   * @returns {Vector}
   */
  normalize() {
    if (this.isZeroLength()) {
      throw Errors.ZERO_DIVISION;
    }
    return new Flatten.Vector(this.x / this.length, this.y / this.length);
  }
  /**
   * Returns new vector rotated by given angle,
   * positive angle defines rotation in counterclockwise direction,
   * negative - in clockwise direction
   * Vector only can be rotated around (0,0) point!
   * @param {number} angle - Angle in radians
   * @param {Point} center - Center of rotation, default is (0,0)
   * @returns {Vector}
   */
  rotate(angle, center = new Flatten.Point()) {
    if (center.x === 0 && center.y === 0) {
      return this.transform(new Matrix().rotate(angle));
    }
    throw Errors.OPERATION_IS_NOT_SUPPORTED;
  }
  /**
   * Return new vector transformed by affine transformation matrix m
   * @param {Matrix} m - affine transformation matrix (a,b,c,d,tx,ty)
   * @returns {Vector}
   */
  transform(m) {
    return new Flatten.Vector(m.transform([this.x, this.y]));
  }
  /**
   * Returns vector rotated 90 degrees counterclockwise
   * @returns {Vector}
   */
  rotate90CCW() {
    return new Flatten.Vector(-this.y, this.x);
  }
  /**
   * Returns vector rotated 90 degrees clockwise
   * @returns {Vector}
   */
  rotate90CW() {
    return new Flatten.Vector(this.y, -this.x);
  }
  /**
   * Return inverted vector
   * @returns {Vector}
   */
  invert() {
    return new Flatten.Vector(-this.x, -this.y);
  }
  /**
   * Return result of addition of other vector to this vector as a new vector
   * @param {Vector} v Other vector
   * @returns {Vector}
   */
  add(v) {
    return new Flatten.Vector(this.x + v.x, this.y + v.y);
  }
  /**
   * Return result of subtraction of other vector from current vector as a new vector
   * @param {Vector} v Another vector
   * @returns {Vector}
   */
  subtract(v) {
    return new Flatten.Vector(this.x - v.x, this.y - v.y);
  }
  /**
   * Return angle between this vector and other vector. <br/>
   * Angle is measured from 0 to 2*PI in the counterclockwise direction
   * from current vector to  another.
   * @param {Vector} v Another vector
   * @returns {number}
   */
  angleTo(v) {
    let norm1 = this.normalize();
    let norm2 = v.normalize();
    let angle = Math.atan2(norm1.cross(norm2), norm1.dot(norm2));
    if (angle < 0) angle += 2 * Math.PI;
    return angle;
  }
  /**
   * Return vector projection of the current vector on another vector
   * @param {Vector} v Another vector
   * @returns {Vector}
   */
  projectionOn(v) {
    let n = v.normalize();
    let d = this.dot(n);
    return n.multiply(d);
  }
  get name() {
    return "vector";
  }
};
Flatten.Vector = Vector$1;
var vector$1 = (...args) => new Flatten.Vector(...args);
Flatten.vector = vector$1;
var Segment$1 = class Segment extends Shape {
  /**
   *
   * @param {Point} ps - start point
   * @param {Point} pe - end point
   */
  constructor(...args) {
    super();
    this.ps = new Flatten.Point();
    this.pe = new Flatten.Point();
    if (args.length === 0) {
      return;
    }
    if (args.length === 1 && args[0] instanceof Array && args[0].length === 4) {
      let coords = args[0];
      this.ps = new Flatten.Point(coords[0], coords[1]);
      this.pe = new Flatten.Point(coords[2], coords[3]);
      return;
    }
    if (args.length === 1 && args[0] instanceof Object && args[0].name === "segment") {
      let { ps, pe } = args[0];
      this.ps = new Flatten.Point(ps.x, ps.y);
      this.pe = new Flatten.Point(pe.x, pe.y);
      return;
    }
    if (args.length === 1 && args[0] instanceof Flatten.Point) {
      this.ps = args[0].clone();
      return;
    }
    if (args.length === 2 && args[0] instanceof Flatten.Point && args[1] instanceof Flatten.Point) {
      this.ps = args[0].clone();
      this.pe = args[1].clone();
      return;
    }
    if (args.length === 4) {
      this.ps = new Flatten.Point(args[0], args[1]);
      this.pe = new Flatten.Point(args[2], args[3]);
      return;
    }
    throw Errors.ILLEGAL_PARAMETERS;
  }
  /**
   * Return new cloned instance of segment
   * @returns {Segment}
   */
  clone() {
    return new Flatten.Segment(this.start, this.end);
  }
  /**
   * Start point
   * @returns {Point}
   */
  get start() {
    return this.ps;
  }
  /**
   * End point
   * @returns {Point}
   */
  get end() {
    return this.pe;
  }
  /**
   * Returns array of start and end point
   * @returns [Point,Point]
   */
  get vertices() {
    return [this.ps.clone(), this.pe.clone()];
  }
  /**
   * Length of a segment
   * @returns {number}
   */
  get length() {
    return this.start.distanceTo(this.end)[0];
  }
  /**
   * Slope of the line - angle to axe x in radians from 0 to 2PI
   * @returns {number}
   */
  get slope() {
    let vec = new Flatten.Vector(this.start, this.end);
    return vec.slope;
  }
  /**
   * Bounding box
   * @returns {Box}
   */
  get box() {
    return new Flatten.Box(
      Math.min(this.start.x, this.end.x),
      Math.min(this.start.y, this.end.y),
      Math.max(this.start.x, this.end.x),
      Math.max(this.start.y, this.end.y)
    );
  }
  /**
   * Returns true if equals to query segment, false otherwise
   * @param {Segment} seg - query segment
   * @returns {boolean}
   */
  equalTo(seg) {
    return this.ps.equalTo(seg.ps) && this.pe.equalTo(seg.pe);
  }
  /**
   * Returns true if segment contains point
   * @param {Point} pt Query point
   * @returns {boolean}
   */
  contains(pt) {
    return Flatten.Utils.EQ_0(this.distanceToPoint(pt));
  }
  /**
   * Returns array of intersection points between segment and other shape
   * @param {Shape} shape - Shape of the one of supported types <br/>
   * @returns {Point[]}
   */
  intersect(shape) {
    if (shape instanceof Flatten.Point) {
      return this.contains(shape) ? [shape] : [];
    }
    if (shape instanceof Flatten.Line) {
      return intersectSegment2Line(this, shape);
    }
    if (shape instanceof Flatten.Ray) {
      return intersectRay2Segment(shape, this);
    }
    if (shape instanceof Flatten.Segment) {
      return intersectSegment2Segment(this, shape);
    }
    if (shape instanceof Flatten.Circle) {
      return intersectSegment2Circle(this, shape);
    }
    if (shape instanceof Flatten.Box) {
      return intersectSegment2Box(this, shape);
    }
    if (shape instanceof Flatten.Arc) {
      return intersectSegment2Arc(this, shape);
    }
    if (shape instanceof Flatten.Polygon) {
      return intersectSegment2Polygon(this, shape);
    }
    if (shape instanceof Flatten.Multiline) {
      return intersectShape2Multiline(this, shape);
    }
  }
  /**
   * Calculate distance and shortest segment from segment to shape and return as array [distance, shortest segment]
   * @param {Shape} shape Shape of the one of supported types Point, Line, Circle, Segment, Arc, Polygon or Planar Set
   * @returns {[number, Segment]} shortest segment between segment and shape (started at segment, ended at shape)
   */
  distanceTo(shape) {
    if (shape instanceof Flatten.Point) {
      let [dist, shortest_segment] = Flatten.Distance.point2segment(shape, this);
      shortest_segment = shortest_segment.reverse();
      return [dist, shortest_segment];
    }
    if (shape instanceof Flatten.Circle) {
      let [dist, shortest_segment] = Flatten.Distance.segment2circle(this, shape);
      return [dist, shortest_segment];
    }
    if (shape instanceof Flatten.Line) {
      let [dist, shortest_segment] = Flatten.Distance.segment2line(this, shape);
      return [dist, shortest_segment];
    }
    if (shape instanceof Flatten.Segment) {
      let [dist, shortest_segment] = Flatten.Distance.segment2segment(this, shape);
      return [dist, shortest_segment];
    }
    if (shape instanceof Flatten.Arc) {
      let [dist, shortest_segment] = Flatten.Distance.segment2arc(this, shape);
      return [dist, shortest_segment];
    }
    if (shape instanceof Flatten.Polygon) {
      let [dist, shortest_segment] = Flatten.Distance.shape2polygon(this, shape);
      return [dist, shortest_segment];
    }
    if (shape instanceof Flatten.PlanarSet) {
      let [dist, shortest_segment] = Flatten.Distance.shape2planarSet(this, shape);
      return [dist, shortest_segment];
    }
    if (shape instanceof Flatten.Multiline) {
      return Flatten.Distance.shape2multiline(this, shape);
    }
  }
  /**
   * Returns unit vector in the direction from start to end
   * @returns {Vector}
   */
  tangentInStart() {
    let vec = new Flatten.Vector(this.start, this.end);
    return vec.normalize();
  }
  /**
   * Return unit vector in the direction from end to start
   * @returns {Vector}
   */
  tangentInEnd() {
    let vec = new Flatten.Vector(this.end, this.start);
    return vec.normalize();
  }
  /**
   * Returns new segment with swapped start and end points
   * @returns {Segment}
   */
  reverse() {
    return new Segment(this.end, this.start);
  }
  /**
   * When point belongs to segment, return array of two segments split by given point,
   * if point is inside segment. Returns clone of this segment if query point is incident
   * to start or end point of the segment. Returns empty array if point does not belong to segment
   * @param {Point} pt Query point
   * @returns {Segment[]}
   */
  split(pt) {
    if (this.start.equalTo(pt))
      return [null, this.clone()];
    if (this.end.equalTo(pt))
      return [this.clone(), null];
    return [
      new Flatten.Segment(this.start, pt),
      new Flatten.Segment(pt, this.end)
    ];
  }
  /**
   * Return middle point of the segment
   * @returns {Point}
   */
  middle() {
    return new Flatten.Point((this.start.x + this.end.x) / 2, (this.start.y + this.end.y) / 2);
  }
  /**
   * Get point at given length
   * @param {number} length - The length along the segment
   * @returns {Point}
   */
  pointAtLength(length) {
    if (length > this.length || length < 0) return null;
    if (length == 0) return this.start;
    if (length == this.length) return this.end;
    let factor = length / this.length;
    return new Flatten.Point(
      (this.end.x - this.start.x) * factor + this.start.x,
      (this.end.y - this.start.y) * factor + this.start.y
    );
  }
  distanceToPoint(pt) {
    let [dist, ...rest] = Flatten.Distance.point2segment(pt, this);
    return dist;
  }
  definiteIntegral(ymin = 0) {
    let dx = this.end.x - this.start.x;
    let dy1 = this.start.y - ymin;
    let dy2 = this.end.y - ymin;
    return dx * (dy1 + dy2) / 2;
  }
  /**
   * Return new segment transformed using affine transformation matrix
   * @param {Matrix} matrix - affine transformation matrix
   * @returns {Segment} - transformed segment
   */
  transform(matrix2 = new Flatten.Matrix()) {
    return new Segment(this.ps.transform(matrix2), this.pe.transform(matrix2));
  }
  /**
   * Returns true if segment start is equal to segment end up to DP_TOL
   * @returns {boolean}
   */
  isZeroLength() {
    return this.ps.equalTo(this.pe);
  }
  /**
   * Sort given array of points from segment start to end, assuming all points lay on the segment
   * @param {Point[]} - array of points
   * @returns {Point[]} new array sorted
   */
  sortPoints(pts) {
    let line2 = new Flatten.Line(this.start, this.end);
    return line2.sortPoints(pts);
  }
  get name() {
    return "segment";
  }
  /**
   * Return string to draw segment in svg
   * @param {Object} attrs - an object with attributes for svg path element,
   * like "stroke", "strokeWidth" <br/>
   * Defaults are stroke:"black", strokeWidth:"1"
   * @returns {string}
   */
  svg(attrs = {}) {
    return `
<line x1="${this.start.x}" y1="${this.start.y}" x2="${this.end.x}" y2="${this.end.y}" ${convertToString(attrs)} />`;
  }
};
Flatten.Segment = Segment$1;
var segment = (...args) => new Flatten.Segment(...args);
Flatten.segment = segment;
var { vector } = Flatten;
var Line$1 = class Line extends Shape {
  /**
   * Line may be constructed by point and normal vector or by two points that a line passes through
   * @param {Point} pt - point that a line passes through
   * @param {Vector|Point} norm - normal vector to a line or second point a line passes through
   */
  constructor(...args) {
    super();
    this.pt = new Flatten.Point();
    this.norm = new Flatten.Vector(0, 1);
    if (args.length === 0) {
      return;
    }
    if (args.length === 1 && args[0] instanceof Object && args[0].name === "line") {
      let { pt, norm } = args[0];
      this.pt = new Flatten.Point(pt);
      this.norm = new Flatten.Vector(norm);
      return;
    }
    if (args.length === 2) {
      let a1 = args[0];
      let a2 = args[1];
      if (a1 instanceof Flatten.Point && a2 instanceof Flatten.Point) {
        this.pt = a1;
        this.norm = Line.points2norm(a1, a2);
        if (this.norm.dot(vector(this.pt.x, this.pt.y)) >= 0) {
          this.norm.invert();
        }
        return;
      }
      if (a1 instanceof Flatten.Point && a2 instanceof Flatten.Vector) {
        if (Flatten.Utils.EQ_0(a2.x) && Flatten.Utils.EQ_0(a2.y)) {
          throw Errors.ILLEGAL_PARAMETERS;
        }
        this.pt = a1.clone();
        this.norm = a2.clone();
        this.norm = this.norm.normalize();
        if (this.norm.dot(vector(this.pt.x, this.pt.y)) >= 0) {
          this.norm.invert();
        }
        return;
      }
      if (a1 instanceof Flatten.Vector && a2 instanceof Flatten.Point) {
        if (Flatten.Utils.EQ_0(a1.x) && Flatten.Utils.EQ_0(a1.y)) {
          throw Errors.ILLEGAL_PARAMETERS;
        }
        this.pt = a2.clone();
        this.norm = a1.clone();
        this.norm = this.norm.normalize();
        if (this.norm.dot(vector(this.pt.x, this.pt.y)) >= 0) {
          this.norm.invert();
        }
        return;
      }
    }
    throw Errors.ILLEGAL_PARAMETERS;
  }
  /**
   * Return new cloned instance of line
   * @returns {Line}
   */
  clone() {
    return new Flatten.Line(this.pt, this.norm);
  }
  /* The following methods need for implementation of Edge interface
  /**
   * Line has no start point
   * @returns {undefined}
   */
  get start() {
    return void 0;
  }
  /**
   * Line has no end point
   */
  get end() {
    return void 0;
  }
  /**
   * Return positive infinity number as length
   * @returns {number}
   */
  get length() {
    return Number.POSITIVE_INFINITY;
  }
  /**
   * Returns infinite box
   * @returns {Box}
   */
  get box() {
    return new Flatten.Box(
      Number.NEGATIVE_INFINITY,
      Number.NEGATIVE_INFINITY,
      Number.POSITIVE_INFINITY,
      Number.POSITIVE_INFINITY
    );
  }
  /**
   * Middle point is undefined
   * @returns {undefined}
   */
  get middle() {
    return void 0;
  }
  /**
   * Slope of the line - angle in radians between line and axe x from 0 to 2PI
   * @returns {number} - slope of the line
   */
  get slope() {
    let vec = new Flatten.Vector(this.norm.y, -this.norm.x);
    return vec.slope;
  }
  /**
   * Get coefficients [A,B,C] of a standard line equation in the form Ax + By = C
   * @code [A, B, C] = line.standard
   * @returns {number[]} - array of coefficients
   */
  get standard() {
    let A = this.norm.x;
    let B = this.norm.y;
    let C = this.norm.dot(vector(this.pt.x, this.pt.y));
    return [A, B, C];
  }
  /**
   * Return true if parallel or incident to other line
   * @param {Line} other_line - line to check
   * @returns {boolean}
   */
  parallelTo(other_line) {
    return Flatten.Utils.EQ_0(this.norm.cross(other_line.norm));
  }
  /**
   * Returns true if incident to other line
   * @param {Line} other_line - line to check
   * @returns {boolean}
   */
  incidentTo(other_line) {
    return this.parallelTo(other_line) && this.pt.on(other_line);
  }
  /**
   * Returns true if point belongs to line
   * @param {Point} pt Query point
   * @returns {boolean}
   */
  contains(pt) {
    if (this.pt.equalTo(pt)) {
      return true;
    }
    let vec = new Flatten.Vector(this.pt, pt);
    return Flatten.Utils.EQ_0(this.norm.dot(vec));
  }
  /**
   * Return coordinate of the point that lies on the line in the transformed
   * coordinate system where center is the projection of the point(0,0) to
   * the line and axe y is collinear to the normal vector. <br/>
   * This method assumes that point lies on the line and does not check it
   * @param {Point} pt - point on a line
   * @returns {number}
   */
  coord(pt) {
    return vector(pt.x, pt.y).cross(this.norm);
  }
  /**
   * Returns array of intersection points
   * @param {Shape} shape - shape to intersect with
   * @returns {Point[]}
   */
  intersect(shape) {
    if (shape instanceof Flatten.Point) {
      return this.contains(shape) ? [shape] : [];
    }
    if (shape instanceof Flatten.Line) {
      return intersectLine2Line(this, shape);
    }
    if (shape instanceof Flatten.Ray) {
      return intersectRay2Line(shape, this);
    }
    if (shape instanceof Flatten.Circle) {
      return intersectLine2Circle(this, shape);
    }
    if (shape instanceof Flatten.Box) {
      return intersectLine2Box(this, shape);
    }
    if (shape instanceof Flatten.Segment) {
      return intersectSegment2Line(shape, this);
    }
    if (shape instanceof Flatten.Arc) {
      return intersectLine2Arc(this, shape);
    }
    if (shape instanceof Flatten.Polygon) {
      return intersectLine2Polygon(this, shape);
    }
    if (shape instanceof Flatten.Multiline) {
      return intersectShape2Multiline(this, shape);
    }
  }
  /**
   * Calculate distance and shortest segment from line to shape and returns array [distance, shortest_segment]
   * @param {Shape} shape Shape of the one of the types Point, Circle, Segment, Arc, Polygon
   * @returns {[number, Segment]}
   */
  distanceTo(shape) {
    if (shape instanceof Flatten.Point) {
      let [distance3, shortest_segment] = Flatten.Distance.point2line(shape, this);
      shortest_segment = shortest_segment.reverse();
      return [distance3, shortest_segment];
    }
    if (shape instanceof Flatten.Circle) {
      let [distance3, shortest_segment] = Flatten.Distance.circle2line(shape, this);
      shortest_segment = shortest_segment.reverse();
      return [distance3, shortest_segment];
    }
    if (shape instanceof Flatten.Segment) {
      let [distance3, shortest_segment] = Flatten.Distance.segment2line(shape, this);
      return [distance3, shortest_segment.reverse()];
    }
    if (shape instanceof Flatten.Arc) {
      let [distance3, shortest_segment] = Flatten.Distance.arc2line(shape, this);
      return [distance3, shortest_segment.reverse()];
    }
    if (shape instanceof Flatten.Polygon) {
      let [distance3, shortest_segment] = Flatten.Distance.shape2polygon(this, shape);
      return [distance3, shortest_segment];
    }
  }
  /**
   * Split line with a point or array of points and return array of shapes
   * Assumed (but not checked) that all points lay on the line
   * @param {Point | Point[]} pt
   * @returns {MultilineShapes}
   */
  split(pt) {
    if (pt instanceof Flatten.Point) {
      return [new Flatten.Ray(pt, this.norm), new Flatten.Ray(pt, this.norm)];
    } else {
      let multiline2 = new Flatten.Multiline([this]);
      let sorted_points = this.sortPoints(pt);
      multiline2.split(sorted_points);
      return multiline2.toShapes();
    }
  }
  /**
   * Return new line rotated by angle
   * @param {number} angle - angle in radians
   * @param {Point} center - center of rotation
   */
  rotate(angle, center = new Flatten.Point()) {
    return new Flatten.Line(
      this.pt.rotate(angle, center),
      this.norm.rotate(angle)
    );
  }
  /**
   * Return new line transformed by affine transformation matrix
   * @param {Matrix} m - affine transformation matrix (a,b,c,d,tx,ty)
   * @returns {Line}
   */
  transform(m) {
    return new Flatten.Line(
      this.pt.transform(m),
      this.norm.clone()
    );
  }
  /**
   * Sort given array of points that lay on a line with respect to coordinate on a line
   * The method assumes that points lay on the line and does not check this
   * @param {Point[]} pts - array of points
   * @returns {Point[]} new array sorted
   */
  sortPoints(pts) {
    return pts.slice().sort((pt1, pt2) => {
      if (this.coord(pt1) < this.coord(pt2)) {
        return -1;
      }
      if (this.coord(pt1) > this.coord(pt2)) {
        return 1;
      }
      return 0;
    });
  }
  get name() {
    return "line";
  }
  /**
   * Return string to draw svg segment representing line inside given box
   * @param {Box} box Box representing drawing area
   * @param {Object} attrs - an object with attributes of svg circle element
   */
  svg(box2, attrs = {}) {
    let ip = intersectLine2Box(this, box2);
    if (ip.length === 0)
      return "";
    let ps = ip[0];
    let pe = ip.length === 2 ? ip[1] : ip.find((pt) => !pt.equalTo(ps));
    if (pe === void 0) pe = ps;
    let segment2 = new Flatten.Segment(ps, pe);
    return segment2.svg(attrs);
  }
  static points2norm(pt1, pt2) {
    if (pt1.equalTo(pt2)) {
      throw Errors.ILLEGAL_PARAMETERS;
    }
    let vec = new Flatten.Vector(pt1, pt2);
    let unit = vec.normalize();
    return unit.rotate90CCW();
  }
};
Flatten.Line = Line$1;
var line = (...args) => new Flatten.Line(...args);
Flatten.line = line;
var Circle$1 = class Circle extends Shape {
  /**
   * Class private property
   * @type {string}
   */
  /**
   *
   * @param {Point} pc - circle center point
   * @param {number} r - circle radius
   */
  constructor(...args) {
    super();
    this.pc = new Flatten.Point();
    this.r = 1;
    if (args.length === 1 && args[0] instanceof Object && args[0].name === "circle") {
      let { pc, r } = args[0];
      this.pc = new Flatten.Point(pc);
      this.r = r;
    } else {
      let [pc, r] = [...args];
      if (pc && pc instanceof Flatten.Point) this.pc = pc.clone();
      if (r !== void 0) this.r = r;
    }
  }
  /**
   * Return new cloned instance of circle
   * @returns {Circle}
   */
  clone() {
    return new Flatten.Circle(this.pc.clone(), this.r);
  }
  /**
   * Circle center
   * @returns {Point}
   */
  get center() {
    return this.pc;
  }
  /**
   * Circle bounding box
   * @returns {Box}
   */
  get box() {
    return new Flatten.Box(
      this.pc.x - this.r,
      this.pc.y - this.r,
      this.pc.x + this.r,
      this.pc.y + this.r
    );
  }
  /**
   * Return true if circle contains shape: no point of shape lies outside of the circle
   * @param {Shape} shape - test shape
   * @returns {boolean}
   */
  contains(shape) {
    if (shape instanceof Flatten.Point) {
      return Flatten.Utils.LE(shape.distanceTo(this.center)[0], this.r);
    }
    if (shape instanceof Flatten.Segment) {
      return Flatten.Utils.LE(shape.start.distanceTo(this.center)[0], this.r) && Flatten.Utils.LE(shape.end.distanceTo(this.center)[0], this.r);
    }
    if (shape instanceof Flatten.Arc) {
      return this.intersect(shape).length === 0 && Flatten.Utils.LE(shape.start.distanceTo(this.center)[0], this.r) && Flatten.Utils.LE(shape.end.distanceTo(this.center)[0], this.r);
    }
    if (shape instanceof Flatten.Circle) {
      return this.intersect(shape).length === 0 && Flatten.Utils.LE(shape.r, this.r) && Flatten.Utils.LE(shape.center.distanceTo(this.center)[0], this.r);
    }
  }
  /**
   * Transform circle to closed arc
   * @param {boolean} counterclockwise
   * @returns {Arc}
   */
  toArc(counterclockwise = true) {
    return new Flatten.Arc(this.center, this.r, Math.PI, -Math.PI, counterclockwise);
  }
  /**
   * Method scale is supported only for uniform scaling of the circle with (0,0) center
   * @param {number} sx
   * @param {number} sy
   * @returns {Circle}
   */
  scale(sx, sy) {
    if (sx !== sy)
      throw Errors.OPERATION_IS_NOT_SUPPORTED;
    if (!(this.pc.x === 0 && this.pc.y === 0))
      throw Errors.OPERATION_IS_NOT_SUPPORTED;
    return new Flatten.Circle(this.pc, this.r * sx);
  }
  /**
   * Return new circle transformed using affine transformation matrix
   * @param {Matrix} matrix - affine transformation matrix
   * @returns {Circle}
   */
  transform(matrix2 = new Flatten.Matrix()) {
    return new Flatten.Circle(this.pc.transform(matrix2), this.r);
  }
  /**
   * Returns array of intersection points between circle and other shape
   * @param {Shape} shape Shape of the one of supported types
   * @returns {Point[]}
   */
  intersect(shape) {
    if (shape instanceof Flatten.Point) {
      return this.contains(shape) ? [shape] : [];
    }
    if (shape instanceof Flatten.Line) {
      return intersectLine2Circle(shape, this);
    }
    if (shape instanceof Flatten.Ray) {
      return intersectRay2Circle(shape, this);
    }
    if (shape instanceof Flatten.Segment) {
      return intersectSegment2Circle(shape, this);
    }
    if (shape instanceof Flatten.Circle) {
      return intersectCircle2Circle(shape, this);
    }
    if (shape instanceof Flatten.Box) {
      return intersectCircle2Box(this, shape);
    }
    if (shape instanceof Flatten.Arc) {
      return intersectArc2Circle(shape, this);
    }
    if (shape instanceof Flatten.Polygon) {
      return intersectCircle2Polygon(this, shape);
    }
    if (shape instanceof Flatten.Multiline) {
      return intersectShape2Multiline(this, shape);
    }
  }
  /**
       * Calculate distance and shortest segment from circle to shape and return array [distance, shortest segment]
       * @param {Shape} shape Shape of the one of supported types Point, Line, Circle, Segment, Arc, Polygon or Planar Set
       * @returns {number} distance from circle to shape
       * @returns {Segment} shortest segment between circle and shape (started at circle, ended at shape)
  
       */
  distanceTo(shape) {
    if (shape instanceof Flatten.Point) {
      let [distance3, shortest_segment] = Flatten.Distance.point2circle(shape, this);
      shortest_segment = shortest_segment.reverse();
      return [distance3, shortest_segment];
    }
    if (shape instanceof Flatten.Circle) {
      let [distance3, shortest_segment] = Flatten.Distance.circle2circle(this, shape);
      return [distance3, shortest_segment];
    }
    if (shape instanceof Flatten.Line) {
      let [distance3, shortest_segment] = Flatten.Distance.circle2line(this, shape);
      return [distance3, shortest_segment];
    }
    if (shape instanceof Flatten.Segment) {
      let [distance3, shortest_segment] = Flatten.Distance.segment2circle(shape, this);
      shortest_segment = shortest_segment.reverse();
      return [distance3, shortest_segment];
    }
    if (shape instanceof Flatten.Arc) {
      let [distance3, shortest_segment] = Flatten.Distance.arc2circle(shape, this);
      shortest_segment = shortest_segment.reverse();
      return [distance3, shortest_segment];
    }
    if (shape instanceof Flatten.Polygon) {
      let [distance3, shortest_segment] = Flatten.Distance.shape2polygon(this, shape);
      return [distance3, shortest_segment];
    }
    if (shape instanceof Flatten.PlanarSet) {
      let [dist, shortest_segment] = Flatten.Distance.shape2planarSet(this, shape);
      return [dist, shortest_segment];
    }
    if (shape instanceof Flatten.Multiline) {
      let [dist, shortest_segment] = Flatten.Distance.shape2multiline(this, shape);
      return [dist, shortest_segment];
    }
  }
  get name() {
    return "circle";
  }
  /**
   * Return string to draw circle in svg
   * @param {Object} attrs - an object with attributes of svg circle element
   * @returns {string}
   */
  svg(attrs = {}) {
    return `
<circle cx="${this.pc.x}" cy="${this.pc.y}" r="${this.r}"
                ${convertToString({ fill: "none", ...attrs })} />`;
  }
};
Flatten.Circle = Circle$1;
var circle = (...args) => new Flatten.Circle(...args);
Flatten.circle = circle;
var Arc = class extends Shape {
  /**
   *
   * @param {Point} pc - arc center
   * @param {number} r - arc radius
   * @param {number} startAngle - start angle in radians from 0 to 2*PI
   * @param {number} endAngle - end angle in radians from 0 to 2*PI
   * @param {boolean} counterClockwise - arc direction, true - clockwise, false - counterclockwise
   */
  constructor(...args) {
    super();
    this.pc = new Flatten.Point();
    this.r = 1;
    this.startAngle = 0;
    this.endAngle = 2 * Math.PI;
    this.counterClockwise = true;
    if (args.length === 0)
      return;
    if (args.length === 1 && args[0] instanceof Object && args[0].name === "arc") {
      let { pc, r, startAngle, endAngle, counterClockwise } = args[0];
      this.pc = new Flatten.Point(pc.x, pc.y);
      this.r = r;
      this.startAngle = startAngle;
      this.endAngle = endAngle;
      this.counterClockwise = counterClockwise;
    } else {
      let [pc, r, startAngle, endAngle, counterClockwise] = [...args];
      if (pc && pc instanceof Flatten.Point) this.pc = pc.clone();
      if (r !== void 0) this.r = r;
      if (startAngle !== void 0) this.startAngle = startAngle;
      if (endAngle !== void 0) this.endAngle = endAngle;
      if (counterClockwise !== void 0) this.counterClockwise = counterClockwise;
    }
  }
  /**
   * Return new cloned instance of arc
   * @returns {Arc}
   */
  clone() {
    return new Flatten.Arc(this.pc.clone(), this.r, this.startAngle, this.endAngle, this.counterClockwise);
  }
  /**
   * Get sweep angle in radians. Sweep angle is non-negative number from 0 to 2*PI
   * @returns {number}
   */
  get sweep() {
    let startAngle = this.startAngle;
    let endAngle = this.endAngle;
    if (Flatten.Utils.EQ(Math.abs(startAngle - endAngle), Flatten.PIx2)) {
      return Flatten.PIx2;
    }
    if (Math.abs(startAngle) > Flatten.PIx2) {
      startAngle -= Math.trunc(startAngle / Flatten.PIx2) * Flatten.PIx2;
    }
    if (startAngle < 0) {
      startAngle += Flatten.PIx2;
    }
    if (Math.abs(endAngle) > Flatten.PIx2) {
      endAngle -= Math.trunc(endAngle / Flatten.PIx2) * Flatten.PIx2;
    }
    if (endAngle < 0) {
      endAngle += Flatten.PIx2;
    }
    let sweep = this.counterClockwise ? endAngle - startAngle : startAngle - endAngle;
    if (sweep < 0) {
      sweep += Flatten.PIx2;
    }
    return sweep;
  }
  /**
   * Get start point of arc
   * @returns {Point}
   */
  get start() {
    let p0 = new Flatten.Point(this.pc.x + this.r, this.pc.y);
    return p0.rotate(this.startAngle, this.pc);
  }
  /**
   * Get end point of arc
   * @returns {Point}
   */
  get end() {
    let p0 = new Flatten.Point(this.pc.x + this.r, this.pc.y);
    return p0.rotate(this.endAngle, this.pc);
  }
  /**
   * Get center of arc
   * @returns {Point}
   */
  get center() {
    return this.pc.clone();
  }
  get vertices() {
    return [this.start.clone(), this.end.clone()];
  }
  /**
   * Get arc length
   * @returns {number}
   */
  get length() {
    return Math.abs(this.sweep * this.r);
  }
  /**
   * Get bounding box of the arc
   * @returns {Box}
   */
  get box() {
    let func_arcs = this.breakToFunctional();
    let box2 = func_arcs.reduce((acc, arc2) => acc.merge(arc2.start.box), new Flatten.Box());
    box2 = box2.merge(this.end.box);
    return box2;
  }
  /**
   * Returns true if arc contains point, false otherwise
   * @param {Point} pt - point to test
   * @returns {boolean}
   */
  contains(pt) {
    if (!Flatten.Utils.EQ(this.pc.distanceTo(pt)[0], this.r))
      return false;
    if (pt.equalTo(this.start))
      return true;
    let angle = new Flatten.Vector(this.pc, pt).slope;
    let test_arc = new Flatten.Arc(this.pc, this.r, this.startAngle, angle, this.counterClockwise);
    return Flatten.Utils.LE(test_arc.length, this.length);
  }
  /**
   * When given point belongs to arc, return array of two arcs split by this point. If points is incident
   * to start or end point of the arc, return clone of the arc. If point does not belong to the arcs, return
   * empty array.
   * @param {Point} pt Query point
   * @returns {Arc[]}
   */
  split(pt) {
    if (this.start.equalTo(pt))
      return [null, this.clone()];
    if (this.end.equalTo(pt))
      return [this.clone(), null];
    let angle = new Flatten.Vector(this.pc, pt).slope;
    return [
      new Flatten.Arc(this.pc, this.r, this.startAngle, angle, this.counterClockwise),
      new Flatten.Arc(this.pc, this.r, angle, this.endAngle, this.counterClockwise)
    ];
  }
  /**
   * Return middle point of the arc
   * @returns {Point}
   */
  middle() {
    let endAngle = this.counterClockwise ? this.startAngle + this.sweep / 2 : this.startAngle - this.sweep / 2;
    let arc2 = new Flatten.Arc(this.pc, this.r, this.startAngle, endAngle, this.counterClockwise);
    return arc2.end;
  }
  /**
   * Get point at given length
   * @param {number} length - The length along the arc
   * @returns {Point}
   */
  pointAtLength(length) {
    if (length > this.length || length < 0) return null;
    if (length === 0) return this.start;
    if (length === this.length) return this.end;
    let factor = length / this.length;
    let endAngle = this.counterClockwise ? this.startAngle + this.sweep * factor : this.startAngle - this.sweep * factor;
    let arc2 = new Flatten.Arc(this.pc, this.r, this.startAngle, endAngle, this.counterClockwise);
    return arc2.end;
  }
  /**
   * Returns chord height ("sagitta") of the arc
   * @returns {number}
   */
  chordHeight() {
    return (1 - Math.cos(Math.abs(this.sweep / 2))) * this.r;
  }
  /**
   * Returns array of intersection points between arc and other shape
   * @param {Shape} shape Shape of the one of supported types <br/>
   * @returns {Point[]}
   */
  intersect(shape) {
    if (shape instanceof Flatten.Point) {
      return this.contains(shape) ? [shape] : [];
    }
    if (shape instanceof Flatten.Line) {
      return intersectLine2Arc(shape, this);
    }
    if (shape instanceof Flatten.Ray) {
      return intersectRay2Arc(shape, this);
    }
    if (shape instanceof Flatten.Circle) {
      return intersectArc2Circle(this, shape);
    }
    if (shape instanceof Flatten.Segment) {
      return intersectSegment2Arc(shape, this);
    }
    if (shape instanceof Flatten.Box) {
      return intersectArc2Box(this, shape);
    }
    if (shape instanceof Flatten.Arc) {
      return intersectArc2Arc(this, shape);
    }
    if (shape instanceof Flatten.Polygon) {
      return intersectArc2Polygon(this, shape);
    }
    if (shape instanceof Flatten.Multiline) {
      return intersectShape2Multiline(this, shape);
    }
  }
  /**
       * Calculate distance and shortest segment from arc to shape and return array [distance, shortest segment]
       * @param {Shape} shape Shape of the one of supported types Point, Line, Circle, Segment, Arc, Polygon or Planar Set
       * @returns {number} distance from arc to shape
       * @returns {Segment} shortest segment between arc and shape (started at arc, ended at shape)
  
       */
  distanceTo(shape) {
    if (shape instanceof Flatten.Point) {
      let [dist, shortest_segment] = Flatten.Distance.point2arc(shape, this);
      shortest_segment = shortest_segment.reverse();
      return [dist, shortest_segment];
    }
    if (shape instanceof Flatten.Circle) {
      let [dist, shortest_segment] = Flatten.Distance.arc2circle(this, shape);
      return [dist, shortest_segment];
    }
    if (shape instanceof Flatten.Line) {
      let [dist, shortest_segment] = Flatten.Distance.arc2line(this, shape);
      return [dist, shortest_segment];
    }
    if (shape instanceof Flatten.Segment) {
      let [dist, shortest_segment] = Flatten.Distance.segment2arc(shape, this);
      shortest_segment = shortest_segment.reverse();
      return [dist, shortest_segment];
    }
    if (shape instanceof Flatten.Arc) {
      let [dist, shortest_segment] = Flatten.Distance.arc2arc(this, shape);
      return [dist, shortest_segment];
    }
    if (shape instanceof Flatten.Polygon) {
      let [dist, shortest_segment] = Flatten.Distance.shape2polygon(this, shape);
      return [dist, shortest_segment];
    }
    if (shape instanceof Flatten.PlanarSet) {
      let [dist, shortest_segment] = Flatten.Distance.shape2planarSet(this, shape);
      return [dist, shortest_segment];
    }
    if (shape instanceof Flatten.Multiline) {
      return Flatten.Distance.shape2multiline(this, shape);
    }
  }
  /**
   * Breaks arc in extreme point 0, pi/2, pi, 3*pi/2 and returns array of sub-arcs
   * @returns {Arc[]}
   */
  breakToFunctional() {
    let func_arcs_array = [];
    let angles = [0, Math.PI / 2, Math.PI, 3 * Math.PI / 2];
    let startAngle = this.startAngle;
    let endAngle = this.endAngle;
    if (Flatten.Utils.EQ(Math.abs(startAngle - endAngle), Flatten.PIx2)) {
      endAngle = startAngle;
    }
    if (Math.abs(startAngle) > Flatten.PIx2) {
      startAngle -= Math.trunc(startAngle / Flatten.PIx2) * Flatten.PIx2;
    }
    if (startAngle < 0) {
      startAngle += Flatten.PIx2;
    }
    if (Math.abs(endAngle) > Flatten.PIx2) {
      endAngle -= Math.trunc(endAngle / Flatten.PIx2) * Flatten.PIx2;
    }
    if (endAngle < 0) {
      endAngle += Flatten.PIx2;
    }
    let prev = startAngle;
    let next;
    let firstj;
    let d;
    if (this.counterClockwise) {
      firstj = Math.ceil(startAngle / (Math.PI / 2)) % 4;
      d = 1;
    } else {
      firstj = Math.floor(startAngle / (Math.PI / 2)) % 4;
      d = -1;
    }
    for (let i = 0, j = firstj; i < 4; i++, j = (j + d + 4) % 4) {
      next = angles[j];
      if (next === prev) {
        continue;
      }
      let incrementalSweep = this.counterClockwise ? next - startAngle : startAngle - next;
      if (incrementalSweep < 0) {
        incrementalSweep += Flatten.PIx2;
      }
      if (incrementalSweep > this.sweep) {
        break;
      }
      func_arcs_array.push(new Flatten.Arc(this.pc, this.r, prev, next, this.counterClockwise));
      prev = next;
    }
    if (func_arcs_array.length === 0) {
      func_arcs_array.push(this);
      return func_arcs_array;
    }
    next = endAngle;
    if (prev !== next) {
      func_arcs_array.push(new Flatten.Arc(this.pc, this.r, prev, next, this.counterClockwise));
    }
    return func_arcs_array;
  }
  /**
   * Return tangent unit vector in the start point in the direction from start to end
   * @returns {Vector}
   */
  tangentInStart() {
    let vec = new Flatten.Vector(this.pc, this.start);
    let angle = this.counterClockwise ? Math.PI / 2 : -Math.PI / 2;
    return vec.rotate(angle).normalize();
  }
  /**
   * Return tangent unit vector in the end point in the direction from end to start
   * @returns {Vector}
   */
  tangentInEnd() {
    let vec = new Flatten.Vector(this.pc, this.end);
    let angle = this.counterClockwise ? -Math.PI / 2 : Math.PI / 2;
    return vec.rotate(angle).normalize();
  }
  /**
   * Returns new arc with swapped start and end angles and reversed direction
   * @returns {Arc}
   */
  reverse() {
    return new Flatten.Arc(this.pc, this.r, this.endAngle, this.startAngle, !this.counterClockwise);
  }
  /**
   * Return new arc transformed using affine transformation matrix <br/>
   * @param {Matrix} matrix - affine transformation matrix
   * @returns {Arc}
   */
  transform(matrix2 = new Flatten.Matrix()) {
    let newStart = this.start.transform(matrix2);
    let newEnd = this.end.transform(matrix2);
    let newCenter = this.pc.transform(matrix2);
    let newDirection = this.counterClockwise;
    if (matrix2.a * matrix2.d < 0) {
      newDirection = !newDirection;
    }
    return Flatten.Arc.arcSE(newCenter, newStart, newEnd, newDirection);
  }
  static arcSE(center, start, end, counterClockwise) {
    let { vector: vector2 } = Flatten;
    let startAngle = vector2(center, start).slope;
    let endAngle = vector2(center, end).slope;
    if (Flatten.Utils.EQ(startAngle, endAngle)) {
      endAngle += 2 * Math.PI;
      counterClockwise = true;
    }
    let r = vector2(center, start).length;
    return new Flatten.Arc(center, r, startAngle, endAngle, counterClockwise);
  }
  definiteIntegral(ymin = 0) {
    let f_arcs = this.breakToFunctional();
    let area = f_arcs.reduce((acc, arc2) => acc + arc2.circularSegmentDefiniteIntegral(ymin), 0);
    return area;
  }
  circularSegmentDefiniteIntegral(ymin) {
    let segment2 = new Flatten.Segment(this.start, this.end);
    let areaTrapez = segment2.definiteIntegral(ymin);
    let areaCircularSegment = Flatten.Utils.EQ(this.sweep, Flatten.PIx2) ? 0 : this.circularSegmentArea();
    return this.counterClockwise ? areaTrapez - areaCircularSegment : areaTrapez + areaCircularSegment;
  }
  circularSegmentArea() {
    return 0.5 * this.r * this.r * (this.sweep - Math.sin(this.sweep));
  }
  /**
   * Sort given array of points from arc start to end, assuming all points lay on the arc
   * @param {Point[]} pts array of points
   * @returns {Point[]} new array sorted
   */
  sortPoints(pts) {
    let { vector: vector2 } = Flatten;
    return pts.slice().sort((pt1, pt2) => {
      let slope1 = vector2(this.pc, pt1).slope;
      let slope2 = vector2(this.pc, pt2).slope;
      if (slope1 < slope2) {
        return -1;
      }
      if (slope1 > slope2) {
        return 1;
      }
      return 0;
    });
  }
  get name() {
    return "arc";
  }
  /**
   * Return string to draw arc in svg
   * @param {Object} attrs - an object with attributes of svg path element
   * @returns {string}
   */
  svg(attrs = {}) {
    let largeArcFlag = this.sweep <= Math.PI ? "0" : "1";
    let sweepFlag = this.counterClockwise ? "1" : "0";
    if (Flatten.Utils.EQ(this.sweep, 2 * Math.PI)) {
      let circle2 = new Flatten.Circle(this.pc, this.r);
      return circle2.svg(attrs);
    } else {
      return `
<path d="M${this.start.x},${this.start.y}
                             A${this.r},${this.r} 0 ${largeArcFlag},${sweepFlag} ${this.end.x},${this.end.y}"
                    ${convertToString({ fill: "none", ...attrs })} />`;
    }
  }
};
Flatten.Arc = Arc;
var arc = (...args) => new Flatten.Arc(...args);
Flatten.arc = arc;
var Box = class _Box extends Shape {
  /**
   *
   * @param {number} xmin - minimal x coordinate
   * @param {number} ymin - minimal y coordinate
   * @param {number} xmax - maximal x coordinate
   * @param {number} ymax - maximal y coordinate
   */
  constructor(xmin = void 0, ymin = void 0, xmax = void 0, ymax = void 0) {
    super();
    this.xmin = xmin;
    this.ymin = ymin;
    this.xmax = xmax;
    this.ymax = ymax;
  }
  /**
   * Return new cloned instance of box
   * @returns {Box}
   */
  clone() {
    return new _Box(this.xmin, this.ymin, this.xmax, this.ymax);
  }
  /**
   * Property low need for interval tree interface
   * @returns {Point}
   */
  get low() {
    return new Flatten.Point(this.xmin, this.ymin);
  }
  /**
   * Property high need for interval tree interface
   * @returns {Point}
   */
  get high() {
    return new Flatten.Point(this.xmax, this.ymax);
  }
  /**
   * Property max returns the box itself !
   * @returns {Box}
   */
  get max() {
    return this.clone();
  }
  /**
   * Return center of the box
   * @returns {Point}
   */
  get center() {
    return new Flatten.Point((this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2);
  }
  /**
   * Return the width of the box
   * @returns {number}
   */
  get width() {
    return Math.abs(this.xmax - this.xmin);
  }
  /**
   * Return the height of the box
   * @returns {number}
   */
  get height() {
    return Math.abs(this.ymax - this.ymin);
  }
  /**
   * Return property box like all other shapes
   * @returns {Box}
   */
  get box() {
    return this.clone();
  }
  /**
   * Returns true if not intersected with other box
   * @param {Box} other_box - other box to test
   * @returns {boolean}
   */
  not_intersect(other_box) {
    return this.xmax < other_box.xmin || this.xmin > other_box.xmax || this.ymax < other_box.ymin || this.ymin > other_box.ymax;
  }
  /**
   * Returns true if intersected with other box
   * @param {Box} other_box - Query box
   * @returns {boolean}
   */
  intersect(other_box) {
    return !this.not_intersect(other_box);
  }
  /**
   * Returns new box merged with other box
   * @param {Box} other_box - Other box to merge with
   * @returns {Box}
   */
  merge(other_box) {
    return new _Box(
      this.xmin === void 0 ? other_box.xmin : Math.min(this.xmin, other_box.xmin),
      this.ymin === void 0 ? other_box.ymin : Math.min(this.ymin, other_box.ymin),
      this.xmax === void 0 ? other_box.xmax : Math.max(this.xmax, other_box.xmax),
      this.ymax === void 0 ? other_box.ymax : Math.max(this.ymax, other_box.ymax)
    );
  }
  /**
   * Defines predicate "less than" between two boxes. Need for interval index
   * @param {Box} other_box - other box
   * @returns {boolean} - true if this box less than other box, false otherwise
   */
  less_than(other_box) {
    if (this.low.lessThan(other_box.low))
      return true;
    if (this.low.equalTo(other_box.low) && this.high.lessThan(other_box.high))
      return true;
    return false;
  }
  /**
   * Returns true if this box is equal to other box, false otherwise
   * @param {Box} other_box - query box
   * @returns {boolean}
   */
  equal_to(other_box) {
    return this.low.equalTo(other_box.low) && this.high.equalTo(other_box.high);
  }
  output() {
    return this.clone();
  }
  comparable_less_than(pt1, pt2) {
    return pt1.lessThan(pt2);
  }
  /**
   * Set new values to the box object
   * @param {number} xmin - mininal x coordinate
   * @param {number} ymin - minimal y coordinate
   * @param {number} xmax - maximal x coordinate
   * @param {number} ymax - maximal y coordinate
   */
  set(xmin, ymin, xmax, ymax) {
    this.xmin = xmin;
    this.ymin = ymin;
    this.xmax = xmax;
    this.ymax = ymax;
  }
  /**
   * Return new extended box
   * @param {number} extension - positive number, how much to extend the box
   * @returns {Box}
   */
  extend(extension) {
    if (extension <= 0) return this.clone();
    return new _Box(
      this.xmin - extension,
      this.ymin - extension,
      this.xmax + extension,
      this.ymax + extension
    );
  }
  /**
   * Transform box into array of points from low left corner in counterclockwise
   * @returns {Point[]}
   */
  toPoints() {
    return [
      new Flatten.Point(this.xmin, this.ymin),
      new Flatten.Point(this.xmax, this.ymin),
      new Flatten.Point(this.xmax, this.ymax),
      new Flatten.Point(this.xmin, this.ymax)
    ];
  }
  /**
   * Transform box into array of segments from low left corner in counterclockwise
   * @returns {Segment[]}
   */
  toSegments() {
    let pts = this.toPoints();
    return [
      new Flatten.Segment(pts[0], pts[1]),
      new Flatten.Segment(pts[1], pts[2]),
      new Flatten.Segment(pts[2], pts[3]),
      new Flatten.Segment(pts[3], pts[0])
    ];
  }
  /**
   * Box rotation is not supported
   * Attempt to rotate box throws error
   * @param {number} angle - angle in radians
   * @param {Point} [center=(0,0)] center
   */
  rotate(angle, center = new Flatten.Point()) {
    throw Errors.OPERATION_IS_NOT_SUPPORTED;
  }
  /**
   * Return new box transformed using affine transformation matrix
   * New box is a bounding box of transformed corner points
   * @param {Matrix} m - affine transformation matrix
   * @returns {Box}
   */
  transform(m = new Flatten.Matrix()) {
    const transformed_points = this.toPoints().map((pt) => pt.transform(m));
    return transformed_points.reduce(
      (new_box, pt) => new_box.merge(pt.box),
      new _Box()
    );
  }
  /**
   * Return true if box contains shape: no point of shape lies outside the box
   * @param {AnyShape} shape - test shape
   * @returns {boolean}
   */
  contains(shape) {
    if (shape instanceof Flatten.Point) {
      return shape.x >= this.xmin && shape.x <= this.xmax && shape.y >= this.ymin && shape.y <= this.ymax;
    }
    if (shape instanceof Flatten.Segment) {
      return shape.vertices.every((vertex) => this.contains(vertex));
    }
    if (shape instanceof Flatten.Box) {
      return shape.toSegments().every((segment2) => this.contains(segment2));
    }
    if (shape instanceof Flatten.Circle) {
      return this.contains(shape.box);
    }
    if (shape instanceof Flatten.Arc) {
      return shape.vertices.every((vertex) => this.contains(vertex)) && this.toSegments().every((segment2) => intersectSegment2Arc(segment2, shape).length === 0);
    }
    if (shape instanceof Flatten.Line || shape instanceof Flatten.Ray) {
      return false;
    }
    if (shape instanceof Flatten.Multiline) {
      return shape.toShapes().every((shape2) => this.contains(shape2));
    }
    if (shape instanceof Flatten.Polygon) {
      return this.contains(shape.box);
    }
  }
  /**
   * Calculate distance and shortest segment from box to shape and return as array [distance, shortest segment]
   * @param {Shape} shape Shape of the one of supported types Point, Line, Circle, Segment, Arc, Polygon or Planar Set
   * @returns {number} distance from box to shape
   * @returns {Segment} shortest segment between box and shape (started at box, ended at shape)
   */
  distanceTo(shape) {
    const distanceInfos = this.toSegments().map((segment2) => segment2.distanceTo(shape));
    let shortestDistanceInfo = [
      Number.MAX_SAFE_INTEGER,
      null
    ];
    distanceInfos.forEach((distanceInfo) => {
      if (distanceInfo[0] < shortestDistanceInfo[0]) {
        shortestDistanceInfo = distanceInfo;
      }
    });
    return shortestDistanceInfo;
  }
  get name() {
    return "box";
  }
  /**
   * Return string to draw box in svg
   * @param {Object} attrs - an object with attributes of svg rectangle element
   * @returns {string}
   */
  svg(attrs = {}) {
    const width = this.xmax - this.xmin;
    const height = this.ymax - this.ymin;
    return `
<rect x="${this.xmin}" y="${this.ymin}" width="${width}" height="${height}"
                ${convertToString({ fill: "none", ...attrs })} />`;
  }
};
Flatten.Box = Box;
var box = (...args) => new Flatten.Box(...args);
Flatten.box = box;
var Edge = class {
  /**
   * Construct new instance of edge
   * @param {Shape} shape Shape of type Segment or Arc
   */
  constructor(shape) {
    this.shape = shape;
    this.next = void 0;
    this.prev = void 0;
    this.face = void 0;
    this.arc_length = 0;
    this.bvStart = void 0;
    this.bvEnd = void 0;
    this.bv = void 0;
    this.overlap = void 0;
  }
  /**
   * Get edge start point
   */
  get start() {
    return this.shape.start;
  }
  /**
   * Get edge end point
   */
  get end() {
    return this.shape.end;
  }
  /**
   * Get edge length
   */
  get length() {
    return this.shape.length;
  }
  /**
   * Get bounding box of the edge
   * @returns {Box}
   */
  get box() {
    return this.shape.box;
  }
  get isSegment() {
    return this.shape instanceof Flatten.Segment;
  }
  get isArc() {
    return this.shape instanceof Flatten.Arc;
  }
  get isLine() {
    return this.shape instanceof Flatten.Line;
  }
  get isRay() {
    return this.shape instanceof Flatten.Ray;
  }
  /**
   * Get middle point of the edge
   * @returns {Point}
   */
  middle() {
    return this.shape.middle();
  }
  /**
   * Get point at given length
   * @param {number} length - The length along the edge
   * @returns {Point}
   */
  pointAtLength(length) {
    return this.shape.pointAtLength(length);
  }
  /**
   * Returns true if point belongs to the edge, false otherwise
   * @param {Point} pt - test point
   */
  contains(pt) {
    return this.shape.contains(pt);
  }
  /**
   * Set inclusion flag of the edge with respect to another polygon
   * Inclusion flag is one of Flatten.INSIDE, Flatten.OUTSIDE, Flatten.BOUNDARY
   * @param polygon
   */
  setInclusion(polygon2) {
    if (this.bv !== void 0) return this.bv;
    if (this.shape instanceof Flatten.Line || this.shape instanceof Flatten.Ray) {
      this.bv = Flatten.OUTSIDE;
      return this.bv;
    }
    if (this.bvStart === void 0) {
      this.bvStart = ray_shoot(polygon2, this.start);
    }
    if (this.bvEnd === void 0) {
      this.bvEnd = ray_shoot(polygon2, this.end);
    }
    if (this.bvStart === Flatten.OUTSIDE || this.bvEnd == Flatten.OUTSIDE) {
      this.bv = Flatten.OUTSIDE;
    } else if (this.bvStart === Flatten.INSIDE || this.bvEnd == Flatten.INSIDE) {
      this.bv = Flatten.INSIDE;
    } else {
      let bvMiddle = ray_shoot(polygon2, this.middle());
      this.bv = bvMiddle;
    }
    return this.bv;
  }
  /**
   * Set overlapping between two coincident boundary edges
   * Overlapping flag is one of Flatten.OVERLAP_SAME or Flatten.OVERLAP_OPPOSITE
   * @param edge
   */
  setOverlap(edge) {
    let flag = void 0;
    let shape1 = this.shape;
    let shape2 = edge.shape;
    if (shape1 instanceof Flatten.Segment && shape2 instanceof Flatten.Segment) {
      if (shape1.start.equalTo(shape2.start) && shape1.end.equalTo(shape2.end)) {
        flag = Flatten.OVERLAP_SAME;
      } else if (shape1.start.equalTo(shape2.end) && shape1.end.equalTo(shape2.start)) {
        flag = Flatten.OVERLAP_OPPOSITE;
      }
    } else if (shape1 instanceof Flatten.Arc && shape2 instanceof Flatten.Arc) {
      if (shape1.start.equalTo(shape2.start) && shape1.end.equalTo(shape2.end) && /*shape1.counterClockwise === shape2.counterClockwise &&*/
      shape1.middle().equalTo(shape2.middle())) {
        flag = Flatten.OVERLAP_SAME;
      } else if (shape1.start.equalTo(shape2.end) && shape1.end.equalTo(shape2.start) && /*shape1.counterClockwise !== shape2.counterClockwise &&*/
      shape1.middle().equalTo(shape2.middle())) {
        flag = Flatten.OVERLAP_OPPOSITE;
      }
    } else if (shape1 instanceof Flatten.Segment && shape2 instanceof Flatten.Arc || shape1 instanceof Flatten.Arc && shape2 instanceof Flatten.Segment) {
      if (shape1.start.equalTo(shape2.start) && shape1.end.equalTo(shape2.end) && shape1.middle().equalTo(shape2.middle())) {
        flag = Flatten.OVERLAP_SAME;
      } else if (shape1.start.equalTo(shape2.end) && shape1.end.equalTo(shape2.start) && shape1.middle().equalTo(shape2.middle())) {
        flag = Flatten.OVERLAP_OPPOSITE;
      }
    }
    if (this.overlap === void 0) this.overlap = flag;
    if (edge.overlap === void 0) edge.overlap = flag;
  }
  svg() {
    if (this.shape instanceof Flatten.Segment) {
      return ` L${this.shape.end.x},${this.shape.end.y}`;
    } else if (this.shape instanceof Flatten.Arc) {
      let arc2 = this.shape;
      let largeArcFlag;
      let sweepFlag = arc2.counterClockwise ? "1" : "0";
      if (Flatten.Utils.EQ(arc2.sweep, 2 * Math.PI)) {
        let sign = arc2.counterClockwise ? 1 : -1;
        let halfArc1 = new Flatten.Arc(arc2.pc, arc2.r, arc2.startAngle, arc2.startAngle + sign * Math.PI, arc2.counterClockwise);
        let halfArc2 = new Flatten.Arc(arc2.pc, arc2.r, arc2.startAngle + sign * Math.PI, arc2.endAngle, arc2.counterClockwise);
        largeArcFlag = "0";
        return ` A${halfArc1.r},${halfArc1.r} 0 ${largeArcFlag},${sweepFlag} ${halfArc1.end.x},${halfArc1.end.y}
                    A${halfArc2.r},${halfArc2.r} 0 ${largeArcFlag},${sweepFlag} ${halfArc2.end.x},${halfArc2.end.y}`;
      } else {
        largeArcFlag = arc2.sweep <= Math.PI ? "0" : "1";
        return ` A${arc2.r},${arc2.r} 0 ${largeArcFlag},${sweepFlag} ${arc2.end.x},${arc2.end.y}`;
      }
    }
  }
  toJSON() {
    return this.shape.toJSON();
  }
};
Flatten.Edge = Edge;
var CircularLinkedList = class extends LinkedList {
  constructor(first, last) {
    super(first, last);
    this.setCircularLinks();
  }
  setCircularLinks() {
    if (this.isEmpty()) return;
    this.last.next = this.first;
    this.first.prev = this.last;
  }
  [Symbol.iterator]() {
    let element = void 0;
    return {
      next: () => {
        let value = element ? element : this.first;
        let done = this.first ? element ? element === this.first : false : true;
        element = value ? value.next : void 0;
        return { value, done };
      }
    };
  }
  /**
   * Append new element to the end of the list
   * @param {LinkedListElement} element - new element to be appended
   * @returns {CircularLinkedList}
   */
  append(element) {
    super.append(element);
    this.setCircularLinks();
    return this;
  }
  /**
   * Insert new element to the list after elementBefore
   * @param {LinkedListElement} newElement - new element to be inserted
   * @param {LinkedListElement} elementBefore - element in the list to insert after it
   * @returns {CircularLinkedList}
   */
  insert(newElement, elementBefore) {
    super.insert(newElement, elementBefore);
    this.setCircularLinks();
    return this;
  }
  /**
   * Remove element from the list
   * @param {LinkedListElement} element - element to be removed from the list
   * @returns {CircularLinkedList}
   */
  remove(element) {
    super.remove(element);
    return this;
  }
};
var Face = class _Face extends CircularLinkedList {
  constructor(polygon2, ...args) {
    super();
    this._box = void 0;
    this._orientation = void 0;
    if (args.length === 0) {
      return;
    }
    if (args.length === 1) {
      if (args[0] instanceof Array) {
        let shapes = args[0];
        if (shapes.length === 0)
          return;
        if (shapes.every((shape) => {
          return shape instanceof Flatten.Point;
        })) {
          let segments = _Face.points2segments(shapes);
          this.shapes2face(polygon2.edges, segments);
        } else if (shapes.every((shape) => {
          return shape instanceof Array && shape.length === 2;
        })) {
          let points = shapes.map((shape) => new Flatten.Point(shape[0], shape[1]));
          let segments = _Face.points2segments(points);
          this.shapes2face(polygon2.edges, segments);
        } else if (shapes.every((shape) => {
          return shape instanceof Flatten.Segment || shape instanceof Flatten.Arc;
        })) {
          this.shapes2face(polygon2.edges, shapes);
        } else if (shapes.every((shape) => {
          return shape.name === "segment" || shape.name === "arc";
        })) {
          let flattenShapes = [];
          for (let shape of shapes) {
            let flattenShape;
            if (shape.name === "segment") {
              flattenShape = new Flatten.Segment(shape);
            } else {
              flattenShape = new Flatten.Arc(shape);
            }
            flattenShapes.push(flattenShape);
          }
          this.shapes2face(polygon2.edges, flattenShapes);
        }
      } else if (args[0] instanceof _Face) {
        let face = args[0];
        this.first = face.first;
        this.last = face.last;
        for (let edge of face) {
          polygon2.edges.add(edge);
        }
      } else if (args[0] instanceof Flatten.Circle) {
        this.shapes2face(polygon2.edges, [args[0].toArc(CCW)]);
      } else if (args[0] instanceof Flatten.Box) {
        let box2 = args[0];
        this.shapes2face(polygon2.edges, [
          new Flatten.Segment(new Flatten.Point(box2.xmin, box2.ymin), new Flatten.Point(box2.xmax, box2.ymin)),
          new Flatten.Segment(new Flatten.Point(box2.xmax, box2.ymin), new Flatten.Point(box2.xmax, box2.ymax)),
          new Flatten.Segment(new Flatten.Point(box2.xmax, box2.ymax), new Flatten.Point(box2.xmin, box2.ymax)),
          new Flatten.Segment(new Flatten.Point(box2.xmin, box2.ymax), new Flatten.Point(box2.xmin, box2.ymin))
        ]);
      }
    }
    if (args.length === 2 && args[0] instanceof Flatten.Edge && args[1] instanceof Flatten.Edge) {
      this.first = args[0];
      this.last = args[1];
      this.last.next = this.first;
      this.first.prev = this.last;
      this.setArcLength();
    }
  }
  /**
   * Return array of edges from first to last
   * @returns {PolygonEdge[]}
   */
  get edges() {
    return this.toArray();
  }
  /**
   * Return array of vertices from first to last
   * @returns {Point[]}
   */
  get vertices() {
    return this.edges.map((edge) => edge.shape.start.clone());
  }
  /**
   * Return array of shapes which comprise the face
   * @returns {Array<Segment | Arc>}
   */
  get shapes() {
    return this.edges.map((edge) => edge.shape.clone());
  }
  /**
   * Return bounding box of the face
   * @returns {Box}
   */
  get box() {
    if (this._box === void 0) {
      let box2 = new Flatten.Box();
      for (let edge of this) {
        box2 = box2.merge(edge.box);
      }
      this._box = box2;
    }
    return this._box;
  }
  /**
   * Get all edges length
   * @returns {number}
   */
  get perimeter() {
    return this.last.arc_length + this.last.length;
  }
  /**
   * Get point on face boundary at given length
   * @param {number} length - The length along the face boundary
   * @returns {Point}
   */
  pointAtLength(length) {
    if (length > this.perimeter || length < 0) return null;
    let point2 = null;
    for (let edge of this) {
      if (length >= edge.arc_length && (edge === this.last || length < edge.next.arc_length)) {
        point2 = edge.pointAtLength(length - edge.arc_length);
        break;
      }
    }
    return point2;
  }
  static points2segments(points) {
    let segments = [];
    for (let i = 0; i < points.length; i++) {
      if (points[i].equalTo(points[(i + 1) % points.length]))
        continue;
      segments.push(new Flatten.Segment(points[i], points[(i + 1) % points.length]));
    }
    return segments;
  }
  shapes2face(edges, shapes) {
    for (let shape of shapes) {
      let edge = new Flatten.Edge(shape);
      this.append(edge);
      edges.add(edge);
    }
  }
  /**
   * Append edge after the last edge of the face (and before the first edge). <br/>
   * @param {Edge} edge - Edge to be appended to the linked list
   * @returns {Face}
   */
  append(edge) {
    super.append(edge);
    this.setOneEdgeArcLength(edge);
    edge.face = this;
    return this;
  }
  /**
   * Insert edge newEdge into the linked list after the edge edgeBefore <br/>
   * @param {Edge} newEdge - Edge to be inserted into linked list
   * @param {Edge} edgeBefore - Edge to insert newEdge after it
   * @returns {Face}
   */
  insert(newEdge, edgeBefore) {
    super.insert(newEdge, edgeBefore);
    this.setOneEdgeArcLength(newEdge);
    newEdge.face = this;
    return this;
  }
  /**
   * Remove the given edge from the linked list of the face <br/>
   * @param {Edge} edge - Edge to be removed
   * @returns {Face}
   */
  remove(edge) {
    super.remove(edge);
    this.setArcLength();
    return this;
  }
  /**
   * Merge current edge with the next edge. Given edge will be extended,
   * next edge after it will be removed. The distortion of the polygon
   * is on the responsibility of the user of this method
   * @param {Edge} edge - edge to be extended
   * @returns {Face}
   */
  merge_with_next_edge(edge) {
    edge.shape.end.x = edge.next.shape.end.x;
    edge.shape.end.y = edge.next.shape.end.y;
    this.remove(edge.next);
    return this;
  }
  /**
   * Reverse orientation of the face: first edge become last and vice a verse,
   * all edges starts and ends swapped, direction of arcs inverted. If face was oriented
   * clockwise, it becomes counterclockwise and vice versa
   */
  reverse() {
    let edges = [];
    let edge_tmp = this.last;
    do {
      edge_tmp.shape = edge_tmp.shape.reverse();
      edges.push(edge_tmp);
      edge_tmp = edge_tmp.prev;
    } while (edge_tmp !== this.last);
    this.first = void 0;
    this.last = void 0;
    for (let edge of edges) {
      if (this.first === void 0) {
        edge.prev = edge;
        edge.next = edge;
        this.first = edge;
        this.last = edge;
      } else {
        edge.prev = this.last;
        this.last.next = edge;
        this.last = edge;
        this.last.next = this.first;
        this.first.prev = this.last;
      }
      this.setOneEdgeArcLength(edge);
    }
    if (this._orientation !== void 0) {
      this._orientation = void 0;
      this._orientation = this.orientation();
    }
  }
  /**
   * Set arc_length property for each of the edges in the face.
   * Arc_length of the edge it the arc length from the first edge of the face
   */
  setArcLength() {
    for (let edge of this) {
      this.setOneEdgeArcLength(edge);
      edge.face = this;
    }
  }
  setOneEdgeArcLength(edge) {
    if (edge === this.first) {
      edge.arc_length = 0;
    } else {
      edge.arc_length = edge.prev.arc_length + edge.prev.length;
    }
  }
  /**
   * Returns the absolute value of the area of the face
   * @returns {number}
   */
  area() {
    return Math.abs(this.signedArea());
  }
  /**
   * Returns signed area of the simple face.
   * Face is simple if it has no self intersections that change its orientation.
   * Then the area will be positive if the orientation of the face is clockwise,
   * and negative if orientation is counterclockwise.
   * It may be zero if polygon is degenerated.
   * @returns {number}
   */
  signedArea() {
    let sArea = 0;
    let ymin = this.box.ymin;
    for (let edge of this) {
      sArea += edge.shape.definiteIntegral(ymin);
    }
    return sArea;
  }
  /**
   * Return face orientation: one of Flatten.ORIENTATION.CCW, Flatten.ORIENTATION.CW, Flatten.ORIENTATION.NOT_ORIENTABLE <br/>
   * According to Green theorem the area of a closed curve may be calculated as double integral,
   * and the sign of the integral will be defined by the direction of the curve.
   * When the integral ("signed area") will be negative, direction is counterclockwise,
   * when positive - clockwise and when it is zero, polygon is not orientable.
   * See {@link https://mathinsight.org/greens_theorem_find_area}
   * @returns {number}
   */
  orientation() {
    if (this._orientation === void 0) {
      let area = this.signedArea();
      if (Flatten.Utils.EQ_0(area)) {
        this._orientation = ORIENTATION.NOT_ORIENTABLE;
      } else if (Flatten.Utils.LT(area, 0)) {
        this._orientation = ORIENTATION.CCW;
      } else {
        this._orientation = ORIENTATION.CW;
      }
    }
    return this._orientation;
  }
  /**
   * Returns true if face of the polygon is simple (no self-intersection points found)
   * NOTE: this method is incomplete because it does not exclude touching points.
   * Self intersection test should check if polygon change orientation in the test point.
   * @param {PlanarSet} edges - reference to polygon edges to provide search index
   * @returns {boolean}
   */
  isSimple(edges) {
    let ip = _Face.getSelfIntersections(this, edges, true);
    return ip.length === 0;
  }
  static getSelfIntersections(face, edges, exitOnFirst = false) {
    let int_points = [];
    for (let edge1 of face) {
      let resp = edges.search(edge1.box);
      for (let edge2 of resp) {
        if (edge1 === edge2)
          continue;
        if (edge2.face !== face)
          continue;
        if (edge1.shape instanceof Flatten.Segment && edge2.shape instanceof Flatten.Segment && (edge1.next === edge2 || edge1.prev === edge2))
          continue;
        let ip = edge1.shape.intersect(edge2.shape);
        for (let pt of ip) {
          if (pt.equalTo(edge1.start) && pt.equalTo(edge2.end) && edge2 === edge1.prev)
            continue;
          if (pt.equalTo(edge1.end) && pt.equalTo(edge2.start) && edge2 === edge1.next)
            continue;
          int_points.push(pt);
          if (exitOnFirst)
            break;
        }
        if (int_points.length > 0 && exitOnFirst)
          break;
      }
      if (int_points.length > 0 && exitOnFirst)
        break;
    }
    return int_points;
  }
  /**
   * Returns edge which contains given point
   * @param {Point} pt - test point
   * @returns {Edge}
   */
  findEdgeByPoint(pt) {
    let edgeFound;
    for (let edge of this) {
      if (pt.equalTo(edge.shape.start)) continue;
      if (pt.equalTo(edge.shape.end) || edge.shape.contains(pt)) {
        edgeFound = edge;
        break;
      }
    }
    return edgeFound;
  }
  /**
   * Returns new polygon created from one face
   * @returns {Polygon}
   */
  toPolygon() {
    return new Flatten.Polygon(this.shapes);
  }
  toJSON() {
    return this.edges.map((edge) => edge.toJSON());
  }
  /**
   * Returns string to be assigned to "d" attribute inside defined "path"
   * @returns {string}
   */
  svg() {
    let svgStr = `M${this.first.start.x},${this.first.start.y}`;
    for (let edge of this) {
      svgStr += edge.svg();
    }
    svgStr += ` z`;
    return svgStr;
  }
};
Flatten.Face = Face;
var Ray = class _Ray extends Shape {
  /**
   * Ray may be constructed by setting an <b>origin</b> point and a <b>normal</b> vector, so that any point <b>x</b>
   * on a ray fit an equation: <br />
   *  (<b>x</b> - <b>origin</b>) * <b>vector</b> = 0 <br />
   * Ray defined by constructor is a right semi-infinite line with respect to the normal vector <br/>
   * If normal vector is omitted ray is considered horizontal (normal vector is (0,1)). <br/>
   * Don't be confused: direction of the normal vector is orthogonal to the ray <br/>
   * @param {Point} pt - start point
   * @param {Vector} norm - normal vector
   */
  constructor(...args) {
    super();
    this.pt = new Flatten.Point();
    this.norm = new Flatten.Vector(0, 1);
    if (args.length === 0) {
      return;
    }
    if (args.length >= 1 && args[0] instanceof Flatten.Point) {
      this.pt = args[0].clone();
    }
    if (args.length === 1) {
      return;
    }
    if (args.length === 2 && args[1] instanceof Flatten.Vector) {
      this.norm = args[1].clone();
      return;
    }
    throw Errors.ILLEGAL_PARAMETERS;
  }
  /**
   * Return new cloned instance of ray
   * @returns {Ray}
   */
  clone() {
    return new _Ray(this.pt, this.norm);
  }
  /**
   * Slope of the ray - angle in radians between ray and axe x from 0 to 2PI
   * @returns {number} - slope of the line
   */
  get slope() {
    let vec = new Flatten.Vector(this.norm.y, -this.norm.x);
    return vec.slope;
  }
  /**
   * Returns half-infinite bounding box of the ray
   * @returns {Box} - bounding box
   */
  get box() {
    let slope = this.slope;
    return new Flatten.Box(
      slope > Math.PI / 2 && slope < 3 * Math.PI / 2 ? Number.NEGATIVE_INFINITY : this.pt.x,
      slope >= 0 && slope <= Math.PI ? this.pt.y : Number.NEGATIVE_INFINITY,
      slope >= Math.PI / 2 && slope <= 3 * Math.PI / 2 ? this.pt.x : Number.POSITIVE_INFINITY,
      slope >= Math.PI && slope <= 2 * Math.PI || slope === 0 ? this.pt.y : Number.POSITIVE_INFINITY
    );
  }
  /**
   * Return ray start point
   * @returns {Point} - ray start point
   */
  get start() {
    return this.pt;
  }
  /**
   * Ray has no end point?
   * @returns {undefined}
   */
  get end() {
    return void 0;
  }
  /**
   * Return positive infinity number as length
   * @returns {number}
   */
  get length() {
    return Number.POSITIVE_INFINITY;
  }
  /**
   * Returns true if point belongs to ray
   * @param {Point} pt Query point
   * @returns {boolean}
   */
  contains(pt) {
    if (this.pt.equalTo(pt)) {
      return true;
    }
    let vec = new Flatten.Vector(this.pt, pt);
    return Flatten.Utils.EQ_0(this.norm.dot(vec)) && Flatten.Utils.GE(vec.cross(this.norm), 0);
  }
  /**
   * Return coordinate of the point that lies on the ray in the transformed
   * coordinate system where center is the projection of the point(0,0) to
   * the line containing this ray and axe y is collinear to the normal vector. <br/>
   * This method assumes that point lies on the ray
   * @param {Point} pt - point on a ray
   * @returns {number}
   */
  coord(pt) {
    return vector$1(pt.x, pt.y).cross(this.norm);
  }
  /**
   * Split ray with point and return array of segment and new ray
   * @param {Point} pt
   * @returns [Segment,Ray]
   */
  split(pt) {
    if (!this.contains(pt))
      return [];
    if (this.pt.equalTo(pt)) {
      return [this];
    }
    return [
      new Flatten.Segment(this.pt, pt),
      new Flatten.Ray(pt, this.norm)
    ];
  }
  /**
   * Returns array of intersection points between ray and another shape
   * @param {Shape} shape - Shape to intersect with ray
   * @returns {Point[]} array of intersection points
   */
  intersect(shape) {
    if (shape instanceof Flatten.Point) {
      return this.contains(shape) ? [shape] : [];
    }
    if (shape instanceof Flatten.Segment) {
      return intersectRay2Segment(this, shape);
    }
    if (shape instanceof Flatten.Arc) {
      return intersectRay2Arc(this, shape);
    }
    if (shape instanceof Flatten.Line) {
      return intersectRay2Line(this, shape);
    }
    if (shape instanceof Flatten.Ray) {
      return intersectRay2Ray(this, shape);
    }
    if (shape instanceof Flatten.Circle) {
      return intersectRay2Circle(this, shape);
    }
    if (shape instanceof Flatten.Box) {
      return intersectRay2Box(this, shape);
    }
    if (shape instanceof Flatten.Polygon) {
      return intersectRay2Polygon(this, shape);
    }
    if (shape instanceof Flatten.Multiline) {
      return intersectShape2Multiline(this, shape);
    }
  }
  /**
   * Return new line rotated by angle
   * @param {number} angle - angle in radians
   * @param {Point} center - center of rotation
   */
  rotate(angle, center = new Flatten.Point()) {
    return new Flatten.Ray(
      this.pt.rotate(angle, center),
      this.norm.rotate(angle)
    );
  }
  /**
   * Return new ray transformed by affine transformation matrix
   * @param {Matrix} m - affine transformation matrix (a,b,c,d,tx,ty)
   * @returns {Ray}
   */
  transform(m) {
    return new Flatten.Ray(
      this.pt.transform(m),
      this.norm.clone()
    );
  }
  get name() {
    return "ray";
  }
  /**
   * Return string to draw svg segment representing ray inside given box
   * @param {Box} box Box representing drawing area
   * @param {Object} attrs - an object with attributes of svg segment element
   */
  svg(box2, attrs = {}) {
    let line2 = new Flatten.Line(this.pt, this.norm);
    let ip = intersectLine2Box(line2, box2);
    ip = ip.filter((pt) => this.contains(pt));
    if (ip.length === 0 || ip.length === 2)
      return "";
    let segment2 = new Flatten.Segment(this.pt, ip[0]);
    return segment2.svg(attrs);
  }
};
Flatten.Ray = Ray;
var ray = (...args) => new Flatten.Ray(...args);
Flatten.ray = ray;
var Polygon$1 = class Polygon {
  /**
   * Constructor creates new instance of polygon. With no arguments new polygon is empty.<br/>
   * Constructor accepts as argument array that define loop of shapes
   * or array of arrays in case of multi polygon <br/>
   * Loop may be defined in different ways: <br/>
   * - array of shapes of type Segment or Arc <br/>
   * - array of points (Flatten.Point) <br/>
   * - array of numeric pairs which represent points <br/>
   * - box or circle object <br/>
   * Alternatively, it is possible to use polygon.addFace method
   * @param {args} - array of shapes or array of arrays
   */
  constructor() {
    this.faces = new Flatten.PlanarSet();
    this.edges = new Flatten.PlanarSet();
    let args = [...arguments];
    if (args.length === 1 && (args[0] instanceof Array && args[0].length > 0 || args[0] instanceof Flatten.Circle || args[0] instanceof Flatten.Box)) {
      let argsArray = args[0];
      if (args[0] instanceof Array && args[0].every((loop) => {
        return loop instanceof Array;
      })) {
        if (argsArray.every((el) => {
          return el instanceof Array && el.length === 2 && typeof el[0] === "number" && typeof el[1] === "number";
        })) {
          this.faces.add(new Flatten.Face(this, argsArray));
        } else {
          for (let loop of argsArray) {
            if (loop instanceof Array && loop[0] instanceof Array && loop[0].every((el) => {
              return el instanceof Array && el.length === 2 && typeof el[0] === "number" && typeof el[1] === "number";
            })) {
              for (let loop1 of loop) {
                this.faces.add(new Flatten.Face(this, loop1));
              }
            } else {
              this.faces.add(new Flatten.Face(this, loop));
            }
          }
        }
      } else {
        this.faces.add(new Flatten.Face(this, argsArray));
      }
    }
  }
  /**
   * (Getter) Returns bounding box of the polygon
   * @returns {Box}
   */
  get box() {
    return [...this.faces].reduce((acc, face) => acc.merge(face.box), new Flatten.Box());
  }
  /**
   * (Getter) Returns array of vertices
   * @returns {Array}
   */
  get vertices() {
    return [...this.faces].flatMap((face) => face.vertices);
  }
  /**
   * Create new cloned instance of the polygon
   * @returns {Polygon}
   */
  clone() {
    let polygon2 = new Polygon();
    for (let face of this.faces) {
      polygon2.addFace(face.shapes);
    }
    return polygon2;
  }
  /**
   * Create a polygon from an array of polygons. Each polygon is an outer face with all containing inner faces
   * @param polygons
   * @returns {Polygon}
   */
  createFromArray(polygons) {
    const newPolygon = new Polygon();
    polygons.forEach((polygon2) => [...polygon2.faces].forEach((face) => newPolygon.addFace(face.shapes)));
    return newPolygon;
  }
  /**
   * Return true is polygon has no edges or faces
   * @returns {boolean}
   */
  isEmpty() {
    return this.edges.size === 0 || this.faces.size === 0;
  }
  /**
   * Return true if polygon is valid for boolean operations
   * Polygon is valid if <br/>
   * 1. All faces are simple polygons (there are no self-intersected polygons) <br/>
   * 2. All faces are orientable and there is no island inside island or hole inside hole - TODO <br/>
   * 3. There is no intersections between faces (excluding touching) - TODO <br/>
   * @returns {boolean}
   */
  isValid() {
    let valid = true;
    for (let face of this.faces) {
      if (!face.isSimple(this.edges)) {
        valid = false;
        break;
      }
    }
    return valid;
  }
  /**
   * Returns area of the polygon. Area of an island will be added, area of a hole will be subtracted
   * @returns {number}
   */
  area() {
    let signedArea = [...this.faces].reduce((acc, face) => acc + face.signedArea(), 0);
    return Math.abs(signedArea);
  }
  /**
   * Add a new face to polygon. Returns added face
   * @param {Point[]|Segment[]|Arc[]|Circle|Box} args -  new face may be create with one of the following ways: <br/>
   * 1) array of points that describe closed path (edges are segments) <br/>
   * 2) array of shapes (segments and arcs) which describe closed path <br/>
   * 3) circle - will be added as counterclockwise arc <br/>
   * 4) box - will be added as counterclockwise rectangle <br/>
   * You can chain method face.reverse() is you need to change direction of the creates face
   * @returns {Face}
   */
  addFace(...args) {
    let face = new Flatten.Face(this, ...args);
    this.faces.add(face);
    return face;
  }
  /**
   * Delete existing face from polygon
   * @param {Face} face Face to be deleted
   * @returns {boolean}
   */
  deleteFace(face) {
    for (let edge of face) {
      this.edges.delete(edge);
    }
    return this.faces.delete(face);
  }
  /**
   * Clear all faces and create new faces from edges
   */
  recreateFaces() {
    this.faces.clear();
    for (let edge of this.edges) {
      edge.face = null;
    }
    let first;
    let unassignedEdgeFound = true;
    while (unassignedEdgeFound) {
      unassignedEdgeFound = false;
      for (let edge of this.edges) {
        if (edge.face === null) {
          first = edge;
          unassignedEdgeFound = true;
          break;
        }
      }
      if (unassignedEdgeFound) {
        let last = first;
        do {
          last = last.next;
        } while (last.next !== first);
        this.addFace(first, last);
      }
    }
  }
  /**
   * Delete chain of edges from the face.
   * @param {Face} face Face to remove chain
   * @param {Edge} edgeFrom Start of the chain of edges to be removed
   * @param {Edge} edgeTo End of the chain of edges to be removed
   */
  removeChain(face, edgeFrom, edgeTo) {
    if (edgeTo.next === edgeFrom) {
      this.deleteFace(face);
      return;
    }
    for (let edge = edgeFrom; edge !== edgeTo.next; edge = edge.next) {
      face.remove(edge);
      this.edges.delete(edge);
      if (face.isEmpty()) {
        this.deleteFace(face);
        break;
      }
    }
  }
  /**
   * Add point as a new vertex and split edge. Point supposed to belong to an edge.
   * When edge is split, new edge created from the start of the edge to the new vertex
   * and inserted before current edge.
   * Current edge is trimmed and updated.
   * Method returns new edge added. If no edge added, it returns edge before vertex
   * @param {Point} pt Point to be added as a new vertex
   * @param {Edge} edge Edge to be split with new vertex and then trimmed from start
   * @returns {Edge}
   */
  addVertex(pt, edge) {
    let shapes = edge.shape.split(pt);
    if (shapes[0] === null)
      return edge.prev;
    if (shapes[1] === null)
      return edge;
    let newEdge = new Flatten.Edge(shapes[0]);
    let edgeBefore = edge.prev;
    edge.face.insert(newEdge, edgeBefore);
    this.edges.delete(edge);
    this.edges.add(newEdge);
    edge.shape = shapes[1];
    this.edges.add(edge);
    return newEdge;
  }
  /**
   * Merge given edge with next edge and remove vertex between them
   * @param {Edge} edge
   */
  removeEndVertex(edge) {
    const edge_next = edge.next;
    if (edge_next === edge) return;
    edge.face.merge_with_next_edge(edge);
    this.edges.delete(edge_next);
  }
  /**
   * Cut polygon with multiline and return a new polygon
   * The cutting is done by intersection of multiline with edges of the polygon.
   * @param multiline
   * @returns {Polygon}
   */
  cut(multiline2) {
    const polygons = this.splitToIslands();
    const result = polygons.flatMap((polygon2) => polygon2._cutSingleIsland(multiline2)).filter((polygon2) => polygon2.isValid() && polygon2.isEmpty() === false);
    return this.createFromArray(result);
  }
  /**
   * Cut polygon with multiline and return a new polygon
   * @param {Multiline} multiline
   * @returns {Polygon}
   */
  _cutSingleIsland(inputMultiline) {
    let newPoly = this.clone();
    const multiline2 = inputMultiline.clone();
    let intersections = {
      int_points1: [],
      int_points2: [],
      int_points1_sorted: [],
      int_points2_sorted: []
    };
    for (let edge1 of multiline2.edges) {
      for (let edge2 of newPoly.edges) {
        let ip = intersectEdge2Edge(edge1, edge2);
        for (let pt of ip) {
          addToIntPoints(edge1, pt, intersections.int_points1);
          addToIntPoints(edge2, pt, intersections.int_points2);
        }
      }
    }
    if (intersections.int_points1.length === 0)
      return newPoly;
    intersections.int_points1_sorted = getSortedArray(intersections.int_points1);
    intersections.int_points2_sorted = getSortedArray(intersections.int_points2);
    splitByIntersections(multiline2, intersections.int_points1_sorted);
    splitByIntersections(newPoly, intersections.int_points2_sorted);
    filterDuplicatedIntersections(intersections);
    intersections.int_points1_sorted = getSortedArray(intersections.int_points1);
    intersections.int_points2_sorted = getSortedArray(intersections.int_points2);
    initializeInclusionFlags(intersections.int_points1);
    calculateInclusionFlags(intersections.int_points1, newPoly);
    for (let int_point1 of intersections.int_points1_sorted) {
      if (int_point1.edge_before && int_point1.edge_after && int_point1.edge_before.bv === int_point1.edge_after.bv) {
        intersections.int_points2[int_point1.id] = -1;
        int_point1.id = -1;
      }
    }
    intersections.int_points1 = intersections.int_points1.filter((int_point) => int_point.id >= 0);
    intersections.int_points2 = intersections.int_points2.filter((int_point) => int_point.id >= 0);
    intersections.int_points1.forEach((int_point, index) => {
      int_point.id = index;
    });
    intersections.int_points2.forEach((int_point, index) => {
      int_point.id = index;
    });
    if (intersections.int_points1.length === 0)
      return newPoly;
    intersections.int_points1_sorted = getSortedArray(intersections.int_points1);
    intersections.int_points2_sorted = getSortedArray(intersections.int_points2);
    let int_point1_prev;
    let int_point1_curr;
    for (let i = 1; i < intersections.int_points1_sorted.length; i++) {
      int_point1_curr = intersections.int_points1_sorted[i];
      int_point1_prev = intersections.int_points1_sorted[i - 1];
      if (int_point1_curr.edge_before && int_point1_curr.edge_before.bv === INSIDE$2) {
        let edgeFrom = int_point1_prev.edge_after;
        let edgeTo = int_point1_curr.edge_before;
        let newEdges = multiline2.getChain(edgeFrom, edgeTo);
        insertBetweenIntPoints(intersections.int_points2[int_point1_prev.id], intersections.int_points2[int_point1_curr.id], newEdges);
        newEdges.forEach((edge) => newPoly.edges.add(edge));
        newEdges = newEdges.reverse().map((edge) => new Flatten.Edge(edge.shape.reverse()));
        for (let k = 0; k < newEdges.length - 1; k++) {
          newEdges[k].next = newEdges[k + 1];
          newEdges[k + 1].prev = newEdges[k];
        }
        insertBetweenIntPoints(intersections.int_points2[int_point1_curr.id], intersections.int_points2[int_point1_prev.id], newEdges);
        newEdges.forEach((edge) => newPoly.edges.add(edge));
      }
    }
    newPoly.recreateFaces();
    return newPoly;
  }
  /**
   * A special case of cut() function
   * The return is a polygon cut with line
   * @param {Line} line - cutting line
   * @returns {Polygon} newPoly - resulted polygon
   */
  cutWithLine(line2) {
    let multiline2 = new Multiline$1([line2]);
    return this.cut(multiline2);
  }
  /**
   * Returns the first found edge of polygon that contains given point
   * If point is a vertex, return the edge where the point is an end vertex, not a start one
   * @param {Point} pt
   * @returns {Edge}
   */
  findEdgeByPoint(pt) {
    let edge;
    for (let face of this.faces) {
      edge = face.findEdgeByPoint(pt);
      if (edge !== void 0)
        break;
    }
    return edge;
  }
  /**
   * Split polygon into array of polygons, where each polygon is an outer face with all
   * containing inner faces
   * @returns {Flatten.Polygon[]}
   */
  splitToIslands() {
    if (this.isEmpty()) return [];
    let polygons = this.toArray();
    polygons.sort((polygon1, polygon2) => polygon2.area() - polygon1.area());
    let orientation2 = [...polygons[0].faces][0].orientation();
    let newPolygons = polygons.filter((polygon2) => [...polygon2.faces][0].orientation() === orientation2);
    for (let polygon2 of polygons) {
      let face = [...polygon2.faces][0];
      if (face.orientation() === orientation2) continue;
      for (let islandPolygon of newPolygons) {
        if (face.shapes.every((shape) => islandPolygon.contains(shape))) {
          islandPolygon.addFace(face.shapes);
          break;
        }
      }
    }
    return newPolygons;
  }
  /**
   * Rearrange polygon to ensure that all outer faces go first and all inner faces (holes) go after
   * @returns {Polygon}
   */
  rearrange() {
    if (this.faces.size <= 1) return this.clone();
    const islands = this.splitToIslands();
    const newPolygon = new Polygon();
    islands.forEach((island) => {
      island.faces.forEach((face) => newPolygon.addFace(face.shapes));
    });
    return newPolygon;
  }
  /**
   * Helper method to get orientation of the polygon as the first face orientation
   * Assume that polygon is properly arranged and the first face is the outer face
   * @returns {Flatten.ORIENTATION.PolygonOrientationType}
   */
  orientation() {
    if (this.isEmpty()) return ORIENTATION.NOT_ORIENTABLE;
    return [...this.faces][0].orientation();
  }
  /**
   * Helper method to check if face is outer face of the polygon
   * @param face
   * @returns {boolean}
   */
  isOuter(face) {
    return face.orientation() === this.orientation();
  }
  /**
   * Helper method to check if a polygon is a multi-polygon (has more than one outer face)
   * @returns {boolean}
   */
  isMultiPolygon() {
    let outerCounter = 0;
    this.faces.forEach((face) => {
      if (this.isOuter(face)) outerCounter++;
    });
    return outerCounter > 1;
  }
  /**
   * Reverse orientation of all faces to opposite
   * @returns {Polygon}
   */
  reverse() {
    for (let face of this.faces) {
      face.reverse();
    }
    return this;
  }
  /**
   * Returns true if polygon contains shape: no point of shape lay outside of the polygon,
   * false otherwise
   * @param {Shape} shape - test shape
   * @returns {boolean}
   */
  contains(shape) {
    if (shape instanceof Flatten.Point) {
      let rel = ray_shoot(this, shape);
      return rel === INSIDE$2 || rel === BOUNDARY$1;
    } else {
      return cover(this, shape);
    }
  }
  /**
   * Return distance and shortest segment between polygon and other shape as array [distance, shortest_segment]
   * @param {Shape} shape Shape of one of the types Point, Circle, Line, Segment, Arc or Polygon
   * @returns {Number | Segment}
   */
  distanceTo(shape) {
    if (shape instanceof Flatten.Point) {
      let [dist, shortest_segment] = Flatten.Distance.point2polygon(shape, this);
      shortest_segment = shortest_segment.reverse();
      return [dist, shortest_segment];
    }
    if (shape instanceof Flatten.Circle || shape instanceof Flatten.Line || shape instanceof Flatten.Segment || shape instanceof Flatten.Arc) {
      let [dist, shortest_segment] = Flatten.Distance.shape2polygon(shape, this);
      shortest_segment = shortest_segment.reverse();
      return [dist, shortest_segment];
    }
    if (shape instanceof Flatten.Polygon) {
      let min_dist_and_segment = [Number.POSITIVE_INFINITY, new Flatten.Segment()];
      let dist, shortest_segment;
      for (let edge of this.edges) {
        let min_stop = min_dist_and_segment[0];
        [dist, shortest_segment] = Flatten.Distance.shape2planarSet(edge.shape, shape.edges, min_stop);
        if (Flatten.Utils.LT(dist, min_stop)) {
          min_dist_and_segment = [dist, shortest_segment];
        }
      }
      return min_dist_and_segment;
    }
  }
  /**
   * Return array of intersection points between polygon and other shape
   * @param shape Shape of the one of supported types <br/>
   * @returns {Point[]}
   */
  intersect(shape) {
    if (shape instanceof Flatten.Point) {
      return this.contains(shape) ? [shape] : [];
    }
    if (shape instanceof Flatten.Line) {
      return intersectLine2Polygon(shape, this);
    }
    if (shape instanceof Flatten.Ray) {
      return intersectRay2Polygon(shape, this);
    }
    if (shape instanceof Flatten.Circle) {
      return intersectCircle2Polygon(shape, this);
    }
    if (shape instanceof Flatten.Segment) {
      return intersectSegment2Polygon(shape, this);
    }
    if (shape instanceof Flatten.Arc) {
      return intersectArc2Polygon(shape, this);
    }
    if (shape instanceof Flatten.Polygon) {
      return intersectPolygon2Polygon(shape, this);
    }
    if (shape instanceof Flatten.Multiline) {
      return intersectMultiline2Polygon(shape, this);
    }
  }
  /**
   * Returns new polygon translated by vector vec
   * @param {Vector} vec
   * @returns {Polygon}
   */
  translate(vec) {
    let newPolygon = new Polygon();
    for (let face of this.faces) {
      newPolygon.addFace(face.shapes.map((shape) => shape.translate(vec)));
    }
    return newPolygon;
  }
  /**
   * Return new polygon rotated by given angle around given point
   * If point omitted, rotate around origin (0,0)
   * Positive value of angle defines rotation counterclockwise, negative - clockwise
   * @param {number} angle - rotation angle in radians
   * @param {Point} center - rotation center, default is (0,0)
   * @returns {Polygon} - new rotated polygon
   */
  rotate(angle = 0, center = new Flatten.Point()) {
    let newPolygon = new Polygon();
    for (let face of this.faces) {
      newPolygon.addFace(face.shapes.map((shape) => shape.rotate(angle, center)));
    }
    return newPolygon;
  }
  /**
   * Return new polygon with coordinates multiplied by scaling factor
   * @param {number} sx - x-axis scaling factor
   * @param {number} sy - y-axis scaling factor
   * @returns {Polygon}
   */
  scale(sx, sy) {
    let newPolygon = new Polygon();
    for (let face of this.faces) {
      newPolygon.addFace(face.shapes.map((shape) => shape.scale(sx, sy)));
    }
    return newPolygon;
  }
  /**
   * Return new polygon transformed using affine transformation matrix
   * @param {Matrix} matrix - affine transformation matrix
   * @returns {Polygon} - new polygon
   */
  transform(matrix2 = new Flatten.Matrix()) {
    let newPolygon = new Polygon();
    for (let face of this.faces) {
      newPolygon.addFace(face.shapes.map((shape) => shape.transform(matrix2)));
    }
    return newPolygon;
  }
  /**
   * This method returns an object that defines how data will be
   * serialized when called JSON.stringify() method
   * @returns {Object}
   */
  toJSON() {
    return [...this.faces].map((face) => face.toJSON());
  }
  /**
   * Transform all faces into array of polygons
   * @returns {Flatten.Polygon[]}
   */
  toArray() {
    return [...this.faces].map((face) => face.toPolygon());
  }
  /**
   * Return string to be assigned to 'd' attribute of <path> element
   * @returns {string}
   */
  dpath() {
    return [...this.faces].reduce((acc, face) => acc + face.svg(), "");
  }
  /**
   * Return string to draw polygon in svg
   * @param attrs  - an object with attributes for svg path element
   * @returns {string}
   */
  svg(attrs = {}) {
    let svgStr = `
<path ${convertToString({ fillRule: "evenodd", fill: "lightcyan", ...attrs })} d="`;
    for (let face of this.faces) {
      svgStr += `
${face.svg()}`;
    }
    svgStr += `" >
</path>`;
    return svgStr;
  }
};
Flatten.Polygon = Polygon$1;
var polygon = (...args) => new Flatten.Polygon(...args);
Flatten.polygon = polygon;
var { Circle: Circle2, Line: Line2, Point: Point$2, Vector: Vector2, Utils } = Flatten;
var Inversion = class _Inversion {
  /**
   * Inversion constructor
   * @param {Circle} inversion_circle inversion circle
   */
  constructor(inversion_circle) {
    this.circle = inversion_circle;
  }
  get inversion_circle() {
    return this.circle;
  }
  static inversePoint(inversion_circle, point2) {
    const v = new Vector2(inversion_circle.pc, point2);
    const k2 = inversion_circle.r * inversion_circle.r;
    const len2 = v.dot(v);
    const reflected_point = Utils.EQ_0(len2) ? new Point$2(Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY) : inversion_circle.pc.translate(v.multiply(k2 / len2));
    return reflected_point;
  }
  static inverseCircle(inversion_circle, circle2) {
    const dist = inversion_circle.pc.distanceTo(circle2.pc)[0];
    if (Utils.EQ(dist, circle2.r)) {
      let d = inversion_circle.r * inversion_circle.r / (2 * circle2.r);
      let v = new Vector2(inversion_circle.pc, circle2.pc);
      v = v.normalize();
      let pt = inversion_circle.pc.translate(v.multiply(d));
      return new Line2(pt, v);
    } else {
      let v = new Vector2(inversion_circle.pc, circle2.pc);
      let s = inversion_circle.r * inversion_circle.r / (v.dot(v) - circle2.r * circle2.r);
      let pc = inversion_circle.pc.translate(v.multiply(s));
      let r = Math.abs(s) * circle2.r;
      return new Circle2(pc, r);
    }
  }
  static inverseLine(inversion_circle, line2) {
    const [dist, shortest_segment] = inversion_circle.pc.distanceTo(line2);
    if (Utils.EQ_0(dist)) {
      return line2.clone();
    } else {
      let r = inversion_circle.r * inversion_circle.r / (2 * dist);
      let v = new Vector2(inversion_circle.pc, shortest_segment.end);
      v = v.multiply(r / dist);
      return new Circle2(inversion_circle.pc.translate(v), r);
    }
  }
  inverse(shape) {
    if (shape instanceof Point$2) {
      return _Inversion.inversePoint(this.circle, shape);
    } else if (shape instanceof Circle2) {
      return _Inversion.inverseCircle(this.circle, shape);
    } else if (shape instanceof Line2) {
      return _Inversion.inverseLine(this.circle, shape);
    }
  }
};
Flatten.Inversion = Inversion;
var inversion = (circle2) => new Flatten.Inversion(circle2);
Flatten.inversion = inversion;
var Distance = class _Distance {
  /**
   * Calculate distance and shortest segment between points
   * @param pt1
   * @param pt2
   * @returns {[number, Flatten.Segment]} - distance and shortest segment
   */
  static point2point(pt1, pt2) {
    return pt1.distanceTo(pt2);
  }
  /**
   * Calculate distance and shortest segment between point and line
   * @param pt
   * @param line
   * @returns {[number, Flatten.Segment]} - distance and shortest segment
   */
  static point2line(pt, line2) {
    let closest_point = pt.projectionOn(line2);
    let vec = new Flatten.Vector(pt, closest_point);
    return [vec.length, new Flatten.Segment(pt, closest_point)];
  }
  /**
   * Calculate distance and shortest segment between point and circle
   * @param pt
   * @param circle
   * @returns {[number, Flatten.Segment]} - distance and shortest segment
   */
  static point2circle(pt, circle2) {
    let [dist2center, shortest_dist] = pt.distanceTo(circle2.center);
    if (Flatten.Utils.EQ_0(dist2center)) {
      return [circle2.r, new Flatten.Segment(pt, circle2.toArc().start)];
    } else {
      let dist = Math.abs(dist2center - circle2.r);
      let v = new Flatten.Vector(circle2.pc, pt).normalize().multiply(circle2.r);
      let closest_point = circle2.pc.translate(v);
      return [dist, new Flatten.Segment(pt, closest_point)];
    }
  }
  /**
   * Calculate distance and shortest segment between point and segment
   * @param pt
   * @param segment
   * @returns {[number, Flatten.Segment]} - distance and shortest segment
   */
  static point2segment(pt, segment2) {
    if (segment2.start.equalTo(segment2.end)) {
      return _Distance.point2point(pt, segment2.start);
    }
    let v_seg = new Flatten.Vector(segment2.start, segment2.end);
    let v_ps2pt = new Flatten.Vector(segment2.start, pt);
    let v_pe2pt = new Flatten.Vector(segment2.end, pt);
    let start_sp = v_seg.dot(v_ps2pt);
    let end_sp = -v_seg.dot(v_pe2pt);
    let dist;
    let closest_point;
    if (Flatten.Utils.GE(start_sp, 0) && Flatten.Utils.GE(end_sp, 0)) {
      let v_unit = segment2.tangentInStart();
      dist = Math.abs(v_unit.cross(v_ps2pt));
      closest_point = segment2.start.translate(v_unit.multiply(v_unit.dot(v_ps2pt)));
      return [dist, new Flatten.Segment(pt, closest_point)];
    } else if (start_sp < 0) {
      return pt.distanceTo(segment2.start);
    } else {
      return pt.distanceTo(segment2.end);
    }
  }
  /**
   * Calculate distance and shortest segment between point and arc
   * @param pt
   * @param arc
   * @returns {[number, Flatten.Segment]} - distance and shortest segment
   */
  static point2arc(pt, arc2) {
    let circle2 = new Flatten.Circle(arc2.pc, arc2.r);
    let dist_and_segment = [];
    let dist, shortest_segment;
    [dist, shortest_segment] = _Distance.point2circle(pt, circle2);
    if (shortest_segment.end.on(arc2)) {
      dist_and_segment.push(_Distance.point2circle(pt, circle2));
    }
    dist_and_segment.push(_Distance.point2point(pt, arc2.start));
    dist_and_segment.push(_Distance.point2point(pt, arc2.end));
    _Distance.sort(dist_and_segment);
    return dist_and_segment[0];
  }
  /**
   * Calculate distance and shortest segment between point and edge
   * @param pt
   * @param edge
   * @returns {[number, Flatten.Segment]}
   */
  static point2edge(pt, edge) {
    return edge.shape instanceof Flatten.Segment ? _Distance.point2segment(pt, edge.shape) : _Distance.point2arc(pt, edge.shape);
  }
  /**
   * Calculate distance and shortest segment between segment and line
   * @param seg
   * @param line
   * @returns {[number, Flatten.Segment]}
   */
  static segment2line(seg, line2) {
    let ip = seg.intersect(line2);
    if (ip.length > 0) {
      return [0, new Flatten.Segment(ip[0], ip[0])];
    }
    let dist_and_segment = [];
    dist_and_segment.push(_Distance.point2line(seg.start, line2));
    dist_and_segment.push(_Distance.point2line(seg.end, line2));
    _Distance.sort(dist_and_segment);
    return dist_and_segment[0];
  }
  /**
   * Calculate distance and shortest segment between two segments
   * @param seg1
   * @param seg2
   * @returns {[number, Flatten.Segment]} - distance and shortest segment
   */
  static segment2segment(seg1, seg2) {
    let ip = intersectSegment2Segment(seg1, seg2);
    if (ip.length > 0) {
      return [0, new Flatten.Segment(ip[0], ip[0])];
    }
    let dist_and_segment = [];
    let dist_tmp, shortest_segment_tmp;
    [dist_tmp, shortest_segment_tmp] = _Distance.point2segment(seg2.start, seg1);
    dist_and_segment.push([dist_tmp, shortest_segment_tmp.reverse()]);
    [dist_tmp, shortest_segment_tmp] = _Distance.point2segment(seg2.end, seg1);
    dist_and_segment.push([dist_tmp, shortest_segment_tmp.reverse()]);
    dist_and_segment.push(_Distance.point2segment(seg1.start, seg2));
    dist_and_segment.push(_Distance.point2segment(seg1.end, seg2));
    _Distance.sort(dist_and_segment);
    return dist_and_segment[0];
  }
  /**
   * Calculate distance and shortest segment between segment and circle
   * @param seg
   * @param circle
   * @returns {[number, Flatten.Segment]} - distance and shortest segment
   */
  static segment2circle(seg, circle2) {
    let ip = seg.intersect(circle2);
    if (ip.length > 0) {
      return [0, new Flatten.Segment(ip[0], ip[0])];
    }
    let line2 = new Flatten.Line(seg.ps, seg.pe);
    let [dist, shortest_segment] = _Distance.point2line(circle2.center, line2);
    if (Flatten.Utils.GE(dist, circle2.r) && shortest_segment.end.on(seg)) {
      return _Distance.point2circle(shortest_segment.end, circle2);
    } else {
      let [dist_from_start, shortest_segment_from_start] = _Distance.point2circle(seg.start, circle2);
      let [dist_from_end, shortest_segment_from_end] = _Distance.point2circle(seg.end, circle2);
      return Flatten.Utils.LT(dist_from_start, dist_from_end) ? [dist_from_start, shortest_segment_from_start] : [dist_from_end, shortest_segment_from_end];
    }
  }
  /**
   * Calculate distance and shortest segment between segment and arc
   * @param seg
   * @param arc
   * @returns {[number, Flatten.Segment]} - distance and shortest segment
   */
  static segment2arc(seg, arc2) {
    let ip = seg.intersect(arc2);
    if (ip.length > 0) {
      return [0, new Flatten.Segment(ip[0], ip[0])];
    }
    let line2 = new Flatten.Line(seg.ps, seg.pe);
    let circle2 = new Flatten.Circle(arc2.pc, arc2.r);
    let [dist_from_center, shortest_segment_from_center] = _Distance.point2line(circle2.center, line2);
    if (Flatten.Utils.GE(dist_from_center, circle2.r) && shortest_segment_from_center.end.on(seg)) {
      let [dist_from_projection, shortest_segment_from_projection] = _Distance.point2circle(shortest_segment_from_center.end, circle2);
      if (shortest_segment_from_projection.end.on(arc2)) {
        return [dist_from_projection, shortest_segment_from_projection];
      }
    }
    let dist_and_segment = [];
    dist_and_segment.push(_Distance.point2arc(seg.start, arc2));
    dist_and_segment.push(_Distance.point2arc(seg.end, arc2));
    let dist_tmp, segment_tmp;
    [dist_tmp, segment_tmp] = _Distance.point2segment(arc2.start, seg);
    dist_and_segment.push([dist_tmp, segment_tmp.reverse()]);
    [dist_tmp, segment_tmp] = _Distance.point2segment(arc2.end, seg);
    dist_and_segment.push([dist_tmp, segment_tmp.reverse()]);
    _Distance.sort(dist_and_segment);
    return dist_and_segment[0];
  }
  /**
   * Calculate distance and shortest segment between two circles
   * @param circle1
   * @param circle2
   * @returns {[number, Flatten.Segment]} - distance and shortest segment
   */
  static circle2circle(circle1, circle2) {
    let ip = circle1.intersect(circle2);
    if (ip.length > 0) {
      return [0, new Flatten.Segment(ip[0], ip[0])];
    }
    if (circle1.center.equalTo(circle2.center)) {
      let arc1 = circle1.toArc();
      let arc2 = circle2.toArc();
      return _Distance.point2point(arc1.start, arc2.start);
    } else {
      let line2 = new Flatten.Line(circle1.center, circle2.center);
      let ip1 = line2.intersect(circle1);
      let ip2 = line2.intersect(circle2);
      let dist_and_segment = [];
      dist_and_segment.push(_Distance.point2point(ip1[0], ip2[0]));
      dist_and_segment.push(_Distance.point2point(ip1[0], ip2[1]));
      dist_and_segment.push(_Distance.point2point(ip1[1], ip2[0]));
      dist_and_segment.push(_Distance.point2point(ip1[1], ip2[1]));
      _Distance.sort(dist_and_segment);
      return dist_and_segment[0];
    }
  }
  /**
   * Calculate distance and shortest segment between two circles
   * @param circle
   * @param line
   * @returns {[number, Flatten.Segment]} - distance and shortest segment
   */
  static circle2line(circle2, line2) {
    let ip = circle2.intersect(line2);
    if (ip.length > 0) {
      return [0, new Flatten.Segment(ip[0], ip[0])];
    }
    let [dist_from_center, shortest_segment_from_center] = _Distance.point2line(circle2.center, line2);
    let [dist, shortest_segment] = _Distance.point2circle(shortest_segment_from_center.end, circle2);
    shortest_segment = shortest_segment.reverse();
    return [dist, shortest_segment];
  }
  /**
   * Calculate distance and shortest segment between arc and line
   * @param arc
   * @param line
   * @returns {[number, Flatten.Segment]} - distance and shortest segment
   */
  static arc2line(arc2, line2) {
    let ip = line2.intersect(arc2);
    if (ip.length > 0) {
      return [0, new Flatten.Segment(ip[0], ip[0])];
    }
    let circle2 = new Flatten.Circle(arc2.center, arc2.r);
    let [dist_from_center, shortest_segment_from_center] = _Distance.point2line(circle2.center, line2);
    if (Flatten.Utils.GE(dist_from_center, circle2.r)) {
      let [dist_from_projection, shortest_segment_from_projection] = _Distance.point2circle(shortest_segment_from_center.end, circle2);
      if (shortest_segment_from_projection.end.on(arc2)) {
        return [dist_from_projection, shortest_segment_from_projection];
      }
    } else {
      let dist_and_segment = [];
      dist_and_segment.push(_Distance.point2line(arc2.start, line2));
      dist_and_segment.push(_Distance.point2line(arc2.end, line2));
      _Distance.sort(dist_and_segment);
      return dist_and_segment[0];
    }
  }
  /**
   * Calculate distance and shortest segment between arc and circle
   * @param arc
   * @param circle2
   * @returns {[number, Flatten.Segment]} - distance and shortest segment
   */
  static arc2circle(arc2, circle2) {
    let ip = arc2.intersect(circle2);
    if (ip.length > 0) {
      return [0, new Flatten.Segment(ip[0], ip[0])];
    }
    let circle1 = new Flatten.Circle(arc2.center, arc2.r);
    let [dist, shortest_segment] = _Distance.circle2circle(circle1, circle2);
    if (shortest_segment.start.on(arc2)) {
      return [dist, shortest_segment];
    } else {
      let dist_and_segment = [];
      dist_and_segment.push(_Distance.point2circle(arc2.start, circle2));
      dist_and_segment.push(_Distance.point2circle(arc2.end, circle2));
      _Distance.sort(dist_and_segment);
      return dist_and_segment[0];
    }
  }
  /**
   * Calculate distance and shortest segment between two arcs
   * @param arc1
   * @param arc2
   * @returns {[number, Flatten.Segment]} - distance and shortest segment
   */
  static arc2arc(arc1, arc2) {
    let ip = arc1.intersect(arc2);
    if (ip.length > 0) {
      return [0, new Flatten.Segment(ip[0], ip[0])];
    }
    let circle1 = new Flatten.Circle(arc1.center, arc1.r);
    let circle2 = new Flatten.Circle(arc2.center, arc2.r);
    let [dist, shortest_segment] = _Distance.circle2circle(circle1, circle2);
    if (shortest_segment.start.on(arc1) && shortest_segment.end.on(arc2)) {
      return [dist, shortest_segment];
    } else {
      let dist_and_segment = [];
      let dist_tmp, segment_tmp;
      [dist_tmp, segment_tmp] = _Distance.point2arc(arc1.start, arc2);
      if (segment_tmp.end.on(arc2)) {
        dist_and_segment.push([dist_tmp, segment_tmp]);
      }
      [dist_tmp, segment_tmp] = _Distance.point2arc(arc1.end, arc2);
      if (segment_tmp.end.on(arc2)) {
        dist_and_segment.push([dist_tmp, segment_tmp]);
      }
      [dist_tmp, segment_tmp] = _Distance.point2arc(arc2.start, arc1);
      if (segment_tmp.end.on(arc1)) {
        dist_and_segment.push([dist_tmp, segment_tmp.reverse()]);
      }
      [dist_tmp, segment_tmp] = _Distance.point2arc(arc2.end, arc1);
      if (segment_tmp.end.on(arc1)) {
        dist_and_segment.push([dist_tmp, segment_tmp.reverse()]);
      }
      [dist_tmp, segment_tmp] = _Distance.point2point(arc1.start, arc2.start);
      dist_and_segment.push([dist_tmp, segment_tmp]);
      [dist_tmp, segment_tmp] = _Distance.point2point(arc1.start, arc2.end);
      dist_and_segment.push([dist_tmp, segment_tmp]);
      [dist_tmp, segment_tmp] = _Distance.point2point(arc1.end, arc2.start);
      dist_and_segment.push([dist_tmp, segment_tmp]);
      [dist_tmp, segment_tmp] = _Distance.point2point(arc1.end, arc2.end);
      dist_and_segment.push([dist_tmp, segment_tmp]);
      _Distance.sort(dist_and_segment);
      return dist_and_segment[0];
    }
  }
  /**
   * Calculate distance and shortest segment between point and polygon
   * @param point
   * @param polygon
   * @returns {[number, Flatten.Segment]} - distance and shortest segment
   */
  static point2polygon(point2, polygon2) {
    let min_dist_and_segment = [Number.POSITIVE_INFINITY, new Flatten.Segment()];
    for (let edge of polygon2.edges) {
      let [dist, shortest_segment] = _Distance.point2edge(point2, edge);
      if (Flatten.Utils.LT(dist, min_dist_and_segment[0])) {
        min_dist_and_segment = [dist, shortest_segment];
      }
    }
    return min_dist_and_segment;
  }
  static shape2polygon(shape, polygon2) {
    let min_dist_and_segment = [Number.POSITIVE_INFINITY, new Flatten.Segment()];
    for (let edge of polygon2.edges) {
      let [dist, shortest_segment] = shape.distanceTo(edge.shape);
      if (Flatten.Utils.LT(dist, min_dist_and_segment[0])) {
        min_dist_and_segment = [dist, shortest_segment];
      }
    }
    return min_dist_and_segment;
  }
  /**
   * Calculate distance and shortest segment between two polygons
   * @param polygon1
   * @param polygon2
   * @returns {[number, Flatten.Segment]} - distance and shortest segment
   */
  static polygon2polygon(polygon1, polygon2) {
    let min_dist_and_segment = [Number.POSITIVE_INFINITY, new Flatten.Segment()];
    for (let edge1 of polygon1.edges) {
      for (let edge2 of polygon2.edges) {
        let [dist, shortest_segment] = edge1.shape.distanceTo(edge2.shape);
        if (Flatten.Utils.LT(dist, min_dist_and_segment[0])) {
          min_dist_and_segment = [dist, shortest_segment];
        }
      }
    }
    return min_dist_and_segment;
  }
  /**
   * Returns [mindist, maxdist] array of squared minimal and maximal distance between boxes
   * Minimal distance by x is
   *    (box2.xmin - box1.xmax), if box1 is left to box2
   *    (box1.xmin - box2.xmax), if box2 is left to box1
   *    0,                       if box1 and box2 are intersected by x
   * Minimal distance by y is defined in the same way
   *
   * Maximal distance is estimated as a sum of squared dimensions of the merged box
   *
   * @param box1
   * @param box2
   * @returns {Number | Number} - minimal and maximal distance
   */
  static box2box_minmax(box1, box2) {
    let mindist_x = Math.max(Math.max(box1.xmin - box2.xmax, 0), Math.max(box2.xmin - box1.xmax, 0));
    let mindist_y = Math.max(Math.max(box1.ymin - box2.ymax, 0), Math.max(box2.ymin - box1.ymax, 0));
    let mindist = mindist_x * mindist_x + mindist_y * mindist_y;
    let box3 = box1.merge(box2);
    let dx = box3.xmax - box3.xmin;
    let dy = box3.ymax - box3.ymin;
    let maxdist = dx * dx + dy * dy;
    return [mindist, maxdist];
  }
  static minmax_tree_process_level(shape, level, min_stop, tree) {
    let mindist, maxdist;
    for (let node of level) {
      [mindist, maxdist] = _Distance.box2box_minmax(shape.box, node.item.key);
      for (let value of node.item.values) {
        if (value instanceof Flatten.Edge) {
          tree.insert([mindist, maxdist], value.shape);
        } else {
          tree.insert([mindist, maxdist], value);
        }
      }
      if (Flatten.Utils.LT(maxdist, min_stop)) {
        min_stop = maxdist;
      }
    }
    if (level.length === 0)
      return min_stop;
    let new_level_left = level.map((node) => node.left.isNil() ? void 0 : node.left).filter((node) => node !== void 0);
    let new_level_right = level.map((node) => node.right.isNil() ? void 0 : node.right).filter((node) => node !== void 0);
    let new_level = [...new_level_left, ...new_level_right].filter((node) => {
      let [mindist2, maxdist2] = _Distance.box2box_minmax(shape.box, node.max);
      return Flatten.Utils.LE(mindist2, min_stop);
    });
    min_stop = _Distance.minmax_tree_process_level(shape, new_level, min_stop, tree);
    return min_stop;
  }
  /**
   * Calculates sorted tree of [mindist, maxdist] intervals between query shape
   * and shapes of the planar set.
   * @param shape
   * @param set
   */
  static minmax_tree(shape, set, min_stop) {
    let tree = new IntervalTree();
    let level = [set.index.root];
    let squared_min_stop = min_stop < Number.POSITIVE_INFINITY ? min_stop * min_stop : Number.POSITIVE_INFINITY;
    squared_min_stop = _Distance.minmax_tree_process_level(shape, level, squared_min_stop, tree);
    return tree;
  }
  static minmax_tree_calc_distance(shape, node, min_dist_and_segment) {
    let min_dist_and_segment_new, stop;
    if (node != null && !node.isNil()) {
      [min_dist_and_segment_new, stop] = _Distance.minmax_tree_calc_distance(shape, node.left, min_dist_and_segment);
      if (stop) {
        return [min_dist_and_segment_new, stop];
      }
      if (Flatten.Utils.LT(min_dist_and_segment_new[0], Math.sqrt(node.item.key.low))) {
        return [min_dist_and_segment_new, true];
      }
      let [dist, shortest_segment] = _Distance.distanceToArray(shape, node.item.values);
      if (Flatten.Utils.LT(dist, min_dist_and_segment_new[0])) {
        min_dist_and_segment_new = [dist, shortest_segment];
      }
      [min_dist_and_segment_new, stop] = _Distance.minmax_tree_calc_distance(shape, node.right, min_dist_and_segment_new);
      return [min_dist_and_segment_new, stop];
    }
    return [min_dist_and_segment, false];
  }
  /**
   * Calculates distance between shape and Planar Set of shapes
   * @param shape
   * @param {PlanarSet} set
   * @param {Number} min_stop
   * @returns {*}
   */
  static shape2planarSet(shape, set, min_stop = Number.POSITIVE_INFINITY) {
    let min_dist_and_segment = [min_stop, new Flatten.Segment()];
    let stop = false;
    if (set instanceof Flatten.PlanarSet) {
      let tree = _Distance.minmax_tree(shape, set, min_stop);
      [min_dist_and_segment, stop] = _Distance.minmax_tree_calc_distance(shape, tree.root, min_dist_and_segment);
    }
    return min_dist_and_segment;
  }
  static sort(dist_and_segment) {
    dist_and_segment.sort((d1, d2) => {
      if (Flatten.Utils.LT(d1[0], d2[0])) {
        return -1;
      }
      if (Flatten.Utils.GT(d1[0], d2[0])) {
        return 1;
      }
      return 0;
    });
  }
  static distance(shape1, shape2) {
    return shape1.distanceTo(shape2);
  }
  static distanceToArray(shape1, shapes) {
    let min_dist_and_segment = [Number.POSITIVE_INFINITY, new Flatten.Segment()];
    for (let shape2 of shapes) {
      let [dist, shortest_segment] = shape1.distanceTo(shape2);
      if (Flatten.Utils.LT(dist, min_dist_and_segment[0])) {
        min_dist_and_segment = [dist, shortest_segment];
      }
    }
    return min_dist_and_segment;
  }
  /**
   * Calculate distance and shortest segment any shape and multiline
   * @param shape
   * @param multiline
   * @returns {[number, Flatten.Segment]}
   */
  static shape2multiline(shape, multiline2) {
    let min_dist_and_segment = [Number.POSITIVE_INFINITY, new Flatten.Segment()];
    for (let edge of multiline2) {
      let [dist, shortest_segment] = _Distance.distance(shape, edge.shape);
      if (Flatten.Utils.LT(dist, min_dist_and_segment[0])) {
        min_dist_and_segment = [dist, shortest_segment];
      }
    }
    return min_dist_and_segment;
  }
  /**
   * Calculate distance and shortest segment between two multilines
   * @param multiline1
   * @param multiline2
   * @returns {[number, Flatten.Segment]}
   */
  static multiline2multiline(multiline1, multiline2) {
    let min_dist_and_segment = [Number.POSITIVE_INFINITY, new Flatten.Segment()];
    for (let edge1 of multiline1) {
      for (let edge2 of multiline2) {
        let [dist, shortest_segment] = _Distance.distance(edge1.shape, edge2.shape);
        if (Flatten.Utils.LT(dist, min_dist_and_segment[0])) {
          min_dist_and_segment = [dist, shortest_segment];
        }
      }
    }
    return min_dist_and_segment;
  }
};
Flatten.Distance = Distance;
var { Multiline: Multiline2, Point: Point$1, Segment: Segment2, Polygon: Polygon2 } = Flatten;
function parseSinglePoint(pointStr) {
  return new Point$1(pointStr.split(" ").map(Number));
}
function parseMultiPoint(multipointStr) {
  return multipointStr.split(", ").map(parseSinglePoint);
}
function parseLineString(lineStr) {
  const points = parseMultiPoint(lineStr);
  let segments = [];
  for (let i = 0; i < points.length - 1; i++) {
    segments.push(new Segment2(points[i], points[i + 1]));
  }
  return new Multiline2(segments);
}
function parseMultiLineString(multilineStr) {
  const lineStrings = multilineStr.replace(/\(\(/, "").replace(/\)\)$/, "").split("), (");
  return lineStrings.map(parseLineString);
}
function parseSinglePolygon(polygonStr) {
  const facesStr = polygonStr.replace(/\(\(/, "").replace(/\)\)$/, "").split("), (");
  const polygon2 = new Polygon2();
  let orientation2;
  facesStr.forEach((facesStr2, idx) => {
    let points = facesStr2.split(", ").map((coordStr) => {
      return new Point$1(coordStr.split(" ").map(Number));
    });
    const face = polygon2.addFace(points);
    if (idx === 0) {
      orientation2 = face.orientation();
    } else {
      if (face.orientation() === orientation2) {
        face.reverse();
      }
    }
  });
  return polygon2;
}
function parseMutliPolygon(multiPolygonString) {
  const polygonStrings = multiPolygonString.split(/\)\), \(\(/).map((polygon3) => "((" + polygon3 + "))");
  const polygons = polygonStrings.map(parseSinglePolygon);
  const polygon2 = new Polygon2();
  const faces = polygons.reduce((acc, polygon3) => [...acc, ...polygon3?.faces], []);
  faces.forEach((face) => polygon2.addFace([...face?.shapes]));
  return polygon2;
}
function parsePolygon(wkt) {
  if (wkt.startsWith("POLYGON")) {
    const polygonStr = wkt.replace(/^POLYGON /, "");
    return parseSinglePolygon(polygonStr);
  } else {
    const multiPolygonString = wkt.replace(/^MULTIPOLYGON \(\(\((.*)\)\)\)$/, "$1");
    return parseMutliPolygon(multiPolygonString);
  }
}
function parseArrayOfPoints(str) {
  const arr = str.split("\n").map((x) => x.match(/\(([^)]+)\)/)[1]);
  return arr.map(parseSinglePoint);
}
function parseArrayOfLineStrings(str) {
  const arr = str.split("\n").map((x) => x.match(/\(([^)]+)\)/)[1]);
  return arr.map(parseLineString).reduce((acc, x) => [...acc, ...x], []);
}
function parseWKT(str) {
  if (str.startsWith("POINT")) {
    const pointStr = str.replace(/^POINT \(/, "").replace(/\)$/, "");
    return parseSinglePoint(pointStr);
  } else if (str.startsWith("MULTIPOINT")) {
    const multiPointStr = str.replace(/^MULTIPOINT \(/, "").replace(/\)$/, "");
    return parseMultiPoint(multiPointStr);
  } else if (str.startsWith("LINESTRING")) {
    const lineStr = str.replace(/^LINESTRING \(/, "").replace(/\)$/, "");
    return parseLineString(lineStr);
  } else if (str.startsWith("MULTILINESTRING")) {
    const multilineStr = str.replace(/^MULTILINESTRING /, "");
    return parseMultiLineString(multilineStr);
  } else if (str.startsWith("POLYGON") || str.startsWith("MULTIPOLYGON")) {
    return parsePolygon(str);
  } else if (str.startsWith("GEOMETRYCOLLECTION")) {
    const regex = /(?<type>POINT|LINESTRING|POLYGON|MULTIPOINT|MULTILINESTRING|MULTIPOLYGON) \((?:[^\(\)]|\([^\)]*\))*\)/g;
    const wktArray = str.match(regex);
    if (wktArray[0].startsWith("GEOMETRYCOLLECTION")) {
      wktArray[0] = wktArray[0].replace("GEOMETRYCOLLECTION (", "");
    }
    const flArray = wktArray.map(parseWKT).map((x) => x instanceof Array ? x : [x]);
    return flArray.reduce((acc, x) => [...acc, ...x], []);
  } else if (isArrayOfPoints(str)) {
    return parseArrayOfPoints(str);
  } else if (isArrayOfLines(str)) {
    return parseArrayOfLineStrings(str);
  }
  return [];
}
function isArrayOfPoints(str) {
  return str.split("\n")?.every((str2) => str2.includes("POINT"));
}
function isArrayOfLines(str) {
  return str.split("\n")?.every((str2) => str2.includes("LINESTRING"));
}
function isWktString(str) {
  return str.startsWith("POINT") || isArrayOfPoints(str) || str.startsWith("LINESTRING") || isArrayOfLines(str) || str.startsWith("MULTILINESTRING") || str.startsWith("POLYGON") || str.startsWith("MULTIPOINT") || str.startsWith("MULTIPOLYGON") || str.startsWith("GEOMETRYCOLLECTION");
}
Flatten.isWktString = isWktString;
Flatten.parseWKT = parseWKT;
Flatten.BooleanOperations = BooleanOperations;
Flatten.Relations = Relations;

// node_modules/@tscircuit/find-convex-regions/dist/index.js
var import_cdt2d = __toESM(require_cdt2d(), 1);
var __create2 = Object.create;
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc2 = Object.getOwnPropertyDescriptor;
var __getOwnPropNames2 = Object.getOwnPropertyNames;
var __getProtoOf2 = Object.getPrototypeOf;
var __hasOwnProp2 = Object.prototype.hasOwnProperty;
var __commonJS2 = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames2(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps2 = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames2(from))
      if (!__hasOwnProp2.call(to, key) && key !== except)
        __defProp2(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc2(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM2 = (mod, isNodeMode, target) => (target = mod != null ? __create2(__getProtoOf2(mod)) : {}, __copyProps2(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp2(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var require_is_buffer = __commonJS2({
  "node_modules/is-buffer/index.js"(exports, module) {
    "use strict";
    module.exports = function(obj) {
      return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer);
    };
    function isBuffer(obj) {
      return !!obj.constructor && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
    }
    function isSlowBuffer(obj) {
      return typeof obj.readFloatLE === "function" && typeof obj.slice === "function" && isBuffer(obj.slice(0, 0));
    }
  }
});
var require_kind_of = __commonJS2({
  "node_modules/kind-of/index.js"(exports, module) {
    "use strict";
    var isBuffer = require_is_buffer();
    var toString = Object.prototype.toString;
    module.exports = function kindOf(val) {
      if (typeof val === "undefined") {
        return "undefined";
      }
      if (val === null) {
        return "null";
      }
      if (val === true || val === false || val instanceof Boolean) {
        return "boolean";
      }
      if (typeof val === "string" || val instanceof String) {
        return "string";
      }
      if (typeof val === "number" || val instanceof Number) {
        return "number";
      }
      if (typeof val === "function" || val instanceof Function) {
        return "function";
      }
      if (typeof Array.isArray !== "undefined" && Array.isArray(val)) {
        return "array";
      }
      if (val instanceof RegExp) {
        return "regexp";
      }
      if (val instanceof Date) {
        return "date";
      }
      var type = toString.call(val);
      if (type === "[object RegExp]") {
        return "regexp";
      }
      if (type === "[object Date]") {
        return "date";
      }
      if (type === "[object Arguments]") {
        return "arguments";
      }
      if (type === "[object Error]") {
        return "error";
      }
      if (isBuffer(val)) {
        return "buffer";
      }
      if (type === "[object Set]") {
        return "set";
      }
      if (type === "[object WeakSet]") {
        return "weakset";
      }
      if (type === "[object Map]") {
        return "map";
      }
      if (type === "[object WeakMap]") {
        return "weakmap";
      }
      if (type === "[object Symbol]") {
        return "symbol";
      }
      if (type === "[object Int8Array]") {
        return "int8array";
      }
      if (type === "[object Uint8Array]") {
        return "uint8array";
      }
      if (type === "[object Uint8ClampedArray]") {
        return "uint8clampedarray";
      }
      if (type === "[object Int16Array]") {
        return "int16array";
      }
      if (type === "[object Uint16Array]") {
        return "uint16array";
      }
      if (type === "[object Int32Array]") {
        return "int32array";
      }
      if (type === "[object Uint32Array]") {
        return "uint32array";
      }
      if (type === "[object Float32Array]") {
        return "float32array";
      }
      if (type === "[object Float64Array]") {
        return "float64array";
      }
      return "object";
    };
  }
});
var require_rename_keys = __commonJS2({
  "node_modules/rename-keys/index.js"(exports, module) {
    "use strict";
    (function() {
      "use strict";
      function rename2(obj, fn) {
        if (typeof fn !== "function") {
          return obj;
        }
        var res = {};
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            res[fn(key, obj[key]) || key] = obj[key];
          }
        }
        return res;
      }
      if (typeof module !== "undefined" && module.exports) {
        module.exports = rename2;
      } else {
        if (typeof define === "function" && define.amd) {
          define([], function() {
            return rename2;
          });
        } else {
          window.rename = rename2;
        }
      }
    })();
  }
});
var require_deep_rename_keys = __commonJS2({
  "node_modules/deep-rename-keys/index.js"(exports, module) {
    "use strict";
    var typeOf = require_kind_of();
    var rename2 = require_rename_keys();
    module.exports = function renameDeep(obj, cb) {
      var type = typeOf(obj);
      if (type !== "object" && type !== "array") {
        throw new Error("expected an object");
      }
      var res = [];
      if (type === "object") {
        obj = rename2(obj, cb);
        res = {};
      }
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          var val = obj[key];
          if (typeOf(val) === "object" || typeOf(val) === "array") {
            res[key] = renameDeep(val, cb);
          } else {
            res[key] = val;
          }
        }
      }
      return res;
    };
  }
});
var require_eventemitter3 = __commonJS2({
  "node_modules/eventemitter3/index.js"(exports, module) {
    "use strict";
    var has = Object.prototype.hasOwnProperty;
    var prefix = "~";
    function Events() {
    }
    if (Object.create) {
      Events.prototype = /* @__PURE__ */ Object.create(null);
      if (!new Events().__proto__) prefix = false;
    }
    function EE(fn, context, once) {
      this.fn = fn;
      this.context = context;
      this.once = once || false;
    }
    function EventEmitter() {
      this._events = new Events();
      this._eventsCount = 0;
    }
    EventEmitter.prototype.eventNames = function eventNames() {
      var names = [], events, name;
      if (this._eventsCount === 0) return names;
      for (name in events = this._events) {
        if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
      }
      if (Object.getOwnPropertySymbols) {
        return names.concat(Object.getOwnPropertySymbols(events));
      }
      return names;
    };
    EventEmitter.prototype.listeners = function listeners(event, exists) {
      var evt = prefix ? prefix + event : event, available = this._events[evt];
      if (exists) return !!available;
      if (!available) return [];
      if (available.fn) return [available.fn];
      for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
        ee[i] = available[i].fn;
      }
      return ee;
    };
    EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
      var evt = prefix ? prefix + event : event;
      if (!this._events[evt]) return false;
      var listeners = this._events[evt], len = arguments.length, args, i;
      if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, void 0, true);
        switch (len) {
          case 1:
            return listeners.fn.call(listeners.context), true;
          case 2:
            return listeners.fn.call(listeners.context, a1), true;
          case 3:
            return listeners.fn.call(listeners.context, a1, a2), true;
          case 4:
            return listeners.fn.call(listeners.context, a1, a2, a3), true;
          case 5:
            return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
          case 6:
            return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for (i = 1, args = new Array(len - 1); i < len; i++) {
          args[i - 1] = arguments[i];
        }
        listeners.fn.apply(listeners.context, args);
      } else {
        var length = listeners.length, j;
        for (i = 0; i < length; i++) {
          if (listeners[i].once) this.removeListener(event, listeners[i].fn, void 0, true);
          switch (len) {
            case 1:
              listeners[i].fn.call(listeners[i].context);
              break;
            case 2:
              listeners[i].fn.call(listeners[i].context, a1);
              break;
            case 3:
              listeners[i].fn.call(listeners[i].context, a1, a2);
              break;
            case 4:
              listeners[i].fn.call(listeners[i].context, a1, a2, a3);
              break;
            default:
              if (!args) for (j = 1, args = new Array(len - 1); j < len; j++) {
                args[j - 1] = arguments[j];
              }
              listeners[i].fn.apply(listeners[i].context, args);
          }
        }
      }
      return true;
    };
    EventEmitter.prototype.on = function on(event, fn, context) {
      var listener = new EE(fn, context || this), evt = prefix ? prefix + event : event;
      if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
      else if (!this._events[evt].fn) this._events[evt].push(listener);
      else this._events[evt] = [this._events[evt], listener];
      return this;
    };
    EventEmitter.prototype.once = function once(event, fn, context) {
      var listener = new EE(fn, context || this, true), evt = prefix ? prefix + event : event;
      if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
      else if (!this._events[evt].fn) this._events[evt].push(listener);
      else this._events[evt] = [this._events[evt], listener];
      return this;
    };
    EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
      var evt = prefix ? prefix + event : event;
      if (!this._events[evt]) return this;
      if (!fn) {
        if (--this._eventsCount === 0) this._events = new Events();
        else delete this._events[evt];
        return this;
      }
      var listeners = this._events[evt];
      if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) {
          if (--this._eventsCount === 0) this._events = new Events();
          else delete this._events[evt];
        }
      } else {
        for (var i = 0, events = [], length = listeners.length; i < length; i++) {
          if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) {
            events.push(listeners[i]);
          }
        }
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else if (--this._eventsCount === 0) this._events = new Events();
        else delete this._events[evt];
      }
      return this;
    };
    EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
      var evt;
      if (event) {
        evt = prefix ? prefix + event : event;
        if (this._events[evt]) {
          if (--this._eventsCount === 0) this._events = new Events();
          else delete this._events[evt];
        }
      } else {
        this._events = new Events();
        this._eventsCount = 0;
      }
      return this;
    };
    EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
    EventEmitter.prototype.addListener = EventEmitter.prototype.on;
    EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
      return this;
    };
    EventEmitter.prefixed = prefix;
    EventEmitter.EventEmitter = EventEmitter;
    if ("undefined" !== typeof module) {
      module.exports = EventEmitter;
    }
  }
});
var require_lexer = __commonJS2({
  "node_modules/xml-lexer/dist/lexer.js"(exports, module) {
    "use strict";
    function _defineProperty(obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
      } else {
        obj[key] = value;
      }
      return obj;
    }
    var EventEmitter = require_eventemitter3();
    var noop = function noop2() {
    };
    var State = {
      data: "state-data",
      cdata: "state-cdata",
      tagBegin: "state-tag-begin",
      tagName: "state-tag-name",
      tagEnd: "state-tag-end",
      attributeNameStart: "state-attribute-name-start",
      attributeName: "state-attribute-name",
      attributeNameEnd: "state-attribute-name-end",
      attributeValueBegin: "state-attribute-value-begin",
      attributeValue: "state-attribute-value"
    };
    var Action = {
      lt: "action-lt",
      gt: "action-gt",
      space: "action-space",
      equal: "action-equal",
      quote: "action-quote",
      slash: "action-slash",
      char: "action-char",
      error: "action-error"
    };
    var Type = {
      text: "text",
      openTag: "open-tag",
      closeTag: "close-tag",
      attributeName: "attribute-name",
      attributeValue: "attribute-value"
    };
    var charToAction = {
      " ": Action.space,
      "	": Action.space,
      "\n": Action.space,
      "\r": Action.space,
      "<": Action.lt,
      ">": Action.gt,
      '"': Action.quote,
      "'": Action.quote,
      "=": Action.equal,
      "/": Action.slash
    };
    var getAction = function getAction2(char) {
      return charToAction[char] || Action.char;
    };
    var create = function create2(options) {
      var _State$data, _State$tagBegin, _State$tagName, _State$tagEnd, _State$attributeNameS, _State$attributeName, _State$attributeNameE, _State$attributeValue, _State$attributeValue2, _lexer$stateMachine;
      options = Object.assign({ debug: false }, options);
      var lexer = new EventEmitter();
      var state = State.data;
      var data = "";
      var tagName = "";
      var attrName = "";
      var attrValue = "";
      var isClosing = "";
      var openingQuote = "";
      var emit = function emit2(type, value) {
        if (tagName[0] === "?" || tagName[0] === "!") {
          return;
        }
        var event = { type, value };
        if (options.debug) {
          console.log("emit:", event);
        }
        lexer.emit("data", event);
      };
      lexer.stateMachine = (_lexer$stateMachine = {}, _defineProperty(_lexer$stateMachine, State.data, (_State$data = {}, _defineProperty(_State$data, Action.lt, function() {
        if (data.trim()) {
          emit(Type.text, data);
        }
        tagName = "";
        isClosing = false;
        state = State.tagBegin;
      }), _defineProperty(_State$data, Action.char, function(char) {
        data += char;
      }), _State$data)), _defineProperty(_lexer$stateMachine, State.cdata, _defineProperty({}, Action.char, function(char) {
        data += char;
        if (data.substr(-3) === "]]>") {
          emit(Type.text, data.slice(0, -3));
          data = "";
          state = State.data;
        }
      })), _defineProperty(_lexer$stateMachine, State.tagBegin, (_State$tagBegin = {}, _defineProperty(_State$tagBegin, Action.space, noop), _defineProperty(_State$tagBegin, Action.char, function(char) {
        tagName = char;
        state = State.tagName;
      }), _defineProperty(_State$tagBegin, Action.slash, function() {
        tagName = "";
        isClosing = true;
      }), _State$tagBegin)), _defineProperty(_lexer$stateMachine, State.tagName, (_State$tagName = {}, _defineProperty(_State$tagName, Action.space, function() {
        if (isClosing) {
          state = State.tagEnd;
        } else {
          state = State.attributeNameStart;
          emit(Type.openTag, tagName);
        }
      }), _defineProperty(_State$tagName, Action.gt, function() {
        if (isClosing) {
          emit(Type.closeTag, tagName);
        } else {
          emit(Type.openTag, tagName);
        }
        data = "";
        state = State.data;
      }), _defineProperty(_State$tagName, Action.slash, function() {
        state = State.tagEnd;
        emit(Type.openTag, tagName);
      }), _defineProperty(_State$tagName, Action.char, function(char) {
        tagName += char;
        if (tagName === "![CDATA[") {
          state = State.cdata;
          data = "";
          tagName = "";
        }
      }), _State$tagName)), _defineProperty(_lexer$stateMachine, State.tagEnd, (_State$tagEnd = {}, _defineProperty(_State$tagEnd, Action.gt, function() {
        emit(Type.closeTag, tagName);
        data = "";
        state = State.data;
      }), _defineProperty(_State$tagEnd, Action.char, noop), _State$tagEnd)), _defineProperty(_lexer$stateMachine, State.attributeNameStart, (_State$attributeNameS = {}, _defineProperty(_State$attributeNameS, Action.char, function(char) {
        attrName = char;
        state = State.attributeName;
      }), _defineProperty(_State$attributeNameS, Action.gt, function() {
        data = "";
        state = State.data;
      }), _defineProperty(_State$attributeNameS, Action.space, noop), _defineProperty(_State$attributeNameS, Action.slash, function() {
        isClosing = true;
        state = State.tagEnd;
      }), _State$attributeNameS)), _defineProperty(_lexer$stateMachine, State.attributeName, (_State$attributeName = {}, _defineProperty(_State$attributeName, Action.space, function() {
        state = State.attributeNameEnd;
      }), _defineProperty(_State$attributeName, Action.equal, function() {
        emit(Type.attributeName, attrName);
        state = State.attributeValueBegin;
      }), _defineProperty(_State$attributeName, Action.gt, function() {
        attrValue = "";
        emit(Type.attributeName, attrName);
        emit(Type.attributeValue, attrValue);
        data = "";
        state = State.data;
      }), _defineProperty(_State$attributeName, Action.slash, function() {
        isClosing = true;
        attrValue = "";
        emit(Type.attributeName, attrName);
        emit(Type.attributeValue, attrValue);
        state = State.tagEnd;
      }), _defineProperty(_State$attributeName, Action.char, function(char) {
        attrName += char;
      }), _State$attributeName)), _defineProperty(_lexer$stateMachine, State.attributeNameEnd, (_State$attributeNameE = {}, _defineProperty(_State$attributeNameE, Action.space, noop), _defineProperty(_State$attributeNameE, Action.equal, function() {
        emit(Type.attributeName, attrName);
        state = State.attributeValueBegin;
      }), _defineProperty(_State$attributeNameE, Action.gt, function() {
        attrValue = "";
        emit(Type.attributeName, attrName);
        emit(Type.attributeValue, attrValue);
        data = "";
        state = State.data;
      }), _defineProperty(_State$attributeNameE, Action.char, function(char) {
        attrValue = "";
        emit(Type.attributeName, attrName);
        emit(Type.attributeValue, attrValue);
        attrName = char;
        state = State.attributeName;
      }), _State$attributeNameE)), _defineProperty(_lexer$stateMachine, State.attributeValueBegin, (_State$attributeValue = {}, _defineProperty(_State$attributeValue, Action.space, noop), _defineProperty(_State$attributeValue, Action.quote, function(char) {
        openingQuote = char;
        attrValue = "";
        state = State.attributeValue;
      }), _defineProperty(_State$attributeValue, Action.gt, function() {
        attrValue = "";
        emit(Type.attributeValue, attrValue);
        data = "";
        state = State.data;
      }), _defineProperty(_State$attributeValue, Action.char, function(char) {
        openingQuote = "";
        attrValue = char;
        state = State.attributeValue;
      }), _State$attributeValue)), _defineProperty(_lexer$stateMachine, State.attributeValue, (_State$attributeValue2 = {}, _defineProperty(_State$attributeValue2, Action.space, function(char) {
        if (openingQuote) {
          attrValue += char;
        } else {
          emit(Type.attributeValue, attrValue);
          state = State.attributeNameStart;
        }
      }), _defineProperty(_State$attributeValue2, Action.quote, function(char) {
        if (openingQuote === char) {
          emit(Type.attributeValue, attrValue);
          state = State.attributeNameStart;
        } else {
          attrValue += char;
        }
      }), _defineProperty(_State$attributeValue2, Action.gt, function(char) {
        if (openingQuote) {
          attrValue += char;
        } else {
          emit(Type.attributeValue, attrValue);
          data = "";
          state = State.data;
        }
      }), _defineProperty(_State$attributeValue2, Action.slash, function(char) {
        if (openingQuote) {
          attrValue += char;
        } else {
          emit(Type.attributeValue, attrValue);
          isClosing = true;
          state = State.tagEnd;
        }
      }), _defineProperty(_State$attributeValue2, Action.char, function(char) {
        attrValue += char;
      }), _State$attributeValue2)), _lexer$stateMachine);
      var step = function step2(char) {
        if (options.debug) {
          console.log(state, char);
        }
        var actions = lexer.stateMachine[state];
        var action = actions[getAction(char)] || actions[Action.error] || actions[Action.char];
        action(char);
      };
      lexer.write = function(str) {
        var len = str.length;
        for (var i = 0; i < len; i++) {
          step(str[i]);
        }
      };
      return lexer;
    };
    module.exports = {
      State,
      Action,
      Type,
      create
    };
  }
});
var require_reader = __commonJS2({
  "node_modules/xml-reader/dist/reader.js"(exports, module) {
    "use strict";
    var EventEmitter = require_eventemitter3();
    var Lexer = require_lexer();
    var Type = Lexer.Type;
    var NodeType = {
      element: "element",
      text: "text"
    };
    var createNode = function createNode2(params) {
      return Object.assign({
        name: "",
        type: NodeType.element,
        value: "",
        parent: null,
        attributes: {},
        children: []
      }, params);
    };
    var create = function create2(options) {
      options = Object.assign({
        stream: false,
        parentNodes: true,
        doneEvent: "done",
        tagPrefix: "tag:",
        emitTopLevelOnly: false,
        debug: false
      }, options);
      var lexer = void 0, rootNode = void 0, current = void 0, attrName = void 0;
      var reader = new EventEmitter();
      var handleLexerData = function handleLexerData2(data) {
        switch (data.type) {
          case Type.openTag:
            if (current === null) {
              current = rootNode;
              current.name = data.value;
            } else {
              var node = createNode({
                name: data.value,
                parent: current
              });
              current.children.push(node);
              current = node;
            }
            break;
          case Type.closeTag:
            var parent = current.parent;
            if (!options.parentNodes) {
              current.parent = null;
            }
            if (current.name !== data.value) {
              break;
            }
            if (options.stream && parent === rootNode) {
              rootNode.children = [];
              current.parent = null;
            }
            if (!options.emitTopLevelOnly || parent === rootNode) {
              reader.emit(options.tagPrefix + current.name, current);
              reader.emit("tag", current.name, current);
            }
            if (current === rootNode) {
              lexer.removeAllListeners("data");
              reader.emit(options.doneEvent, current);
              rootNode = null;
            }
            current = parent;
            break;
          case Type.text:
            if (current) {
              current.children.push(createNode({
                type: NodeType.text,
                value: data.value,
                parent: options.parentNodes ? current : null
              }));
            }
            break;
          case Type.attributeName:
            attrName = data.value;
            current.attributes[attrName] = "";
            break;
          case Type.attributeValue:
            current.attributes[attrName] = data.value;
            break;
        }
      };
      reader.reset = function() {
        lexer = Lexer.create({ debug: options.debug });
        lexer.on("data", handleLexerData);
        rootNode = createNode();
        current = null;
        attrName = "";
        reader.parse = lexer.write;
      };
      reader.reset();
      return reader;
    };
    var parseSync2 = function parseSync3(xml, options) {
      options = Object.assign({}, options, { stream: false, tagPrefix: ":" });
      var reader = create(options);
      var res = void 0;
      reader.on("done", function(ast) {
        res = ast;
      });
      reader.parse(xml);
      return res;
    };
    module.exports = {
      parseSync: parseSync2,
      create,
      NodeType
    };
  }
});
var { cos: cos2, sin: sin2, PI: PI2 } = Math;
var { tan: tan2 } = Math;
var import_deep_rename_keys = __toESM2(require_deep_rename_keys());
var import_xml_reader = __toESM2(require_reader());
function setStepOfAllObjects(graphics, step) {
  if (graphics.points) {
    for (const p of graphics.points) {
      p.step = step;
    }
  }
  if (graphics.lines) {
    for (const line2 of graphics.lines) {
      line2.step = step;
    }
  }
  if (graphics.infiniteLines) {
    for (const infiniteLine of graphics.infiniteLines) {
      infiniteLine.step = step;
    }
  }
  if (graphics.polygons) {
    for (const polygon2 of graphics.polygons) {
      polygon2.step = step;
    }
  }
  if (graphics.rects) {
    for (const rect of graphics.rects) {
      rect.step = step;
    }
  }
  if (graphics.circles) {
    for (const circle2 of graphics.circles) {
      circle2.step = step;
    }
  }
  if (graphics.texts) {
    for (const text of graphics.texts) {
      text.step = step;
    }
  }
  return graphics;
}
var BaseSolver4 = class {
  MAX_ITERATIONS = 1e5;
  solved = false;
  failed = false;
  iterations = 0;
  progress = 0;
  error = null;
  activeSubSolver;
  failedSubSolvers;
  timeToSolve;
  stats = {};
  _setupDone = false;
  getSolverName() {
    return this.constructor.name;
  }
  setup() {
    if (this._setupDone) return;
    this._setup();
    this._setupDone = true;
  }
  /** Override this method to perform setup logic */
  _setup() {
  }
  /** DO NOT OVERRIDE! Override _step() instead */
  step() {
    if (!this._setupDone) {
      this.setup();
    }
    if (this.solved) return;
    if (this.failed) return;
    this.iterations++;
    try {
      this._step();
    } catch (e) {
      this.error = `${this.getSolverName()} error: ${e}`;
      this.failed = true;
      throw e;
    }
    if (!this.solved && this.iterations >= this.MAX_ITERATIONS) {
      this.tryFinalAcceptance();
    }
    if (!this.solved && this.iterations >= this.MAX_ITERATIONS) {
      this.error = `${this.getSolverName()} ran out of iterations`;
      this.failed = true;
    }
    if ("computeProgress" in this) {
      this.progress = this.computeProgress();
    }
  }
  /** Override this method to implement solver logic */
  _step() {
  }
  getConstructorParams() {
    throw new Error("getConstructorParams not implemented");
  }
  /**
   * Override this method to return the standardized output of the solver.
   * This method should only be called after the solver has completed successfully.
   * Returns null by default - solvers with outputs should override this method.
   */
  getOutput() {
    return null;
  }
  solve() {
    const startTime = Date.now();
    while (!this.solved && !this.failed) {
      this.step();
    }
    const endTime = Date.now();
    this.timeToSolve = endTime - startTime;
  }
  visualize() {
    return {
      lines: [],
      points: [],
      rects: [],
      circles: []
    };
  }
  /**
   * Called when the solver is about to fail, but we want to see if we have an
   * "acceptable" or "passable" solution. Mostly used for optimizers that
   * have an aggressive early stopping criterion.
   */
  tryFinalAcceptance() {
  }
  /**
   * A lightweight version of the visualize method that can be used to stream
   * progress
   */
  preview() {
    return {
      lines: [],
      points: [],
      rects: [],
      circles: []
    };
  }
};
function definePipelineStep(solverName, solverClass, getConstructorParams, opts = {}) {
  return {
    solverName,
    solverClass,
    getConstructorParams,
    onSolved: opts.onSolved
  };
}
var BasePipelineSolver = class extends BaseSolver4 {
  startTimeOfStage = {};
  endTimeOfStage = {};
  timeSpentOnStage = {};
  firstIterationOfStage = {};
  currentPipelineStageIndex = 0;
  inputProblem;
  /** Stores the outputs from each completed pipeline stage */
  pipelineOutputs = {};
  constructor(inputProblem) {
    super();
    this.inputProblem = inputProblem;
    this.MAX_ITERATIONS = 1e6;
  }
  _step() {
    const pipelineStageDef = this.pipelineDef[this.currentPipelineStageIndex];
    if (!pipelineStageDef) {
      this.solved = true;
      return;
    }
    if (this.activeSubSolver) {
      this.activeSubSolver.step();
      if (this.activeSubSolver.solved) {
        this.endTimeOfStage[pipelineStageDef.solverName] = performance.now();
        this.timeSpentOnStage[pipelineStageDef.solverName] = this.endTimeOfStage[pipelineStageDef.solverName] - this.startTimeOfStage[pipelineStageDef.solverName];
        const output = this.activeSubSolver.getOutput();
        if (output !== null) {
          this.pipelineOutputs[pipelineStageDef.solverName] = output;
        }
        pipelineStageDef.onSolved?.(this);
        this.activeSubSolver = null;
        this.currentPipelineStageIndex++;
      } else if (this.activeSubSolver.failed) {
        this.error = this.activeSubSolver?.error;
        this.failed = true;
        this.activeSubSolver = null;
      }
      return;
    }
    const constructorParams = pipelineStageDef.getConstructorParams(this);
    this.activeSubSolver = new pipelineStageDef.solverClass(
      ...constructorParams
    );
    this[pipelineStageDef.solverName] = this.activeSubSolver;
    this.timeSpentOnStage[pipelineStageDef.solverName] = 0;
    this.startTimeOfStage[pipelineStageDef.solverName] = performance.now();
    this.firstIterationOfStage[pipelineStageDef.solverName] = this.iterations;
  }
  solveUntilStage(stageName) {
    while (this.getCurrentStageName().toLowerCase() !== stageName.toLowerCase()) {
      this.step();
      if (this.failed || this.solved) break;
    }
  }
  getCurrentStageName() {
    return this.pipelineDef[this.currentPipelineStageIndex]?.solverName ?? "none";
  }
  getStageProgress() {
    const totalStages = this.pipelineDef.length;
    if (totalStages === 0) return 1;
    const currentStageProgress = this.activeSubSolver?.progress ?? 0;
    return (this.currentPipelineStageIndex + currentStageProgress) / totalStages;
  }
  getStageStats() {
    const stats = {};
    for (const stage of this.pipelineDef) {
      const timeSpent = this.timeSpentOnStage[stage.solverName] || 0;
      const firstIteration = this.firstIterationOfStage[stage.solverName] || 0;
      const currentIteration = this.iterations;
      const iterations = stage.solverName === this.getCurrentStageName() ? currentIteration - firstIteration : 0;
      const completed = this.currentPipelineStageIndex > this.pipelineDef.findIndex((s) => s.solverName === stage.solverName);
      stats[stage.solverName] = {
        timeSpent,
        iterations,
        completed
      };
    }
    return stats;
  }
  initialVisualize() {
    return null;
  }
  finalVisualize() {
    return null;
  }
  visualize() {
    if (!this.solved && this.activeSubSolver) {
      return this.activeSubSolver.visualize();
    }
    let stageStepOffset = 0;
    const initialVisualization = this.initialVisualize();
    if (initialVisualization) {
      setStepOfAllObjects(initialVisualization, 0);
      stageStepOffset = 1;
    }
    let finalVisualization = null;
    if (this.solved) {
      finalVisualization = this.finalVisualize();
    }
    const visualizations = [initialVisualization].filter(Boolean).concat(
      this.pipelineDef.map((stage, stageIndex) => {
        const solver = this[stage.solverName];
        const viz = solver?.visualize();
        if (!viz) return null;
        setStepOfAllObjects(viz, stageIndex + stageStepOffset);
        return viz;
      }).filter(Boolean)
    );
    if (visualizations.length === 0) {
      return { points: [], rects: [], lines: [], circles: [], texts: [] };
    }
    if (this.solved && finalVisualization) {
      setStepOfAllObjects(
        finalVisualization,
        visualizations.length + stageStepOffset + 1
      );
      visualizations.push(finalVisualization);
    }
    if (visualizations.length === 1) {
      return visualizations[0];
    }
    return {
      points: visualizations.flatMap((v) => v.points || []),
      rects: visualizations.flatMap((v) => v.rects || []),
      lines: visualizations.flatMap((v) => v.lines || []),
      circles: visualizations.flatMap((v) => v.circles || []),
      texts: visualizations.flatMap((v) => v.texts || [])
    };
  }
  preview() {
    if (this.activeSubSolver) {
      return this.activeSubSolver.preview();
    }
    return super.preview();
  }
  computeProgress() {
    return this.getStageProgress();
  }
  /**
   * Get the output from a specific pipeline stage
   */
  getStageOutput(stageOutput) {
    return this.pipelineOutputs[stageOutput];
  }
  /**
   * Get all pipeline outputs
   */
  getAllOutputs() {
    return { ...this.pipelineOutputs };
  }
  /**
   * Check if a step has completed and produced output
   */
  hasStageOutput(stageName) {
    return stageName in this.pipelineOutputs;
  }
  /**
   * Get a solver instance by name
   */
  getSolver(stageName) {
    return this[stageName];
  }
};
var cross = (params) => {
  const { o, a, b } = params;
  return (a.x - o.x) * (b.y - o.y) - (a.y - o.y) * (b.x - o.x);
};
var hullIdx = (indices, pts) => {
  const tagged = [...new Set(indices)].map((i) => {
    const pt = pts[i];
    if (!pt) return null;
    return { i, x: pt.x, y: pt.y };
  }).filter((value) => value !== null);
  tagged.sort((a, b) => a.x - b.x || a.y - b.y);
  if (tagged.length <= 2) return tagged.map((v) => v.i);
  const lower = [];
  const upper = [];
  for (const p of tagged) {
    while (lower.length >= 2) {
      const prev2 = lower[lower.length - 2];
      const prev1 = lower[lower.length - 1];
      if (!prev2 || !prev1 || cross({ o: prev2, a: prev1, b: p }) > 1e-10) break;
      lower.pop();
    }
    lower.push(p);
  }
  for (let k = tagged.length - 1; k >= 0; k--) {
    const p = tagged[k];
    if (!p) continue;
    while (upper.length >= 2) {
      const prev2 = upper[upper.length - 2];
      const prev1 = upper[upper.length - 1];
      if (!prev2 || !prev1 || cross({ o: prev2, a: prev1, b: p }) > 1e-10) break;
      upper.pop();
    }
    upper.push(p);
  }
  lower.pop();
  upper.pop();
  return lower.concat(upper).map((v) => v.i);
};
var isDefined = (value) => value !== void 0;
var buildRegionsFromCells = (merged) => {
  const regions = merged.cells.map(
    (cell) => cell.map((i) => merged.pts[i]).filter(isDefined)
  );
  const hulls = merged.cells.map(
    (cell) => hullIdx(cell, merged.pts).map((i) => merged.pts[i]).filter(isDefined)
  );
  return { regions, hulls };
};
var clampPointToBounds = (point4, bounds) => ({
  x: Math.min(bounds.maxX, Math.max(bounds.minX, point4.x)),
  y: Math.min(bounds.maxY, Math.max(bounds.minY, point4.y))
});
var BuildRegionsSolver = class extends BaseSolver4 {
  input;
  output = null;
  constructor(input) {
    super();
    this.input = input;
  }
  _step() {
    const boundedPts = this.input.pts.map(
      (pt) => clampPointToBounds(pt, this.input.bounds)
    );
    const { regions, hulls } = buildRegionsFromCells({
      ...this.input,
      pts: boundedPts
    });
    this.output = {
      pts: boundedPts,
      validTris: this.input.validTris,
      regions,
      hulls,
      depths: this.input.depths
    };
    this.stats = { regions: regions.length };
    this.solved = true;
  }
  getConstructorParams() {
    return [this.input];
  }
  getOutput() {
    return this.output;
  }
  visualize() {
    const output = this.output;
    if (!output) {
      return { points: [], lines: [], rects: [], circles: [], texts: [] };
    }
    return {
      points: output.pts.map((pt) => ({ x: pt.x, y: pt.y, color: "#3b82f6" })),
      lines: output.regions.flatMap(
        (region) => region.flatMap((point4, i) => {
          const next = region[(i + 1) % region.length];
          if (!next) return [];
          return [{ points: [point4, next], strokeColor: "#0f766e" }];
        })
      ),
      rects: [],
      circles: [],
      texts: [
        {
          x: 4,
          y: 12,
          text: `regions: ${output.regions.length}`,
          color: "#1f2937"
        }
      ]
    };
  }
};
var getOffsetPolygonPoints = (params) => {
  const { polygon: polygon2, clearance, verticesOnly = false } = params;
  const pts = polygon2.points;
  const n = pts.length;
  if (n < 3) return [];
  const flattenPoly = new Polygon$1(pts.map((p) => point(p.x, p.y)));
  const isCCW = flattenPoly.orientation() === ORIENTATION.CCW;
  const offsetLines = [];
  for (let i = 0; i < n; i++) {
    const p1 = pts[i];
    const p2 = pts[(i + 1) % n];
    const edgeVec = vector$1(p2.x - p1.x, p2.y - p1.y);
    const len = edgeVec.length;
    if (len === 0) {
      offsetLines.push(line(point(p1.x, p1.y), vector$1(1, 0)));
      continue;
    }
    const dir = edgeVec.normalize();
    const outwardNormal = isCCW ? vector$1(dir.y, -dir.x) : vector$1(-dir.y, dir.x);
    const offsetPt = point(
      p1.x + clearance * outwardNormal.x,
      p1.y + clearance * outwardNormal.y
    );
    offsetLines.push(line(offsetPt, outwardNormal));
  }
  const offsetVertices = [];
  for (let i = 0; i < n; i++) {
    const prevLine = offsetLines[(i - 1 + n) % n];
    const currLine = offsetLines[i];
    const intersections = prevLine.intersect(currLine);
    if (intersections.length > 0) {
      const ip = intersections[0];
      offsetVertices.push({ x: ip.x, y: ip.y });
    } else {
      offsetVertices.push({ x: currLine.pt.x, y: currLine.pt.y });
    }
  }
  if (verticesOnly) {
    return offsetVertices;
  }
  const result = [];
  for (let i = 0; i < n; i++) {
    const v1 = offsetVertices[i];
    const v2 = offsetVertices[(i + 1) % n];
    const seg = segment(point(v1.x, v1.y), point(v2.x, v2.y));
    const edgeLength = seg.length;
    const numSegments = Math.max(2, Math.ceil(edgeLength / 20));
    for (let j = 0; j < numSegments; j++) {
      const t = j / numSegments;
      result.push({
        x: v1.x + t * (v2.x - v1.x),
        y: v1.y + t * (v2.y - v1.y)
      });
    }
  }
  return result;
};
var rotatePoint = (params) => {
  const { localX, localY, rect } = params;
  const cosTheta = Math.cos(rect.ccwRotation);
  const sinTheta = Math.sin(rect.ccwRotation);
  return {
    x: rect.center.x + localX * cosTheta - localY * sinTheta,
    y: rect.center.y + localX * sinTheta + localY * cosTheta
  };
};
var generateBoundaryPoints = (params) => {
  const {
    bounds,
    vias,
    clearance,
    rects,
    polygons = [],
    viaSegments = 24
  } = params;
  const points = [];
  const { minX: x0, maxX: x1, minY: y0, maxY: y1 } = bounds;
  points.push(
    { x: x0, y: y0 },
    { x: x1, y: y0 },
    { x: x1, y: y1 },
    { x: x0, y: y1 }
  );
  const edgeSegments = 10;
  for (let i = 1; i < edgeSegments; i++) {
    const t = i / edgeSegments;
    points.push({ x: x0 + t * (x1 - x0), y: y0 });
    points.push({ x: x1, y: y0 + t * (y1 - y0) });
    points.push({ x: x1 - t * (x1 - x0), y: y1 });
    points.push({ x: x0, y: y1 - t * (y1 - y0) });
  }
  for (const via of vias) {
    const radius = via.diameter / 2 + clearance;
    for (let i = 0; i < viaSegments; i++) {
      const angle = 2 * Math.PI * i / viaSegments;
      points.push({
        x: via.center.x + radius * Math.cos(angle),
        y: via.center.y + radius * Math.sin(angle)
      });
    }
  }
  for (const rect of rects) {
    const halfWidth = rect.width / 2 + clearance;
    const halfHeight = rect.height / 2 + clearance;
    const rectEdgeSegments = Math.max(
      2,
      Math.ceil(Math.max(halfWidth * 2, halfHeight * 2) / 20)
    );
    for (let i = 0; i < rectEdgeSegments; i++) {
      const t = i / rectEdgeSegments;
      points.push(
        rotatePoint({
          localX: -halfWidth + t * 2 * halfWidth,
          localY: -halfHeight,
          rect
        })
      );
      points.push(
        rotatePoint({
          localX: halfWidth,
          localY: -halfHeight + t * 2 * halfHeight,
          rect
        })
      );
      points.push(
        rotatePoint({
          localX: halfWidth - t * 2 * halfWidth,
          localY: halfHeight,
          rect
        })
      );
      points.push(
        rotatePoint({
          localX: -halfWidth,
          localY: halfHeight - t * 2 * halfHeight,
          rect
        })
      );
    }
  }
  for (const polygon2 of polygons) {
    if (polygon2.points.length < 3) continue;
    const offsetPoints = getOffsetPolygonPoints({ polygon: polygon2, clearance });
    points.push(...offsetPoints);
  }
  return points.map((pt, i) => ({
    x: pt.x + (i % 7 - 3) * 1e-6,
    y: pt.y + (i % 5 - 2) * 1e-6
  }));
};
var resolveConstraintCrossings = (pts, constraintEdges, ringBoundaries) => {
  const edgeRing = new Array(constraintEdges.length);
  for (let ei = 0; ei < constraintEdges.length; ei++) {
    for (let ri = ringBoundaries.length - 1; ri >= 0; ri--) {
      if (ei >= ringBoundaries[ri]) {
        edgeRing[ei] = ri;
        break;
      }
    }
  }
  const edgeSplits = /* @__PURE__ */ new Map();
  const outPts = pts.slice();
  for (let i = 0; i < constraintEdges.length; i++) {
    for (let j = i + 1; j < constraintEdges.length; j++) {
      if (edgeRing[i] === edgeRing[j]) continue;
      const [a1, a2] = constraintEdges[i];
      const [b1, b2] = constraintEdges[j];
      const p1 = outPts[a1];
      const p2 = outPts[a2];
      const p3 = outPts[b1];
      const p4 = outPts[b2];
      const d1x = p2.x - p1.x;
      const d1y = p2.y - p1.y;
      const d2x = p4.x - p3.x;
      const d2y = p4.y - p3.y;
      const denom = d1x * d2y - d1y * d2x;
      if (Math.abs(denom) < 1e-10) continue;
      const t = ((p3.x - p1.x) * d2y - (p3.y - p1.y) * d2x) / denom;
      const u = ((p3.x - p1.x) * d1y - (p3.y - p1.y) * d1x) / denom;
      if (t > 1e-6 && t < 1 - 1e-6 && u > 1e-6 && u < 1 - 1e-6) {
        const ix = p1.x + t * d1x;
        const iy = p1.y + t * d1y;
        const newIdx = outPts.length;
        outPts.push({ x: ix, y: iy });
        if (!edgeSplits.has(i)) edgeSplits.set(i, []);
        edgeSplits.get(i).push({ t, idx: newIdx });
        if (!edgeSplits.has(j)) edgeSplits.set(j, []);
        edgeSplits.get(j).push({ t: u, idx: newIdx });
      }
    }
  }
  if (edgeSplits.size === 0) {
    return { pts, constraintEdges, hadCrossings: false };
  }
  const outEdges = [];
  for (let ei = 0; ei < constraintEdges.length; ei++) {
    const splits = edgeSplits.get(ei);
    if (!splits || splits.length === 0) {
      outEdges.push(constraintEdges[ei]);
      continue;
    }
    splits.sort((a, b) => a.t - b.t);
    const [startIdx, endIdx] = constraintEdges[ei];
    let prev = startIdx;
    for (const split of splits) {
      outEdges.push([prev, split.idx]);
      prev = split.idx;
    }
    outEdges.push([prev, endIdx]);
  }
  return { pts: outPts, constraintEdges: outEdges, hadCrossings: true };
};
var ringToFlattenPoly = (ring) => {
  return new Polygon$1(ring.map((p) => point(p.x, p.y)));
};
var extractFaces = (poly) => {
  const result = [];
  for (const face of poly.faces) {
    const ring = [];
    for (const v of face.vertices) {
      ring.push({ x: v.x, y: v.y });
    }
    if (ring.length >= 3) {
      result.push(ring);
    }
  }
  return result;
};
var unionObstacleBoundaries = (rings) => {
  if (rings.length <= 1) return rings;
  try {
    let polys = rings.map(ringToFlattenPoly);
    for (let pass = 0; pass < 2; pass++) {
      const merged = [];
      const used = /* @__PURE__ */ new Set();
      for (let i = 0; i < polys.length; i++) {
        if (used.has(i)) continue;
        let current = polys[i];
        for (let j = i + 1; j < polys.length; j++) {
          if (used.has(j)) continue;
          const boxA = current.box;
          const boxB = polys[j].box;
          if (boxA.xmin > boxB.xmax + 1e-6 || boxA.xmax < boxB.xmin - 1e-6 || boxA.ymin > boxB.ymax + 1e-6 || boxA.ymax < boxB.ymin - 1e-6) {
            continue;
          }
          try {
            const unified = BooleanOperations.unify(current, polys[j]);
            if (unified.faces.size > 0) {
              current = unified;
              used.add(j);
            }
          } catch {
          }
        }
        merged.push(current);
        used.add(i);
      }
      polys = merged;
    }
    const result = [];
    for (const poly of polys) {
      const faces = extractFaces(poly);
      result.push(...faces);
    }
    return result.length > 0 ? result : rings;
  } catch {
    return rings;
  }
};
var addRing = (ringPts, allPts, constraintEdges) => {
  const startIdx = allPts.length;
  allPts.push(...ringPts);
  const n = ringPts.length;
  for (let i = 0; i < n; i++) {
    constraintEdges.push([startIdx + i, startIdx + (i + 1) % n]);
  }
};
var generateBoundaryPointsWithEdges = (params) => {
  const {
    bounds,
    vias,
    clearance,
    rects,
    polygons = [],
    viaSegments = 8
  } = params;
  const allPts = [];
  const constraintEdges = [];
  const ringBoundaries = [];
  const { minX: x0, maxX: x1, minY: y0, maxY: y1 } = bounds;
  const edgeSegments = 10;
  const boundsPts = [];
  for (let i = 0; i < edgeSegments; i++) {
    const t = i / edgeSegments;
    boundsPts.push({ x: x0 + t * (x1 - x0), y: y0 });
  }
  for (let i = 0; i < edgeSegments; i++) {
    const t = i / edgeSegments;
    boundsPts.push({ x: x1, y: y0 + t * (y1 - y0) });
  }
  for (let i = 0; i < edgeSegments; i++) {
    const t = i / edgeSegments;
    boundsPts.push({ x: x1 - t * (x1 - x0), y: y1 });
  }
  for (let i = 0; i < edgeSegments; i++) {
    const t = i / edgeSegments;
    boundsPts.push({ x: x0, y: y1 - t * (y1 - y0) });
  }
  ringBoundaries.push(constraintEdges.length);
  addRing(boundsPts, allPts, constraintEdges);
  const obstacleRings = [];
  for (const via of vias) {
    const radius = via.diameter / 2 + clearance;
    const viaPts = [];
    for (let i = 0; i < viaSegments; i++) {
      const angle = 2 * Math.PI * i / viaSegments;
      viaPts.push({
        x: via.center.x + radius * Math.cos(angle),
        y: via.center.y + radius * Math.sin(angle)
      });
    }
    obstacleRings.push(viaPts);
  }
  for (const rect of rects) {
    const halfWidth = rect.width / 2 + clearance;
    const halfHeight = rect.height / 2 + clearance;
    const rectPts = [
      rotatePoint({ localX: -halfWidth, localY: -halfHeight, rect }),
      rotatePoint({ localX: halfWidth, localY: -halfHeight, rect }),
      rotatePoint({ localX: halfWidth, localY: halfHeight, rect }),
      rotatePoint({ localX: -halfWidth, localY: halfHeight, rect })
    ];
    obstacleRings.push(rectPts);
  }
  for (const polygon2 of polygons) {
    if (polygon2.points.length < 3) continue;
    const offsetPoints = getOffsetPolygonPoints({
      polygon: polygon2,
      clearance,
      verticesOnly: true
    });
    obstacleRings.push(offsetPoints);
  }
  const mergedRings = unionObstacleBoundaries(obstacleRings);
  for (const ring of mergedRings) {
    ringBoundaries.push(constraintEdges.length);
    addRing(ring, allPts, constraintEdges);
  }
  const resolved = resolveConstraintCrossings(
    allPts,
    constraintEdges,
    ringBoundaries
  );
  const jitteredPts = resolved.pts.map((pt, i) => ({
    x: pt.x + (i % 7 - 3) * 1e-6,
    y: pt.y + (i % 5 - 2) * 1e-6
  }));
  return {
    pts: jitteredPts,
    constraintEdges: resolved.constraintEdges,
    hadCrossings: resolved.hadCrossings
  };
};
var GeneratePointsSolver = class extends BaseSolver4 {
  input;
  output = null;
  constructor(input) {
    super();
    this.input = input;
  }
  _step() {
    const vias = this.input.vias ?? [];
    const rects = this.input.rects ?? [];
    const polygons = this.input.polygons ?? [];
    if (this.input.useConstrainedDelaunay !== false) {
      const result = generateBoundaryPointsWithEdges({
        bounds: this.input.bounds,
        vias,
        clearance: this.input.clearance,
        rects,
        polygons,
        viaSegments: this.input.viaSegments
      });
      this.output = {
        pts: result.pts,
        constraintEdges: result.constraintEdges,
        hadCrossings: result.hadCrossings
      };
    } else {
      this.output = {
        pts: generateBoundaryPoints({
          bounds: this.input.bounds,
          vias,
          clearance: this.input.clearance,
          rects,
          polygons,
          viaSegments: this.input.viaSegments
        })
      };
    }
    this.stats = { points: this.output.pts.length };
    this.solved = true;
  }
  getConstructorParams() {
    return [this.input];
  }
  getOutput() {
    return this.output;
  }
  visualize() {
    const points = (this.output?.pts ?? []).map((pt) => ({
      x: pt.x,
      y: pt.y,
      color: "#2563eb"
    }));
    const vias = this.input.vias ?? [];
    return {
      points,
      lines: [],
      rects: [],
      circles: vias.map((via) => ({
        center: { x: via.center.x, y: via.center.y },
        radius: via.diameter / 2 + this.input.clearance,
        stroke: "#ef4444"
      })),
      texts: [
        {
          x: this.input.bounds.minX + 6,
          y: this.input.bounds.minY + 12,
          text: `sample points: ${points.length}`,
          color: "#1f2937"
        }
      ]
    };
  }
};
var ptSegDist = (params) => {
  const { p, a, b } = params;
  const dx = b.x - a.x;
  const dy = b.y - a.y;
  const l2 = dx * dx + dy * dy;
  if (l2 < 1e-10) return Math.hypot(p.x - a.x, p.y - a.y);
  let t = ((p.x - a.x) * dx + (p.y - a.y) * dy) / l2;
  t = Math.max(0, Math.min(1, t));
  return Math.hypot(p.x - a.x - t * dx, p.y - a.y - t * dy);
};
var concavityDepth = (ring, pts) => {
  if (ring.length <= 3) return 0;
  const hull = hullIdx(ring, pts);
  const hullSet = new Set(hull);
  const hullPoints = hull.map((i) => pts[i]).filter((pt) => Boolean(pt));
  let maxDepth = 0;
  for (const index of ring) {
    if (hullSet.has(index)) continue;
    const p = pts[index];
    if (!p) continue;
    let minDistance = Number.POSITIVE_INFINITY;
    for (let i = 0; i < hullPoints.length; i++) {
      const a = hullPoints[i];
      const b = hullPoints[(i + 1) % hullPoints.length];
      if (!a || !b) continue;
      minDistance = Math.min(minDistance, ptSegDist({ p, a, b }));
    }
    maxDepth = Math.max(maxDepth, minDistance);
  }
  return maxDepth;
};
var edgeKey = (a, b) => a < b ? a * 1e5 + b : b * 1e5 + a;
var stitchRings = (ringA, ringB) => {
  const edgeA = ringA.map((v, i) => [v, ringA[(i + 1) % ringA.length]]);
  const edgeB = ringB.map((v, i) => [v, ringB[(i + 1) % ringB.length]]);
  const sharedKeys = /* @__PURE__ */ new Set();
  for (const [a1, a2] of edgeA) {
    if (a2 === void 0) continue;
    for (const [b1, b2] of edgeB) {
      if (b2 === void 0) continue;
      if (a1 === b2 && a2 === b1) sharedKeys.add(edgeKey(a1, a2));
    }
  }
  if (sharedKeys.size === 0) return null;
  const remainingEdges = [];
  for (const [a1, a2] of edgeA) {
    if (a2 === void 0) continue;
    if (!sharedKeys.has(edgeKey(a1, a2))) remainingEdges.push([a1, a2]);
  }
  for (const [b1, b2] of edgeB) {
    if (b2 === void 0) continue;
    if (!sharedKeys.has(edgeKey(b1, b2))) remainingEdges.push([b1, b2]);
  }
  if (remainingEdges.length === 0) return null;
  const adjacency = /* @__PURE__ */ new Map();
  for (const [from, to] of remainingEdges) adjacency.set(from, to);
  const start = remainingEdges[0]?.[0];
  if (start === void 0) return null;
  const chain = [start];
  let current = adjacency.get(start);
  let safety = 0;
  while (current !== void 0 && current !== start && safety++ < remainingEdges.length + 5) {
    chain.push(current);
    current = adjacency.get(current);
  }
  if (current !== start || chain.length !== remainingEdges.length) return null;
  return chain;
};
var edgeKey2 = (a, b) => a < b ? a * 1e5 + b : b * 1e5 + a;
var mergeCells = (params) => {
  const { triangles, pts, concavityTolerance } = params;
  if (!triangles.length) return { cells: [], depths: [] };
  const cells = triangles.map(([a, b, c]) => {
    const pa = pts[a];
    const pb = pts[b];
    const pc = pts[c];
    if (!pa || !pb || !pc) return [a, b, c];
    return cross({ o: pa, a: pb, b: pc }) < 0 ? [a, c, b] : [a, b, c];
  });
  let changed = true;
  let iterations = 0;
  while (changed && iterations++ < 800) {
    changed = false;
    const edgeMap = /* @__PURE__ */ new Map();
    const adjacency = cells.map(() => /* @__PURE__ */ new Set());
    for (let ci = 0; ci < cells.length; ci++) {
      const ring = cells[ci];
      if (!ring) continue;
      for (let i = 0; i < ring.length; i++) {
        const current = ring[i];
        const next = ring[(i + 1) % ring.length];
        if (current === void 0 || next === void 0) continue;
        const key = edgeKey2(current, next);
        if (edgeMap.has(key)) {
          const other = edgeMap.get(key);
          if (other !== void 0) {
            adjacency[ci]?.add(other);
            adjacency[other]?.add(ci);
          }
        } else {
          edgeMap.set(key, ci);
        }
      }
    }
    let bestI = -1;
    let bestJ = -1;
    let bestRing = null;
    let bestDepth = Number.POSITIVE_INFINITY;
    for (let i = 0; i < cells.length; i++) {
      const neighbors = adjacency[i];
      if (!neighbors) continue;
      for (const j of neighbors) {
        if (j <= i) continue;
        const merged = stitchRings(cells[i] ?? [], cells[j] ?? []);
        if (!merged) continue;
        const depth = concavityDepth(merged, pts);
        if (depth <= concavityTolerance + 1e-6 && depth < bestDepth) {
          bestDepth = depth;
          bestI = i;
          bestJ = j;
          bestRing = merged;
        }
      }
    }
    if (bestI < 0 || bestJ < 0 || !bestRing) break;
    cells[bestI] = bestRing;
    cells.splice(bestJ, 1);
    changed = true;
  }
  const depths = cells.map((cell) => concavityDepth(cell, pts));
  return { cells, depths };
};
var edgeKey3 = (a, b) => a < b ? a * 1e5 + b : b * 1e5 + a;
var mergeCellsPolyanya = (params) => {
  const { triangles, pts } = params;
  if (!triangles.length) return { cells: [], depths: [] };
  const n = triangles.length;
  const cells = triangles.map(([a, b, c]) => {
    const pa = pts[a];
    const pb = pts[b];
    const pc = pts[c];
    if (!pa || !pb || !pc) return [a, b, c];
    return cross({ o: pa, a: pb, b: pc }) < 0 ? [a, c, b] : [a, b, c];
  });
  const adj = new Array(n).fill(null);
  for (let i = 0; i < n; i++) adj[i] = /* @__PURE__ */ new Map();
  function rebuildAdj() {
    for (let i = 0; i < adj.length; i++) {
      if (adj[i]) adj[i].clear();
    }
    const edgeMap = /* @__PURE__ */ new Map();
    for (let ci = 0; ci < cells.length; ci++) {
      const ring = cells[ci];
      if (!ring) continue;
      for (let k = 0; k < ring.length; k++) {
        const a = ring[k];
        const b = ring[(k + 1) % ring.length];
        const key = edgeKey3(a, b);
        const existing = edgeMap.get(key);
        if (existing) {
          adj[ci].set(k, {
            neighbor: existing.cellIdx,
            neighborEdge: existing.edgePos
          });
          adj[existing.cellIdx].set(existing.edgePos, {
            neighbor: ci,
            neighborEdge: k
          });
        } else {
          edgeMap.set(key, { cellIdx: ci, edgePos: k });
        }
      }
    }
  }
  rebuildAdj();
  function cellArea(ring) {
    let a = 0;
    for (let i = 0; i < ring.length; i++) {
      const p = pts[ring[i]];
      const q = pts[ring[(i + 1) % ring.length]];
      a += p.x * q.y - q.x * p.y;
    }
    return Math.abs(a) / 2;
  }
  function findBoundary(xIdx, yIdx) {
    const xRing = cells[xIdx];
    const xAdj = adj[xIdx];
    const L = xRing.length;
    let seedK = -1;
    for (const [k, entry] of xAdj) {
      if (entry.neighbor === yIdx) {
        seedK = k;
        break;
      }
    }
    if (seedK === -1) return null;
    let firstK = seedK;
    while (true) {
      const prev = (firstK - 1 + L) % L;
      if (prev === seedK) break;
      const prevEntry = xAdj.get(prev);
      if (!prevEntry || prevEntry.neighbor !== yIdx) break;
      firstK = prev;
    }
    let lastK = seedK;
    while (true) {
      const next = (lastK + 1) % L;
      if (next === firstK) break;
      const nextEntry = xAdj.get(next);
      if (!nextEntry || nextEntry.neighbor !== yIdx) break;
      lastK = next;
    }
    const sharedCount = (lastK - firstK + L) % L + 1;
    return { firstK, lastK, sharedCount };
  }
  function canMerge(xIdx, yIdx) {
    const xRing = cells[xIdx];
    const yRing = cells[yIdx];
    const boundary = findBoundary(xIdx, yIdx);
    if (!boundary) return false;
    const { firstK, lastK, sharedCount } = boundary;
    const N = xRing.length;
    const M = yRing.length;
    const A = xRing[firstK];
    const B = xRing[(lastK + 1) % N];
    let mA = -1;
    for (let i = 0; i < M; i++) {
      if (yRing[i] === A) {
        mA = i;
        break;
      }
    }
    if (mA === -1) return false;
    const mB = (mA - sharedCount + M) % M;
    if (yRing[mB] !== B) return false;
    const prevX = pts[xRing[(firstK - 1 + N) % N]];
    const pA = pts[A];
    const nextY = pts[yRing[(mA + 1) % M]];
    if (cross({ o: prevX, a: pA, b: nextY }) < -1e-8) return false;
    const prevY = pts[yRing[(mB - 1 + M) % M]];
    const pB = pts[B];
    const nextX = pts[xRing[(lastK + 2) % N]];
    if (cross({ o: prevY, a: pB, b: nextX }) < -1e-8) return false;
    return true;
  }
  function doMerge(xIdx, yIdx) {
    const xRing = cells[xIdx];
    const yRing = cells[yIdx];
    const boundary = findBoundary(xIdx, yIdx);
    const { firstK, lastK, sharedCount } = boundary;
    const N = xRing.length;
    const M = yRing.length;
    const A = xRing[firstK];
    const B = xRing[(lastK + 1) % N];
    let mA = -1;
    for (let i = 0; i < M; i++) {
      if (yRing[i] === A) {
        mA = i;
        break;
      }
    }
    const newRing = [];
    newRing.push(A);
    const yNonShared = M - sharedCount - 1;
    for (let j = 1; j <= yNonShared; j++) {
      newRing.push(yRing[(mA + j) % M]);
    }
    newRing.push(B);
    const xNonShared = N - sharedCount - 1;
    for (let j = 2; j <= xNonShared + 1; j++) {
      newRing.push(xRing[(lastK + j) % N]);
    }
    cells[xIdx] = newRing;
    cells[yIdx] = null;
  }
  let changed = true;
  while (changed) {
    changed = false;
    rebuildAdj();
    for (let i = 0; i < cells.length; i++) {
      if (!cells[i]) continue;
      const iAdj = adj[i];
      const neighbors = /* @__PURE__ */ new Set();
      for (const [, entry] of iAdj) {
        if (cells[entry.neighbor]) neighbors.add(entry.neighbor);
      }
      if (neighbors.size === 1) {
        const nIdx = neighbors.values().next().value;
        if (canMerge(i, nIdx)) {
          doMerge(i, nIdx);
          changed = true;
        }
      }
    }
  }
  rebuildAdj();
  const areas = new Array(cells.length).fill(0);
  for (let i = 0; i < cells.length; i++) {
    if (cells[i]) areas[i] = cellArea(cells[i]);
  }
  const heap = [];
  function heapPush(e) {
    heap.push(e);
    let i = heap.length - 1;
    while (i > 0) {
      const p = i - 1 >> 1;
      if (heap[p].area >= heap[i].area) break;
      const t = heap[p];
      heap[p] = heap[i];
      heap[i] = t;
      i = p;
    }
  }
  function heapPop() {
    if (heap.length === 0) return void 0;
    const top = heap[0];
    const last = heap.pop();
    if (heap.length > 0) {
      heap[0] = last;
      let i = 0;
      while (true) {
        let big = i;
        const l = 2 * i + 1;
        const r = 2 * i + 2;
        if (l < heap.length && heap[l].area > heap[big].area) big = l;
        if (r < heap.length && heap[r].area > heap[big].area) big = r;
        if (big === i) break;
        const t = heap[i];
        heap[i] = heap[big];
        heap[big] = t;
        i = big;
      }
    }
    return top;
  }
  const seenPairs = /* @__PURE__ */ new Set();
  for (let i = 0; i < cells.length; i++) {
    if (!cells[i]) continue;
    const iAdj = adj[i];
    const neighbors = /* @__PURE__ */ new Set();
    for (const [, entry] of iAdj) {
      if (cells[entry.neighbor]) neighbors.add(entry.neighbor);
    }
    for (const nIdx of neighbors) {
      const pairKey = i < nIdx ? i * 1e5 + nIdx : nIdx * 1e5 + i;
      if (seenPairs.has(pairKey)) continue;
      seenPairs.add(pairKey);
      if (canMerge(i, nIdx)) {
        heapPush({ area: areas[i] + areas[nIdx], xIdx: i, yIdx: nIdx });
      }
    }
  }
  while (heap.length > 0) {
    const entry = heapPop();
    const { xIdx, yIdx } = entry;
    if (!cells[xIdx] || !cells[yIdx]) continue;
    const currentArea = areas[xIdx] + areas[yIdx];
    if (Math.abs(currentArea - entry.area) > 1e-10) {
      if (canMerge(xIdx, yIdx)) {
        heapPush({ area: currentArea, xIdx, yIdx });
      }
      continue;
    }
    if (!canMerge(xIdx, yIdx)) continue;
    doMerge(xIdx, yIdx);
    areas[xIdx] = cellArea(cells[xIdx]);
    rebuildAdj();
    const xAdj = adj[xIdx];
    const neighbors = /* @__PURE__ */ new Set();
    for (const [, e] of xAdj) {
      if (cells[e.neighbor]) neighbors.add(e.neighbor);
    }
    for (const nIdx of neighbors) {
      if (canMerge(xIdx, nIdx)) {
        heapPush({ area: areas[xIdx] + areas[nIdx], xIdx, yIdx: nIdx });
      }
    }
  }
  const liveCells = cells.filter((c) => c !== null);
  const depths = liveCells.map(() => 0);
  return { cells: liveCells, depths };
};
var MergeCellsSolver = class extends BaseSolver4 {
  input;
  output = null;
  constructor(input) {
    super();
    this.input = input;
  }
  _step() {
    const merged = this.input.usePolyanyaMerge !== false ? mergeCellsPolyanya({
      triangles: this.input.validTris,
      pts: this.input.pts
    }) : mergeCells({
      triangles: this.input.validTris,
      pts: this.input.pts,
      concavityTolerance: this.input.concavityTolerance
    });
    this.output = {
      pts: this.input.pts,
      bounds: this.input.bounds,
      validTris: this.input.validTris,
      cells: merged.cells,
      depths: merged.depths
    };
    this.stats = {
      mergedCells: merged.cells.length,
      maxDepth: merged.depths.length ? Math.max(...merged.depths) : 0
    };
    this.solved = true;
  }
  getConstructorParams() {
    return [this.input];
  }
  getOutput() {
    return this.output;
  }
  visualize() {
    const cells = this.output?.cells ?? [];
    return {
      points: this.input.pts.map((pt) => ({
        x: pt.x,
        y: pt.y,
        color: "#3b82f6"
      })),
      lines: cells.flatMap(
        (cell) => cell.flatMap((index, i) => {
          const from = this.input.pts[index];
          const nextIndex = cell[(i + 1) % cell.length];
          const to = nextIndex === void 0 ? void 0 : this.input.pts[nextIndex];
          if (!from || !to) return [];
          return [{ points: [from, to], strokeColor: "#10b981" }];
        })
      ),
      rects: [],
      circles: [],
      texts: [
        {
          x: 4,
          y: 12,
          text: `merged cells: ${cells.length}`,
          color: "#1f2937"
        }
      ]
    };
  }
};
var constrainedDelaunay = (pts, constraintEdges) => {
  const coords = pts.map((p) => [p.x, p.y]);
  return (0, import_cdt2d.default)(coords, constraintEdges, { exterior: false });
};
var circumcircle = (params) => {
  const { a, b, c } = params;
  const d = 2 * (a.x * (b.y - c.y) + b.x * (c.y - a.y) + c.x * (a.y - b.y));
  if (Math.abs(d) < 1e-10) return { x: 0, y: 0, r2: 1e18 };
  const a2 = a.x * a.x + a.y * a.y;
  const b2 = b.x * b.x + b.y * b.y;
  const c2 = c.x * c.x + c.y * c.y;
  const ux = (a2 * (b.y - c.y) + b2 * (c.y - a.y) + c2 * (a.y - b.y)) / d;
  const uy = (a2 * (c.x - b.x) + b2 * (a.x - c.x) + c2 * (b.x - a.x)) / d;
  return { x: ux, y: uy, r2: (a.x - ux) ** 2 + (a.y - uy) ** 2 };
};
var hasEdge = (triangle, p1, p2) => [triangle.a, triangle.b, triangle.c].includes(p1) && [triangle.a, triangle.b, triangle.c].includes(p2);
var delaunay = (rawPoints) => {
  const points = rawPoints.map((p, i) => ({ ...p, i }));
  if (points.length < 3) return [];
  let minX = Number.POSITIVE_INFINITY;
  let minY = Number.POSITIVE_INFINITY;
  let maxX = Number.NEGATIVE_INFINITY;
  let maxY = Number.NEGATIVE_INFINITY;
  for (const p of points) {
    minX = Math.min(minX, p.x);
    minY = Math.min(minY, p.y);
    maxX = Math.max(maxX, p.x);
    maxY = Math.max(maxY, p.y);
  }
  const dimension = Math.max(maxX - minX, maxY - minY) || 1;
  const midX = (minX + maxX) / 2;
  const midY = (minY + maxY) / 2;
  const s0 = {
    x: midX - 30 * dimension,
    y: midY - dimension,
    i: -1
  };
  const s1 = { x: midX, y: midY + 30 * dimension, i: -2 };
  const s2 = {
    x: midX + 30 * dimension,
    y: midY - dimension,
    i: -3
  };
  let triangles = [
    { a: s0, b: s1, c: s2, cc: circumcircle({ a: s0, b: s1, c: s2 }) }
  ];
  for (const p of points) {
    const bad = triangles.filter((triangle) => {
      const dx = p.x - triangle.cc.x;
      const dy = p.y - triangle.cc.y;
      return dx * dx + dy * dy < triangle.cc.r2 + 1e-6;
    });
    const badSet = new Set(bad);
    const boundaryEdges = [];
    for (const triangle of bad) {
      const triangleEdges = [
        [triangle.a, triangle.b],
        [triangle.b, triangle.c],
        [triangle.c, triangle.a]
      ];
      for (const [ea, eb] of triangleEdges) {
        let isShared = false;
        for (const other of bad) {
          if (other === triangle) continue;
          if (hasEdge(other, ea, eb)) {
            isShared = true;
            break;
          }
        }
        if (!isShared) boundaryEdges.push([ea, eb]);
      }
    }
    triangles = triangles.filter((triangle) => !badSet.has(triangle));
    for (const [ea, eb] of boundaryEdges) {
      triangles.push({
        a: ea,
        b: eb,
        c: p,
        cc: circumcircle({ a: ea, b: eb, c: p })
      });
    }
  }
  return triangles.filter(
    (triangle) => triangle.a.i >= 0 && triangle.b.i >= 0 && triangle.c.i >= 0
  ).map((triangle) => [triangle.a.i, triangle.b.i, triangle.c.i]);
};
var isPointInOrNearPolygon = (params) => {
  const { px, py, polygonPoints, clearance } = params;
  const n = polygonPoints.length;
  if (n < 3) return false;
  const pts = polygonPoints.map((p) => point(p.x, p.y));
  const shapes = [];
  for (let i = 0; i < pts.length; i++) {
    const p1 = pts[i];
    const p2 = pts[(i + 1) % pts.length];
    shapes.push(segment(p1, p2));
  }
  const flattenPoly = new Polygon$1();
  flattenPoly.addFace(shapes);
  const testPoint = point(px, py);
  if (flattenPoly.contains(testPoint)) {
    return true;
  }
  const [distance3] = flattenPoly.distanceTo(testPoint);
  return distance3 < clearance - 0.1;
};
var inFreeSpace = (params) => {
  const { px, py, bounds, vias, clearance, rects, polygons } = params;
  const { minX, maxX, minY, maxY } = bounds;
  const maxDim = Math.max(maxX - minX, maxY - minY, 1);
  const eps = maxDim * 1e-6;
  if (px < minX - eps || px > maxX + eps || py < minY - eps || py > maxY + eps) {
    return false;
  }
  for (const via of vias) {
    const radius = via.diameter / 2 + clearance;
    const effectiveRadius = Math.max(0, radius - eps);
    if ((px - via.center.x) ** 2 + (py - via.center.y) ** 2 < effectiveRadius * effectiveRadius) {
      return false;
    }
  }
  for (const rect of rects) {
    const halfWidth = rect.width / 2 + clearance;
    const halfHeight = rect.height / 2 + clearance;
    const effectiveHalfWidth = Math.max(0, halfWidth - eps);
    const effectiveHalfHeight = Math.max(0, halfHeight - eps);
    const dx = px - rect.center.x;
    const dy = py - rect.center.y;
    const cosTheta = Math.cos(rect.ccwRotation);
    const sinTheta = Math.sin(rect.ccwRotation);
    const localX = dx * cosTheta + dy * sinTheta;
    const localY = -dx * sinTheta + dy * cosTheta;
    if (Math.abs(localX) < effectiveHalfWidth && Math.abs(localY) < effectiveHalfHeight) {
      return false;
    }
  }
  for (const polygon2 of polygons) {
    if (isPointInOrNearPolygon({
      px,
      py,
      polygonPoints: polygon2.points,
      clearance
    })) {
      return false;
    }
  }
  return true;
};
var filterTris = (params) => {
  const { triangles, pts, bounds, vias, clearance, rects, polygons } = params;
  return triangles.filter(([a, b, c]) => {
    const pa = pts[a];
    const pb = pts[b];
    const pc = pts[c];
    if (!pa || !pb || !pc) return false;
    const cx = (pa.x + pb.x + pc.x) / 3;
    const cy = (pa.y + pb.y + pc.y) / 3;
    if (!inFreeSpace({
      px: cx,
      py: cy,
      bounds,
      vias,
      clearance,
      rects,
      polygons
    })) {
      return false;
    }
    if (polygons.length > 0) {
      const pointsToCheck = [
        pa,
        pb,
        pc,
        { x: (pa.x + pb.x) / 2, y: (pa.y + pb.y) / 2 },
        { x: (pb.x + pc.x) / 2, y: (pb.y + pc.y) / 2 },
        { x: (pc.x + pa.x) / 2, y: (pc.y + pa.y) / 2 }
      ];
      for (const pt of pointsToCheck) {
        for (const polygon2 of polygons) {
          if (isPointInOrNearPolygon({
            px: pt.x,
            py: pt.y,
            polygonPoints: polygon2.points,
            clearance
          })) {
            return false;
          }
        }
      }
    }
    return true;
  });
};
var TriangulateSolver = class extends BaseSolver4 {
  input;
  output = null;
  constructor(input) {
    super();
    this.input = input;
  }
  _step() {
    const vias = this.input.vias ?? [];
    const rects = this.input.rects ?? [];
    const polygons = this.input.polygons ?? [];
    let validTris;
    if (this.input.useConstrainedDelaunay !== false && this.input.constraintEdges) {
      const cdtTris = constrainedDelaunay(
        this.input.pts,
        this.input.constraintEdges
      );
      const hasObstacles = vias.length > 0 || rects.length > 0 || polygons.length > 0;
      validTris = hasObstacles ? filterTris({
        triangles: cdtTris,
        pts: this.input.pts,
        bounds: this.input.bounds,
        vias,
        clearance: this.input.clearance,
        rects,
        polygons
      }) : cdtTris;
    } else {
      const allTriangles = delaunay(this.input.pts);
      validTris = filterTris({
        triangles: allTriangles,
        pts: this.input.pts,
        bounds: this.input.bounds,
        vias,
        clearance: this.input.clearance,
        rects,
        polygons
      });
    }
    this.output = {
      pts: this.input.pts,
      bounds: this.input.bounds,
      validTris
    };
    this.stats = {
      validTriangles: validTris.length
    };
    this.solved = true;
  }
  getConstructorParams() {
    return [this.input];
  }
  getOutput() {
    return this.output;
  }
  visualize() {
    const triangles = this.output?.validTris ?? [];
    return {
      points: this.input.pts.map((pt) => ({
        x: pt.x,
        y: pt.y,
        color: "#2563eb"
      })),
      lines: triangles.flatMap(([a, b, c]) => {
        const pa = this.input.pts[a];
        const pb = this.input.pts[b];
        const pc = this.input.pts[c];
        if (!pa || !pb || !pc) return [];
        return [
          { points: [pa, pb], strokeColor: "#64748b" },
          { points: [pb, pc], strokeColor: "#64748b" },
          { points: [pc, pa], strokeColor: "#64748b" }
        ];
      }),
      rects: [],
      circles: [],
      texts: [
        {
          x: this.input.bounds.minX + 6,
          y: this.input.bounds.minY + 12,
          text: `valid triangles: ${triangles.length}`,
          color: "#1f2937"
        }
      ]
    };
  }
};
var ConvexRegionsSolver = class extends BasePipelineSolver {
  pipelineDef = [
    definePipelineStep("generatePoints", GeneratePointsSolver, (instance) => [
      instance.inputProblem
    ]),
    definePipelineStep("triangulate", TriangulateSolver, (instance) => {
      const generated = instance.getStageOutput("generatePoints");
      if (!generated) throw new Error("generatePoints output missing");
      return [
        {
          pts: generated.pts,
          bounds: instance.inputProblem.bounds,
          vias: instance.inputProblem.vias,
          rects: instance.inputProblem.rects,
          polygons: instance.inputProblem.polygons,
          clearance: instance.inputProblem.clearance,
          useConstrainedDelaunay: instance.inputProblem.useConstrainedDelaunay,
          constraintEdges: generated.constraintEdges,
          hadCrossings: generated.hadCrossings
        }
      ];
    }),
    definePipelineStep("mergeCells", MergeCellsSolver, (instance) => {
      const triangulated = instance.getStageOutput("triangulate");
      if (!triangulated) throw new Error("triangulate output missing");
      return [
        {
          pts: triangulated.pts,
          bounds: triangulated.bounds,
          validTris: triangulated.validTris,
          concavityTolerance: instance.inputProblem.concavityTolerance,
          usePolyanyaMerge: instance.inputProblem.usePolyanyaMerge
        }
      ];
    }),
    definePipelineStep("buildRegions", BuildRegionsSolver, (instance) => {
      const merged = instance.getStageOutput("mergeCells");
      if (!merged) throw new Error("mergeCells output missing");
      return [merged];
    })
  ];
  getConstructorParams() {
    return [this.inputProblem];
  }
  getOutput() {
    return this.getStageOutput("buildRegions") ?? null;
  }
  visualize() {
    const result = this.getOutput();
    if (!result) {
      return { points: [], lines: [], rects: [], circles: [], texts: [] };
    }
    const boundsWidth = this.inputProblem.bounds.maxX - this.inputProblem.bounds.minX;
    const boundsHeight = this.inputProblem.bounds.maxY - this.inputProblem.bounds.minY;
    const maxDim = Math.max(boundsWidth, boundsHeight, Number.EPSILON);
    const targetVisualSize = 400;
    const displayScale = Math.max(1, targetVisualSize / maxDim);
    const displayOffsetX = -this.inputProblem.bounds.minX * displayScale;
    const displayOffsetY = -this.inputProblem.bounds.minY * displayScale;
    const toDisplayPoint = (point4) => ({
      x: point4.x * displayScale + displayOffsetX,
      y: point4.y * displayScale + displayOffsetY
    });
    const polygonLines = (this.inputProblem.polygons ?? []).flatMap(
      (polygon2) => {
        const pts = polygon2.points;
        return pts.map((p, i) => {
          const next = pts[(i + 1) % pts.length];
          return {
            points: [toDisplayPoint(p), toDisplayPoint(next)],
            strokeColor: "#ff9f43",
            strokeWidth: 2
          };
        });
      }
    );
    const rectLines = (this.inputProblem.rects ?? []).flatMap((rect) => {
      const halfW = rect.width / 2;
      const halfH = rect.height / 2;
      const cos22 = Math.cos(rect.ccwRotation);
      const sin22 = Math.sin(rect.ccwRotation);
      const corners = [
        { lx: -halfW, ly: -halfH },
        { lx: halfW, ly: -halfH },
        { lx: halfW, ly: halfH },
        { lx: -halfW, ly: halfH }
      ].map(({ lx, ly }) => ({
        x: rect.center.x + lx * cos22 - ly * sin22,
        y: rect.center.y + lx * sin22 + ly * cos22
      }));
      return corners.map((p, i) => {
        const next = corners[(i + 1) % corners.length];
        return {
          points: [toDisplayPoint(p), toDisplayPoint(next)],
          strokeColor: "#ff6b6b",
          strokeWidth: 2
        };
      });
    });
    return {
      points: result.pts.map((pt) => ({
        ...toDisplayPoint(pt),
        color: "#38b6ff"
      })),
      lines: [
        ...result.regions.flatMap(
          (region) => region.map((p, i) => {
            const next = region[(i + 1) % region.length] ?? p;
            return {
              points: [toDisplayPoint(p), toDisplayPoint(next)],
              strokeColor: "#4ecb82"
            };
          })
        ),
        ...polygonLines,
        ...rectLines
      ],
      rects: [],
      circles: (this.inputProblem.vias ?? []).map((via) => ({
        center: toDisplayPoint(via.center),
        radius: via.diameter / 2 * displayScale,
        stroke: "#ff6b6b"
      })),
      texts: [
        {
          x: 8,
          y: 16,
          text: `regions=${result.regions.length}`,
          color: "#ffffff"
        }
      ]
    };
  }
};

// lib/ViaGraphSolver/via-graph-generator/findSharedEdges.ts
function areCollinear(a1, a2, b1, b2, tolerance) {
  const dax = a2.x - a1.x;
  const day = a2.y - a1.y;
  const dbx = b2.x - b1.x;
  const dby = b2.y - b1.y;
  const cross2 = dax * dby - day * dbx;
  const lenA = Math.sqrt(dax * dax + day * day);
  const lenB = Math.sqrt(dbx * dbx + dby * dby);
  if (lenA < tolerance || lenB < tolerance) return false;
  const normalizedCross = Math.abs(cross2) / (lenA * lenB);
  if (normalizedCross > tolerance) return false;
  const vx = b1.x - a1.x;
  const vy = b1.y - a1.y;
  const crossToB1 = Math.abs(dax * vy - day * vx) / lenA;
  return crossToB1 < tolerance;
}
function projectOntoSegment(p, a, b) {
  const dx = b.x - a.x;
  const dy = b.y - a.y;
  const lenSq = dx * dx + dy * dy;
  if (lenSq < 1e-12) {
    const dist = Math.sqrt((p.x - a.x) ** 2 + (p.y - a.y) ** 2);
    return { t: 0, distance: dist };
  }
  const t = ((p.x - a.x) * dx + (p.y - a.y) * dy) / lenSq;
  const closestX = a.x + t * dx;
  const closestY = a.y + t * dy;
  const distance3 = Math.sqrt((p.x - closestX) ** 2 + (p.y - closestY) ** 2);
  return { t, distance: distance3 };
}
function rangeOverlap(t1Start, t1End, t2Start, t2End) {
  const min1 = Math.min(t1Start, t1End);
  const max1 = Math.max(t1Start, t1End);
  const min2 = Math.min(t2Start, t2End);
  const max2 = Math.max(t2Start, t2End);
  const overlapStart = Math.max(min1, min2);
  const overlapEnd = Math.min(max1, max2);
  if (overlapEnd - overlapStart < 1e-6) return null;
  return { from: overlapStart, to: overlapEnd };
}
function findSharedEdges(polygon1, polygon2, tolerance = 0.01) {
  const sharedEdges = [];
  for (let i = 0; i < polygon1.length; i++) {
    const a1 = polygon1[i];
    const a2 = polygon1[(i + 1) % polygon1.length];
    for (let j = 0; j < polygon2.length; j++) {
      const b1 = polygon2[j];
      const b2 = polygon2[(j + 1) % polygon2.length];
      if (!areCollinear(a1, a2, b1, b2, tolerance)) continue;
      const proj1 = projectOntoSegment(b1, a1, a2);
      const proj2 = projectOntoSegment(b2, a1, a2);
      if (proj1.distance > tolerance || proj2.distance > tolerance) continue;
      const overlap = rangeOverlap(0, 1, proj1.t, proj2.t);
      if (!overlap) continue;
      const dx = a2.x - a1.x;
      const dy = a2.y - a1.y;
      const from = {
        x: a1.x + overlap.from * dx,
        y: a1.y + overlap.from * dy
      };
      const to = {
        x: a1.x + overlap.to * dx,
        y: a1.y + overlap.to * dy
      };
      sharedEdges.push({ from, to });
    }
  }
  return sharedEdges;
}
function createPortsAlongEdge(edge, portPitch = 0.4) {
  const dx = edge.to.x - edge.from.x;
  const dy = edge.to.y - edge.from.y;
  const length = Math.sqrt(dx * dx + dy * dy);
  if (length < 1e-3) return [];
  const count = Math.max(1, Math.floor(length / portPitch));
  const ports = [];
  for (let i = 0; i < count; i++) {
    const t = (i + 0.5) / count;
    ports.push({
      x: edge.from.x + t * dx,
      y: edge.from.y + t * dy
    });
  }
  return ports;
}

// lib/ViaGraphSolver/via-graph-generator/generateConvexViaTopologyRegions.ts
var DEFAULT_PORT_PITCH = 0.4;
var DEFAULT_CLEARANCE = 0.1;
function deduplicateConsecutivePoints(points, tolerance = 1e-3) {
  if (points.length <= 1) return points;
  const result = [points[0]];
  for (let i = 1; i < points.length; i++) {
    const prev = result[result.length - 1];
    const curr = points[i];
    const dist = Math.sqrt((curr.x - prev.x) ** 2 + (curr.y - prev.y) ** 2);
    if (dist > tolerance) {
      result.push(curr);
    }
  }
  if (result.length > 1) {
    const first = result[0];
    const last = result[result.length - 1];
    const dist = Math.sqrt((last.x - first.x) ** 2 + (last.y - first.y) ** 2);
    if (dist < tolerance) {
      result.pop();
    }
  }
  return result;
}
function boundsFromPolygon(points) {
  let minX = Infinity;
  let maxX = -Infinity;
  let minY = Infinity;
  let maxY = -Infinity;
  for (const p of points) {
    if (p.x < minX) minX = p.x;
    if (p.x > maxX) maxX = p.x;
    if (p.y < minY) minY = p.y;
    if (p.y > maxY) maxY = p.y;
  }
  return { minX, maxX, minY, maxY };
}
function centroid(points) {
  let cx = 0;
  let cy = 0;
  for (const p of points) {
    cx += p.x;
    cy += p.y;
  }
  return { x: cx / points.length, y: cy / points.length };
}
function createRegionFromPolygon(regionId, polygon2, opts) {
  const bounds = boundsFromPolygon(polygon2);
  return {
    regionId,
    ports: [],
    d: {
      bounds,
      center: centroid(polygon2),
      polygon: polygon2,
      isPad: false,
      isViaRegion: opts?.isViaRegion
    }
  };
}
function generateViaRegionPolygon(vias) {
  if (vias.length === 0) return [];
  const topVia = vias.reduce(
    (best, v) => v.position.y > best.position.y ? v : best
  );
  const bottomVia = vias.reduce(
    (best, v) => v.position.y < best.position.y ? v : best
  );
  const leftVia = vias.reduce(
    (best, v) => v.position.x < best.position.x ? v : best
  );
  const rightVia = vias.reduce(
    (best, v) => v.position.x > best.position.x ? v : best
  );
  const topSeg = {
    xStart: topVia.position.x - topVia.diameter / 2,
    xEnd: topVia.position.x + topVia.diameter / 2,
    y: topVia.position.y + topVia.diameter / 2
  };
  const botSeg = {
    xStart: bottomVia.position.x - bottomVia.diameter / 2,
    xEnd: bottomVia.position.x + bottomVia.diameter / 2,
    y: bottomVia.position.y - bottomVia.diameter / 2
  };
  const leftSeg = {
    x: leftVia.position.x - leftVia.diameter / 2,
    yStart: leftVia.position.y - leftVia.diameter / 2,
    yEnd: leftVia.position.y + leftVia.diameter / 2
  };
  const rightSeg = {
    x: rightVia.position.x + rightVia.diameter / 2,
    yStart: rightVia.position.y - rightVia.diameter / 2,
    yEnd: rightVia.position.y + rightVia.diameter / 2
  };
  const rawPolygon = [
    { x: topSeg.xStart, y: topSeg.y },
    { x: topSeg.xEnd, y: topSeg.y },
    { x: rightSeg.x, y: rightSeg.yEnd },
    { x: rightSeg.x, y: rightSeg.yStart },
    { x: botSeg.xEnd, y: botSeg.y },
    { x: botSeg.xStart, y: botSeg.y },
    { x: leftSeg.x, y: leftSeg.yStart },
    { x: leftSeg.x, y: leftSeg.yEnd }
  ];
  return deduplicateConsecutivePoints(rawPolygon);
}
function translateVias(vias, dx, dy, prefix) {
  return vias.map((v) => ({
    viaId: `${prefix}:${v.viaId}`,
    diameter: v.diameter,
    position: {
      x: v.position.x + dx,
      y: v.position.y + dy
    }
  }));
}
function translateRouteSegments(routeSegments, dx, dy, prefix) {
  return routeSegments.map((segment2) => ({
    routeId: `${prefix}:${segment2.routeId}`,
    fromPort: `${prefix}:${segment2.fromPort}`,
    toPort: `${prefix}:${segment2.toPort}`,
    layer: segment2.layer,
    segments: segment2.segments.map((point2) => ({
      x: point2.x + dx,
      y: point2.y + dy
    }))
  }));
}
function isBakedViaTile(viaTile) {
  return "regions" in viaTile && Array.isArray(viaTile.regions);
}
function hasBakedViaTilePorts(viaTile) {
  return Array.isArray(viaTile.ports);
}
function extractViaNetNameFromRegionId(regionId) {
  const marker = ":v:";
  const markerIndex = regionId.lastIndexOf(marker);
  if (markerIndex === -1) return null;
  return regionId.slice(markerIndex + marker.length);
}
function replaceTilePrefix(templateRegionId, prefix) {
  const colonIndex = templateRegionId.indexOf(":");
  if (colonIndex === -1) return `${prefix}:${templateRegionId}`;
  return `${prefix}${templateRegionId.slice(colonIndex)}`;
}
function translatePolygon(polygon2, dx, dy) {
  return polygon2.map((p) => ({ x: p.x + dx, y: p.y + dy }));
}
function rectPolygonFromBounds(b) {
  return [
    { x: b.minX, y: b.minY },
    { x: b.maxX, y: b.minY },
    { x: b.maxX, y: b.maxY },
    { x: b.minX, y: b.maxY }
  ];
}
function findViaRegionSidePorts(polygon2) {
  if (polygon2.length < 3) {
    return { top: null, bottom: null, left: null, right: null };
  }
  const bounds = boundsFromPolygon(polygon2);
  const tolerance = 1e-3;
  let topPort = null;
  let bottomPort = null;
  let leftPort = null;
  let rightPort = null;
  for (let i = 0; i < polygon2.length; i++) {
    const p1 = polygon2[i];
    const p2 = polygon2[(i + 1) % polygon2.length];
    if (Math.abs(p1.y - bounds.maxY) < tolerance && Math.abs(p2.y - bounds.maxY) < tolerance) {
      topPort = { x: (p1.x + p2.x) / 2, y: bounds.maxY };
    }
    if (Math.abs(p1.y - bounds.minY) < tolerance && Math.abs(p2.y - bounds.minY) < tolerance) {
      bottomPort = { x: (p1.x + p2.x) / 2, y: bounds.minY };
    }
    if (Math.abs(p1.x - bounds.minX) < tolerance && Math.abs(p2.x - bounds.minX) < tolerance) {
      leftPort = { x: bounds.minX, y: (p1.y + p2.y) / 2 };
    }
    if (Math.abs(p1.x - bounds.maxX) < tolerance && Math.abs(p2.x - bounds.maxX) < tolerance) {
      rightPort = { x: bounds.maxX, y: (p1.y + p2.y) / 2 };
    }
  }
  return { top: topPort, bottom: bottomPort, left: leftPort, right: rightPort };
}
function extendViaRegionToTileEdge(polygon2, tileBounds, threshold = 0.1) {
  if (polygon2.length === 0) return polygon2;
  const polyBounds = boundsFromPolygon(polygon2);
  const distToLeft = polyBounds.minX - tileBounds.minX;
  const distToRight = tileBounds.maxX - polyBounds.maxX;
  const distToBottom = polyBounds.minY - tileBounds.minY;
  const distToTop = tileBounds.maxY - polyBounds.maxY;
  const extendLeft = distToLeft > 0 && distToLeft < threshold;
  const extendRight = distToRight > 0 && distToRight < threshold;
  const extendBottom = distToBottom > 0 && distToBottom < threshold;
  const extendTop = distToTop > 0 && distToTop < threshold;
  if (!extendLeft && !extendRight && !extendBottom && !extendTop) {
    return polygon2;
  }
  const result = polygon2.map((p) => {
    let x = p.x;
    let y = p.y;
    if (extendLeft && Math.abs(p.x - polyBounds.minX) < 1e-3) {
      x = tileBounds.minX;
    }
    if (extendRight && Math.abs(p.x - polyBounds.maxX) < 1e-3) {
      x = tileBounds.maxX;
    }
    if (extendBottom && Math.abs(p.y - polyBounds.minY) < 1e-3) {
      y = tileBounds.minY;
    }
    if (extendTop && Math.abs(p.y - polyBounds.maxY) < 1e-3) {
      y = tileBounds.maxY;
    }
    return { x, y };
  });
  return deduplicateConsecutivePoints(result);
}
function pointInPolygon(point2, polygon2) {
  let inside2 = false;
  const n = polygon2.length;
  for (let i = 0, j = n - 1; i < n; j = i++) {
    const xi = polygon2[i].x;
    const yi = polygon2[i].y;
    const xj = polygon2[j].x;
    const yj = polygon2[j].y;
    const onEdge = Math.abs((point2.y - yi) * (xj - xi) - (point2.x - xi) * (yj - yi)) < 1e-3 && point2.x >= Math.min(xi, xj) - 1e-3 && point2.x <= Math.max(xi, xj) + 1e-3 && point2.y >= Math.min(yi, yj) - 1e-3 && point2.y <= Math.max(yi, yj) + 1e-3;
    if (onEdge) return true;
    if (yi > point2.y !== yj > point2.y) {
      const intersectX = (xj - xi) * (point2.y - yi) / (yj - yi) + xi;
      if (point2.x < intersectX) {
        inside2 = !inside2;
      }
    }
  }
  return inside2;
}
function findRegionContainingPoint(point2, regions) {
  for (const region of regions) {
    if (region.d.polygon && pointInPolygon(point2, region.d.polygon)) {
      return region;
    }
  }
  return null;
}
function computeUnitTileTemplate(viaTile, tileWidth, tileHeight, clearance, concavityTolerance) {
  const halfWidth = tileWidth / 2;
  const halfHeight = tileHeight / 2;
  const tileBounds = {
    minX: -halfWidth,
    maxX: halfWidth,
    minY: -halfHeight,
    maxY: halfHeight
  };
  const viaRegions = [];
  for (const [netName, vias] of Object.entries(viaTile.viasByNet)) {
    if (vias.length === 0) continue;
    const polygon2 = generateViaRegionPolygon(vias);
    if (polygon2.length === 0) continue;
    viaRegions.push({
      templateRegionId: `t0_0:v:${netName}`,
      netName,
      polygon: polygon2,
      bounds: boundsFromPolygon(polygon2),
      center: centroid(polygon2)
    });
  }
  const obstaclePolygons = viaRegions.map((r) => ({
    points: extendViaRegionToTileEdge(r.polygon, tileBounds)
  }));
  const solver = new ConvexRegionsSolver({
    bounds: tileBounds,
    polygons: obstaclePolygons,
    clearance,
    concavityTolerance
  });
  solver.solve();
  const solverOutput = solver.getOutput();
  if (!solverOutput) {
    throw new Error("ConvexRegionsSolver failed to compute unit tile regions");
  }
  const convexRegions = solverOutput.regions.map((polygon2, index) => ({
    templateRegionId: `t0_0:convex:${index}`,
    polygon: polygon2,
    bounds: boundsFromPolygon(polygon2),
    center: centroid(polygon2)
  }));
  return {
    viaRegions,
    convexRegions,
    internalPorts: [],
    tileWidth,
    tileHeight
  };
}
function computeUnitTileTemplateFromBakedViaTile(viaTile, tileWidth, tileHeight) {
  const insideRegions = viaTile.regions.filter(
    (region) => region.polygon.length >= 3
  );
  const insideRegionById = new Map(
    insideRegions.map((region) => [region.regionId, region])
  );
  const viaRegions = insideRegions.filter((region) => region.isViaRegion).map((region) => ({
    templateRegionId: region.regionId,
    netName: region.netName ?? extractViaNetNameFromRegionId(region.regionId) ?? "unknown",
    polygon: region.polygon,
    bounds: region.bounds,
    center: region.center
  }));
  const convexRegions = insideRegions.filter((region) => !region.isViaRegion).map((region) => ({
    templateRegionId: region.regionId,
    polygon: region.polygon,
    bounds: region.bounds,
    center: region.center
  }));
  let internalPorts = [];
  if (hasBakedViaTilePorts(viaTile)) {
    const bakedInternalPorts = [];
    for (const port of viaTile.ports) {
      const region1 = insideRegionById.get(port.region1Id);
      const region2 = insideRegionById.get(port.region2Id);
      if (!region1 || !region2) {
        throw new Error(
          `Baked via tile port ${port.portId} references missing regions (${port.region1Id}, ${port.region2Id}).`
        );
      }
      if (region1.isViaRegion || region2.isViaRegion) {
        continue;
      }
      bakedInternalPorts.push({
        templatePortId: port.portId,
        templateRegion1Id: port.region1Id,
        templateRegion2Id: port.region2Id,
        position: port.position
      });
    }
    internalPorts = bakedInternalPorts;
  }
  return {
    viaRegions,
    convexRegions,
    internalPorts,
    tileWidth,
    tileHeight
  };
}
function generateConvexViaTopologyRegions(opts) {
  const tileWidth = opts.tileWidth ?? opts.tileSize ?? opts.viaTile.tileWidth;
  const tileHeight = opts.tileHeight ?? opts.tileSize ?? opts.viaTile.tileHeight;
  if (tileWidth === void 0 || tileHeight === void 0) {
    throw new Error(
      "tileWidth and tileHeight must be provided either in opts or in viaTile"
    );
  }
  const portPitch = opts.portPitch ?? DEFAULT_PORT_PITCH;
  const clearance = opts.clearance ?? DEFAULT_CLEARANCE;
  const concavityTolerance = opts.concavityTolerance ?? 0;
  const { bounds, viaTile: inputViaTile } = opts;
  const { viasByNet, routeSegments } = inputViaTile;
  const width = bounds.maxX - bounds.minX;
  const height = bounds.maxY - bounds.minY;
  const cols = Math.floor(width / tileWidth);
  const rows = Math.floor(height / tileHeight);
  const allRegions = [];
  const allPorts = [];
  const viaTile = { viasByNet: {}, routeSegments: [] };
  const viaRegions = [];
  const convexRegions = [];
  const gridWidth = cols * tileWidth;
  const gridHeight = rows * tileHeight;
  const gridMinX = bounds.minX + (width - gridWidth) / 2;
  const gridMinY = bounds.minY + (height - gridHeight) / 2;
  const gridMaxX = gridMinX + gridWidth;
  const gridMaxY = gridMinY + gridHeight;
  const halfWidth = tileWidth / 2;
  const halfHeight = tileHeight / 2;
  let portIdCounter = 0;
  const usedPortPositions = /* @__PURE__ */ new Set();
  const getPortPosKey = (x, y) => `${x.toFixed(4)},${y.toFixed(4)}`;
  const createPort = (portId, region1, region2, pos) => {
    const posKey = getPortPosKey(pos.x, pos.y);
    if (usedPortPositions.has(posKey)) {
      return null;
    }
    usedPortPositions.add(posKey);
    const port = {
      portId,
      region1,
      region2,
      d: { x: pos.x, y: pos.y }
    };
    region1.ports.push(port);
    region2.ports.push(port);
    allPorts.push(port);
    return port;
  };
  let unitTileTemplate = null;
  if (rows > 0 && cols > 0) {
    unitTileTemplate = isBakedViaTile(inputViaTile) ? computeUnitTileTemplateFromBakedViaTile(
      inputViaTile,
      tileWidth,
      tileHeight
    ) : computeUnitTileTemplate(
      inputViaTile,
      tileWidth,
      tileHeight,
      clearance,
      concavityTolerance
    );
  }
  const useBakedInternalPorts = Boolean(
    unitTileTemplate && unitTileTemplate.internalPorts.length > 0
  );
  if (rows > 0 && cols > 0 && unitTileTemplate) {
    for (let row = 0; row < rows; row++) {
      for (let col = 0; col < cols; col++) {
        const tileCenterX = gridMinX + col * tileWidth + halfWidth;
        const tileCenterY = gridMinY + row * tileHeight + halfHeight;
        const prefix = `t${row}_${col}`;
        const tileRegionByTemplateId = /* @__PURE__ */ new Map();
        for (const templateViaRegion of unitTileTemplate.viaRegions) {
          const translatedPolygon = translatePolygon(
            templateViaRegion.polygon,
            tileCenterX,
            tileCenterY
          );
          const viaRegionId = replaceTilePrefix(
            templateViaRegion.templateRegionId,
            prefix
          );
          const viaRegion = createRegionFromPolygon(
            viaRegionId,
            translatedPolygon,
            { isViaRegion: true }
          );
          viaRegions.push(viaRegion);
          allRegions.push(viaRegion);
          tileRegionByTemplateId.set(
            templateViaRegion.templateRegionId,
            viaRegion
          );
        }
        for (const templateConvexRegion of unitTileTemplate.convexRegions) {
          const translatedPolygon = translatePolygon(
            templateConvexRegion.polygon,
            tileCenterX,
            tileCenterY
          );
          const convexRegionId = replaceTilePrefix(
            templateConvexRegion.templateRegionId,
            prefix
          );
          const convexRegion = createRegionFromPolygon(
            convexRegionId,
            translatedPolygon
          );
          convexRegions.push(convexRegion);
          allRegions.push(convexRegion);
          tileRegionByTemplateId.set(
            templateConvexRegion.templateRegionId,
            convexRegion
          );
        }
        if (useBakedInternalPorts) {
          for (const templatePort of unitTileTemplate.internalPorts) {
            const region1 = tileRegionByTemplateId.get(
              templatePort.templateRegion1Id
            );
            const region2 = tileRegionByTemplateId.get(
              templatePort.templateRegion2Id
            );
            if (!region1 || !region2) {
              throw new Error(
                `Missing region for baked port template ${templatePort.templatePortId} in tile ${prefix}.`
              );
            }
            createPort(
              `${prefix}:baked:${templatePort.templatePortId}:${portIdCounter++}`,
              region1,
              region2,
              {
                x: templatePort.position.x + tileCenterX,
                y: templatePort.position.y + tileCenterY
              }
            );
          }
        }
        for (const [netName, vias] of Object.entries(viasByNet)) {
          if (vias.length === 0) continue;
          const translatedVias = translateVias(
            vias,
            tileCenterX,
            tileCenterY,
            prefix
          );
          if (!viaTile.viasByNet[netName]) {
            viaTile.viasByNet[netName] = [];
          }
          viaTile.viasByNet[netName].push(...translatedVias);
        }
        viaTile.routeSegments.push(
          ...translateRouteSegments(
            routeSegments,
            tileCenterX,
            tileCenterY,
            prefix
          )
        );
      }
    }
  }
  const fillerRegions = [];
  const topMargin = bounds.maxY - gridMaxY;
  const bottomMargin = gridMinY - bounds.minY;
  const leftMargin = gridMinX - bounds.minX;
  const rightMargin = bounds.maxX - gridMaxX;
  const verticalMargin = Math.max(topMargin, bottomMargin);
  const horizontalMargin = Math.max(leftMargin, rightMargin);
  const topBottomGetCorners = verticalMargin >= horizontalMargin;
  const topMinX = topBottomGetCorners ? bounds.minX : gridMinX;
  const topMaxX = topBottomGetCorners ? bounds.maxX : gridMaxX;
  const bottomMinX = topBottomGetCorners ? bounds.minX : gridMinX;
  const bottomMaxX = topBottomGetCorners ? bounds.maxX : gridMaxX;
  const leftMinY = topBottomGetCorners ? gridMinY : bounds.minY;
  const leftMaxY = topBottomGetCorners ? gridMaxY : bounds.maxY;
  const rightMinY = topBottomGetCorners ? gridMinY : bounds.minY;
  const rightMaxY = topBottomGetCorners ? gridMaxY : bounds.maxY;
  if (topMargin > 1e-3) {
    const topWidth = topMaxX - topMinX;
    const targetStripWidth = Math.max(topMargin, portPitch);
    const numTopStrips = Math.max(1, Math.floor(topWidth / targetStripWidth));
    const stripWidth = topWidth / numTopStrips;
    for (let i = 0; i < numTopStrips; i++) {
      const fillerBounds = {
        minX: topMinX + i * stripWidth,
        maxX: topMinX + (i + 1) * stripWidth,
        minY: gridMaxY,
        maxY: bounds.maxY
      };
      const regionId = `filler:top:${i}`;
      const filler = createRegionFromPolygon(
        regionId,
        rectPolygonFromBounds(fillerBounds)
      );
      fillerRegions.push(filler);
      allRegions.push(filler);
    }
  }
  if (bottomMargin > 1e-3) {
    const bottomWidth = bottomMaxX - bottomMinX;
    const targetStripWidth = Math.max(bottomMargin, portPitch);
    const numBottomStrips = Math.max(
      1,
      Math.floor(bottomWidth / targetStripWidth)
    );
    const stripWidth = bottomWidth / numBottomStrips;
    for (let i = 0; i < numBottomStrips; i++) {
      const fillerBounds = {
        minX: bottomMinX + i * stripWidth,
        maxX: bottomMinX + (i + 1) * stripWidth,
        minY: bounds.minY,
        maxY: gridMinY
      };
      const regionId = `filler:bottom:${i}`;
      const filler = createRegionFromPolygon(
        regionId,
        rectPolygonFromBounds(fillerBounds)
      );
      fillerRegions.push(filler);
      allRegions.push(filler);
    }
  }
  if (leftMargin > 1e-3) {
    const leftHeight = leftMaxY - leftMinY;
    const targetStripHeight = Math.max(leftMargin, portPitch);
    const numLeftStrips = Math.max(
      1,
      Math.floor(leftHeight / targetStripHeight)
    );
    const stripHeight = leftHeight / numLeftStrips;
    for (let i = 0; i < numLeftStrips; i++) {
      const fillerBounds = {
        minX: bounds.minX,
        maxX: gridMinX,
        minY: leftMinY + i * stripHeight,
        maxY: leftMinY + (i + 1) * stripHeight
      };
      const regionId = `filler:left:${i}`;
      const filler = createRegionFromPolygon(
        regionId,
        rectPolygonFromBounds(fillerBounds)
      );
      fillerRegions.push(filler);
      allRegions.push(filler);
    }
  }
  if (rightMargin > 1e-3) {
    const rightHeight = rightMaxY - rightMinY;
    const targetStripHeight = Math.max(rightMargin, portPitch);
    const numRightStrips = Math.max(
      1,
      Math.floor(rightHeight / targetStripHeight)
    );
    const stripHeight = rightHeight / numRightStrips;
    for (let i = 0; i < numRightStrips; i++) {
      const fillerBounds = {
        minX: gridMaxX,
        maxX: bounds.maxX,
        minY: rightMinY + i * stripHeight,
        maxY: rightMinY + (i + 1) * stripHeight
      };
      const regionId = `filler:right:${i}`;
      const filler = createRegionFromPolygon(
        regionId,
        rectPolygonFromBounds(fillerBounds)
      );
      fillerRegions.push(filler);
      allRegions.push(filler);
    }
  }
  if (unitTileTemplate && rows > 0 && cols > 0 && !useBakedInternalPorts) {
    const regionsPerTile = unitTileTemplate.convexRegions.length;
    for (let row = 0; row < rows; row++) {
      for (let col = 0; col < cols; col++) {
        const tileIndex = row * cols + col;
        const tileStartIdx = tileIndex * regionsPerTile;
        for (let i = 0; i < regionsPerTile; i++) {
          for (let j = i + 1; j < regionsPerTile; j++) {
            const region1 = convexRegions[tileStartIdx + i];
            const region2 = convexRegions[tileStartIdx + j];
            const sharedEdges = findSharedEdges(
              region1.d.polygon,
              region2.d.polygon,
              clearance * 2
            );
            for (const edge of sharedEdges) {
              const portPositions = createPortsAlongEdge(edge, portPitch);
              for (const pos of portPositions) {
                createPort(
                  `t${row}_${col}:convex:${i}-${j}:${portIdCounter++}`,
                  region1,
                  region2,
                  pos
                );
              }
            }
          }
        }
      }
    }
  }
  if (unitTileTemplate && rows > 0 && cols > 0) {
    const convexPerTile = unitTileTemplate.convexRegions.length;
    const viasPerTile = unitTileTemplate.viaRegions.length;
    const numVerticalPorts = Math.floor(tileHeight / portPitch);
    const verticalPortYOffsets = [];
    for (let i = 0; i < numVerticalPorts; i++) {
      verticalPortYOffsets.push(-halfHeight + (i + 0.5) * portPitch);
    }
    const numHorizontalPorts = Math.floor(tileWidth / portPitch);
    const horizontalPortXOffsets = [];
    for (let i = 0; i < numHorizontalPorts; i++) {
      horizontalPortXOffsets.push(-halfWidth + (i + 0.5) * portPitch);
    }
    for (let row = 0; row < rows; row++) {
      for (let col = 0; col < cols; col++) {
        const tileIndex = row * cols + col;
        const convexStartIdx = tileIndex * convexPerTile;
        const viaStartIdx = tileIndex * viasPerTile;
        const tileCenterX = gridMinX + col * tileWidth + halfWidth;
        const tileCenterY = gridMinY + row * tileHeight + halfHeight;
        const tileConvexRegions = convexRegions.slice(
          convexStartIdx,
          convexStartIdx + convexPerTile
        );
        const tileViaRegions = viaRegions.slice(
          viaStartIdx,
          viaStartIdx + viasPerTile
        );
        const tileAllRegions = [...tileConvexRegions, ...tileViaRegions];
        if (col + 1 < cols) {
          const rightTileIndex = row * cols + (col + 1);
          const rightConvexStartIdx = rightTileIndex * convexPerTile;
          const rightViaStartIdx = rightTileIndex * viasPerTile;
          const rightTileConvexRegions = convexRegions.slice(
            rightConvexStartIdx,
            rightConvexStartIdx + convexPerTile
          );
          const rightTileViaRegions = viaRegions.slice(
            rightViaStartIdx,
            rightViaStartIdx + viasPerTile
          );
          const rightTileAllRegions = [
            ...rightTileConvexRegions,
            ...rightTileViaRegions
          ];
          const boundaryX = tileCenterX + halfWidth;
          for (const yOffset of verticalPortYOffsets) {
            const portY = tileCenterY + yOffset;
            const pointInCurrentTile = { x: boundaryX - 0.01, y: portY };
            const pointInRightTile = { x: boundaryX + 0.01, y: portY };
            const region1 = findRegionContainingPoint(
              pointInCurrentTile,
              tileAllRegions
            );
            const region2 = findRegionContainingPoint(
              pointInRightTile,
              rightTileAllRegions
            );
            if (region1 && region2) {
              createPort(
                `tile:${row}_${col}-${row}_${col + 1}:${portIdCounter++}`,
                region1,
                region2,
                { x: boundaryX, y: portY }
              );
            }
          }
        }
        if (row + 1 < rows) {
          const topTileIndex = (row + 1) * cols + col;
          const topConvexStartIdx = topTileIndex * convexPerTile;
          const topViaStartIdx = topTileIndex * viasPerTile;
          const topTileConvexRegions = convexRegions.slice(
            topConvexStartIdx,
            topConvexStartIdx + convexPerTile
          );
          const topTileViaRegions = viaRegions.slice(
            topViaStartIdx,
            topViaStartIdx + viasPerTile
          );
          const topTileAllRegions = [
            ...topTileConvexRegions,
            ...topTileViaRegions
          ];
          const boundaryY = tileCenterY + halfHeight;
          for (const xOffset of horizontalPortXOffsets) {
            const portX = tileCenterX + xOffset;
            const pointInCurrentTile = { x: portX, y: boundaryY - 0.01 };
            const pointInTopTile = { x: portX, y: boundaryY + 0.01 };
            const region1 = findRegionContainingPoint(
              pointInCurrentTile,
              tileAllRegions
            );
            const region2 = findRegionContainingPoint(
              pointInTopTile,
              topTileAllRegions
            );
            if (region1 && region2) {
              createPort(
                `tile:${row}_${col}-${row + 1}_${col}:${portIdCounter++}`,
                region1,
                region2,
                { x: portX, y: boundaryY }
              );
            }
          }
        }
      }
    }
  }
  const fillerPortPositions = /* @__PURE__ */ new Map();
  for (const fillerRegion of fillerRegions) {
    fillerPortPositions.set(fillerRegion.regionId, []);
    const fillerBounds = fillerRegion.d.bounds;
    const stripWidth = fillerBounds.maxX - fillerBounds.minX;
    const stripHeight = fillerBounds.maxY - fillerBounds.minY;
    const isHorizontalStrip = stripWidth > stripHeight;
    const stripSize = isHorizontalStrip ? stripWidth : stripHeight;
    const numPorts = Math.max(1, Math.floor(stripSize / portPitch));
    const actualPitch = stripSize / numPorts;
    const adjacencyTolerance = clearance * 2;
    const isTopFiller = fillerRegion.regionId.startsWith("filler:top:");
    const isBottomFiller = fillerRegion.regionId.startsWith("filler:bottom:");
    const isLeftFiller = fillerRegion.regionId.startsWith("filler:left:");
    const isRightFiller = fillerRegion.regionId.startsWith("filler:right:");
    const tileRegions = [...convexRegions, ...viaRegions];
    for (const tileRegion of tileRegions) {
      const tileBounds = tileRegion.d.bounds;
      const eps = 1e-3;
      let isAdjacent = false;
      let edgeX = null;
      let edgeY = null;
      if (isHorizontalStrip) {
        const overlapMinX = Math.max(fillerBounds.minX, tileBounds.minX);
        const overlapMaxX = Math.min(fillerBounds.maxX, tileBounds.maxX);
        const hasXOverlap = overlapMaxX > overlapMinX + eps;
        if (hasXOverlap) {
          if (isTopFiller) {
            isAdjacent = Math.abs(tileBounds.maxY - fillerBounds.minY) < adjacencyTolerance;
            edgeY = fillerBounds.minY;
          } else if (isBottomFiller) {
            isAdjacent = Math.abs(tileBounds.minY - fillerBounds.maxY) < adjacencyTolerance;
            edgeY = fillerBounds.maxY;
          }
        }
      } else {
        const overlapMinY = Math.max(fillerBounds.minY, tileBounds.minY);
        const overlapMaxY = Math.min(fillerBounds.maxY, tileBounds.maxY);
        const hasYOverlap = overlapMaxY > overlapMinY + eps;
        if (hasYOverlap) {
          if (isLeftFiller) {
            isAdjacent = Math.abs(tileBounds.minX - fillerBounds.maxX) < adjacencyTolerance;
            edgeX = fillerBounds.maxX;
          } else if (isRightFiller) {
            isAdjacent = Math.abs(tileBounds.maxX - fillerBounds.minX) < adjacencyTolerance;
            edgeX = fillerBounds.minX;
          }
        }
      }
      if (!isAdjacent) continue;
      let overlapMin;
      let overlapMax;
      if (isHorizontalStrip) {
        overlapMin = Math.max(fillerBounds.minX, tileBounds.minX);
        overlapMax = Math.min(fillerBounds.maxX, tileBounds.maxX);
      } else {
        overlapMin = Math.max(fillerBounds.minY, tileBounds.minY);
        overlapMax = Math.min(fillerBounds.maxY, tileBounds.maxY);
      }
      const overlapSize = overlapMax - overlapMin;
      if (overlapSize < eps) continue;
      const overlapNumPorts = Math.max(1, Math.floor(overlapSize / portPitch));
      const overlapActualPitch = overlapSize / overlapNumPorts;
      for (let i = 0; i < overlapNumPorts; i++) {
        let pos;
        if (isHorizontalStrip) {
          const x = overlapMin + (i + 0.5) * overlapActualPitch;
          pos = { x, y: edgeY };
        } else {
          const y = overlapMin + (i + 0.5) * overlapActualPitch;
          pos = { x: edgeX, y };
        }
        if (tileRegion.d.polygon) {
          let testPoint;
          if (isTopFiller) {
            const gap = fillerBounds.minY - tileBounds.maxY;
            const testOffset = gap + 0.01;
            testPoint = { x: pos.x, y: pos.y - testOffset };
          } else if (isBottomFiller) {
            const gap = tileBounds.minY - fillerBounds.maxY;
            const testOffset = gap + 0.01;
            testPoint = { x: pos.x, y: pos.y + testOffset };
          } else if (isLeftFiller) {
            const gap = tileBounds.minX - fillerBounds.maxX;
            const testOffset = gap + 0.01;
            testPoint = { x: pos.x + testOffset, y: pos.y };
          } else {
            const gap = fillerBounds.minX - tileBounds.maxX;
            const testOffset = gap + 0.01;
            testPoint = { x: pos.x - testOffset, y: pos.y };
          }
          if (!pointInPolygon(testPoint, tileRegion.d.polygon)) {
            continue;
          }
        }
        const existingPositions = fillerPortPositions.get(
          fillerRegion.regionId
        );
        const tooClose = existingPositions.some((existing) => {
          const dist = Math.sqrt(
            (pos.x - existing.x) ** 2 + (pos.y - existing.y) ** 2
          );
          return dist < portPitch;
        });
        if (tooClose) {
          continue;
        }
        existingPositions.push(pos);
        createPort(
          `filler:${tileRegion.regionId}-${fillerRegion.regionId}:${portIdCounter++}`,
          tileRegion,
          fillerRegion,
          pos
        );
      }
    }
  }
  for (let i = 0; i < fillerRegions.length; i++) {
    for (let j = i + 1; j < fillerRegions.length; j++) {
      const region1 = fillerRegions[i];
      const region2 = fillerRegions[j];
      const sharedEdges = findSharedEdges(
        region1.d.polygon,
        region2.d.polygon,
        0.01
      );
      for (const edge of sharedEdges) {
        const edgeLength = Math.sqrt(
          (edge.to.x - edge.from.x) ** 2 + (edge.to.y - edge.from.y) ** 2
        );
        if (edgeLength < 0.01) {
          continue;
        }
        let portPositions;
        if (edgeLength < portPitch) {
          portPositions = [
            {
              x: (edge.from.x + edge.to.x) / 2,
              y: (edge.from.y + edge.to.y) / 2
            }
          ];
        } else {
          portPositions = createPortsAlongEdge(edge, portPitch);
        }
        for (const pos of portPositions) {
          createPort(
            `filler:${region1.regionId}-${region2.regionId}:${portIdCounter++}`,
            region1,
            region2,
            pos
          );
        }
      }
    }
  }
  const nonViaRegions = allRegions.filter((r) => !r.d.isViaRegion);
  const createdViaSidePorts = /* @__PURE__ */ new Set();
  for (const viaRegion of viaRegions) {
    const sidePorts = findViaRegionSidePorts(viaRegion.d.polygon);
    const viaBounds = viaRegion.d.bounds;
    const sides = ["top", "bottom", "left", "right"];
    for (const side of sides) {
      const portPos = sidePorts[side];
      if (!portPos) continue;
      const sideKey = `${viaRegion.regionId}:${side}`;
      if (createdViaSidePorts.has(sideKey)) continue;
      const adjacencyTolerance = 0.2;
      const testOffset = adjacencyTolerance;
      let testPoint;
      switch (side) {
        case "top":
          testPoint = { x: portPos.x, y: viaBounds.maxY + testOffset };
          break;
        case "bottom":
          testPoint = { x: portPos.x, y: viaBounds.minY - testOffset };
          break;
        case "left":
          testPoint = { x: viaBounds.minX - testOffset, y: portPos.y };
          break;
        case "right":
          testPoint = { x: viaBounds.maxX + testOffset, y: portPos.y };
          break;
      }
      for (const adjacentRegion of nonViaRegions) {
        const adjBounds = adjacentRegion.d.bounds;
        let boundsAdjacent = false;
        switch (side) {
          case "top":
            boundsAdjacent = Math.abs(adjBounds.minY - viaBounds.maxY) < adjacencyTolerance && adjBounds.minX < portPos.x && adjBounds.maxX > portPos.x;
            break;
          case "bottom":
            boundsAdjacent = Math.abs(adjBounds.maxY - viaBounds.minY) < adjacencyTolerance && adjBounds.minX < portPos.x && adjBounds.maxX > portPos.x;
            break;
          case "left":
            boundsAdjacent = Math.abs(adjBounds.maxX - viaBounds.minX) < adjacencyTolerance && adjBounds.minY < portPos.y && adjBounds.maxY > portPos.y;
            break;
          case "right":
            boundsAdjacent = Math.abs(adjBounds.minX - viaBounds.maxX) < adjacencyTolerance && adjBounds.minY < portPos.y && adjBounds.maxY > portPos.y;
            break;
        }
        if (!boundsAdjacent) continue;
        if (adjacentRegion.d.polygon && pointInPolygon(testPoint, adjacentRegion.d.polygon)) {
          createPort(
            `via-side:${viaRegion.regionId}:${side}:${portIdCounter++}`,
            viaRegion,
            adjacentRegion,
            portPos
          );
          createdViaSidePorts.add(sideKey);
          break;
        }
      }
    }
  }
  return {
    regions: allRegions,
    ports: allPorts,
    viaTile,
    tileCount: { rows, cols }
  };
}

// assets/ViaGraphSolver/via-tile-3-regions-baked.json
var via_tile_3_regions_baked_default = {
  viasByNet: {
    net1: [
      {
        viaId: "1b0111be-ce08-409a-80b7-5006cb5e2c5b",
        diameter: 0.3,
        position: {
          x: -0.396773,
          y: 0.05144
        }
      },
      {
        viaId: "2f36dd01-8bf4-49dc-b86b-22c27e4cb7bf",
        diameter: 0.3,
        position: {
          x: -0.04486,
          y: -0.267596
        }
      }
    ],
    net2: [
      {
        viaId: "51af4ca3-53f4-4a03-914b-6dba63eb8c4a",
        diameter: 0.3,
        position: {
          x: 0.39936,
          y: 0.600815
        }
      },
      {
        viaId: "b602bfde-3ed8-4f47-9fa7-5baa7a8a9ec4",
        diameter: 0.3,
        position: {
          x: -0.563329,
          y: -0.420006
        }
      }
    ],
    net3: [
      {
        viaId: "095a83cb-28a7-472c-95fe-bfb08db097f5",
        diameter: 0.3,
        position: {
          x: -0.070756,
          y: 0.430539
        }
      },
      {
        viaId: "e8d75a9d-5b0e-4158-8d39-01b264e49299",
        diameter: 0.3,
        position: {
          x: 0.280866,
          y: 0.111752
        }
      }
    ]
  },
  routeSegments: [
    {
      routeId: "net1:route_0",
      fromPort: "1b0111be-ce08-409a-80b7-5006cb5e2c5b",
      toPort: "2f36dd01-8bf4-49dc-b86b-22c27e4cb7bf",
      layer: "bottom",
      segments: [
        {
          x: -0.396773,
          y: 0.05144
        },
        {
          x: -0.363896,
          y: 0.05144
        },
        {
          x: -0.04486,
          y: -0.267596
        }
      ]
    },
    {
      routeId: "net2:route_0",
      fromPort: "51af4ca3-53f4-4a03-914b-6dba63eb8c4a",
      toPort: "b602bfde-3ed8-4f47-9fa7-5baa7a8a9ec4",
      layer: "bottom",
      segments: [
        {
          x: 0.39936,
          y: 0.600815
        },
        {
          x: 0.681866,
          y: 0.318309
        },
        {
          x: 0.681866,
          y: -0.10797
        },
        {
          x: 0.12124,
          y: -0.668596
        },
        {
          x: -0.314739,
          y: -0.668596
        },
        {
          x: -0.563329,
          y: -0.420006
        }
      ]
    },
    {
      routeId: "net3:route_0",
      fromPort: "095a83cb-28a7-472c-95fe-bfb08db097f5",
      toPort: "e8d75a9d-5b0e-4158-8d39-01b264e49299",
      layer: "bottom",
      segments: [
        {
          x: -0.070756,
          y: 0.430539
        },
        {
          x: -0.037921,
          y: 0.430539
        },
        {
          x: 0.280866,
          y: 0.111752
        }
      ]
    }
  ],
  tileWidth: 1.6201949999999998,
  tileHeight: 1.6444109999999998,
  regions: [
    {
      regionId: "t0_0:v:net1",
      polygon: [
        {
          x: -0.546773,
          y: 0.20144
        },
        {
          x: -0.246773,
          y: 0.20144
        },
        {
          x: 0.10514,
          y: -0.117596
        },
        {
          x: 0.10514,
          y: -0.41759599999999997
        },
        {
          x: -0.19485999999999998,
          y: -0.41759599999999997
        },
        {
          x: -0.546773,
          y: -0.09856
        }
      ],
      bounds: {
        minX: -0.546773,
        maxX: 0.10514,
        minY: -0.41759599999999997,
        maxY: 0.20144
      },
      center: {
        x: -0.22081649999999997,
        y: -0.108078
      },
      isViaRegion: true,
      netName: "net1"
    },
    {
      regionId: "t0_0:v:net2",
      polygon: [
        {
          x: 0.24936,
          y: 0.750815
        },
        {
          x: 0.54936,
          y: 0.750815
        },
        {
          x: 0.54936,
          y: 0.45081499999999997
        },
        {
          x: -0.41332899999999995,
          y: -0.570006
        },
        {
          x: -0.713329,
          y: -0.570006
        },
        {
          x: -0.713329,
          y: -0.27000599999999997
        }
      ],
      bounds: {
        minX: -0.713329,
        maxX: 0.54936,
        minY: -0.570006,
        maxY: 0.750815
      },
      center: {
        x: -0.0819845,
        y: 0.0904045
      },
      isViaRegion: true,
      netName: "net2"
    },
    {
      regionId: "t0_0:v:net3",
      polygon: [
        {
          x: -0.220756,
          y: 0.580539
        },
        {
          x: 0.079244,
          y: 0.580539
        },
        {
          x: 0.43086599999999997,
          y: 0.261752
        },
        {
          x: 0.43086599999999997,
          y: -0.03824799999999999
        },
        {
          x: 0.130866,
          y: -0.03824799999999999
        },
        {
          x: -0.220756,
          y: 0.280539
        }
      ],
      bounds: {
        minX: -0.220756,
        maxX: 0.43086599999999997,
        minY: -0.03824799999999999,
        maxY: 0.580539
      },
      center: {
        x: 0.10505499999999997,
        y: 0.2711455
      },
      isViaRegion: true,
      netName: "net3"
    },
    {
      regionId: "t0_0:convex:0",
      polygon: [
        {
          x: -0.6480799999999999,
          y: -0.8222054999999999
        },
        {
          x: -0.4860594999999999,
          y: -0.8222054999999999
        },
        {
          x: -0.32403899999999997,
          y: -0.8222044999999999
        },
        {
          x: -0.3701817305825413,
          y: -0.670007
        },
        {
          x: -0.8100964999999999,
          y: -0.6700079999999999
        },
        {
          x: -0.8100974999999999,
          y: -0.8222054999999999
        }
      ],
      bounds: {
        minX: -0.8100974999999999,
        maxX: -0.32403899999999997,
        minY: -0.8222054999999999,
        maxY: -0.670007
      },
      center: {
        x: -0.5747590384304234,
        y: -0.7714726666666666
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:1",
      polygon: [
        {
          x: -0.16201849999999998,
          y: -0.8222035
        },
        {
          x: -0.22645191931396433,
          y: -0.5175979999999999
        },
        {
          x: -0.3701817305825413,
          y: -0.670007
        },
        {
          x: -0.32403899999999997,
          y: -0.8222044999999999
        }
      ],
      bounds: {
        minX: -0.3701817305825413,
        maxX: -0.16201849999999998,
        minY: -0.8222044999999999,
        maxY: -0.5175979999999999
      },
      center: {
        x: -0.2706727874741264,
        y: -0.70800325
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:2",
      polygon: [
        {
          x: 2e-6,
          y: -0.8222054999999999
        },
        {
          x: 0.16202249999999999,
          y: -0.8222054999999999
        },
        {
          x: 0.324036,
          y: -0.8222054999999999
        },
        {
          x: 0.20513699999999999,
          y: -0.517594
        },
        {
          x: -0.22645191931396433,
          y: -0.5175979999999999
        },
        {
          x: -0.16201849999999998,
          y: -0.8222035
        }
      ],
      bounds: {
        minX: -0.22645191931396433,
        maxX: 0.324036,
        minY: -0.8222054999999999,
        maxY: -0.517594
      },
      center: {
        x: 0.05045451344767262,
        y: -0.7206686666666666
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:3",
      polygon: [
        {
          x: 0.8100974999999999,
          y: -0.32888120000000004
        },
        {
          x: 0.8100944999999999,
          y: -0.1644390999999999
        },
        {
          x: 0.5308679999999999,
          y: -0.13824799999999998
        },
        {
          x: 0.205143,
          y: -0.13824699999999998
        },
        {
          x: 0.20513699999999999,
          y: -0.517594
        },
        {
          x: 0.324036,
          y: -0.8222054999999999
        },
        {
          x: 0.48605649999999995,
          y: -0.8222044999999999
        },
        {
          x: 0.6480769999999999,
          y: -0.8222035
        },
        {
          x: 0.8100974999999999,
          y: -0.6577654
        },
        {
          x: 0.8100974999999999,
          y: -0.4933232999999999
        }
      ],
      bounds: {
        minX: 0.20513699999999999,
        maxX: 0.8100974999999999,
        minY: -0.8222054999999999,
        maxY: -0.13824699999999998
      },
      center: {
        x: 0.5639704499999999,
        y: -0.49051114999999995
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:4",
      polygon: [
        {
          x: 0.6480769999999999,
          y: -0.8222035
        },
        {
          x: 0.8100974999999999,
          y: -0.8222054999999999
        },
        {
          x: 0.8100974999999999,
          y: -0.6577654
        }
      ],
      bounds: {
        minX: 0.6480769999999999,
        maxX: 0.8100974999999999,
        minY: -0.8222054999999999,
        maxY: -0.6577654
      },
      center: {
        x: 0.7560906666666666,
        y: -0.7673914666666667
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:5",
      polygon: [
        {
          x: 0.8100974999999999,
          y: 0.3288821999999998
        },
        {
          x: 0.6493599999999999,
          y: 0.411097723794497
        },
        {
          x: 0.530867,
          y: 0.28544946055995296
        },
        {
          x: 0.5308679999999999,
          y: -0.13824799999999998
        },
        {
          x: 0.8100944999999999,
          y: -0.1644390999999999
        },
        {
          x: 0.8100955,
          y: -2e-6
        },
        {
          x: 0.8100964999999999,
          y: 0.1644400999999999
        }
      ],
      bounds: {
        minX: 0.530867,
        maxX: 0.8100974999999999,
        minY: -0.1644390999999999,
        maxY: 0.411097723794497
      },
      center: {
        x: 0.7073541428571428,
        y: 0.12674005490777857
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:6",
      polygon: [
        {
          x: 0.6493599999999999,
          y: 0.411097723794497
        },
        {
          x: 0.8100974999999999,
          y: 0.3288821999999998
        },
        {
          x: 0.8100974999999999,
          y: 0.4933243000000001
        },
        {
          x: 0.8100974999999999,
          y: 0.6577664
        },
        {
          x: 0.8100974999999999,
          y: 0.8222035
        },
        {
          x: 0.649358,
          y: 0.8222054999999999
        }
      ],
      bounds: {
        minX: 0.649358,
        maxX: 0.8100974999999999,
        minY: 0.3288821999999998,
        maxY: 0.8222054999999999
      },
      center: {
        x: 0.7565179999999999,
        y: 0.5892466039657495
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:7",
      polygon: [
        {
          x: 1e-6,
          y: 0.8222035
        },
        {
          x: -0.027378080330350014,
          y: 0.680539
        },
        {
          x: 0.11004202589152173,
          y: 0.8222054999999999
        }
      ],
      bounds: {
        minX: -0.027378080330350014,
        maxX: 0.11004202589152173,
        minY: 0.680539,
        maxY: 0.8222054999999999
      },
      center: {
        x: 0.027554981853723907,
        y: 0.7749826666666667
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:8",
      polygon: [
        {
          x: -0.027378080330350014,
          y: 0.680539
        },
        {
          x: 1e-6,
          y: 0.8222035
        },
        {
          x: -0.16201749999999998,
          y: 0.8222044999999999
        },
        {
          x: -0.324036,
          y: 0.8222054999999999
        },
        {
          x: -0.32075300000000007,
          y: 0.680538
        }
      ],
      bounds: {
        minX: -0.324036,
        maxX: 1e-6,
        minY: 0.680538,
        maxY: 0.8222054999999999
      },
      center: {
        x: -0.16683671606607003,
        y: 0.7655380999999999
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:9",
      polygon: [
        {
          x: -0.32075300000000007,
          y: 0.680538
        },
        {
          x: -0.324036,
          y: 0.8222054999999999
        },
        {
          x: -0.4860614999999999,
          y: 0.8222054999999999
        },
        {
          x: -0.6480799999999999,
          y: 0.8222054999999999
        },
        {
          x: -0.8100974999999999,
          y: 0.8222035
        },
        {
          x: -0.8100974999999999,
          y: 0.6577633999999999
        },
        {
          x: -0.8100964999999999,
          y: 0.4933232999999999
        },
        {
          x: -0.8100955,
          y: 0.3288832
        },
        {
          x: -0.64677,
          y: 0.30143800000000004
        },
        {
          x: -0.3951083951938174,
          y: 0.30143900000000007
        },
        {
          x: -0.32075400000000004,
          y: 0.3780859678974683
        }
      ],
      bounds: {
        minX: -0.8100974999999999,
        maxX: -0.32075300000000007,
        minY: 0.30143800000000004,
        maxY: 0.8222054999999999
      },
      center: {
        x: -0.580177263199438,
        y: 0.5845718970815881
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:10",
      polygon: [
        {
          x: -0.8100955,
          y: 0.3288832
        },
        {
          x: -0.8100944999999999,
          y: 0.1644430999999999
        },
        {
          x: -0.64677,
          y: 0.30143800000000004
        }
      ],
      bounds: {
        minX: -0.8100955,
        maxX: -0.64677,
        minY: 0.1644430999999999,
        maxY: 0.3288832
      },
      center: {
        x: -0.7556533333333334,
        y: 0.26492143333333334
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:11",
      polygon: [
        {
          x: -0.646771,
          y: 0.04199388419849993
        },
        {
          x: -0.64677,
          y: 0.30143800000000004
        },
        {
          x: -0.8100944999999999,
          y: 0.1644430999999999
        },
        {
          x: -0.8100974999999999,
          y: -2e-6
        },
        {
          x: -0.8100974999999999,
          y: -0.12637992705088938
        }
      ],
      bounds: {
        minX: -0.8100974999999999,
        maxX: -0.64677,
        minY: -0.12637992705088938,
        maxY: 0.30143800000000004
      },
      center: {
        x: -0.7447660999999999,
        y: 0.0762986114295221
      },
      isViaRegion: false
    }
  ],
  ports: [
    {
      portId: "t0_0:convex:1-2:0",
      region1Id: "t0_0:convex:1",
      region2Id: "t0_0:convex:2",
      position: {
        x: -0.19423520965698216,
        y: -0.6699007499999999
      }
    },
    {
      portId: "t0_0:convex:2-3:1",
      region1Id: "t0_0:convex:2",
      region2Id: "t0_0:convex:3",
      position: {
        x: 0.2645865,
        y: -0.6698997499999999
      }
    },
    {
      portId: "t0_0:convex:3-4:2",
      region1Id: "t0_0:convex:3",
      region2Id: "t0_0:convex:4",
      position: {
        x: 0.7290872499999999,
        y: -0.7399844499999999
      }
    },
    {
      portId: "t0_0:convex:3-5:3",
      region1Id: "t0_0:convex:3",
      region2Id: "t0_0:convex:5",
      position: {
        x: 0.6704812499999999,
        y: -0.15134354999999994
      }
    },
    {
      portId: "t0_0:convex:10-11:4",
      region1Id: "t0_0:convex:10",
      region2Id: "t0_0:convex:11",
      position: {
        x: -0.72843225,
        y: 0.23294054999999997
      }
    },
    {
      portId: "via-side:t0_0:v:net1:top:5",
      region1Id: "t0_0:v:net1",
      region2Id: "t0_0:convex:9",
      position: {
        x: -0.396773,
        y: 0.20144
      }
    },
    {
      portId: "via-side:t0_0:v:net1:bottom:6",
      region1Id: "t0_0:v:net1",
      region2Id: "t0_0:convex:2",
      position: {
        x: -0.04485999999999999,
        y: -0.41759599999999997
      }
    },
    {
      portId: "via-side:t0_0:v:net1:left:7",
      region1Id: "t0_0:v:net1",
      region2Id: "t0_0:convex:11",
      position: {
        x: -0.546773,
        y: 0.05144000000000001
      }
    },
    {
      portId: "via-side:t0_0:v:net1:right:8",
      region1Id: "t0_0:v:net1",
      region2Id: "t0_0:convex:3",
      position: {
        x: 0.10514,
        y: -0.267596
      }
    },
    {
      portId: "via-side:t0_0:v:net2:bottom:9",
      region1Id: "t0_0:v:net2",
      region2Id: "t0_0:convex:0",
      position: {
        x: -0.563329,
        y: -0.570006
      }
    },
    {
      portId: "via-side:t0_0:v:net2:right:10",
      region1Id: "t0_0:v:net2",
      region2Id: "t0_0:convex:6",
      position: {
        x: 0.54936,
        y: 0.600815
      }
    },
    {
      portId: "via-side:t0_0:v:net3:top:11",
      region1Id: "t0_0:v:net3",
      region2Id: "t0_0:convex:8",
      position: {
        x: -0.07075600000000001,
        y: 0.580539
      }
    },
    {
      portId: "via-side:t0_0:v:net3:bottom:12",
      region1Id: "t0_0:v:net3",
      region2Id: "t0_0:convex:3",
      position: {
        x: 0.280866,
        y: -0.03824799999999999
      }
    },
    {
      portId: "via-side:t0_0:v:net3:left:13",
      region1Id: "t0_0:v:net3",
      region2Id: "t0_0:convex:9",
      position: {
        x: -0.220756,
        y: 0.430539
      }
    },
    {
      portId: "via-side:t0_0:v:net3:right:14",
      region1Id: "t0_0:v:net3",
      region2Id: "t0_0:convex:5",
      position: {
        x: 0.43086599999999997,
        y: 0.11175199999999999
      }
    }
  ]
};

// assets/ViaGraphSolver/via-tile-4-regions-baked.json
var via_tile_4_regions_baked_default = {
  viasByNet: {
    net1: [
      {
        viaId: "14ee4bf1-e7e7-4351-ad16-ba1a8aac0af3",
        diameter: 0.3,
        position: {
          x: 0.815244,
          y: -0.055081
        }
      },
      {
        viaId: "8a898812-db2b-4b81-899d-f953b3222f9a",
        diameter: 0.3,
        position: {
          x: -0.528763,
          y: 0.676055
        }
      }
    ],
    net3: [
      {
        viaId: "13cd75da-d582-4eed-bc2c-fee6fa78bc6a",
        diameter: 0.3,
        position: {
          x: -0.808222,
          y: -0.726499
        }
      },
      {
        viaId: "9f188f9d-bce8-46c7-b9e8-542b8599d48d",
        diameter: 0.3,
        position: {
          x: 0.901143,
          y: 0.437488
        }
      }
    ],
    net4: [
      {
        viaId: "2ef3b96b-58c4-4150-b5d1-e90f74b92b25",
        diameter: 0.3,
        position: {
          x: -0.029,
          y: 0.691542
        }
      },
      {
        viaId: "37a70467-7553-415f-8ad7-8b88a5e56ca8",
        diameter: 0.3,
        position: {
          x: -0.824388,
          y: 0.272808
        }
      },
      {
        viaId: "6d182b7d-a260-427b-8c43-a09409422252",
        diameter: 0.3,
        position: {
          x: 0.075,
          y: -0.806274
        }
      }
    ],
    net5: [
      {
        viaId: "346c301a-f2b4-44d7-b975-5438ddaa0bde",
        diameter: 0.3,
        position: {
          x: 0.517145,
          y: -0.456503
        }
      },
      {
        viaId: "c54b4b94-90e0-4240-97ef-883cf097d79d",
        diameter: 0.3,
        position: {
          x: 0.471002,
          y: 0.692404
        }
      },
      {
        viaId: "f3cb916e-b0fd-4c5e-b14b-3779f4f9bd01",
        diameter: 0.3,
        position: {
          x: -0.833162,
          y: -0.227118
        }
      }
    ]
  },
  routeSegments: [
    {
      routeId: "net1:route_0",
      fromPort: "14ee4bf1-e7e7-4351-ad16-ba1a8aac0af3",
      toPort: "8a898812-db2b-4b81-899d-f953b3222f9a",
      layer: "bottom",
      segments: [
        {
          x: 0.815244,
          y: -0.055081
        },
        {
          x: 0.893145,
          y: -0.132982
        },
        {
          x: 0.893145,
          y: -0.753669
        },
        {
          x: 0.465539,
          y: -1.181274
        },
        {
          x: -0.113744,
          y: -1.181274
        },
        {
          x: -0.4,
          y: -0.895018
        },
        {
          x: -0.4,
          y: 0.547292
        },
        {
          x: -0.528763,
          y: 0.676055
        }
      ]
    },
    {
      routeId: "net3:route_0",
      fromPort: "13cd75da-d582-4eed-bc2c-fee6fa78bc6a",
      toPort: "9f188f9d-bce8-46c7-b9e8-542b8599d48d",
      layer: "bottom",
      segments: [
        {
          x: -0.808222,
          y: -0.726499
        },
        {
          x: -0.808222,
          y: -0.912474
        },
        {
          x: -0.238422,
          y: -1.482274
        },
        {
          x: 0.590217,
          y: -1.482274
        },
        {
          x: 1.36382,
          y: -0.708672
        },
        {
          x: 1.36382,
          y: -1202e-6
        },
        {
          x: 0.92513,
          y: 0.437488
        },
        {
          x: 0.901143,
          y: 0.437488
        }
      ]
    },
    {
      routeId: "net4:route_0",
      fromPort: "2ef3b96b-58c4-4150-b5d1-e90f74b92b25",
      toPort: "6d182b7d-a260-427b-8c43-a09409422252",
      layer: "bottom",
      segments: [
        {
          x: -0.029,
          y: 0.691542
        },
        {
          x: 0.075,
          y: 0.587542
        },
        {
          x: 0.075,
          y: -0.806274
        }
      ]
    },
    {
      routeId: "net4:route_1",
      fromPort: "2ef3b96b-58c4-4150-b5d1-e90f74b92b25",
      toPort: "37a70467-7553-415f-8ad7-8b88a5e56ca8",
      layer: "bottom",
      segments: [
        {
          x: -0.029,
          y: 0.691542
        },
        {
          x: -0.029,
          y: 0.778747
        },
        {
          x: -0.352308,
          y: 1.102055
        },
        {
          x: -0.705218,
          y: 1.102055
        },
        {
          x: -0.954763,
          y: 0.85251
        },
        {
          x: -0.954763,
          y: 0.403183
        },
        {
          x: -0.824388,
          y: 0.272808
        }
      ]
    },
    {
      routeId: "net5:route_0",
      fromPort: "346c301a-f2b4-44d7-b975-5438ddaa0bde",
      toPort: "c54b4b94-90e0-4240-97ef-883cf097d79d",
      layer: "bottom",
      segments: [
        {
          x: 0.517145,
          y: -0.456503
        },
        {
          x: 0.389244,
          y: -0.328602
        },
        {
          x: 0.389244,
          y: 0.610646
        },
        {
          x: 0.471002,
          y: 0.692404
        }
      ]
    },
    {
      routeId: "net5:route_1",
      fromPort: "c54b4b94-90e0-4240-97ef-883cf097d79d",
      toPort: "f3cb916e-b0fd-4c5e-b14b-3779f4f9bd01",
      layer: "bottom",
      segments: [
        {
          x: 0.471002,
          y: 0.692404
        },
        {
          x: 0.471002,
          y: 1.111132
        },
        {
          x: 0.129079,
          y: 1.453055
        },
        {
          x: -0.850606,
          y: 1.453055
        },
        {
          x: -1.305763,
          y: 0.997899
        },
        {
          x: -1.305763,
          y: 0.151728
        },
        {
          x: -0.926917,
          y: -0.227118
        },
        {
          x: -0.833162,
          y: -0.227118
        }
      ]
    }
  ],
  tileWidth: 2.9695829999999996,
  tileHeight: 3.2353289999999997,
  regions: [
    {
      regionId: "t0_0:v:net1",
      polygon: [
        {
          x: -0.678763,
          y: 0.826055
        },
        {
          x: -0.37876299999999996,
          y: 0.826055
        },
        {
          x: 0.965244,
          y: 0.094919
        },
        {
          x: 0.965244,
          y: -0.20508099999999999
        },
        {
          x: 0.665244,
          y: -0.20508099999999999
        },
        {
          x: -0.678763,
          y: 0.5260549999999999
        }
      ],
      bounds: {
        minX: -0.678763,
        maxX: 0.965244,
        minY: -0.20508099999999999,
        maxY: 0.826055
      },
      center: {
        x: 0.1432405,
        y: 0.31048699999999996
      },
      isViaRegion: true,
      netName: "net1"
    },
    {
      regionId: "t0_0:v:net3",
      polygon: [
        {
          x: 0.751143,
          y: 0.587488
        },
        {
          x: 1.051143,
          y: 0.587488
        },
        {
          x: 1.051143,
          y: 0.28748799999999997
        },
        {
          x: -0.658222,
          y: -0.876499
        },
        {
          x: -0.958222,
          y: -0.876499
        },
        {
          x: -0.958222,
          y: -0.576499
        }
      ],
      bounds: {
        minX: -0.958222,
        maxX: 1.051143,
        minY: -0.876499,
        maxY: 0.587488
      },
      center: {
        x: 0.046460500000000036,
        y: -0.1445055
      },
      isViaRegion: true,
      netName: "net3"
    },
    {
      regionId: "t0_0:v:net4",
      polygon: [
        {
          x: -0.179,
          y: 0.841542
        },
        {
          x: 0.121,
          y: 0.841542
        },
        {
          x: 0.22499999999999998,
          y: -0.656274
        },
        {
          x: 0.22499999999999998,
          y: -0.9562740000000001
        },
        {
          x: -0.075,
          y: -0.9562740000000001
        },
        {
          x: -0.974388,
          y: 0.122808
        },
        {
          x: -0.974388,
          y: 0.42280799999999996
        }
      ],
      bounds: {
        minX: -0.974388,
        maxX: 0.22499999999999998,
        minY: -0.9562740000000001,
        maxY: 0.841542
      },
      center: {
        x: -0.23311085714285715,
        y: -0.04858885714285716
      },
      isViaRegion: true,
      netName: "net4"
    },
    {
      regionId: "t0_0:v:net5",
      polygon: [
        {
          x: 0.321002,
          y: 0.842404
        },
        {
          x: 0.6210019999999999,
          y: 0.842404
        },
        {
          x: 0.667145,
          y: -0.30650299999999997
        },
        {
          x: 0.667145,
          y: -0.606503
        },
        {
          x: 0.36714499999999994,
          y: -0.606503
        },
        {
          x: -0.983162,
          y: -0.37711799999999995
        },
        {
          x: -0.983162,
          y: -0.07711799999999999
        }
      ],
      bounds: {
        minX: -0.983162,
        maxX: 0.667145,
        minY: -0.606503,
        maxY: 0.842404
      },
      center: {
        x: 0.09673071428571425,
        y: -0.04127671428571427
      },
      isViaRegion: true,
      netName: "net5"
    },
    {
      regionId: "t0_0:convex:0",
      polygon: [
        {
          x: -1.058219,
          y: -0.9764970000000001
        },
        {
          x: -1.4847905,
          y: -1.2941295999999998
        },
        {
          x: -1.4847914999999998,
          y: -1.6176644999999998
        },
        {
          x: -1.1878351999999999,
          y: -1.6176644999999998
        },
        {
          x: -0.8908758999999999,
          y: -1.6176644999999998
        },
        {
          x: -0.5939165999999999,
          y: -1.6176635
        },
        {
          x: -0.29695730000000004,
          y: -1.6176624999999998
        },
        {
          x: -0.6274055486066086,
          y: -0.976498
        }
      ],
      bounds: {
        minX: -1.4847914999999998,
        maxX: -0.29695730000000004,
        minY: -1.6176644999999998,
        maxY: -0.9764970000000001
      },
      center: {
        x: -0.9530989435758261,
        y: -1.4169305124999998
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:1",
      polygon: [
        {
          x: -0.12183239333000057,
          y: -1.056275
        },
        {
          x: -0.3472980954230426,
          y: -0.7857599839936004
        },
        {
          x: -0.6274055486066086,
          y: -0.976498
        },
        {
          x: -0.29695730000000004,
          y: -1.6176624999999998
        },
        {
          x: 2e-6,
          y: -1.6176644999999998
        }
      ],
      bounds: {
        minX: -0.6274055486066086,
        maxX: 2e-6,
        minY: -1.6176644999999998,
        maxY: -0.7857599839936004
      },
      center: {
        x: -0.2786982674719304,
        y: -1.21077199679872
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:2",
      polygon: [
        {
          x: 2e-6,
          y: -1.6176644999999998
        },
        {
          x: 0.324999,
          y: -1.0562760000000002
        },
        {
          x: -0.12183239333000057,
          y: -1.056275
        }
      ],
      bounds: {
        minX: -0.12183239333000057,
        maxX: 0.324999,
        minY: -1.6176644999999998,
        maxY: -1.056275
      },
      center: {
        x: 0.0677228688899998,
        y: -1.2434051666666666
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:3",
      polygon: [
        {
          x: 0.8908728999999999,
          y: -1.6176635
        },
        {
          x: 1.1878322,
          y: -1.6176624999999998
        },
        {
          x: 1.4847914999999998,
          y: -1.2941325999999997
        },
        {
          x: 1.4847914999999998,
          y: -0.9705986999999998
        },
        {
          x: 1.4847914999999998,
          y: -0.6470648
        },
        {
          x: 0.7671479999999999,
          y: -0.706503
        },
        {
          x: 0.324999,
          y: -1.0562760000000002
        },
        {
          x: 2e-6,
          y: -1.6176644999999998
        },
        {
          x: 0.2969613,
          y: -1.6176644999999998
        },
        {
          x: 0.5939135999999998,
          y: -1.6176644999999998
        }
      ],
      bounds: {
        minX: 2e-6,
        maxX: 1.4847914999999998,
        minY: -1.6176644999999998,
        maxY: -0.6470648
      },
      center: {
        x: 0.85161035,
        y: -1.2762894599999999
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:4",
      polygon: [
        {
          x: 1.1878322,
          y: -1.6176624999999998
        },
        {
          x: 1.4847914999999998,
          y: -1.6176644999999998
        },
        {
          x: 1.4847914999999998,
          y: -1.2941325999999997
        }
      ],
      bounds: {
        minX: 1.1878322,
        maxX: 1.4847914999999998,
        minY: -1.6176644999999998,
        maxY: -1.2941325999999997
      },
      center: {
        x: 1.3858050666666666,
        y: -1.5098198666666665
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:5",
      polygon: [
        {
          x: 1.065245,
          y: -0.305083
        },
        {
          x: 0.7671469999999999,
          y: -0.30508199999999996
        },
        {
          x: 0.7671479999999999,
          y: -0.706503
        },
        {
          x: 1.4847914999999998,
          y: -0.6470648
        },
        {
          x: 1.4847884999999998,
          y: -0.3235308999999998
        }
      ],
      bounds: {
        minX: 0.7671469999999999,
        maxX: 1.4847914999999998,
        minY: -0.706503,
        maxY: -0.30508199999999996
      },
      center: {
        x: 1.113824,
        y: -0.4574527399999999
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:6",
      polygon: [
        {
          x: 1.4847894999999998,
          y: -2e-6
        },
        {
          x: 1.065244,
          y: 0.15436033275504174
        },
        {
          x: 1.065245,
          y: -0.305083
        },
        {
          x: 1.4847884999999998,
          y: -0.3235308999999998
        }
      ],
      bounds: {
        minX: 1.065244,
        maxX: 1.4847894999999998,
        minY: -0.3235308999999998,
        maxY: 0.15436033275504174
      },
      center: {
        x: 1.2750167499999998,
        y: -0.11856389181123951
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:7",
      polygon: [
        {
          x: 1.151141,
          y: 0.234599693035695
        },
        {
          x: 1.4847894999999998,
          y: -2e-6
        },
        {
          x: 1.4847905,
          y: 0.3235318999999998
        },
        {
          x: 1.4847914999999998,
          y: 0.6470657999999998
        },
        {
          x: 1.4847914999999998,
          y: 0.9705997000000003
        },
        {
          x: 1.15114,
          y: 0.687487
        }
      ],
      bounds: {
        minX: 1.15114,
        maxX: 1.4847914999999998,
        minY: -2e-6,
        maxY: 0.9705997000000003
      },
      center: {
        x: 1.3735739999999999,
        y: 0.47721368217261584
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:8",
      polygon: [
        {
          x: 0.7170683669341472,
          y: 0.942406
        },
        {
          x: 1.4847914999999998,
          y: 0.9705997000000003
        },
        {
          x: 1.4847914999999998,
          y: 1.2941335999999999
        },
        {
          x: 1.4847914999999998,
          y: 1.6176624999999998
        },
        {
          x: 1.1878301999999998,
          y: 1.6176635
        },
        {
          x: 0.8908729,
          y: 1.6176644999999998
        },
        {
          x: 0.5939155999999999,
          y: 1.6176644999999998
        },
        {
          x: 0.2969583,
          y: 1.6176644999999998
        },
        {
          x: 0.28929422081219347,
          y: 0.942405
        }
      ],
      bounds: {
        minX: 0.28929422081219347,
        maxX: 1.4847914999999998,
        minY: 0.942405,
        maxY: 1.6176644999999998
      },
      center: {
        x: 0.9367015653051488,
        y: 1.3597626444444444
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:9",
      polygon: [
        {
          x: 1e-6,
          y: 1.6176624999999998
        },
        {
          x: -0.20371678480848432,
          y: 0.94154
        },
        {
          x: 0.21429632417207728,
          y: 0.941541
        },
        {
          x: 0.2969583,
          y: 1.6176644999999998
        }
      ],
      bounds: {
        minX: -0.20371678480848432,
        maxX: 0.2969583,
        minY: 0.94154,
        maxY: 1.6176644999999998
      },
      center: {
        x: 0.07688470984089824,
        y: 1.279602
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:10",
      polygon: [
        {
          x: -0.2969563,
          y: 1.6176635
        },
        {
          x: -0.3533204384162378,
          y: 0.926056
        },
        {
          x: -0.2942159061220332,
          y: 0.8939010379109219
        },
        {
          x: -0.20371678480848432,
          y: 0.94154
        },
        {
          x: 1e-6,
          y: 1.6176624999999998
        }
      ],
      bounds: {
        minX: -0.3533204384162378,
        maxX: 1e-6,
        minY: 0.8939010379109219,
        maxY: 1.6176635
      },
      center: {
        x: -0.22964168586935108,
        y: 1.1993646075821842
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:11",
      polygon: [
        {
          x: -0.3533204384162378,
          y: 0.926056
        },
        {
          x: -0.2969563,
          y: 1.6176635
        },
        {
          x: -0.5939135999999998,
          y: 1.6176644999999998
        },
        {
          x: -0.8908778999999998,
          y: 1.6176644999999998
        },
        {
          x: -0.778761,
          y: 0.926055
        }
      ],
      bounds: {
        minX: -0.8908778999999998,
        maxX: -0.2969563,
        minY: 0.926055,
        maxY: 1.6176644999999998
      },
      center: {
        x: -0.5827658476832476,
        y: 1.3410207
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:12",
      polygon: [
        {
          x: -0.778761,
          y: 0.926055
        },
        {
          x: -0.8908778999999998,
          y: 1.6176644999999998
        },
        {
          x: -1.1878351999999999,
          y: 1.6176644999999998
        },
        {
          x: -1.4847914999999998,
          y: 1.6176624999999998
        },
        {
          x: -1.4847914999999998,
          y: 1.2941306
        },
        {
          x: -1.4847905,
          y: 0.9705986999999998
        },
        {
          x: -1.4847894999999998,
          y: 0.6470668
        },
        {
          x: -1.4847884999999998,
          y: 0.3235348999999998
        },
        {
          x: -1.0743880000000001,
          y: 0.4831719103506663
        },
        {
          x: -0.778762,
          y: 0.6388054302654751
        }
      ],
      bounds: {
        minX: -1.4847914999999998,
        maxX: -0.778761,
        minY: 0.3235348999999998,
        maxY: 1.6176644999999998
      },
      center: {
        x: -1.21345756,
        y: 1.013635484061614
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:13",
      polygon: [
        {
          x: -1.4847884999999998,
          y: 0.3235348999999998
        },
        {
          x: -1.4847914999999998,
          y: -2e-6
        },
        {
          x: -1.074389,
          y: 0.08660027443180957
        },
        {
          x: -1.0743880000000001,
          y: 0.4831719103506663
        }
      ],
      bounds: {
        minX: -1.4847914999999998,
        maxX: -1.0743880000000001,
        minY: -2e-6,
        maxY: 0.4831719103506663
      },
      center: {
        x: -1.27958925,
        y: 0.22332627119561893
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:14",
      polygon: [
        {
          x: -1.083165,
          y: -0.025267833873400588
        },
        {
          x: -1.4847914999999998,
          y: -2e-6
        },
        {
          x: -1.4847914999999998,
          y: -0.32353389999999976
        },
        {
          x: -1.4847914999999998,
          y: -0.6470657999999998
        },
        {
          x: -1.083159,
          y: -0.4615640153219094
        }
      ],
      bounds: {
        minX: -1.4847914999999998,
        maxX: -1.083159,
        minY: -0.6470657999999998,
        maxY: -2e-6
      },
      center: {
        x: -1.3241397,
        y: -0.29148670983906194
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:15",
      polygon: [
        {
          x: -1.4847914999999998,
          y: -0.6470657999999998
        },
        {
          x: -1.4847914999999998,
          y: -0.9705977000000002
        },
        {
          x: -1.4847905,
          y: -1.2941295999999998
        },
        {
          x: -1.058219,
          y: -0.9764970000000001
        },
        {
          x: -1.058225,
          y: -0.5236126930356947
        }
      ],
      bounds: {
        minX: -1.4847914999999998,
        maxX: -1.058219,
        minY: -1.2941295999999998,
        maxY: -0.5236126930356947
      },
      center: {
        x: -1.3141634999999998,
        y: -0.8823805586071389
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:16",
      polygon: [
        {
          x: -1.083159,
          y: -0.4615640153219094
        },
        {
          x: -1.4847914999999998,
          y: -0.6470657999999998
        },
        {
          x: -1.058225,
          y: -0.5236126930356947
        },
        {
          x: -0.9902729041136373,
          y: -0.47734432068720295
        }
      ],
      bounds: {
        minX: -1.4847914999999998,
        maxX: -0.9902729041136373,
        minY: -0.6470657999999998,
        maxY: -0.4615640153219094
      },
      center: {
        x: -1.1541121010284092,
        y: -0.5273967072612017
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:17",
      polygon: [
        {
          x: -1.074389,
          y: 0.08660027443180957
        },
        {
          x: -1.4847914999999998,
          y: -2e-6
        },
        {
          x: -1.083165,
          y: -0.025267833873400588
        },
        {
          x: -1.0189109931810225,
          y: 0.020035791667712174
        }
      ],
      bounds: {
        minX: -1.4847914999999998,
        maxX: -1.0189109931810225,
        minY: -0.025267833873400588,
        maxY: 0.08660027443180957
      },
      center: {
        x: -1.1653141232952557,
        y: 0.020341558056530287
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:18",
      polygon: [
        {
          x: 0.28929422081219347,
          y: 0.942405
        },
        {
          x: 0.2969583,
          y: 1.6176644999999998
        },
        {
          x: 0.21429632417207728,
          y: 0.941541
        },
        {
          x: 0.2177404023152286,
          y: 0.8919545237301704
        }
      ],
      bounds: {
        minX: 0.21429632417207728,
        maxX: 0.2969583,
        minY: 0.8919545237301704,
        maxY: 1.6176644999999998
      },
      center: {
        x: 0.25457231182487483,
        y: 1.0983912559325426
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:19",
      polygon: [
        {
          x: 1.15114,
          y: 0.687487
        },
        {
          x: 1.4847914999999998,
          y: 0.9705997000000003
        },
        {
          x: 0.7170683669341472,
          y: 0.942406
        },
        {
          x: 0.7273074358013402,
          y: 0.687486
        }
      ],
      bounds: {
        minX: 0.7170683669341472,
        maxX: 1.4847914999999998,
        minY: 0.687486,
        maxY: 0.9705997000000003
      },
      center: {
        x: 1.020076825683872,
        y: 0.821994675
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:20",
      polygon: [
        {
          x: 1.065244,
          y: 0.15436033275504174
        },
        {
          x: 1.4847894999999998,
          y: -2e-6
        },
        {
          x: 1.151141,
          y: 0.234599693035695
        },
        {
          x: 1.0474881564581504,
          y: 0.16401791733667992
        }
      ],
      bounds: {
        minX: 1.0474881564581504,
        maxX: 1.4847894999999998,
        minY: -2e-6,
        maxY: 0.234599693035695
      },
      center: {
        x: 1.1871656641145374,
        y: 0.13824398578185415
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:21",
      polygon: [
        {
          x: 0.7671479999999999,
          y: -0.706503
        },
        {
          x: 0.35870860067449234,
          y: -0.706502
        },
        {
          x: 0.324999,
          y: -1.0562760000000002
        }
      ],
      bounds: {
        minX: 0.324999,
        maxX: 0.7671479999999999,
        minY: -1.0562760000000002,
        maxY: -0.706502
      },
      center: {
        x: 0.48361853355816414,
        y: -0.8230936666666668
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:22",
      polygon: [
        {
          x: 0.35870860067449234,
          y: -0.706502
        },
        {
          x: 0.32499799999999995,
          y: -0.7007742019305844
        },
        {
          x: 0.324999,
          y: -1.0562760000000002
        }
      ],
      bounds: {
        minX: 0.32499799999999995,
        maxX: 0.35870860067449234,
        minY: -1.0562760000000002,
        maxY: -0.7007742019305844
      },
      center: {
        x: 0.3362352002248308,
        y: -0.8211840673101948
      },
      isViaRegion: false
    }
  ],
  ports: [
    {
      portId: "t0_0:convex:0-1:0",
      region1Id: "t0_0:convex:0",
      region2Id: "t0_0:convex:1",
      position: {
        x: -0.46218142430330433,
        y: -1.2970802499999998
      }
    },
    {
      portId: "t0_0:convex:0-15:1",
      region1Id: "t0_0:convex:0",
      region2Id: "t0_0:convex:15",
      position: {
        x: -1.27150475,
        y: -1.1353133
      }
    },
    {
      portId: "t0_0:convex:1-2:2",
      region1Id: "t0_0:convex:1",
      region2Id: "t0_0:convex:2",
      position: {
        x: -0.06091519666500028,
        y: -1.33696975
      }
    },
    {
      portId: "t0_0:convex:2-3:3",
      region1Id: "t0_0:convex:2",
      region2Id: "t0_0:convex:3",
      position: {
        x: 0.1625005,
        y: -1.33697025
      }
    },
    {
      portId: "t0_0:convex:3-4:4",
      region1Id: "t0_0:convex:3",
      region2Id: "t0_0:convex:4",
      position: {
        x: 1.33631185,
        y: -1.4558975499999998
      }
    },
    {
      portId: "t0_0:convex:3-5:5",
      region1Id: "t0_0:convex:3",
      region2Id: "t0_0:convex:5",
      position: {
        x: 1.1259697499999999,
        y: -0.6767839
      }
    },
    {
      portId: "t0_0:convex:3-21:6",
      region1Id: "t0_0:convex:3",
      region2Id: "t0_0:convex:21",
      position: {
        x: 0.5460735,
        y: -0.8813895
      }
    },
    {
      portId: "t0_0:convex:5-6:7",
      region1Id: "t0_0:convex:5",
      region2Id: "t0_0:convex:6",
      position: {
        x: 1.2750167499999998,
        y: -0.31430694999999986
      }
    },
    {
      portId: "t0_0:convex:6-20:8",
      region1Id: "t0_0:convex:6",
      region2Id: "t0_0:convex:20",
      position: {
        x: 1.2750167499999998,
        y: 0.07717916637752087
      }
    },
    {
      portId: "t0_0:convex:7-19:9",
      region1Id: "t0_0:convex:7",
      region2Id: "t0_0:convex:19",
      position: {
        x: 1.31796575,
        y: 0.8290433500000001
      }
    },
    {
      portId: "t0_0:convex:7-20:10",
      region1Id: "t0_0:convex:7",
      region2Id: "t0_0:convex:20",
      position: {
        x: 1.3179652499999999,
        y: 0.1172988465178475
      }
    },
    {
      portId: "t0_0:convex:8-9:11",
      region1Id: "t0_0:convex:8",
      region2Id: "t0_0:convex:9",
      position: {
        x: 0.29312626040609674,
        y: 1.28003475
      }
    },
    {
      portId: "t0_0:convex:8-19:14",
      region1Id: "t0_0:convex:8",
      region2Id: "t0_0:convex:19",
      position: {
        x: 1.1009299334670735,
        y: 0.9565028500000001
      }
    },
    {
      portId: "t0_0:convex:9-10:15",
      region1Id: "t0_0:convex:9",
      region2Id: "t0_0:convex:10",
      position: {
        x: -0.10185789240424216,
        y: 1.2796012499999998
      }
    },
    {
      portId: "t0_0:convex:9-18:16",
      region1Id: "t0_0:convex:9",
      region2Id: "t0_0:convex:18",
      position: {
        x: 0.256231599283678,
        y: 1.2845454430699506
      }
    },
    {
      portId: "t0_0:convex:9-18:17",
      region1Id: "t0_0:convex:9",
      region2Id: "t0_0:convex:18",
      position: {
        x: 0.2556273120860386,
        y: 1.27960275
      }
    },
    {
      portId: "t0_0:convex:10-11:18",
      region1Id: "t0_0:convex:10",
      region2Id: "t0_0:convex:11",
      position: {
        x: -0.3251383692081189,
        y: 1.27185975
      }
    },
    {
      portId: "t0_0:convex:11-12:19",
      region1Id: "t0_0:convex:11",
      region2Id: "t0_0:convex:12",
      position: {
        x: -0.8348194499999999,
        y: 1.27185975
      }
    },
    {
      portId: "t0_0:convex:12-13:20",
      region1Id: "t0_0:convex:12",
      region2Id: "t0_0:convex:13",
      position: {
        x: -1.27958825,
        y: 0.403353405175333
      }
    },
    {
      portId: "t0_0:convex:13-17:21",
      region1Id: "t0_0:convex:13",
      region2Id: "t0_0:convex:17",
      position: {
        x: -1.27959025,
        y: 0.04329913721590478
      }
    },
    {
      portId: "t0_0:convex:14-15:22",
      region1Id: "t0_0:convex:14",
      region2Id: "t0_0:convex:15",
      position: {
        x: -1.2855100382914353,
        y: -0.5550237794956899
      }
    },
    {
      portId: "t0_0:convex:14-16:23",
      region1Id: "t0_0:convex:14",
      region2Id: "t0_0:convex:16",
      position: {
        x: -1.28397525,
        y: -0.5543149076609546
      }
    },
    {
      portId: "t0_0:convex:14-17:25",
      region1Id: "t0_0:convex:14",
      region2Id: "t0_0:convex:17",
      position: {
        x: -1.2839782499999999,
        y: -0.012634916936700293
      }
    },
    {
      portId: "t0_0:convex:15-16:26",
      region1Id: "t0_0:convex:15",
      region2Id: "t0_0:convex:16",
      position: {
        x: -1.274726872016046,
        y: -0.5862707516595418
      }
    },
    {
      portId: "t0_0:convex:15-16:27",
      region1Id: "t0_0:convex:15",
      region2Id: "t0_0:convex:16",
      position: {
        x: -1.27150825,
        y: -0.5853392465178473
      }
    },
    {
      portId: "t0_0:convex:21-22:28",
      region1Id: "t0_0:convex:21",
      region2Id: "t0_0:convex:22",
      position: {
        x: 0.34185380033724616,
        y: -0.8813890000000001
      }
    },
    {
      portId: "via-side:t0_0:v:net1:top:30",
      region1Id: "t0_0:v:net1",
      region2Id: "t0_0:convex:11",
      position: {
        x: -0.528763,
        y: 0.826055
      }
    },
    {
      portId: "via-side:t0_0:v:net1:bottom:31",
      region1Id: "t0_0:v:net1",
      region2Id: "t0_0:convex:5",
      position: {
        x: 0.815244,
        y: -0.20508099999999999
      }
    },
    {
      portId: "via-side:t0_0:v:net1:left:32",
      region1Id: "t0_0:v:net1",
      region2Id: "t0_0:convex:12",
      position: {
        x: -0.678763,
        y: 0.676055
      }
    },
    {
      portId: "via-side:t0_0:v:net1:right:33",
      region1Id: "t0_0:v:net1",
      region2Id: "t0_0:convex:6",
      position: {
        x: 0.965244,
        y: -0.05508099999999999
      }
    },
    {
      portId: "via-side:t0_0:v:net3:top:34",
      region1Id: "t0_0:v:net3",
      region2Id: "t0_0:convex:19",
      position: {
        x: 0.901143,
        y: 0.587488
      }
    },
    {
      portId: "via-side:t0_0:v:net3:bottom:35",
      region1Id: "t0_0:v:net3",
      region2Id: "t0_0:convex:0",
      position: {
        x: -0.808222,
        y: -0.876499
      }
    },
    {
      portId: "via-side:t0_0:v:net3:left:36",
      region1Id: "t0_0:v:net3",
      region2Id: "t0_0:convex:15",
      position: {
        x: -0.958222,
        y: -0.726499
      }
    },
    {
      portId: "via-side:t0_0:v:net3:right:37",
      region1Id: "t0_0:v:net3",
      region2Id: "t0_0:convex:7",
      position: {
        x: 1.051143,
        y: 0.437488
      }
    },
    {
      portId: "via-side:t0_0:v:net4:top:38",
      region1Id: "t0_0:v:net4",
      region2Id: "t0_0:convex:9",
      position: {
        x: -0.028999999999999998,
        y: 0.841542
      }
    },
    {
      portId: "via-side:t0_0:v:net4:bottom:39",
      region1Id: "t0_0:v:net4",
      region2Id: "t0_0:convex:2",
      position: {
        x: 0.07499999999999998,
        y: -0.9562740000000001
      }
    },
    {
      portId: "via-side:t0_0:v:net4:left:40",
      region1Id: "t0_0:v:net4",
      region2Id: "t0_0:convex:13",
      position: {
        x: -0.974388,
        y: 0.272808
      }
    },
    {
      portId: "via-side:t0_0:v:net4:right:41",
      region1Id: "t0_0:v:net4",
      region2Id: "t0_0:convex:21",
      position: {
        x: 0.22499999999999998,
        y: -0.806274
      }
    },
    {
      portId: "via-side:t0_0:v:net5:top:42",
      region1Id: "t0_0:v:net5",
      region2Id: "t0_0:convex:8",
      position: {
        x: 0.471002,
        y: 0.842404
      }
    },
    {
      portId: "via-side:t0_0:v:net5:bottom:43",
      region1Id: "t0_0:v:net5",
      region2Id: "t0_0:convex:21",
      position: {
        x: 0.517145,
        y: -0.606503
      }
    },
    {
      portId: "via-side:t0_0:v:net5:left:44",
      region1Id: "t0_0:v:net5",
      region2Id: "t0_0:convex:14",
      position: {
        x: -0.983162,
        y: -0.227118
      }
    },
    {
      portId: "via-side:t0_0:v:net5:right:45",
      region1Id: "t0_0:v:net5",
      region2Id: "t0_0:convex:5",
      position: {
        x: 0.667145,
        y: -0.456503
      }
    }
  ]
};

// assets/ViaGraphSolver/via-tile-5-regions-baked.json
var via_tile_5_regions_baked_default = {
  viasByNet: {
    net1: [
      {
        viaId: "14ee4bf1-e7e7-4351-ad16-ba1a8aac0af3",
        diameter: 0.3,
        position: {
          x: 0.778514,
          y: -0.012215
        }
      },
      {
        viaId: "8a898812-db2b-4b81-899d-f953b3222f9a",
        diameter: 0.3,
        position: {
          x: -0.770591,
          y: 0.97317
        }
      }
    ],
    net2: [
      {
        viaId: "1f552ada-e01a-4230-b5f5-0006595b14d5",
        diameter: 0.3,
        position: {
          x: 1.014826,
          y: 0.42842
        }
      },
      {
        viaId: "6987544a-501f-4711-bdff-dc583936a21c",
        diameter: 0.3,
        position: {
          x: -0.854951,
          y: -0.884286
        }
      }
    ],
    net3: [
      {
        viaId: "13cd75da-d582-4eed-bc2c-fee6fa78bc6a",
        diameter: 0.3,
        position: {
          x: -1.067887,
          y: -0.431891
        }
      },
      {
        viaId: "9f188f9d-bce8-46c7-b9e8-542b8599d48d",
        diameter: 0.3,
        position: {
          x: 0.695984,
          y: 0.813573
        }
      }
    ],
    net4: [
      {
        viaId: "2ef3b96b-58c4-4150-b5d1-e90f74b92b25",
        diameter: 0.3,
        position: {
          x: -0.273716,
          y: 1.029009
        }
      },
      {
        viaId: "37a70467-7553-415f-8ad7-8b88a5e56ca8",
        diameter: 0.3,
        position: {
          x: -1.062855,
          y: 0.56748
        }
      },
      {
        viaId: "6d182b7d-a260-427b-8c43-a09409422252",
        diameter: 0.3,
        position: {
          x: 0.04738,
          y: -0.678598
        }
      }
    ],
    net5: [
      {
        viaId: "346c301a-f2b4-44d7-b975-5438ddaa0bde",
        diameter: 0.3,
        position: {
          x: 0.462204,
          y: -0.39945
        }
      },
      {
        viaId: "c54b4b94-90e0-4240-97ef-883cf097d79d",
        diameter: 0.3,
        position: {
          x: 0.22363,
          y: 0.977538
        }
      },
      {
        viaId: "f3cb916e-b0fd-4c5e-b14b-3779f4f9bd01",
        diameter: 0.3,
        position: {
          x: -1.047736,
          y: 0.067706
        }
      }
    ]
  },
  routeSegments: [
    {
      routeId: "net1:route_0",
      fromPort: "14ee4bf1-e7e7-4351-ad16-ba1a8aac0af3",
      toPort: "8a898812-db2b-4b81-899d-f953b3222f9a",
      layer: "bottom",
      segments: [
        {
          x: 0.778514,
          y: -0.012215
        },
        {
          x: 0.863204,
          y: -0.096905
        },
        {
          x: 0.863204,
          y: -0.56555
        },
        {
          x: 0.349156,
          y: -1.079598
        },
        {
          x: -0.11872,
          y: -1.079598
        },
        {
          x: -0.35362,
          y: -0.844698
        },
        {
          x: -0.35362,
          y: -0.818517
        },
        {
          x: -0.646736,
          y: -0.525401
        },
        {
          x: -0.646736,
          y: 0.849315
        },
        {
          x: -0.770591,
          y: 0.97317
        }
      ]
    },
    {
      routeId: "net2:route_0",
      fromPort: "1f552ada-e01a-4230-b5f5-0006595b14d5",
      toPort: "6987544a-501f-4711-bdff-dc583936a21c",
      layer: "bottom",
      segments: [
        {
          x: 1.014826,
          y: 0.42842
        },
        {
          x: 1.179514,
          y: 0.263732
        },
        {
          x: 1.179514,
          y: -0.674918
        },
        {
          x: 0.473834,
          y: -1.380598
        },
        {
          x: -0.358639,
          y: -1.380598
        },
        {
          x: -0.854951,
          y: -0.884286
        }
      ]
    },
    {
      routeId: "net3:route_0",
      fromPort: "13cd75da-d582-4eed-bc2c-fee6fa78bc6a",
      toPort: "9f188f9d-bce8-46c7-b9e8-542b8599d48d",
      layer: "bottom",
      segments: [
        {
          x: -1.067887,
          y: -0.431891
        },
        {
          x: -1.255951,
          y: -0.619955
        },
        {
          x: -1.255951,
          y: -1.050386
        },
        {
          x: -0.624739,
          y: -1.681598
        },
        {
          x: 0.598512,
          y: -1.681598
        },
        {
          x: 1.480514,
          y: -0.799596
        },
        {
          x: 1.480514,
          y: 0.529832
        },
        {
          x: 1.180926,
          y: 0.82942
        },
        {
          x: 0.711831,
          y: 0.82942
        },
        {
          x: 0.695984,
          y: 0.813573
        }
      ]
    },
    {
      routeId: "net4:route_0",
      fromPort: "2ef3b96b-58c4-4150-b5d1-e90f74b92b25",
      toPort: "37a70467-7553-415f-8ad7-8b88a5e56ca8",
      layer: "bottom",
      segments: [
        {
          x: -0.273716,
          y: 1.029009
        },
        {
          x: -0.273716,
          y: 1.043395
        },
        {
          x: -0.604491,
          y: 1.37417
        },
        {
          x: -0.936691,
          y: 1.37417
        },
        {
          x: -1.171591,
          y: 1.13927
        },
        {
          x: -1.171591,
          y: 0.676216
        },
        {
          x: -1.062855,
          y: 0.56748
        }
      ]
    },
    {
      routeId: "net4:route_1",
      fromPort: "2ef3b96b-58c4-4150-b5d1-e90f74b92b25",
      toPort: "6d182b7d-a260-427b-8c43-a09409422252",
      layer: "bottom",
      segments: [
        {
          x: -0.273716,
          y: 1.029009
        },
        {
          x: -0.273716,
          y: -0.357502
        },
        {
          x: 0.04738,
          y: -0.678598
        }
      ]
    },
    {
      routeId: "net5:route_0",
      fromPort: "346c301a-f2b4-44d7-b975-5438ddaa0bde",
      toPort: "c54b4b94-90e0-4240-97ef-883cf097d79d",
      layer: "bottom",
      segments: [
        {
          x: 0.462204,
          y: -0.39945
        },
        {
          x: 0.22363,
          y: -0.160876
        },
        {
          x: 0.22363,
          y: 0.977538
        }
      ]
    },
    {
      routeId: "net5:route_1",
      fromPort: "c54b4b94-90e0-4240-97ef-883cf097d79d",
      toPort: "f3cb916e-b0fd-4c5e-b14b-3779f4f9bd01",
      layer: "bottom",
      segments: [
        {
          x: 0.22363,
          y: 0.977538
        },
        {
          x: 0.22363,
          y: 1.098763
        },
        {
          x: -0.352777,
          y: 1.67517
        },
        {
          x: -1.061369,
          y: 1.67517
        },
        {
          x: -1.472591,
          y: 1.263948
        },
        {
          x: -1.472591,
          y: 0.410116
        },
        {
          x: -1.130181,
          y: 0.067706
        },
        {
          x: -1.047736,
          y: 0.067706
        }
      ]
    }
  ],
  tileWidth: 3.253105,
  tileHeight: 3.656768,
  regions: [
    {
      regionId: "t0_0:v:net1",
      polygon: [
        {
          x: -0.920591,
          y: 1.12317
        },
        {
          x: -0.620591,
          y: 1.12317
        },
        {
          x: 0.9285140000000001,
          y: 0.137785
        },
        {
          x: 0.9285140000000001,
          y: -0.162215
        },
        {
          x: 0.628514,
          y: -0.162215
        },
        {
          x: -0.920591,
          y: 0.82317
        }
      ],
      bounds: {
        minX: -0.920591,
        maxX: 0.9285140000000001,
        minY: -0.162215,
        maxY: 1.12317
      },
      center: {
        x: 0.003961500000000007,
        y: 0.4804775000000001
      },
      isViaRegion: true,
      netName: "net1"
    },
    {
      regionId: "t0_0:v:net2",
      polygon: [
        {
          x: 0.864826,
          y: 0.57842
        },
        {
          x: 1.164826,
          y: 0.57842
        },
        {
          x: 1.164826,
          y: 0.27842
        },
        {
          x: -0.704951,
          y: -1.034286
        },
        {
          x: -1.004951,
          y: -1.034286
        },
        {
          x: -1.004951,
          y: -0.734286
        }
      ],
      bounds: {
        minX: -1.004951,
        maxX: 1.164826,
        minY: -1.034286,
        maxY: 0.57842
      },
      center: {
        x: 0.07993750000000006,
        y: -0.22793300000000002
      },
      isViaRegion: true,
      netName: "net2"
    },
    {
      regionId: "t0_0:v:net3",
      polygon: [
        {
          x: 0.545984,
          y: 0.963573
        },
        {
          x: 0.8459840000000001,
          y: 0.963573
        },
        {
          x: 0.8459840000000001,
          y: 0.663573
        },
        {
          x: -0.917887,
          y: -0.581891
        },
        {
          x: -1.217887,
          y: -0.581891
        },
        {
          x: -1.217887,
          y: -0.281891
        }
      ],
      bounds: {
        minX: -1.217887,
        maxX: 0.8459840000000001,
        minY: -0.581891,
        maxY: 0.963573
      },
      center: {
        x: -0.18595149999999996,
        y: 0.19084099999999996
      },
      isViaRegion: true,
      netName: "net3"
    },
    {
      regionId: "t0_0:v:net4",
      polygon: [
        {
          x: -0.423716,
          y: 1.179009
        },
        {
          x: -0.12371600000000002,
          y: 1.179009
        },
        {
          x: 0.19738,
          y: -0.528598
        },
        {
          x: 0.19738,
          y: -0.8285980000000001
        },
        {
          x: -0.10261999999999999,
          y: -0.8285980000000001
        },
        {
          x: -1.212855,
          y: 0.41747999999999996
        },
        {
          x: -1.212855,
          y: 0.71748
        }
      ],
      bounds: {
        minX: -1.212855,
        maxX: 0.19738,
        minY: -0.8285980000000001,
        maxY: 1.179009
      },
      center: {
        x: -0.38300028571428574,
        y: 0.18674057142857142
      },
      isViaRegion: true,
      netName: "net4"
    },
    {
      regionId: "t0_0:v:net5",
      polygon: [
        {
          x: 0.07363,
          y: 1.127538
        },
        {
          x: 0.37363,
          y: 1.127538
        },
        {
          x: 0.612204,
          y: -0.24945000000000003
        },
        {
          x: 0.612204,
          y: -0.54945
        },
        {
          x: 0.31220400000000004,
          y: -0.54945
        },
        {
          x: -1.197736,
          y: -0.08229399999999999
        },
        {
          x: -1.197736,
          y: 0.217706
        }
      ],
      bounds: {
        minX: -1.197736,
        maxX: 0.612204,
        minY: -0.54945,
        maxY: 1.127538
      },
      center: {
        x: -0.0588,
        y: 0.14887685714285714
      },
      isViaRegion: true,
      netName: "net5"
    },
    {
      regionId: "t0_0:convex:0",
      polygon: [
        {
          x: -1.104954,
          y: -1.1342880000000002
        },
        {
          x: -1.6265515000000001,
          y: -1.4627051999999998
        },
        {
          x: -1.6265525,
          y: -1.828384
        },
        {
          x: -1.301244,
          y: -1.828384
        },
        {
          x: -0.9759325,
          y: -1.828384
        },
        {
          x: -0.6506210000000001,
          y: -1.828383
        },
        {
          x: -0.32530949999999986,
          y: -1.828382
        },
        {
          x: -0.67334963343571,
          y: -1.134284
        }
      ],
      bounds: {
        minX: -1.6265525,
        maxX: -0.32530949999999986,
        minY: -1.828384,
        maxY: -1.134284
      },
      center: {
        x: -1.0355643291794636,
        y: -1.609149275
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:1",
      polygon: [
        {
          x: -0.14745539353012446,
          y: -0.928598
        },
        {
          x: -0.2370859277013201,
          y: -0.8279985835953872
        },
        {
          x: -0.67334963343571,
          y: -1.134284
        },
        {
          x: -0.32530949999999986,
          y: -1.828382
        },
        {
          x: 2e-6,
          y: -1.828384
        }
      ],
      bounds: {
        minX: -0.67334963343571,
        maxX: 2e-6,
        minY: -1.828384,
        maxY: -0.8279985835953872
      },
      center: {
        x: -0.2766396909334309,
        y: -1.3095293167190776
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:2",
      polygon: [
        {
          x: 0.29738,
          y: -0.9285990000000001
        },
        {
          x: -0.14745539353012446,
          y: -0.928598
        },
        {
          x: 2e-6,
          y: -1.828384
        },
        {
          x: 0.3253134999999998,
          y: -1.828384
        }
      ],
      bounds: {
        minX: -0.14745539353012446,
        maxX: 0.3253134999999998,
        minY: -1.828384,
        maxY: -0.928598
      },
      center: {
        x: 0.11881002661746884,
        y: -1.37849125
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:3",
      polygon: [
        {
          x: 0.9759295000000004,
          y: -1.828383
        },
        {
          x: 1.301241,
          y: -1.828382
        },
        {
          x: 1.6265525,
          y: -1.4627082
        },
        {
          x: 1.6265525,
          y: -1.0970304
        },
        {
          x: 1.6265525,
          y: -0.7313526
        },
        {
          x: 0.712202,
          y: -0.649448
        },
        {
          x: 0.297379,
          y: -0.6494519999999999
        },
        {
          x: 0.29738,
          y: -0.9285990000000001
        },
        {
          x: 0.3253134999999998,
          y: -1.828384
        },
        {
          x: 0.6506179999999999,
          y: -1.828384
        }
      ],
      bounds: {
        minX: 0.297379,
        maxX: 1.6265525,
        minY: -1.828384,
        maxY: -0.649448
      },
      center: {
        x: 0.94397205,
        y: -1.28321232
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:4",
      polygon: [
        {
          x: 1.301241,
          y: -1.828382
        },
        {
          x: 1.6265525,
          y: -1.828384
        },
        {
          x: 1.6265525,
          y: -1.4627082
        }
      ],
      bounds: {
        minX: 1.301241,
        maxX: 1.6265525,
        minY: -1.828384,
        maxY: -1.4627082
      },
      center: {
        x: 1.5181153333333333,
        y: -1.7064914
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:5",
      polygon: [
        {
          x: 1.0285170000000001,
          y: -0.262215
        },
        {
          x: 0.712201,
          y: -0.262214
        },
        {
          x: 0.712202,
          y: -0.649448
        },
        {
          x: 1.6265525,
          y: -0.7313526
        },
        {
          x: 1.6265495,
          y: -0.3656747999999999
        }
      ],
      bounds: {
        minX: 0.712201,
        maxX: 1.6265525,
        minY: -0.7313526,
        maxY: -0.262214
      },
      center: {
        x: 1.1412044000000001,
        y: -0.45418088
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:6",
      polygon: [
        {
          x: 1.6265505,
          y: -2e-6
        },
        {
          x: 1.6265515000000001,
          y: 0.36567579999999994
        },
        {
          x: 1.264827,
          y: 0.22644042974475398
        },
        {
          x: 1.0285160000000002,
          y: 0.06053491775321725
        },
        {
          x: 1.0285170000000001,
          y: -0.262215
        },
        {
          x: 1.6265495,
          y: -0.3656747999999999
        }
      ],
      bounds: {
        minX: 1.0285160000000002,
        maxX: 1.6265515000000001,
        minY: -0.3656747999999999,
        maxY: 0.36567579999999994
      },
      center: {
        x: 1.3669185833333335,
        y: 0.004126557916328553
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:7",
      polygon: [
        {
          x: 1.264826,
          y: 0.678422
        },
        {
          x: 1.264827,
          y: 0.22644042974475398
        },
        {
          x: 1.6265515000000001,
          y: 0.36567579999999994
        },
        {
          x: 1.6265525,
          y: 0.7313536
        }
      ],
      bounds: {
        minX: 1.264826,
        maxX: 1.6265525,
        minY: 0.22644042974475398,
        maxY: 0.7313536
      },
      center: {
        x: 1.4456892499999998,
        y: 0.5004729574361885
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:8",
      polygon: [
        {
          x: 1.6265525,
          y: 1.0970314
        },
        {
          x: 0.9459820000000001,
          y: 1.063573
        },
        {
          x: 0.945983,
          y: 0.678421
        },
        {
          x: 1.264826,
          y: 0.678422
        },
        {
          x: 1.6265525,
          y: 0.7313536
        }
      ],
      bounds: {
        minX: 0.9459820000000001,
        maxX: 1.6265525,
        minY: 0.678421,
        maxY: 1.0970314
      },
      center: {
        x: 1.2819791999999999,
        y: 0.8497602000000001
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:9",
      polygon: [
        {
          x: 0.4577960301822552,
          y: 1.22754
        },
        {
          x: 0.5142343492649757,
          y: 1.0635720000000002
        },
        {
          x: 0.9459820000000001,
          y: 1.063573
        },
        {
          x: 1.6265525,
          y: 1.0970314
        },
        {
          x: 1.6265525,
          y: 1.4627092
        },
        {
          x: 1.6265525,
          y: 1.828382
        },
        {
          x: 1.301239,
          y: 1.828383
        },
        {
          x: 0.9759295,
          y: 1.828384
        },
        {
          x: 0.6506200000000001,
          y: 1.828384
        },
        {
          x: 0.32531049999999984,
          y: 1.828384
        }
      ],
      bounds: {
        minX: 0.32531049999999984,
        maxX: 1.6265525,
        minY: 1.0635720000000002,
        maxY: 1.828384
      },
      center: {
        x: 1.0050768879447232,
        y: 1.5056342600000001
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:10",
      polygon: [
        {
          x: -0.04076829030879819,
          y: 1.2790080000000001
        },
        {
          x: -0.02247520650291584,
          y: 1.1817306460139294
        },
        {
          x: 0.041535316582505054,
          y: 1.227539
        },
        {
          x: 0.32531049999999984,
          y: 1.828384
        },
        {
          x: 1e-6,
          y: 1.828382
        }
      ],
      bounds: {
        minX: -0.04076829030879819,
        maxX: 0.32531049999999984,
        minY: 1.1817306460139294,
        maxY: 1.828384
      },
      center: {
        x: 0.06072066395415817,
        y: 1.4690087292027858
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:11",
      polygon: [
        {
          x: 0.32531049999999984,
          y: 1.828384
        },
        {
          x: 0.041535316582505054,
          y: 1.227539
        },
        {
          x: 0.4577960301822552,
          y: 1.22754
        }
      ],
      bounds: {
        minX: 0.041535316582505054,
        maxX: 0.4577960301822552,
        minY: 1.227539,
        maxY: 1.828384
      },
      center: {
        x: 0.27488061558825333,
        y: 1.427821
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:12",
      polygon: [
        {
          x: -0.04076829030879819,
          y: 1.2790080000000001
        },
        {
          x: 1e-6,
          y: 1.828382
        },
        {
          x: -0.32530849999999983,
          y: 1.828383
        },
        {
          x: -0.6506179999999999,
          y: 1.828384
        },
        {
          x: -0.4508136525377509,
          y: 1.279007
        }
      ],
      bounds: {
        minX: -0.6506179999999999,
        maxX: 1e-6,
        minY: 1.279007,
        maxY: 1.828384
      },
      center: {
        x: -0.2935014885693098,
        y: 1.6086328
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:13",
      polygon: [
        {
          x: -0.9759345000000004,
          y: 1.828384
        },
        {
          x: -1.301244,
          y: 1.828384
        },
        {
          x: -1.020589,
          y: 1.22317
        },
        {
          x: -0.5914781273848957,
          y: 1.223171
        },
        {
          x: -0.6506179999999999,
          y: 1.828384
        }
      ],
      bounds: {
        minX: -1.301244,
        maxX: -0.5914781273848957,
        minY: 1.22317,
        maxY: 1.828384
      },
      center: {
        x: -0.9079727254769793,
        y: 1.5862986
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:14",
      polygon: [
        {
          x: -1.6265525,
          y: 1.4627062000000002
        },
        {
          x: -1.6265515000000001,
          y: 1.0970304
        },
        {
          x: -1.312855,
          y: 0.7748397948423481
        },
        {
          x: -1.02059,
          y: 0.9457717862849203
        },
        {
          x: -1.020589,
          y: 1.22317
        },
        {
          x: -1.301244,
          y: 1.828384
        },
        {
          x: -1.6265525,
          y: 1.828382
        }
      ],
      bounds: {
        minX: -1.6265525,
        maxX: -1.020589,
        minY: 0.7748397948423481,
        maxY: 1.828384
      },
      center: {
        x: -1.3621335000000003,
        y: 1.3086120258753238
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:15",
      polygon: [
        {
          x: -1.6265505,
          y: 0.7313546000000001
        },
        {
          x: -1.312856,
          y: 0.379395159306606
        },
        {
          x: -1.312855,
          y: 0.7748397948423481
        },
        {
          x: -1.6265515000000001,
          y: 1.0970304
        }
      ],
      bounds: {
        minX: -1.6265515000000001,
        maxX: -1.312855,
        minY: 0.379395159306606,
        maxY: 1.0970304
      },
      center: {
        x: -1.4697032500000002,
        y: 0.7456549885372385
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:16",
      polygon: [
        {
          x: -1.6265525,
          y: -2e-6
        },
        {
          x: -1.6265525,
          y: -0.3656777999999999
        },
        {
          x: -1.3178860000000001,
          y: -0.23008248432450779
        },
        {
          x: -1.297733,
          y: -0.15603295102834283
        },
        {
          x: -1.297739,
          y: 0.2691114016192869
        },
        {
          x: -1.6265495,
          y: 0.3656787999999999
        }
      ],
      bounds: {
        minX: -1.6265525,
        maxX: -1.297733,
        minY: -0.3656777999999999,
        maxY: 0.3656787999999999
      },
      center: {
        x: -1.4655020833333332,
        y: -0.01950083895559393
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:17",
      polygon: [
        {
          x: -1.6265525,
          y: -0.3656777999999999
        },
        {
          x: -1.317887,
          y: -0.68189
        },
        {
          x: -1.3178860000000001,
          y: -0.23008248432450779
        }
      ],
      bounds: {
        minX: -1.6265525,
        maxX: -1.3178860000000001,
        minY: -0.68189,
        maxY: -0.23008248432450779
      },
      center: {
        x: -1.4207751666666668,
        y: -0.4258834281081692
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:18",
      polygon: [
        {
          x: -1.317887,
          y: -0.68189
        },
        {
          x: -1.6265525,
          y: -0.3656777999999999
        },
        {
          x: -1.6265525,
          y: -0.7313536
        },
        {
          x: -1.6265525,
          y: -1.0970294000000003
        },
        {
          x: -1.6265515000000001,
          y: -1.4627051999999998
        },
        {
          x: -1.104954,
          y: -1.1342880000000002
        }
      ],
      bounds: {
        minX: -1.6265525,
        maxX: -1.104954,
        minY: -1.4627051999999998,
        maxY: -0.3656777999999999
      },
      center: {
        x: -1.488175,
        y: -0.9121573333333334
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:19",
      polygon: [
        {
          x: -1.2388222238680076,
          y: -0.17426049624915768
        },
        {
          x: -1.297733,
          y: -0.15603295102834283
        },
        {
          x: -1.3178860000000001,
          y: -0.23008248432450779
        }
      ],
      bounds: {
        minX: -1.3178860000000001,
        maxX: -1.2388222238680076,
        minY: -0.23008248432450779,
        maxY: -0.15603295102834283
      },
      center: {
        x: -1.284813741289336,
        y: -0.18679197720066942
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:20",
      polygon: [
        {
          x: -1.312856,
          y: 0.379395159306606
        },
        {
          x: -1.6265505,
          y: 0.7313546000000001
        },
        {
          x: -1.6265495,
          y: 0.3656787999999999
        },
        {
          x: -1.297739,
          y: 0.2691114016192869
        },
        {
          x: -1.2469689855126633,
          y: 0.30544440514072957
        }
      ],
      bounds: {
        minX: -1.6265505,
        maxX: -1.2469689855126633,
        minY: 0.2691114016192869,
        maxY: 0.7313546000000001
      },
      center: {
        x: -1.4221327971025326,
        y: 0.4101968732133245
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:21",
      polygon: [
        {
          x: -0.4508136525377509,
          y: 1.279007
        },
        {
          x: -0.6506179999999999,
          y: 1.828384
        },
        {
          x: -0.5914781273848957,
          y: 1.223171
        },
        {
          x: -0.5698356477081257,
          y: 1.2094014117272271
        }
      ],
      bounds: {
        minX: -0.6506179999999999,
        maxX: -0.4508136525377509,
        minY: 1.2094014117272271,
        maxY: 1.828384
      },
      center: {
        x: -0.5656863569076931,
        y: 1.3849908529318067
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:22",
      polygon: [
        {
          x: 0.4577960301822552,
          y: 1.22754
        },
        {
          x: 0.48926113449838465,
          y: 1.0459332516952444
        },
        {
          x: 0.5142343492649757,
          y: 1.0635720000000002
        }
      ],
      bounds: {
        minX: 0.4577960301822552,
        maxX: 0.5142343492649757,
        minY: 1.0459332516952444,
        maxY: 1.22754
      },
      center: {
        x: 0.4870971713152052,
        y: 1.1123484172317482
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:23",
      polygon: [
        {
          x: -1.104954,
          y: -1.1342880000000002
        },
        {
          x: -1.104953,
          y: -0.6823094297447541
        },
        {
          x: -1.317887,
          y: -0.68189
        }
      ],
      bounds: {
        minX: -1.317887,
        maxX: -1.104953,
        minY: -1.1342880000000002,
        maxY: -0.68189
      },
      center: {
        x: -1.1759313333333334,
        y: -0.8328291432482514
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:24",
      polygon: [
        {
          x: -1.104953,
          y: -0.6823094297447541
        },
        {
          x: -1.104357426244828,
          y: -0.681891
        },
        {
          x: -1.317887,
          y: -0.68189
        }
      ],
      bounds: {
        minX: -1.317887,
        maxX: -1.104357426244828,
        minY: -0.6823094297447541,
        maxY: -0.68189
      },
      center: {
        x: -1.1757324754149427,
        y: -0.6820301432482513
      },
      isViaRegion: false
    }
  ],
  ports: [
    {
      portId: "t0_0:convex:0-1:0",
      region1Id: "t0_0:convex:0",
      region2Id: "t0_0:convex:1",
      position: {
        x: -0.4993295667178549,
        y: -1.481333
      }
    },
    {
      portId: "t0_0:convex:0-18:1",
      region1Id: "t0_0:convex:0",
      region2Id: "t0_0:convex:18",
      position: {
        x: -1.36575275,
        y: -1.2984966
      }
    },
    {
      portId: "t0_0:convex:1-2:2",
      region1Id: "t0_0:convex:1",
      region2Id: "t0_0:convex:2",
      position: {
        x: -0.036862348382531114,
        y: -1.6034375
      }
    },
    {
      portId: "t0_0:convex:1-2:3",
      region1Id: "t0_0:convex:1",
      region2Id: "t0_0:convex:2",
      position: {
        x: -0.11059104514759335,
        y: -1.1535445
      }
    },
    {
      portId: "t0_0:convex:2-3:4",
      region1Id: "t0_0:convex:2",
      region2Id: "t0_0:convex:3",
      position: {
        x: 0.31833012499999985,
        y: -1.60343775
      }
    },
    {
      portId: "t0_0:convex:2-3:5",
      region1Id: "t0_0:convex:2",
      region2Id: "t0_0:convex:3",
      position: {
        x: 0.30436337499999994,
        y: -1.15354525
      }
    },
    {
      portId: "t0_0:convex:3-4:6",
      region1Id: "t0_0:convex:3",
      region2Id: "t0_0:convex:4",
      position: {
        x: 1.46389675,
        y: -1.6455451
      }
    },
    {
      portId: "t0_0:convex:3-5:7",
      region1Id: "t0_0:convex:3",
      region2Id: "t0_0:convex:5",
      position: {
        x: 1.397964875,
        y: -0.71087645
      }
    },
    {
      portId: "t0_0:convex:3-5:8",
      region1Id: "t0_0:convex:3",
      region2Id: "t0_0:convex:5",
      position: {
        x: 0.9407896250000001,
        y: -0.66992415
      }
    },
    {
      portId: "t0_0:convex:5-6:9",
      region1Id: "t0_0:convex:5",
      region2Id: "t0_0:convex:6",
      position: {
        x: 1.32753325,
        y: -0.31394489999999997
      }
    },
    {
      portId: "t0_0:convex:6-7:10",
      region1Id: "t0_0:convex:6",
      region2Id: "t0_0:convex:7",
      position: {
        x: 1.44568925,
        y: 0.296058114872377
      }
    },
    {
      portId: "t0_0:convex:7-8:11",
      region1Id: "t0_0:convex:7",
      region2Id: "t0_0:convex:8",
      position: {
        x: 1.44568925,
        y: 0.7048878000000001
      }
    },
    {
      portId: "t0_0:convex:8-9:12",
      region1Id: "t0_0:convex:8",
      region2Id: "t0_0:convex:9",
      position: {
        x: 1.28626725,
        y: 1.0803022000000002
      }
    },
    {
      portId: "t0_0:convex:9-11:13",
      region1Id: "t0_0:convex:9",
      region2Id: "t0_0:convex:11",
      position: {
        x: 0.39155326509112753,
        y: 1.527962
      }
    },
    {
      portId: "t0_0:convex:10-11:14",
      region1Id: "t0_0:convex:10",
      region2Id: "t0_0:convex:11",
      position: {
        x: 0.18342290829125246,
        y: 1.5279615
      }
    },
    {
      portId: "t0_0:convex:10-12:15",
      region1Id: "t0_0:convex:10",
      region2Id: "t0_0:convex:12",
      position: {
        x: -0.020383645154399093,
        y: 1.553695
      }
    },
    {
      portId: "t0_0:convex:12-21:16",
      region1Id: "t0_0:convex:12",
      region2Id: "t0_0:convex:21",
      position: {
        x: -0.5507158262688754,
        y: 1.5536955
      }
    },
    {
      portId: "t0_0:convex:13-14:17",
      region1Id: "t0_0:convex:13",
      region2Id: "t0_0:convex:14",
      position: {
        x: -1.1609165,
        y: 1.5257770000000002
      }
    },
    {
      portId: "t0_0:convex:13-21:18",
      region1Id: "t0_0:convex:13",
      region2Id: "t0_0:convex:21",
      position: {
        x: -0.6210480636924478,
        y: 1.5257775
      }
    },
    {
      portId: "t0_0:convex:14-15:19",
      region1Id: "t0_0:convex:14",
      region2Id: "t0_0:convex:15",
      position: {
        x: -1.4697032500000002,
        y: 0.935935097421174
      }
    },
    {
      portId: "t0_0:convex:15-20:20",
      region1Id: "t0_0:convex:15",
      region2Id: "t0_0:convex:20",
      position: {
        x: -1.46970325,
        y: 0.555374879653303
      }
    },
    {
      portId: "t0_0:convex:16-17:21",
      region1Id: "t0_0:convex:16",
      region2Id: "t0_0:convex:17",
      position: {
        x: -1.4722192500000002,
        y: -0.29788014216225384
      }
    },
    {
      portId: "t0_0:convex:16-20:22",
      region1Id: "t0_0:convex:16",
      region2Id: "t0_0:convex:20",
      position: {
        x: -1.4621442500000001,
        y: 0.3173951008096434
      }
    },
    {
      portId: "t0_0:convex:17-18:23",
      region1Id: "t0_0:convex:17",
      region2Id: "t0_0:convex:18",
      position: {
        x: -1.47221975,
        y: -0.5237839
      }
    },
    {
      portId: "t0_0:convex:18-23:24",
      region1Id: "t0_0:convex:18",
      region2Id: "t0_0:convex:23",
      position: {
        x: -1.2114205,
        y: -0.9080890000000001
      }
    },
    {
      portId: "t0_0:convex:23-24:25",
      region1Id: "t0_0:convex:23",
      region2Id: "t0_0:convex:24",
      position: {
        x: -1.21142,
        y: -0.6820997148723771
      }
    },
    {
      portId: "via-side:t0_0:v:net1:top:27",
      region1Id: "t0_0:v:net1",
      region2Id: "t0_0:convex:13",
      position: {
        x: -0.770591,
        y: 1.12317
      }
    },
    {
      portId: "via-side:t0_0:v:net1:bottom:28",
      region1Id: "t0_0:v:net1",
      region2Id: "t0_0:convex:5",
      position: {
        x: 0.778514,
        y: -0.162215
      }
    },
    {
      portId: "via-side:t0_0:v:net1:left:29",
      region1Id: "t0_0:v:net1",
      region2Id: "t0_0:convex:14",
      position: {
        x: -0.920591,
        y: 0.97317
      }
    },
    {
      portId: "via-side:t0_0:v:net1:right:30",
      region1Id: "t0_0:v:net1",
      region2Id: "t0_0:convex:6",
      position: {
        x: 0.9285140000000001,
        y: -0.012215000000000004
      }
    },
    {
      portId: "via-side:t0_0:v:net2:top:31",
      region1Id: "t0_0:v:net2",
      region2Id: "t0_0:convex:8",
      position: {
        x: 1.014826,
        y: 0.57842
      }
    },
    {
      portId: "via-side:t0_0:v:net2:bottom:32",
      region1Id: "t0_0:v:net2",
      region2Id: "t0_0:convex:0",
      position: {
        x: -0.854951,
        y: -1.034286
      }
    },
    {
      portId: "via-side:t0_0:v:net2:left:33",
      region1Id: "t0_0:v:net2",
      region2Id: "t0_0:convex:23",
      position: {
        x: -1.004951,
        y: -0.884286
      }
    },
    {
      portId: "via-side:t0_0:v:net2:right:34",
      region1Id: "t0_0:v:net2",
      region2Id: "t0_0:convex:7",
      position: {
        x: 1.164826,
        y: 0.42842
      }
    },
    {
      portId: "via-side:t0_0:v:net3:top:35",
      region1Id: "t0_0:v:net3",
      region2Id: "t0_0:convex:9",
      position: {
        x: 0.695984,
        y: 0.963573
      }
    },
    {
      portId: "via-side:t0_0:v:net3:left:36",
      region1Id: "t0_0:v:net3",
      region2Id: "t0_0:convex:17",
      position: {
        x: -1.217887,
        y: -0.431891
      }
    },
    {
      portId: "via-side:t0_0:v:net3:right:37",
      region1Id: "t0_0:v:net3",
      region2Id: "t0_0:convex:8",
      position: {
        x: 0.8459840000000001,
        y: 0.813573
      }
    },
    {
      portId: "via-side:t0_0:v:net4:top:38",
      region1Id: "t0_0:v:net4",
      region2Id: "t0_0:convex:12",
      position: {
        x: -0.273716,
        y: 1.179009
      }
    },
    {
      portId: "via-side:t0_0:v:net4:bottom:39",
      region1Id: "t0_0:v:net4",
      region2Id: "t0_0:convex:2",
      position: {
        x: 0.047380000000000005,
        y: -0.8285980000000001
      }
    },
    {
      portId: "via-side:t0_0:v:net4:left:40",
      region1Id: "t0_0:v:net4",
      region2Id: "t0_0:convex:15",
      position: {
        x: -1.212855,
        y: 0.56748
      }
    },
    {
      portId: "via-side:t0_0:v:net4:right:41",
      region1Id: "t0_0:v:net4",
      region2Id: "t0_0:convex:3",
      position: {
        x: 0.19738,
        y: -0.678598
      }
    },
    {
      portId: "via-side:t0_0:v:net5:top:42",
      region1Id: "t0_0:v:net5",
      region2Id: "t0_0:convex:11",
      position: {
        x: 0.22363,
        y: 1.127538
      }
    },
    {
      portId: "via-side:t0_0:v:net5:bottom:43",
      region1Id: "t0_0:v:net5",
      region2Id: "t0_0:convex:3",
      position: {
        x: 0.462204,
        y: -0.54945
      }
    },
    {
      portId: "via-side:t0_0:v:net5:left:44",
      region1Id: "t0_0:v:net5",
      region2Id: "t0_0:convex:16",
      position: {
        x: -1.197736,
        y: 0.06770600000000002
      }
    },
    {
      portId: "via-side:t0_0:v:net5:right:45",
      region1Id: "t0_0:v:net5",
      region2Id: "t0_0:convex:5",
      position: {
        x: 0.612204,
        y: -0.39945
      }
    }
  ]
};

// assets/ViaGraphSolver/via-tile-6-regions-baked.json
var via_tile_6_regions_baked_default = {
  viasByNet: {
    net1: [
      {
        viaId: "afbcad2b-4805-48e1-aa34-1f4472329d76",
        diameter: 0.3,
        position: {
          x: 0.648081,
          y: -0.653655
        }
      },
      {
        viaId: "d31e4843-afe8-4699-8221-70cba52d9589",
        diameter: 0.3,
        position: {
          x: 0.082317,
          y: 0.912692
        }
      }
    ],
    net2: [
      {
        viaId: "096f26d0-a555-4492-94da-865de1f8e6e6",
        diameter: 0.3,
        position: {
          x: 1.336913,
          y: 0.267523
        }
      },
      {
        viaId: "71432b8b-1d41-4586-88f8-1dd9c542b47b",
        diameter: 0.3,
        position: {
          x: -0.651699,
          y: -1.264802
        }
      }
    ],
    net3: [
      {
        viaId: "833f3d74-7403-4d5b-8999-848795f1be47",
        diameter: 0.3,
        position: {
          x: -0.652635,
          y: -0.2648
        }
      },
      {
        viaId: "ff5f1055-a4f7-4a85-a790-4769e4eea87b",
        diameter: 0.3,
        position: {
          x: 0.58222,
          y: 0.92265
        }
      }
    ],
    net4: [
      {
        viaId: "6e2c4dc3-f43d-4f13-bff3-c0e08585ceb1",
        diameter: 0.3,
        position: {
          x: -0.15182,
          y: -1.253675
        }
      },
      {
        viaId: "b11b8fa4-a804-42b8-8de3-4416f00feda9",
        diameter: 0.3,
        position: {
          x: -0.650488,
          y: 0.235198
        }
      }
    ],
    net5: [
      {
        viaId: "bd0008ee-fb87-4f6a-922b-14f6d989ee78",
        diameter: 0.3,
        position: {
          x: -0.305576,
          y: 0.59719
        }
      },
      {
        viaId: "cd839c31-ee5e-47be-973e-a4e0fd041bae",
        diameter: 0.3,
        position: {
          x: 0.251735,
          y: -0.95847
        }
      }
    ],
    net6: [
      {
        viaId: "aa3a0b88-786d-4e3a-9cf4-ab924faca4e9",
        diameter: 0.3,
        position: {
          x: -0.65095,
          y: -0.7648
        }
      },
      {
        viaId: "c0f2259e-7d00-43c3-bfa3-183bc4286c46",
        diameter: 0.3,
        position: {
          x: 0.971187,
          y: 0.608473
        }
      }
    ]
  },
  routeSegments: [
    {
      routeId: "net1:route_0",
      fromPort: "afbcad2b-4805-48e1-aa34-1f4472329d76",
      toPort: "d31e4843-afe8-4699-8221-70cba52d9589",
      layer: "bottom",
      segments: [
        {
          x: 0.648081,
          y: -0.653655
        },
        {
          x: 0.648081,
          y: 0.268604
        },
        {
          x: 0.082317,
          y: 0.834368
        },
        {
          x: 0.082317,
          y: 0.912692
        }
      ]
    },
    {
      routeId: "net2:route_0",
      fromPort: "096f26d0-a555-4492-94da-865de1f8e6e6",
      toPort: "71432b8b-1d41-4586-88f8-1dd9c542b47b",
      layer: "bottom",
      segments: [
        {
          x: 1.336913,
          y: 0.267523
        },
        {
          x: 1.336913,
          y: -0.531923
        },
        {
          x: 0.214161,
          y: -1.654675
        },
        {
          x: -0.31792,
          y: -1.654675
        },
        {
          x: -0.651699,
          y: -1.320896
        },
        {
          x: -0.651699,
          y: -1.264802
        }
      ]
    },
    {
      routeId: "net3:route_0",
      fromPort: "833f3d74-7403-4d5b-8999-848795f1be47",
      toPort: "ff5f1055-a4f7-4a85-a790-4769e4eea87b",
      layer: "bottom",
      segments: [
        {
          x: -0.652635,
          y: -0.2648
        },
        {
          x: -0.71759,
          y: -0.2648
        },
        {
          x: -1.051488,
          y: 0.069098
        },
        {
          x: -1.051488,
          y: 0.418378
        },
        {
          x: -0.156174,
          y: 1.313692
        },
        {
          x: 0.248417,
          y: 1.313692
        },
        {
          x: 0.58222,
          y: 0.979889
        },
        {
          x: 0.58222,
          y: 0.92265
        }
      ]
    },
    {
      routeId: "net4:route_0",
      fromPort: "6e2c4dc3-f43d-4f13-bff3-c0e08585ceb1",
      toPort: "b11b8fa4-a804-42b8-8de3-4416f00feda9",
      layer: "bottom",
      segments: [
        {
          x: -0.15182,
          y: -1.253675
        },
        {
          x: -0.15182,
          y: -0.198515
        },
        {
          x: -0.585533,
          y: 0.235198
        },
        {
          x: -0.650488,
          y: 0.235198
        }
      ]
    },
    {
      routeId: "net5:route_0",
      fromPort: "bd0008ee-fb87-4f6a-922b-14f6d989ee78",
      toPort: "cd839c31-ee5e-47be-973e-a4e0fd041bae",
      layer: "bottom",
      segments: [
        {
          x: -0.305576,
          y: 0.59719
        },
        {
          x: 0.14918,
          y: 0.142434
        },
        {
          x: 0.14918,
          y: -0.855915
        },
        {
          x: 0.251735,
          y: -0.95847
        }
      ]
    },
    {
      routeId: "net6:route_0",
      fromPort: "aa3a0b88-786d-4e3a-9cf4-ab924faca4e9",
      toPort: "c0f2259e-7d00-43c3-bfa3-183bc4286c46",
      layer: "bottom",
      segments: [
        {
          x: -0.65095,
          y: -0.7648
        },
        {
          x: -0.75509,
          y: -0.7648
        },
        {
          x: -1.402488,
          y: -0.117402
        },
        {
          x: -1.402488,
          y: 0.563766
        },
        {
          x: -0.301563,
          y: 1.664692
        },
        {
          x: 0.442633,
          y: 1.664692
        },
        {
          x: 1.023297,
          y: 1.084028
        },
        {
          x: 1.023297,
          y: 0.660583
        },
        {
          x: 0.971187,
          y: 0.608473
        }
      ]
    }
  ],
  tileWidth: 3.1144009999999995,
  tileHeight: 3.619367,
  regions: [
    {
      regionId: "t0_0:v:net1",
      polygon: [
        {
          x: -0.067683,
          y: 1.062692
        },
        {
          x: 0.232317,
          y: 1.062692
        },
        {
          x: 0.798081,
          y: -0.503655
        },
        {
          x: 0.798081,
          y: -0.803655
        },
        {
          x: 0.498081,
          y: -0.803655
        },
        {
          x: -0.067683,
          y: 0.7626919999999999
        }
      ],
      bounds: {
        minX: -0.067683,
        maxX: 0.798081,
        minY: -0.803655,
        maxY: 1.062692
      },
      center: {
        x: 0.365199,
        y: 0.12951849999999998
      },
      isViaRegion: true,
      netName: "net1"
    },
    {
      regionId: "t0_0:v:net2",
      polygon: [
        {
          x: 1.186913,
          y: 0.417523
        },
        {
          x: 1.486913,
          y: 0.417523
        },
        {
          x: 1.486913,
          y: 0.11752300000000002
        },
        {
          x: -0.501699,
          y: -1.414802
        },
        {
          x: -0.801699,
          y: -1.414802
        },
        {
          x: -0.801699,
          y: -1.114802
        }
      ],
      bounds: {
        minX: -0.801699,
        maxX: 1.486913,
        minY: -1.414802,
        maxY: 0.417523
      },
      center: {
        x: 0.3426069999999999,
        y: -0.49863949999999996
      },
      isViaRegion: true,
      netName: "net2"
    },
    {
      regionId: "t0_0:v:net3",
      polygon: [
        {
          x: 0.43221999999999994,
          y: 1.0726499999999999
        },
        {
          x: 0.73222,
          y: 1.0726499999999999
        },
        {
          x: 0.73222,
          y: 0.77265
        },
        {
          x: -0.5026349999999999,
          y: -0.41479999999999995
        },
        {
          x: -0.802635,
          y: -0.41479999999999995
        },
        {
          x: -0.802635,
          y: -0.11479999999999999
        }
      ],
      bounds: {
        minX: -0.802635,
        maxX: 0.73222,
        minY: -0.41479999999999995,
        maxY: 1.0726499999999999
      },
      center: {
        x: -0.035207500000000023,
        y: 0.32892499999999997
      },
      isViaRegion: true,
      netName: "net3"
    },
    {
      regionId: "t0_0:v:net4",
      polygon: [
        {
          x: -0.800488,
          y: 0.385198
        },
        {
          x: -0.5004879999999999,
          y: 0.385198
        },
        {
          x: -0.001820000000000016,
          y: -1.1036750000000002
        },
        {
          x: -0.001820000000000016,
          y: -1.403675
        },
        {
          x: -0.30182,
          y: -1.403675
        },
        {
          x: -0.800488,
          y: 0.085198
        }
      ],
      bounds: {
        minX: -0.800488,
        maxX: -0.001820000000000016,
        minY: -1.403675,
        maxY: 0.385198
      },
      center: {
        x: -0.40115399999999996,
        y: -0.5092385
      },
      isViaRegion: true,
      netName: "net4"
    },
    {
      regionId: "t0_0:v:net5",
      polygon: [
        {
          x: -0.455576,
          y: 0.74719
        },
        {
          x: -0.15557600000000002,
          y: 0.74719
        },
        {
          x: 0.40173499999999995,
          y: -0.80847
        },
        {
          x: 0.40173499999999995,
          y: -1.10847
        },
        {
          x: 0.10173499999999999,
          y: -1.10847
        },
        {
          x: -0.455576,
          y: 0.44719
        }
      ],
      bounds: {
        minX: -0.455576,
        maxX: 0.40173499999999995,
        minY: -1.10847,
        maxY: 0.74719
      },
      center: {
        x: -0.026920500000000014,
        y: -0.18064000000000002
      },
      isViaRegion: true,
      netName: "net5"
    },
    {
      regionId: "t0_0:v:net6",
      polygon: [
        {
          x: 0.821187,
          y: 0.7584730000000001
        },
        {
          x: 1.121187,
          y: 0.7584730000000001
        },
        {
          x: 1.121187,
          y: 0.458473
        },
        {
          x: -0.50095,
          y: -0.9148000000000001
        },
        {
          x: -0.80095,
          y: -0.9148000000000001
        },
        {
          x: -0.80095,
          y: -0.6148
        }
      ],
      bounds: {
        minX: -0.80095,
        maxX: 1.121187,
        minY: -0.9148000000000001,
        maxY: 0.7584730000000001
      },
      center: {
        x: 0.16011849999999997,
        y: -0.07816350000000001
      },
      isViaRegion: true,
      netName: "net6"
    },
    {
      regionId: "t0_0:convex:0",
      polygon: [
        {
          x: -1.2457623999999998,
          y: -1.8096835
        },
        {
          x: -0.9343212999999998,
          y: -1.8096835
        },
        {
          x: -0.6228802,
          y: -1.8096825
        },
        {
          x: -0.9016970000000001,
          y: -1.5148
        },
        {
          x: -1.5571994999999998,
          y: -1.4477448000000002
        },
        {
          x: -1.5572004999999998,
          y: -1.8096835
        }
      ],
      bounds: {
        minX: -1.5572004999999998,
        maxX: -0.6228802,
        minY: -1.8096835,
        maxY: -1.4477448000000002
      },
      center: {
        x: -1.1365101499999999,
        y: -1.7002129666666665
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:1",
      polygon: [
        {
          x: -0.6228802,
          y: -1.8096825
        },
        {
          x: -0.3114390999999998,
          y: -1.8096815
        },
        {
          x: -0.468569740192827,
          y: -1.514801
        },
        {
          x: -0.9016970000000001,
          y: -1.5148
        }
      ],
      bounds: {
        minX: -0.9016970000000001,
        maxX: -0.3114390999999998,
        minY: -1.8096825,
        maxY: -1.5148
      },
      center: {
        x: -0.5761465100482067,
        y: -1.6622412500000001
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:2",
      polygon: [
        {
          x: -0.3737878658736271,
          y: -1.503676
        },
        {
          x: -0.3114390999999998,
          y: -1.8096815
        },
        {
          x: 2e-6,
          y: -1.8096835
        },
        {
          x: 0.31144309999999975,
          y: -1.8096835
        },
        {
          x: 0.09817799999999999,
          y: -1.5036770000000002
        }
      ],
      bounds: {
        minX: -0.3737878658736271,
        maxX: 0.31144309999999975,
        minY: -1.8096835,
        maxY: -1.503676
      },
      center: {
        x: -0.055120773174725454,
        y: -1.6872803
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:3",
      polygon: [
        {
          x: 0.5017379999999999,
          y: -1.2084690000000002
        },
        {
          x: 0.09817699999999999,
          y: -1.208468
        },
        {
          x: 0.09817799999999999,
          y: -1.5036770000000002
        },
        {
          x: 0.31144309999999975,
          y: -1.8096835
        },
        {
          x: 0.6228771999999998,
          y: -1.8096835
        }
      ],
      bounds: {
        minX: 0.09817699999999999,
        maxX: 0.6228771999999998,
        minY: -1.8096835,
        maxY: -1.208468
      },
      center: {
        x: 0.32648265999999987,
        y: -1.5079962000000002
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:4",
      polygon: [
        {
          x: 0.9343183000000003,
          y: -1.8096825
        },
        {
          x: 1.2457593999999999,
          y: -1.8096815
        },
        {
          x: 1.5572004999999998,
          y: -1.4477478
        },
        {
          x: 1.5572004999999998,
          y: -1.0858101
        },
        {
          x: 0.898082,
          y: -0.903656
        },
        {
          x: 0.5017369999999999,
          y: -0.903655
        },
        {
          x: 0.5017379999999999,
          y: -1.2084690000000002
        },
        {
          x: 0.6228771999999998,
          y: -1.8096835
        }
      ],
      bounds: {
        minX: 0.5017369999999999,
        maxX: 1.5572004999999998,
        minY: -1.8096835,
        maxY: -0.903655
      },
      center: {
        x: 0.9773641124999999,
        y: -1.372298175
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:5",
      polygon: [
        {
          x: 1.2457593999999999,
          y: -1.8096815
        },
        {
          x: 1.5572004999999998,
          y: -1.8096835
        },
        {
          x: 1.5572004999999998,
          y: -1.4477478
        }
      ],
      bounds: {
        minX: 1.2457593999999999,
        maxX: 1.5572004999999998,
        minY: -1.8096835,
        maxY: -1.4477478
      },
      center: {
        x: 1.4533867999999996,
        y: -1.6890376
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:6",
      polygon: [
        {
          x: 1.5572004999999998,
          y: -0.7238724
        },
        {
          x: 1.5571974999999998,
          y: -0.3619347
        },
        {
          x: 0.898081,
          y: -0.4976807126365452
        },
        {
          x: 0.898082,
          y: -0.903656
        },
        {
          x: 1.5572004999999998,
          y: -1.0858101
        }
      ],
      bounds: {
        minX: 0.898081,
        maxX: 1.5572004999999998,
        minY: -1.0858101,
        maxY: -0.3619347
      },
      center: {
        x: 1.2935522999999998,
        y: -0.714590782527309
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:7",
      polygon: [
        {
          x: 1.5571974999999998,
          y: -0.3619347
        },
        {
          x: 1.5572004999999998,
          y: -0.007131531126714692
        },
        {
          x: 0.898081,
          y: -0.4976807126365452
        }
      ],
      bounds: {
        minX: 0.898081,
        maxX: 1.5572004999999998,
        minY: -0.4976807126365452,
        maxY: -0.007131531126714692
      },
      center: {
        x: 1.337493,
        y: -0.28891564792108665
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:8",
      polygon: [
        {
          x: 1.5572004999999998,
          y: 0.7238733999999998
        },
        {
          x: 1.5572004999999998,
          y: 1.0858111
        },
        {
          x: 1.22119,
          y: 0.858472
        }
      ],
      bounds: {
        minX: 1.22119,
        maxX: 1.5572004999999998,
        minY: 0.7238733999999998,
        maxY: 1.0858111
      },
      center: {
        x: 1.4451969999999996,
        y: 0.8893854999999999
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:9",
      polygon: [
        {
          x: 1.5572004999999998,
          y: 0.7238733999999998
        },
        {
          x: 1.22119,
          y: 0.858472
        },
        {
          x: 1.221184,
          y: 0.517523
        },
        {
          x: 1.5572004999999998,
          y: 0.5175249999999999
        }
      ],
      bounds: {
        minX: 1.221184,
        maxX: 1.5572004999999998,
        minY: 0.517523,
        maxY: 0.858472
      },
      center: {
        x: 1.3891937499999998,
        y: 0.65434835
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:10",
      polygon: [
        {
          x: 0.8322189999999999,
          y: 1.17265
        },
        {
          x: 0.8322219999999999,
          y: 0.8584710000000001
        },
        {
          x: 1.22119,
          y: 0.858472
        },
        {
          x: 1.5572004999999998,
          y: 1.0858111
        },
        {
          x: 1.5572004999999998,
          y: 1.4477488000000003
        }
      ],
      bounds: {
        minX: 0.8322189999999999,
        maxX: 1.5572004999999998,
        minY: 0.8584710000000001,
        maxY: 1.4477488000000003
      },
      center: {
        x: 1.2000064,
        y: 1.08463058
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:11",
      polygon: [
        {
          x: 0.8322189999999999,
          y: 1.17265
        },
        {
          x: 1.5572004999999998,
          y: 1.4477488000000003
        },
        {
          x: 1.5572004999999998,
          y: 1.8096815
        },
        {
          x: 1.2457573999999998,
          y: 1.8096825
        },
        {
          x: 0.9343182999999998,
          y: 1.8096835
        },
        {
          x: 0.6228792,
          y: 1.8096835
        },
        {
          x: 0.3114400999999998,
          y: 1.8096835
        },
        {
          x: 0.39193830311295386,
          y: 1.172649
        }
      ],
      bounds: {
        minX: 0.3114400999999998,
        maxX: 1.5572004999999998,
        minY: 1.172649,
        maxY: 1.8096835
      },
      center: {
        x: 0.9316191628891191,
        y: 1.6051827875
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:12",
      polygon: [
        {
          x: 1e-6,
          y: 1.8096815
        },
        {
          x: -0.167681,
          y: 1.162693
        },
        {
          x: 0.30252337094105375,
          y: 1.1626940000000001
        },
        {
          x: 0.3114400999999998,
          y: 1.8096835
        }
      ],
      bounds: {
        minX: -0.167681,
        maxX: 0.3114400999999998,
        minY: 1.162693,
        maxY: 1.8096835
      },
      center: {
        x: 0.11157086773526338,
        y: 1.486188
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:13",
      polygon: [
        {
          x: 1e-6,
          y: 1.8096815
        },
        {
          x: -0.3114380999999998,
          y: 1.8096825
        },
        {
          x: -0.167681,
          y: 1.162693
        }
      ],
      bounds: {
        minX: -0.3114380999999998,
        maxX: 1e-6,
        minY: 1.162693,
        maxY: 1.8096825
      },
      center: {
        x: -0.15970603333333325,
        y: 1.594019
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:14",
      polygon: [
        {
          x: -0.6228771999999998,
          y: 1.8096835
        },
        {
          x: -0.555576,
          y: 0.847189
        },
        {
          x: -0.167682,
          y: 0.84719
        },
        {
          x: -0.167681,
          y: 1.162693
        },
        {
          x: -0.3114380999999998,
          y: 1.8096825
        }
      ],
      bounds: {
        minX: -0.6228771999999998,
        maxX: -0.167681,
        minY: 0.847189,
        maxY: 1.8096835
      },
      center: {
        x: -0.3650508599999999,
        y: 1.2952876
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:15",
      polygon: [
        {
          x: -0.555576,
          y: 0.847189
        },
        {
          x: -0.6228771999999998,
          y: 1.8096835
        },
        {
          x: -0.9343233000000002,
          y: 1.8096835
        },
        {
          x: -1.2457623999999998,
          y: 1.8096835
        },
        {
          x: -1.5572004999999998,
          y: 1.8096815
        },
        {
          x: -1.5572004999999998,
          y: 1.4477458
        },
        {
          x: -1.5571994999999998,
          y: 1.0858101
        },
        {
          x: -1.5571984999999997,
          y: 0.7238744
        },
        {
          x: -0.9004899999999999,
          y: 0.4852
        },
        {
          x: -0.555577,
          y: 0.485196
        }
      ],
      bounds: {
        minX: -1.5572004999999998,
        maxX: -0.555576,
        minY: 0.485196,
        maxY: 1.8096835
      },
      center: {
        x: -1.1043404899999998,
        y: 1.23137473
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:16",
      polygon: [
        {
          x: -1.5571984999999997,
          y: 0.7238744
        },
        {
          x: -1.5571974999999998,
          y: 0.3619387
        },
        {
          x: -0.9004899999999999,
          y: 0.4852
        }
      ],
      bounds: {
        minX: -1.5571984999999997,
        maxX: -0.9004899999999999,
        minY: 0.3619387,
        maxY: 0.7238744
      },
      center: {
        x: -1.338295333333333,
        y: 0.5236710333333333
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:17",
      polygon: [
        {
          x: -0.9004909999999999,
          y: 0.06889752588522823
        },
        {
          x: -0.9004899999999999,
          y: 0.4852
        },
        {
          x: -1.5571974999999998,
          y: 0.3619387
        },
        {
          x: -1.5572004999999998,
          y: -2e-6
        }
      ],
      bounds: {
        minX: -1.5572004999999998,
        maxX: -0.9004899999999999,
        minY: -2e-6,
        maxY: 0.4852
      },
      center: {
        x: -1.2288447499999997,
        y: 0.22900855647130705
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:18",
      polygon: [
        {
          x: -1.5572004999999998,
          y: -0.3619377
        },
        {
          x: -1.5572004999999998,
          y: -0.7238733999999998
        },
        {
          x: -0.9026339999999999,
          y: -0.5148019999999999
        },
        {
          x: -0.902633,
          y: -0.07222869307447181
        },
        {
          x: -1.5572004999999998,
          y: -2e-6
        }
      ],
      bounds: {
        minX: -1.5572004999999998,
        maxX: -0.902633,
        minY: -0.7238733999999998,
        maxY: -2e-6
      },
      center: {
        x: -1.2953736999999999,
        y: -0.33456875861489427
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:19",
      polygon: [
        {
          x: -0.900952,
          y: -1.0148000000000001
        },
        {
          x: -0.9009510000000001,
          y: -0.568434282045964
        },
        {
          x: -1.5572004999999998,
          y: -0.7238733999999998
        },
        {
          x: -1.5572004999999998,
          y: -1.0858091
        }
      ],
      bounds: {
        minX: -1.5572004999999998,
        maxX: -0.9009510000000001,
        minY: -1.0858091,
        maxY: -0.568434282045964
      },
      center: {
        x: -1.2290759999999998,
        y: -0.848229195511491
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:20",
      polygon: [
        {
          x: -0.901696,
          y: -1.0656152955659204
        },
        {
          x: -1.5572004999999998,
          y: -1.0858091
        },
        {
          x: -1.5571994999999998,
          y: -1.4477448000000002
        },
        {
          x: -0.9016970000000001,
          y: -1.5148
        }
      ],
      bounds: {
        minX: -1.5572004999999998,
        maxX: -0.901696,
        minY: -1.5148,
        maxY: -1.0656152955659204
      },
      center: {
        x: -1.22944825,
        y: -1.2784922988914802
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:21",
      polygon: [
        {
          x: -0.468569740192827,
          y: -1.514801
        },
        {
          x: -0.3114390999999998,
          y: -1.8096815
        },
        {
          x: -0.3737878658736271,
          y: -1.503676
        },
        {
          x: -0.38971616264549963,
          y: -1.4561149001487406
        }
      ],
      bounds: {
        minX: -0.468569740192827,
        maxX: -0.3114390999999998,
        minY: -1.8096815,
        maxY: -1.4561149001487406
      },
      center: {
        x: -0.3858782171779884,
        y: -1.5710683500371854
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:22",
      polygon: [
        {
          x: -0.900952,
          y: -1.0148000000000001
        },
        {
          x: -1.5572004999999998,
          y: -1.0858091
        },
        {
          x: -0.901696,
          y: -1.0656152955659204
        },
        {
          x: -0.8357578110570957,
          y: -1.014801
        }
      ],
      bounds: {
        minX: -1.5572004999999998,
        maxX: -0.8357578110570957,
        minY: -1.0858091,
        maxY: -1.0148000000000001
      },
      center: {
        x: -1.0489015777642738,
        y: -1.0452563488914801
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:23",
      polygon: [
        {
          x: -0.9026339999999999,
          y: -0.5148019999999999
        },
        {
          x: -1.5572004999999998,
          y: -0.7238733999999998
        },
        {
          x: -0.9009510000000001,
          y: -0.568434282045964
        },
        {
          x: -0.8375949529611417,
          y: -0.514798
        }
      ],
      bounds: {
        minX: -1.5572004999999998,
        maxX: -0.8375949529611417,
        minY: -0.7238733999999998,
        maxY: -0.514798
      },
      center: {
        x: -1.0495951132402852,
        y: -0.5804769205114909
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:24",
      polygon: [
        {
          x: -0.9004909999999999,
          y: 0.06889752588522823
        },
        {
          x: -1.5572004999999998,
          y: -2e-6
        },
        {
          x: -0.902633,
          y: -0.07222869307447181
        },
        {
          x: -0.865256043353791,
          y: -0.03628656661060304
        }
      ],
      bounds: {
        minX: -1.5572004999999998,
        maxX: -0.865256043353791,
        minY: -0.07222869307447181,
        maxY: 0.06889752588522823
      },
      center: {
        x: -1.0563951358384478,
        y: -0.009904933449961658
      },
      isViaRegion: false
    },
    {
      regionId: "t0_0:convex:25",
      polygon: [
        {
          x: 0.39193830311295386,
          y: 1.172649
        },
        {
          x: 0.3114400999999998,
          y: 1.8096835
        },
        {
          x: 0.30252337094105375,
          y: 1.1626940000000001
        },
        {
          x: 0.3228996394549733,
          y: 1.1062606316768617
        }
      ],
      bounds: {
        minX: 0.30252337094105375,
        maxX: 0.39193830311295386,
        minY: 1.1062606316768617,
        maxY: 1.8096835
      },
      center: {
        x: 0.33220035337724513,
        y: 1.3128217829192155
      },
      isViaRegion: false
    }
  ],
  ports: [
    {
      portId: "t0_0:convex:0-1:0",
      region1Id: "t0_0:convex:0",
      region2Id: "t0_0:convex:1",
      position: {
        x: -0.7622886,
        y: -1.6622412500000001
      }
    },
    {
      portId: "t0_0:convex:0-20:1",
      region1Id: "t0_0:convex:0",
      region2Id: "t0_0:convex:20",
      position: {
        x: -1.22944825,
        y: -1.4812724
      }
    },
    {
      portId: "t0_0:convex:1-21:2",
      region1Id: "t0_0:convex:1",
      region2Id: "t0_0:convex:21",
      position: {
        x: -0.3900044200964134,
        y: -1.6622412500000001
      }
    },
    {
      portId: "t0_0:convex:2-3:3",
      region1Id: "t0_0:convex:2",
      region2Id: "t0_0:convex:3",
      position: {
        x: 0.20481054999999987,
        y: -1.65668025
      }
    },
    {
      portId: "t0_0:convex:2-21:4",
      region1Id: "t0_0:convex:2",
      region2Id: "t0_0:convex:21",
      position: {
        x: -0.3426134829368135,
        y: -1.65667875
      }
    },
    {
      portId: "t0_0:convex:3-4:5",
      region1Id: "t0_0:convex:3",
      region2Id: "t0_0:convex:4",
      position: {
        x: 0.5623075999999998,
        y: -1.5090762500000001
      }
    },
    {
      portId: "t0_0:convex:4-5:6",
      region1Id: "t0_0:convex:4",
      region2Id: "t0_0:convex:5",
      position: {
        x: 1.4014799499999997,
        y: -1.62871465
      }
    },
    {
      portId: "t0_0:convex:4-6:7",
      region1Id: "t0_0:convex:4",
      region2Id: "t0_0:convex:6",
      position: {
        x: 1.22764125,
        y: -0.99473305
      }
    },
    {
      portId: "t0_0:convex:6-7:8",
      region1Id: "t0_0:convex:6",
      region2Id: "t0_0:convex:7",
      position: {
        x: 1.22763925,
        y: -0.4298077063182726
      }
    },
    {
      portId: "t0_0:convex:8-9:9",
      region1Id: "t0_0:convex:8",
      region2Id: "t0_0:convex:9",
      position: {
        x: 1.3891952499999998,
        y: 0.7911727
      }
    },
    {
      portId: "t0_0:convex:8-10:10",
      region1Id: "t0_0:convex:8",
      region2Id: "t0_0:convex:10",
      position: {
        x: 1.3891952499999998,
        y: 0.9721415499999999
      }
    },
    {
      portId: "t0_0:convex:10-11:11",
      region1Id: "t0_0:convex:10",
      region2Id: "t0_0:convex:11",
      position: {
        x: 1.19470975,
        y: 1.3101994000000001
      }
    },
    {
      portId: "t0_0:convex:11-12:12",
      region1Id: "t0_0:convex:11",
      region2Id: "t0_0:convex:12",
      position: {
        x: 0.35160563047796883,
        y: 1.4918276021563592
      }
    },
    {
      portId: "t0_0:convex:11-25:13",
      region1Id: "t0_0:convex:11",
      region2Id: "t0_0:convex:25",
      position: {
        x: 0.3516892015564768,
        y: 1.49116625
      }
    },
    {
      portId: "t0_0:convex:12-13:15",
      region1Id: "t0_0:convex:12",
      region2Id: "t0_0:convex:13",
      position: {
        x: -0.08384,
        y: 1.48618725
      }
    },
    {
      portId: "t0_0:convex:12-25:16",
      region1Id: "t0_0:convex:12",
      region2Id: "t0_0:convex:25",
      position: {
        x: 0.307058811859238,
        y: 1.4917813404964075
      }
    },
    {
      portId: "t0_0:convex:12-25:17",
      region1Id: "t0_0:convex:12",
      region2Id: "t0_0:convex:25",
      position: {
        x: 0.30698173547052676,
        y: 1.4861887500000002
      }
    },
    {
      portId: "t0_0:convex:13-14:18",
      region1Id: "t0_0:convex:13",
      region2Id: "t0_0:convex:14",
      position: {
        x: -0.2395595499999999,
        y: 1.48618775
      }
    },
    {
      portId: "t0_0:convex:14-15:19",
      region1Id: "t0_0:convex:14",
      region2Id: "t0_0:convex:15",
      position: {
        x: -0.6060518999999999,
        y: 1.569059875
      }
    },
    {
      portId: "t0_0:convex:14-15:20",
      region1Id: "t0_0:convex:14",
      region2Id: "t0_0:convex:15",
      position: {
        x: -0.5724012999999999,
        y: 1.087812625
      }
    },
    {
      portId: "t0_0:convex:15-16:21",
      region1Id: "t0_0:convex:15",
      region2Id: "t0_0:convex:16",
      position: {
        x: -1.2288442499999999,
        y: 0.6045372
      }
    },
    {
      portId: "t0_0:convex:16-17:22",
      region1Id: "t0_0:convex:16",
      region2Id: "t0_0:convex:17",
      position: {
        x: -1.2288437499999998,
        y: 0.42356935
      }
    },
    {
      portId: "t0_0:convex:17-24:23",
      region1Id: "t0_0:convex:17",
      region2Id: "t0_0:convex:24",
      position: {
        x: -1.2288457499999998,
        y: 0.03444776294261411
      }
    },
    {
      portId: "t0_0:convex:18-19:24",
      region1Id: "t0_0:convex:18",
      region2Id: "t0_0:convex:19",
      position: {
        x: -1.2369259236689427,
        y: -0.621576300991815
      }
    },
    {
      portId: "t0_0:convex:18-23:25",
      region1Id: "t0_0:convex:18",
      region2Id: "t0_0:convex:23",
      position: {
        x: -1.2299172499999997,
        y: -0.6193376999999998
      }
    },
    {
      portId: "t0_0:convex:18-24:27",
      region1Id: "t0_0:convex:18",
      region2Id: "t0_0:convex:24",
      position: {
        x: -1.22991675,
        y: -0.03611534653723591
      }
    },
    {
      portId: "t0_0:convex:19-20:28",
      region1Id: "t0_0:convex:19",
      region2Id: "t0_0:convex:20",
      position: {
        x: -1.2321613530099345,
        y: -1.050638372306859
      }
    },
    {
      portId: "t0_0:convex:19-22:29",
      region1Id: "t0_0:convex:19",
      region2Id: "t0_0:convex:22",
      position: {
        x: -1.2290762499999999,
        y: -1.0503045500000001
      }
    },
    {
      portId: "t0_0:convex:19-23:31",
      region1Id: "t0_0:convex:19",
      region2Id: "t0_0:convex:23",
      position: {
        x: -1.2290757499999998,
        y: -0.6461538410229819
      }
    },
    {
      portId: "t0_0:convex:20-22:33",
      region1Id: "t0_0:convex:20",
      region2Id: "t0_0:convex:22",
      position: {
        x: -1.22944825,
        y: -1.0757121977829602
      }
    },
    {
      portId: "via-side:t0_0:v:net1:top:35",
      region1Id: "t0_0:v:net1",
      region2Id: "t0_0:convex:12",
      position: {
        x: 0.082317,
        y: 1.062692
      }
    },
    {
      portId: "via-side:t0_0:v:net1:bottom:36",
      region1Id: "t0_0:v:net1",
      region2Id: "t0_0:convex:4",
      position: {
        x: 0.648081,
        y: -0.803655
      }
    },
    {
      portId: "via-side:t0_0:v:net1:left:37",
      region1Id: "t0_0:v:net1",
      region2Id: "t0_0:convex:14",
      position: {
        x: -0.067683,
        y: 0.912692
      }
    },
    {
      portId: "via-side:t0_0:v:net1:right:38",
      region1Id: "t0_0:v:net1",
      region2Id: "t0_0:convex:6",
      position: {
        x: 0.798081,
        y: -0.653655
      }
    },
    {
      portId: "via-side:t0_0:v:net2:top:39",
      region1Id: "t0_0:v:net2",
      region2Id: "t0_0:convex:9",
      position: {
        x: 1.336913,
        y: 0.417523
      }
    },
    {
      portId: "via-side:t0_0:v:net2:bottom:40",
      region1Id: "t0_0:v:net2",
      region2Id: "t0_0:convex:1",
      position: {
        x: -0.651699,
        y: -1.414802
      }
    },
    {
      portId: "via-side:t0_0:v:net2:left:41",
      region1Id: "t0_0:v:net2",
      region2Id: "t0_0:convex:20",
      position: {
        x: -0.801699,
        y: -1.264802
      }
    },
    {
      portId: "via-side:t0_0:v:net3:top:42",
      region1Id: "t0_0:v:net3",
      region2Id: "t0_0:convex:11",
      position: {
        x: 0.58222,
        y: 1.0726499999999999
      }
    },
    {
      portId: "via-side:t0_0:v:net3:left:43",
      region1Id: "t0_0:v:net3",
      region2Id: "t0_0:convex:18",
      position: {
        x: -0.802635,
        y: -0.2648
      }
    },
    {
      portId: "via-side:t0_0:v:net3:right:44",
      region1Id: "t0_0:v:net3",
      region2Id: "t0_0:convex:10",
      position: {
        x: 0.73222,
        y: 0.92265
      }
    },
    {
      portId: "via-side:t0_0:v:net4:top:45",
      region1Id: "t0_0:v:net4",
      region2Id: "t0_0:convex:15",
      position: {
        x: -0.650488,
        y: 0.385198
      }
    },
    {
      portId: "via-side:t0_0:v:net4:bottom:46",
      region1Id: "t0_0:v:net4",
      region2Id: "t0_0:convex:2",
      position: {
        x: -0.15182,
        y: -1.403675
      }
    },
    {
      portId: "via-side:t0_0:v:net4:left:47",
      region1Id: "t0_0:v:net4",
      region2Id: "t0_0:convex:17",
      position: {
        x: -0.800488,
        y: 0.235198
      }
    },
    {
      portId: "via-side:t0_0:v:net4:right:48",
      region1Id: "t0_0:v:net4",
      region2Id: "t0_0:convex:3",
      position: {
        x: -0.001820000000000016,
        y: -1.253675
      }
    },
    {
      portId: "via-side:t0_0:v:net5:top:49",
      region1Id: "t0_0:v:net5",
      region2Id: "t0_0:convex:14",
      position: {
        x: -0.305576,
        y: 0.74719
      }
    },
    {
      portId: "via-side:t0_0:v:net5:bottom:50",
      region1Id: "t0_0:v:net5",
      region2Id: "t0_0:convex:3",
      position: {
        x: 0.251735,
        y: -1.10847
      }
    },
    {
      portId: "via-side:t0_0:v:net5:left:51",
      region1Id: "t0_0:v:net5",
      region2Id: "t0_0:convex:15",
      position: {
        x: -0.455576,
        y: 0.59719
      }
    },
    {
      portId: "via-side:t0_0:v:net5:right:52",
      region1Id: "t0_0:v:net5",
      region2Id: "t0_0:convex:4",
      position: {
        x: 0.40173499999999995,
        y: -0.95847
      }
    },
    {
      portId: "via-side:t0_0:v:net6:top:53",
      region1Id: "t0_0:v:net6",
      region2Id: "t0_0:convex:10",
      position: {
        x: 0.971187,
        y: 0.7584730000000001
      }
    },
    {
      portId: "via-side:t0_0:v:net6:left:54",
      region1Id: "t0_0:v:net6",
      region2Id: "t0_0:convex:19",
      position: {
        x: -0.80095,
        y: -0.7648
      }
    },
    {
      portId: "via-side:t0_0:v:net6:right:55",
      region1Id: "t0_0:v:net6",
      region2Id: "t0_0:convex:9",
      position: {
        x: 1.121187,
        y: 0.608473
      }
    }
  ]
};

// lib/ViaGraphSolver/via-graph-generator/recommendViaTileFromGraphInput.ts
var DEFAULT_VIA_TILE_CANDIDATES = [
  {
    viaRegionName: "via-tile-3-regions",
    viaTile: via_tile_3_regions_baked_default
  },
  {
    viaRegionName: "via-tile-4-regions",
    viaTile: via_tile_4_regions_baked_default
  },
  {
    viaRegionName: "via-tile-5-regions",
    viaTile: via_tile_5_regions_baked_default
  },
  {
    viaRegionName: "via-tile-6-regions",
    viaTile: via_tile_6_regions_baked_default
  }
];
var round2 = (value) => Math.round(value * 100) / 100;
var clamp4 = (value, min, max) => Math.max(min, Math.min(max, value));
var sigmoid = (x) => 1 / (1 + Math.exp(-x));
var ccw = (a, b, c) => (c.y - a.y) * (b.x - a.x) > (b.y - a.y) * (c.x - a.x);
var segmentsIntersect = (a1, a2, b1, b2) => ccw(a1, b1, b2) !== ccw(a2, b1, b2) && ccw(a1, a2, b1) !== ccw(a1, a2, b2);
var countIntersections = (xyConnections) => {
  let intersections = 0;
  for (let i = 0; i < xyConnections.length; i++) {
    for (let j = i + 1; j < xyConnections.length; j++) {
      if (segmentsIntersect(
        xyConnections[i].start,
        xyConnections[i].end,
        xyConnections[j].start,
        xyConnections[j].end
      )) {
        intersections++;
      }
    }
  }
  return intersections;
};
var getBoundsFromSample = (sample) => {
  const regions = sample.connectionRegions ?? [];
  if (regions.length === 0) return null;
  const minX = Math.min(...regions.map((r) => r.d.bounds.minX));
  const maxX = Math.max(...regions.map((r) => r.d.bounds.maxX));
  const minY = Math.min(...regions.map((r) => r.d.bounds.minY));
  const maxY = Math.max(...regions.map((r) => r.d.bounds.maxY));
  return {
    widthMm: maxX - minX,
    heightMm: maxY - minY
  };
};
var extractXYConnectionsFromSample = (sample) => {
  const connections = sample.connections ?? [];
  const regionMap = new Map(
    (sample.connectionRegions ?? []).map((r) => [r.regionId, r.d.center])
  );
  const xyConnections = [];
  for (const conn of connections) {
    const start = regionMap.get(conn.startRegionId);
    const end = regionMap.get(conn.endRegionId);
    if (!start || !end) continue;
    xyConnections.push({
      connectionId: conn.connectionId,
      start,
      end
    });
  }
  return xyConnections;
};
var predictViaRegionFromSolveMatrix = (input) => {
  const area = input.graphWidthMm * input.graphHeightMm;
  if (input.graphWidthMm > 22) {
    return "via-tile-4-regions";
  }
  if (input.intersectionCount <= 20) {
    if (input.intersectionCount <= 17) {
      return "via-tile-5-regions";
    }
    return input.graphWidthMm <= 12.6 ? "via-tile-3-regions" : "via-tile-4-regions";
  }
  return area <= 246.01 ? "via-tile-3-regions" : "via-tile-5-regions";
};
var getViaTileBounds = (viaTile) => {
  const points = [];
  for (const vias of Object.values(viaTile.viasByNet)) {
    for (const via of vias) points.push(via.position);
  }
  for (const route of viaTile.routeSegments) {
    for (const p of route.segments) points.push(p);
  }
  if (points.length === 0) {
    return { width: 1, height: 1 };
  }
  const minX = Math.min(...points.map((p) => p.x));
  const maxX = Math.max(...points.map((p) => p.x));
  const minY = Math.min(...points.map((p) => p.y));
  const maxY = Math.max(...points.map((p) => p.y));
  return {
    width: Math.max(maxX - minX, 0.01),
    height: Math.max(maxY - minY, 0.01)
  };
};
var scoreViaTileForProblem = (problem, candidate) => {
  const viaCount = Object.values(candidate.viaTile.viasByNet).reduce(
    (sum, vias) => sum + vias.length,
    0
  );
  const netCount = Object.keys(candidate.viaTile.viasByNet).length;
  const routeSegmentCount = candidate.viaTile.routeSegments.length;
  const bounds = getViaTileBounds(candidate.viaTile);
  const tileArea = Math.max(
    candidate.viaTile.tileWidth && candidate.viaTile.tileHeight ? candidate.viaTile.tileWidth * candidate.viaTile.tileHeight : bounds.width * bounds.height,
    0.01
  );
  const graphArea = Math.max(problem.graphWidthMm * problem.graphHeightMm, 0.01);
  const crossingPerConnection = problem.intersectionCount / Math.max(problem.connectionCount, 1);
  const density = problem.connectionCount / graphArea;
  const requiredCapacityScore = problem.connectionCount * 1.2 + problem.intersectionCount * 1.5 + crossingPerConnection * 5 + density * 40;
  const capacityScore = viaCount * 3.1 + routeSegmentCount * 2.4 + netCount * 0.5 + 1 / tileArea * 4.5;
  const predictedReliability = clamp4(
    sigmoid((capacityScore - requiredCapacityScore) / 3.2),
    0,
    1
  );
  const oversupplyRatio = Math.max(
    0,
    (capacityScore - requiredCapacityScore) / Math.max(requiredCapacityScore, 1)
  );
  const undersupplyRatio = Math.max(
    0,
    (requiredCapacityScore - capacityScore) / Math.max(requiredCapacityScore, 1)
  );
  const estimatedIterationCost = problem.connectionCount * 120 + problem.intersectionCount * 140 + oversupplyRatio * 900 + undersupplyRatio * 6e3;
  return {
    viaRegionName: candidate.viaRegionName,
    predictedReliability,
    estimatedIterationCost,
    capacityScore,
    requiredCapacityScore,
    acceptedAsReliable: predictedReliability >= 0.9
  };
};
var calculateBoundsFromConnections = (xyConnections) => {
  if (xyConnections.length === 0) {
    throw new Error("Cannot calculate bounds from empty connections array");
  }
  let minX = Infinity;
  let maxX = -Infinity;
  let minY = Infinity;
  let maxY = -Infinity;
  for (const conn of xyConnections) {
    minX = Math.min(minX, conn.start.x, conn.end.x);
    maxX = Math.max(maxX, conn.start.x, conn.end.x);
    minY = Math.min(minY, conn.start.y, conn.end.y);
    maxY = Math.max(maxY, conn.start.y, conn.end.y);
  }
  return { minX, maxX, minY, maxY };
};
var normalizeGraphProblemInput = (input, fallbackXYConnections) => {
  const xyConnections = (input.xyConnections && input.xyConnections.length > 0 ? input.xyConnections : fallbackXYConnections).slice();
  let graphWidthMm = input.graphWidthMm;
  let graphHeightMm = input.graphHeightMm;
  let connectionCount = input.connectionCount;
  let intersectionCount = input.intersectionCount;
  if (input.sample) {
    const sampleXYConnections = extractXYConnectionsFromSample(input.sample);
    if (xyConnections.length === 0 && sampleXYConnections.length > 0) {
      xyConnections.push(...sampleXYConnections);
    }
    if (!connectionCount) {
      connectionCount = input.sample.connections?.length ?? xyConnections.length;
    }
    if (intersectionCount == null) {
      intersectionCount = input.sample.config?.numCrossings ?? (xyConnections.length > 0 ? countIntersections(xyConnections) : 0);
    }
    if (graphWidthMm == null || graphHeightMm == null) {
      const bounds = getBoundsFromSample(input.sample);
      if (bounds) {
        graphWidthMm = graphWidthMm ?? bounds.widthMm;
        graphHeightMm = graphHeightMm ?? bounds.heightMm;
      }
    }
  }
  if (xyConnections.length > 0) {
    const bounds = calculateBoundsFromConnections(xyConnections);
    graphWidthMm = graphWidthMm ?? bounds.maxX - bounds.minX;
    graphHeightMm = graphHeightMm ?? bounds.maxY - bounds.minY;
    connectionCount = connectionCount ?? xyConnections.length;
    intersectionCount = intersectionCount ?? countIntersections(xyConnections);
  }
  if (graphWidthMm == null || graphHeightMm == null || connectionCount == null || intersectionCount == null) {
    throw new Error(
      "Insufficient graph input. Provide width/height/connections/intersections, or pass xyConnections."
    );
  }
  return {
    graphWidthMm: round2(graphWidthMm),
    graphHeightMm: round2(graphHeightMm),
    connectionCount,
    intersectionCount
  };
};
var recommendViaTileFromGraphInput = (problemInput, fallbackXYConnections = [], viaTileCandidates = DEFAULT_VIA_TILE_CANDIDATES, _opts) => {
  if (viaTileCandidates.length === 0) {
    throw new Error("No via-tile candidates provided");
  }
  const xyConnections = problemInput.xyConnections && problemInput.xyConnections.length > 0 ? problemInput.xyConnections : fallbackXYConnections;
  const normalizedInput = normalizeGraphProblemInput(
    problemInput,
    xyConnections
  );
  const scored = viaTileCandidates.map((candidate) => scoreViaTileForProblem(normalizedInput, candidate)).sort((a, b) => {
    if (a.acceptedAsReliable !== b.acceptedAsReliable) {
      return a.acceptedAsReliable ? -1 : 1;
    }
    if (a.acceptedAsReliable && b.acceptedAsReliable) {
      if (a.estimatedIterationCost !== b.estimatedIterationCost) {
        return a.estimatedIterationCost - b.estimatedIterationCost;
      }
    } else if (a.predictedReliability !== b.predictedReliability) {
      return b.predictedReliability - a.predictedReliability;
    }
    return a.estimatedIterationCost - b.estimatedIterationCost;
  });
  const predictedViaRegionName = predictViaRegionFromSolveMatrix(normalizedInput);
  const predictedCandidate = scored.find(
    (candidate) => candidate.viaRegionName === predictedViaRegionName
  );
  if (predictedCandidate) {
    return {
      recommendedViaRegionName: predictedCandidate.viaRegionName,
      inputFeatures: normalizedInput,
      candidates: [
        predictedCandidate,
        ...scored.filter(
          (candidate) => candidate.viaRegionName !== predictedViaRegionName
        )
      ]
    };
  }
  return {
    recommendedViaRegionName: scored[0].viaRegionName,
    inputFeatures: normalizedInput,
    candidates: scored
  };
};
var selectViaTileForProblemInput = (problemInput, xyConnections) => {
  const recommendation = recommendViaTileFromGraphInput(
    problemInput,
    xyConnections
  );
  const selectedCandidate = DEFAULT_VIA_TILE_CANDIDATES.find(
    (candidate) => candidate.viaRegionName === recommendation.recommendedViaRegionName
  );
  return selectedCandidate?.viaTile ?? via_tile_4_regions_baked_default;
};

// lib/ViaGraphSolver/via-graph-generator/createConvexViaGraphFromXYConnections.ts
var isViaTile = (input) => Boolean(
  input && typeof input === "object" && "viasByNet" in input && "routeSegments" in input
);
function calculateBoundsFromConnections2(xyConnections) {
  if (xyConnections.length === 0) {
    throw new Error("Cannot calculate bounds from empty connections array");
  }
  let minX = Infinity;
  let maxX = -Infinity;
  let minY = Infinity;
  let maxY = -Infinity;
  for (const conn of xyConnections) {
    minX = Math.min(minX, conn.start.x, conn.end.x);
    maxX = Math.max(maxX, conn.start.x, conn.end.x);
    minY = Math.min(minY, conn.start.y, conn.end.y);
    maxY = Math.max(maxY, conn.start.y, conn.end.y);
  }
  return { minX, maxX, minY, maxY };
}
function createConvexViaGraphFromXYConnections(xyConnections, viaTileOrProblem, opts) {
  const selectedViaTile = isViaTile(viaTileOrProblem) ? viaTileOrProblem : selectViaTileForProblemInput(
    {
      ...viaTileOrProblem ?? {},
      xyConnections: viaTileOrProblem?.xyConnections ?? xyConnections
    },
    xyConnections
  );
  const bounds = calculateBoundsFromConnections2(xyConnections);
  const {
    regions,
    ports,
    viaTile: generatedViaTile,
    tileCount
  } = generateConvexViaTopologyRegions({
    viaTile: selectedViaTile,
    bounds,
    tileWidth: opts?.tileWidth ?? selectedViaTile.tileWidth,
    tileHeight: opts?.tileHeight ?? selectedViaTile.tileHeight,
    tileSize: opts?.tileSize,
    portPitch: opts?.portPitch,
    clearance: opts?.clearance,
    concavityTolerance: opts?.concavityTolerance
  });
  const baseGraph = { regions, ports };
  const graphWithConnections = createViaGraphWithConnections(
    baseGraph,
    xyConnections
  );
  return {
    ...graphWithConnections,
    viaTile: generatedViaTile,
    tileCount
  };
}
export {
  ConnectBuilder,
  HyperGraphSectionOptimizer,
  HyperGraphSectionOptimizer2,
  HyperGraphSolver,
  JUMPER_GRAPH_SOLVER_DEFAULTS,
  JumperGraphSolver,
  PortBuilder,
  RegionBuilder,
  Topology,
  TopologyError,
  VIA_GRAPH_SOLVER_DEFAULTS,
  ViaGraphSolver,
  applyTransformToGraph,
  calculateGraphBounds,
  convertConnectionsToSerializedConnections,
  convertHyperGraphToSerializedHyperGraph,
  createBlankHyperGraph,
  createConvexViaGraphFromXYConnections,
  createGraphWithConnectionsFromBaseGraph,
  createViaGraphWithConnections,
  extractSectionOfHyperGraph,
  generateConvexViaTopologyRegions,
  generateDefaultViaTopologyRegions,
  generateJumperGrid,
  generateJumperX4Grid,
  generateViaTopologyRegions,
  pruneDeadEndPorts,
  reattachSectionToGraph,
  recommendViaTileFromGraphInput,
  rotateGraph90Degrees,
  via_tile_4_regions_default as viaTile
};
/*! Bundled license information:

@tscircuit/find-convex-regions/dist/index.js:
  (*! Bundled license information:
  
  is-buffer/index.js:
    (*!
     * Determine if an object is a Buffer
     *
     * @author   Feross Aboukhadijeh <https://feross.org>
     * @license  MIT
     *)
  
  deep-rename-keys/index.js:
    (*!
     * deep-rename-keys <https://github.com/jonschlinkert/deep-rename-keys>
     *
     * Copyright (c) 2015 Jon Schlinkert, contributors.
     * Licensed under the MIT license.
     *)
  *)
*/
